webpackJsonp([0],{

/***/ "+Gg3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "+InE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m fixed flexy align-top",staticStyle:{"width":"50%","padding-right":"40px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("y93l"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery),expression:"delivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"0"},domProps:{"checked":_vm._q(_vm.delivery,"0")},on:{"change":function($event){_vm.delivery="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery),expression:"delivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"1"},domProps:{"checked":_vm._q(_vm.delivery,"1")},on:{"change":function($event){_vm.delivery="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("FREE shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery),expression:"delivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"2"},domProps:{"checked":_vm._q(_vm.delivery,"2")},on:{"change":function($event){_vm.delivery="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("$6.98 - Standart shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery),expression:"delivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"3"},domProps:{"checked":_vm._q(_vm.delivery,"3")},on:{"change":function($event){_vm.delivery="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("$13.98 - Two-Day Shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery),expression:"delivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"4"},domProps:{"checked":_vm._q(_vm.delivery,"4")},on:{"change":function($event){_vm.delivery="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("$20.98 - One-Day Shipping")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Iun":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-m fixed silver rounded",staticStyle:{"width":"300px"}},[_c('h3',[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide",class:{grey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('ul',[(!_vm.isShippingFilled)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentFilled)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.87")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$96.85")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+TgY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "+VEc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("2Zye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d9d751_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("6h8B");
function injectStyle (ssrContext) {
  __webpack_require__("1G4+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00d9d751"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d9d751_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+h5J":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPnSURBVHgB1VgxUxNBFH67FxytCDgj0pAL0RkLxdAxDEjo7MDOzvALsKQj/AKTX2Do7AyVWgEDw9h52DljhoNKbBI7B3K7vnfmdO+8JHvJXcBvJjO5t7d73717+977loEmzHwhbTjOKnBYksDyDKSJ5nR7uIk2G20WCNh3DKNmW3tNiBGs1w1I0OTCWWcMigoxHVQddrllWx9tiAEdiZIHuRCbjMmXMACkZGXB+dagHg4l6npROrs4aEI8sNG7y4N4lwcN9/Pz+S4km+jhLfwt44Oz9eMDRj+HGWNkk1JWJJIKmWcacmSX1oY+4fNoF0/aSGTtq3W4BxrI5ReLUsJm2Dr9etbn0VCSTFbQY7O6JAl166AqcA4GaCUw5HqW4h8iwvD+TM88eYU7+6k6SJ+5bh1uNL/ZPyEiaE7j/Oz97ckpfHdWUIbSTMLNxvnpB4gA99PTJzekc+IfkRUkOdCO95CbWSjjW6+rNorxKCHgfnokuRmw2w6kShATHJ4qBTcZF6lITmBuxZFOw2+FNYoziBH38gsFzKm7iqmJsZ/Vza/cLYt+2HGTJLQ3o0oKS/LFqu58TrVbNWAu3IGEIINZgBtLunO5BOlLwpxDDRICrr2nXlNzA5rgDJipGlqQsiAh4Nq2et3uwLRAu96XfONuzwJr2wGTduLn8J+AiPo8mJ2dz0BCCCmd2l+PNpOtGgzJs5AUWi3f5iFVAJrgmISPVYMQUICEgLvelzdd6aI9V/pTBgvU5FjB2Ir/GvZBE5yEGAQqBpU7iBm5R4vFYAvpgKGdszmlI6wY26oRw+F1Pz1jJ9BakkOw8alGSYVuehI8VQ6uTcIOYoIrEoPeRIUKEeA2ztjkNscnpsYwhua8AWyi58YmTMAGVzuOwoANOSnZDZ8Re90T6+gNREDK+0M9I0qRFfXN8QElfFC6H7nbVW5LNgoR8UeKkHQYnZzewZSxypTSRp7lIJ+P38n8aHw/00on5sOFAmfyXVDaKMiP382YKFW0O7V/dD1JWkcabzvIZRvVZU0IbAVTKcvzsvlgzsRrk3O+1Pag7kasotxe07lxWAcQ3aBF1ggz0ubCMNjmUtxSN1hfwI2DMfkFXdKp99QKA61DMkM4JbzzBejDzc2Ct8qe0szNLFZ7rNHVsz2Jwl/CaQNQX2EvIJl83G64lWNHiceOzKKySBUnLEsMQlabaFzol6wBQwbGYm18IpONGrNDJ0roh+yVECVEJTv0GA2iV8wK7pgnn45Or1zc1T8fFFGTbHca96TRlXvUQwfP2pgBXKLXRi7/9qzvyKfJmfPMu7g2HvVAlXAELtKXcMNO8jAkMfwC7fTLO+OBCF8AAAAASUVORK5CYII="

/***/ }),

/***/ "+jl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
    };
  }
});

/***/ }),

/***/ "+lDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l fixed flexy align-top",staticStyle:{"width":"50%"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("+TgY"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900","padding-bottom":"8px"}},[_vm._v("Shopping cart")]),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"flexy align-top",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"64px","margin-right":"16px"}},[_c('img',{attrs:{"src":item.img,"width":"64px"}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"font-size":"14px","padding-top":"6px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("x"+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.editPressed()}}},[_vm._v("Edit")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+sb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shopping cart")]),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"60px"}},[_c('img',{attrs:{"src":item.img,"width":"40px"}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',[_vm._v("Quantity: "+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.editPressed()}}},[_vm._v("Edit")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+z/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"fixed flexy align-top fading",staticStyle:{"width":"50%","padding-right":"40px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("CUcu"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Payment information")]),_vm._v(" "),(_vm.selectedPayment === null)?_c('div',{staticStyle:{"padding-top":"12px","position":"relative"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"background-color":"#3a84e8"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add payment method")]),_vm._v(" "),(!_vm.isSignedIn)?_c('div',{staticStyle:{"font-size":"14px","padding-top":"12px"}},[_c('button',{staticStyle:{"font-size":"13px","padding":"3px 8px","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.openSignIn()}}},[_vm._v("Sign in")]),_vm._v(" for 1-click checkout")]):_vm._e()]):_c('div',{staticStyle:{"padding-top":"8px"}},[_c('div',[_vm._v(_vm._s(_vm.payments[_vm.selectedPayment].name))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.mutateCardNumber(_vm.payments[_vm.selectedPayment].number)))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.payments[_vm.selectedPayment].month)+" / "+_vm._s(_vm.payments[_vm.selectedPayment].year))]),_vm._v(" "),_c('div',{staticStyle:{"color":"transparent","width":"0","height":"0","overflow":"hidden"}},[_vm._v(_vm._s(_vm.reactivator))]),_vm._v(" "),_c('transition',{attrs:{"name":"popover"}},[(_vm.doShowMethodsList)?_c('div',[_c('div',{staticClass:"popover-curtain",on:{"click":function($event){_vm.doShowMethodsList=false}}}),_vm._v(" "),_c('div',{staticClass:"popover-content",on:{"click":function($event){$event.stopPropagation();_vm.doNothing($event)}}},[_vm._l((_vm.payments),function(payment,i){return _c('div',{key:i,staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":function($event){_vm.choosePressed(i)}}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('div',[_c('strong',[_vm._v(_vm._s(payment.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.month)+" / "+_vm._s(payment.year))])])])}),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px","margin-top":"4px"},on:{"click":_vm.addNewPaymentPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Add new payment")])])]),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":_vm.managePaymentPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Manage payment methods")])])])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.changePressed()}}},[_vm._v("\n            Change\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/JjF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63250fda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("SsKr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63250fda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/KXV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/YkI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/YnR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/gak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/kAr":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABdSURBVHgBnZHLDcAgDEONMlIW6DRZo7BGpukC2alN1SIhQHx8ciK9d3EQkQjgxF4SmdnFzOE5DqwlqWokbxuSF/ZC/2dBkuFCMCkp4EowkFRwU9CRNOFhfOJv5m5u2yovCkw90cUAAAAASUVORK5CYII="

/***/ }),

/***/ "/xK5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['selectedAddress', 'selectedPayment', 'cart'
  // 'delivery'
  ],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.selectedAddress !== null && this.selectedPayment !== null;
    },
    cartSum: function cartSum() {
      var sum = 0;
      for (var i in this.cart) {
        sum += this.cart[i].price * this.cart[i].quantity;
      }
      return sum.toFixed(2);
    },
    deliveryPrice: function deliveryPrice() {
      switch (this.$store.getters.getChosenDelivery) {
        case '0':
          return 0;
        case '1':
          return 0;
        case '2':
          return 6.98;
        case '3':
          return 13.98;
        case '4':
          return 20.98;
        default:
          break;
      }
    },
    beforeTax: function beforeTax() {
      var beforeTaxTemp = 0;
      beforeTaxTemp = parseInt(this.cartSum) + this.deliveryPrice;
      return beforeTaxTemp.toFixed(2);
    },
    tax: function tax() {
      var taxTemp = 0;
      taxTemp = parseInt(this.beforeTax) * 0.18;
      return taxTemp.toFixed(2);
    },
    total: function total() {
      var totalTemp = 0;
      totalTemp = parseInt(this.beforeTax) + parseInt(this.tax);
      return totalTemp.toFixed(2);
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "0+KD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("sFdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0edffd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("0UKQ");
function injectStyle (ssrContext) {
  __webpack_require__("1Tk1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b0edffd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0edffd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "03OD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shipping address")]),_vm._v(" "),(!_vm.isShippingFilled)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add shipping address")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Sam Bell")]),_vm._v(" "),_c('div',[_vm._v("821 Washington St")]),_vm._v(" "),_c('div',[_vm._v("Ashland, Illinois, United States")]),_vm._v(" "),_c('div',[_vm._v("1 555 374 82 96")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "07PK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "0ABa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("Jh+S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1384cd66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("jku2");
function injectStyle (ssrContext) {
  __webpack_require__("RtV/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1384cd66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1384cd66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0PkL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shopping cart")]),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"60px"}},[_c('img',{attrs:{"src":item.img,"width":"40px"}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',[_vm._v("Quantity: "+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.editPressed()}}},[_vm._v("Edit")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0S+M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0UKQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"border-bottom":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","border-radius":"10px 10px 0 0"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[_vm._v("Payment information")])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"16px","padding-bottom":"40px"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"cardName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n            Shouldn't be empty\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number.value),expression:"number.value"}],class:{errorInputHighlight: !_vm.number.isValid && !_vm.number.wasFocused},attrs:{"type":"text","name":"","id":"cardNumber"},domProps:{"value":(_vm.number.value)},on:{"focus":function($event){_vm.number.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.number, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.number.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.number.wasFocused}},[_vm._v("\n            Shouldn't be empty\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month.value),expression:"month.value"}],class:{errorInputHighlight: !_vm.month.isValid && !_vm.month.wasFocused},on:{"focus":function($event){_vm.month.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.month, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose month...")]),_vm._v(" "),_c('option',[_vm._v("01")]),_vm._v(" "),_c('option',[_vm._v("02")]),_vm._v(" "),_c('option',[_vm._v("03")]),_vm._v(" "),_c('option',[_vm._v("04")]),_vm._v(" "),_c('option',[_vm._v("05")]),_vm._v(" "),_c('option',[_vm._v("06")]),_vm._v(" "),_c('option',[_vm._v("07")]),_vm._v(" "),_c('option',[_vm._v("08")]),_vm._v(" "),_c('option',[_vm._v("09")]),_vm._v(" "),_c('option',[_vm._v("10")]),_vm._v(" "),_c('option',[_vm._v("11")]),_vm._v(" "),_c('option',[_vm._v("12")])]),_vm._v(" "),(!_vm.month.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.month.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year.value),expression:"year.value"}],class:{errorInputHighlight: !_vm.year.isValid && !_vm.year.wasFocused},on:{"focus":function($event){_vm.year.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.year, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose year...")]),_vm._v(" "),_c('option',[_vm._v("17")]),_vm._v(" "),_c('option',[_vm._v("18")]),_vm._v(" "),_c('option',[_vm._v("19")]),_vm._v(" "),_c('option',[_vm._v("20")]),_vm._v(" "),_c('option',[_vm._v("21")]),_vm._v(" "),_c('option',[_vm._v("22")]),_vm._v(" "),_c('option',[_vm._v("23")]),_vm._v(" "),_c('option',[_vm._v("24")]),_vm._v(" "),_c('option',[_vm._v("25")]),_vm._v(" "),_c('option',[_vm._v("26")]),_vm._v(" "),_c('option',[_vm._v("27")])]),_vm._v(" "),(!_vm.year.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.year.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",staticStyle:{"border-top":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","padding-top":"10px","text-align":"right","border-radius":"0 0 10px 10px"}},[_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary",staticStyle:{"min-width":"120px"},on:{"click":_vm.savePressed}},[_vm._v("Save")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1+5K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-hor-xl fixed",class:{shadowyBottom: _vm.didScroll},staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"24px","z-index":"200","transition":"all .4s"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[(_vm.mode === 'add')?_c('span',[_vm._v("New shipping address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('span',[_vm._v("Edit address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'manage')?_c('span',[_vm._v("Manage shipping addresses")]):_vm._e()]),_vm._v(" "),(this.mode === 'manage')?_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.$emit('cancelled')}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl",class:{roundBottom: _vm.mode === 'manage'},staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"","padding-bottom":"12px"},attrs:{"id":"watchMeScroll"},on:{"scroll":_vm.checkScrollPosition}},[(this.mode === 'manage')?_c('div',[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"flexy",staticStyle:{"padding":"12px 0"}},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"#409EFF"},on:{"click":function($event){_vm.editSelectedPressed(i)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"silver"},on:{"click":function($event){_vm.deleteSelectedPressed(i)}}},[_vm._v("Delete")])])])}),_vm._v(" "),_c('div',{staticClass:"clickable flexy",staticStyle:{"padding":"24px 0","color":"#409EFF","font-weight":"500","font-size":"14px"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("\n            Add new address\n          ")])],2):_vm._e(),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1.value),expression:"address1.value"}],class:{errorInputHighlight: !_vm.address1.isValid && !_vm.address1.wasFocused},attrs:{"type":"text","name":"","id":"addressLine1"},domProps:{"value":(_vm.address1.value)},on:{"focus":function($event){_vm.address1.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address1, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.address1.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.address1.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city.value),expression:"city.value"}],class:{errorInputHighlight: !_vm.city.isValid && !_vm.city.wasFocused},attrs:{"type":"text","name":"","id":"city"},domProps:{"value":(_vm.city.value)},on:{"focus":function($event){_vm.city.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.city, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.city.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.city.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],class:{errorInputHighlight: !_vm.state.isValid && !_vm.state.wasFocused},attrs:{"type":"text","name":"","id":"state"},domProps:{"value":(_vm.state.value)},on:{"focus":function($event){_vm.state.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.state.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.state.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country.value),expression:"country.value"}],class:{errorInputHighlight: !_vm.country.isValid && !_vm.country.wasFocused},on:{"focus":function($event){_vm.country.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.country, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose country...")]),_vm._v(" "),_c('option',{attrs:{"value":"United States"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"Mexico"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"Canada"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"Brazil"}},[_vm._v("Brazil")])]),_vm._v(" "),(!_vm.country.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.country.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zip.value),expression:"zip.value"}],class:{errorInputHighlight: !_vm.zip.isValid && !_vm.zip.wasFocused},attrs:{"type":"text","name":"","id":"zip"},domProps:{"value":(_vm.zip.value)},on:{"focus":function($event){_vm.zip.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zip, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.zip.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.zip.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone.value),expression:"phone.value"}],class:{errorInputHighlight: !_vm.phone.isValid && !_vm.phone.wasFocused},attrs:{"type":"text","name":"","id":"phone"},domProps:{"value":(_vm.phone.value)},on:{"focus":function($event){_vm.phone.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.phone, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.phone.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.phone.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',{staticClass:"fixed padding-hor-xl padding-vert-m",class:{shadowyTop: _vm.doesHaveScrollDown},staticStyle:{"z-index":"200","background-color":"white","text-align":"right","border-radius":"0 0 10px 10px","transition":"all .4s"}},[_c('button',{staticClass:"boxed primary properGrey",staticStyle:{"margin-right":"4px"},on:{"click":function($event){_vm.cancelPressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary properBlue",staticStyle:{"min-width":"120px"},on:{"click":function($event){_vm.savePressed()}}},[_vm._v("Save")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1G4+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1I9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100vh","overflow":"auto"}},[_c('div',{staticStyle:{"background-color":"#24303D","color":"white"}},[_c('div',{staticClass:"flexy",staticStyle:{"height":"60px","position":"relative","align-items":"flex-start"},attrs:{"id":"first"}},[_c('div',{staticClass:"fixed padding-hor-l",staticStyle:{"width":"140px","cursor":"pointer","padding-top":"12px"},on:{"click":function($event){_vm.currentView = 'Start'}}},[_c('img',{staticStyle:{"width":"84px"},attrs:{"src":__webpack_require__("23Cc"),"alt":""}})]),_vm._v(" "),_c('transition',{attrs:{"name":"lineonecheckout"}},[(_vm.currentView !== 'Start' && _vm.currentView !== 'ShoppingCart')?_c('div',{staticStyle:{"position":"absolute","margin-top":"12px","padding-top":"4px","padding-bottom":"4px","margin-left":"132px","padding-left":"21px","color":"#FF9900","font-size":"19px","font-weight":"500","border-left":"1px solid rgba(255,255,255,0.2)"}},[_vm._v("Checkout")]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"lineoneinit"}},[(_vm.currentView === 'Start' || _vm.currentView === 'ShoppingCart')?_c('div',{staticClass:"flexy padding-hor-m lineoneinit"},[_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"width":"48px","height":"35px","background-color":"#f3f3f3","border-right":"1px solid d1d1d1","color":"#666","border-radius":"5px 0 0 5px","text-align":"center","cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n            All\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("/kAr"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"white","height":"35px","cursor":"text"}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","background-color":"#FFB647","height":"35px","line-height":"35px","border-radius":"0 5px 5px 0","text-align":"center","padding-top":"4px","cursor":"pointer"}},[_c('img',{staticStyle:{"width":"21px"},attrs:{"src":__webpack_require__("+h5J"),"alt":""}})])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"lineoneinit"}},[(_vm.currentView === 'Start' || _vm.currentView === 'ShoppingCart')?_c('div',{staticClass:"fixed padding-hor-l flexy align-center lineoneinit",staticStyle:{"width":"140px","cursor":"pointer"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',[_c('img',{staticStyle:{"width":"38px","padding-top":"6px"},attrs:{"src":__webpack_require__("c6bX"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","top":"-1px","left":"11px","width":"24px","text-align":"center","color":"#FF9900","font-weight":"900","font-size":"16px"}},[_vm._v(_vm._s(_vm.cart.length))])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"18px","font-weight":"900"}},[_vm._v("\n          cart\n        ")])]):_vm._e()])],1),_vm._v(" "),_c('transition',{attrs:{"name":"linetwo"}},[(_vm.currentView === 'Start' || _vm.currentView === 'ShoppingCart')?_c('div',{staticClass:"flexy align-center linetwo-container",attrs:{"id":"second"}},[_c('div',{staticClass:"fixed padding-hor-l flexy align-center",staticStyle:{"width":"140px","cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n          Departments\n        ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"flexy padding-hor-m align-center",staticStyle:{"opacity":"0.6","font-size":"13px"}},[_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right"}},[_vm._v("\n            Browsing History\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("My Amazon.com")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Today's Deals")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Gift Cards")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Registry")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Sell")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Help")])]),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-l flexy align-center",staticStyle:{"cursor":"pointer","font-size":"13px","font-weight":"900"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"cursor":"pointer","padding-right":"24px"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n            Account & Lists\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-right":"24px"}},[_vm._v("Orders")]),_vm._v(" "),_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n            Try Prime\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})])])]):_vm._e()])],1),_vm._v(" "),(_vm.currentView === 'Start')?_c('Start'):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShoppingCart')?_c('ShoppingCart',{attrs:{"cart":_vm.cart,"alsoItems":_vm.alsoItems,"recentItems":_vm.recentItems,"extraItems":_vm.extraItems,"laterItems":_vm.laterItems},on:{"updated":function($event){_vm.shoppingCartUpdated($event)},"confirmed":function($event){_vm.shoppingCartConfirmed($event)}}}):_vm._e(),_vm._v(" "),(_vm.doShowAddressManager)?_c('ShippingAddress',{attrs:{"mode":_vm.addressMode,"addresses":_vm.addresses,"selectedAddress":_vm.selectedAddressForEditing},on:{"add":function($event){_vm.addAddressPressed()},"edit":function($event){_vm.editAddressPressed($event)},"delete":function($event){_vm.deleteAddressPressed($event)},"saveNew":function($event){_vm.shippingAddressSaveNew($event)},"saveExisting":function($event){_vm.shippingAddressSaveExisting($event)},"backToManager":function($event){_vm.shippingAddressCancelledBackToManager()},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.doShowPaymentManager)?_c('PaymentMethod',{attrs:{"mode":_vm.paymentMode,"payments":_vm.payments,"selectedPayment":_vm.selectedPaymentForEditing},on:{"add":function($event){_vm.addPaymentPressed()},"edit":function($event){_vm.editPaymentPressed($event)},"delete":function($event){_vm.deletePaymentPressed($event)},"saveNew":function($event){_vm.paymentMethodSaveNew($event)},"saveExisting":function($event){_vm.paymentMethodSaveExisting($event)},"backToManager":function($event){_vm.paymentMethodCancelledBackToManager()},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ExtraSignup')?_c('ExtraSignup'):_vm._e(),_vm._v(" "),(_vm.currentView === 'Checkout')?_c('div',{attrs:{"id":"checkout"}},[_c('div',[_c('div',{staticClass:"flexy align-stretch",staticStyle:{"flex-direction":"row-reverse"}},[_c('OrderSummary',{attrs:{"selectedAddress":_vm.selectedAddress,"selectedPayment":_vm.selectedPayment},on:{"placed":function($event){_vm.currentView = 'ExtraSignup'}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{attrs:{"selectedAddress":_vm.selectedAddress,"addresses":_vm.addresses,"reactivator":_vm.reactivator},on:{"add":function($event){_vm.addAddressPressed()},"signin":function($event){_vm.signInPressed()},"change":function($event){_vm.changeAddressSelected($event)},"manage":function($event){_vm.manageAddressPressed()}}}),_vm._v(" "),_c('PaymentMethodMin',{attrs:{"selectedPayment":_vm.selectedPayment,"payments":_vm.payments,"reactivator":_vm.reactivator},on:{"add":function($event){_vm.addPaymentPressed()},"signin":function($event){_vm.signInPressed()},"change":function($event){_vm.changePaymentSelected($event)},"manage":function($event){_vm.managePaymentPressed()}}})],1),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch",staticStyle:{"padding-top":"32px"}},[_c('ShoppingCartMin',{attrs:{"cart":_vm.cart},on:{"edit":function($event){_vm.currentView = 'ShoppingCart'}}}),_vm._v(" "),_c('Delivery',{attrs:{"chosenDelivery":_vm.chosenDelivery}})],1)]),_vm._v(" "),(_vm.doShowSignIn)?_c('SignIn',{on:{"close":function($event){_vm.signInClosed()},"login":_vm.loginPressed}}):_vm._e()],1)])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1RU4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("EHf2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cff83ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("8OTr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cff83ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Tk1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1blU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("VZ47");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c04005_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("TOBd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c04005_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1gmF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__ = __webpack_require__("dBG7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_328f26da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__ = __webpack_require__("GdNK");
function injectStyle (ssrContext) {
  __webpack_require__("Iu2J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-328f26da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_328f26da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1jdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("i7oi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba41940a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("SPtR");
function injectStyle (ssrContext) {
  __webpack_require__("qIRn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba41940a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba41940a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1pjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"400px","margin":"5vh auto","border-radius":"2px","box-shadow":"0px 12px 36px rgba(0,0,0,0.1)"}},[_c('div',{staticClass:"flexy padding-hor-xl",staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"16px"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[_vm._v("Sign in")])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl",staticStyle:{"max-height":"80vh","overflow":"auto","background-color":"white"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","name":"","id":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl padding-vert-l",staticStyle:{"background-color":"white","flex":"0 0 auto","text-align":"right","border-radius":"0 0 10px 10px","padding-top":"24px"}},[_c('button',{staticClass:"boxed primary properGrey",staticStyle:{"margin-right":"4px"},on:{"click":function($event){_vm.closePressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary properBlue",staticStyle:{"min-width":"120px"},on:{"click":function($event){_vm.loginPressed()}}},[_vm._v("Login")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1qWs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1s+U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  props: ['cart', 'didAcceptShoppingCart']
});

/***/ }),

/***/ "2+Fc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("/JjF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__ = __webpack_require__("3Zis");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__ = __webpack_require__("HXuk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Delivery__ = __webpack_require__("GxlM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__ = __webpack_require__("XHsM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__ = __webpack_require__("FXfW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__ = __webpack_require__("e218");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__ = __webpack_require__("WDex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderSummary__ = __webpack_require__("htAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__ = __webpack_require__("HUrK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SignIn__ = __webpack_require__("3dD8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Start: __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
    ShoppingCart: __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__["a" /* default */],
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_3__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_8__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__["a" /* default */],
    SignIn: __WEBPACK_IMPORTED_MODULE_10__SignIn__["a" /* default */]
  },
  data: function data() {
    return {
      currentView: 'Start',
      chosenDelivery: '1',
      reactivator: 0,
      //
      addressMode: null,
      doShowAddressManager: false,
      selectedAddress: null,
      selectedAddressForEditing: null,
      addresses: [],
      //
      // isPaymentFilled: false,
      paymentMode: null,
      doShowPaymentManager: false,
      selectedPayment: null,
      selectedPaymentForEditing: null,
      payments: [],
      //
      doShowSignIn: false,
      //
      cart: [{
        name: 'Beautiful Evidence',
        by: 'Edward R. Tufte',
        img: __webpack_require__("OEdX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 28.87,
        quantity: 1
      }, {
        name: 'Hooked: How to Build Habit-Forming Products',
        by: 'Nir Eyal',
        img: __webpack_require__("IBtq"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 18.56,
        quantity: 1
      }],
      alsoItems: [{
        name: 'The Lean Startup: How Today\'s Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses',
        by: 'Eric Ries',
        img: __webpack_require__("xcPX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.29,
        quantity: 1
      }, {
        name: 'The Hard Thing About Hard Things: Building a Business When There Are No Easy Answers',
        by: 'Ben Horowitz',
        img: __webpack_require__("fiE3"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 19.66,
        quantity: 1
      }, {
        name: 'Rework',
        by: 'Jason Fried',
        img: __webpack_require__("7fXA"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 17.68,
        quantity: 1
      }, {
        name: 'Remote: Office Not Required',
        by: 'Jason Fried',
        img: __webpack_require__("LhVL"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 15.59,
        quantity: 1
      }],
      recentItems: [{
        name: 'Sprint: How to Solve Big Problems and Test New Ideas in Just Five Days',
        by: 'Jake Knapp',
        img: __webpack_require__("RVgH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.53,
        quantity: 1
      }, {
        name: 'About Face: The Essentials of Interaction Design',
        by: 'Alan Cooper',
        img: __webpack_require__("y+PD"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 36.47,
        quantity: 1
      }, {
        name: '100 Things Every Designer Needs to Know About People',
        by: 'Susan Weinschenk',
        img: __webpack_require__("P+u0"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 22.95,
        quantity: 1
      }, {
        name: 'HTML and CSS: Design and Build Websites',
        by: 'Jon Duckett',
        img: __webpack_require__("AqZH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.53,
        quantity: 1
      }],
      extraItems: [{
        name: 'Logo Design Love: A Guide to Creating Iconic Brand Identities, 2nd Edition',
        by: 'David Airey',
        img: __webpack_require__("WOmI"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.05,
        quantity: 1
      }, {
        name: 'Layout Essentials: 100 Design Principles for Using Grids (Design Essentials)',
        by: 'Beth Tondreau',
        img: __webpack_require__("Mvmb"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.76,
        quantity: 1
      }],
      laterItems: [{
        name: 'CSS: The Missing Manual',
        by: 'David Sawyer McFarland',
        img: __webpack_require__("PF3y"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 24.61,
        quantity: 1
      }, {
        name: 'The Principles of Beautiful Web Design: Designing Great Web Sites is Not Rocket Science!',
        by: 'Jason Beaird',
        img: __webpack_require__("jAj8"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.23,
        quantity: 1
      }]
    };
  },

  methods: {
    shoppingCartConfirmed: function shoppingCartConfirmed(items) {
      this.currentView = 'Checkout';
      this.cart = items;
    },

    //
    // ADDRESS
    addAddressPressed: function addAddressPressed() {
      this.addressMode = 'add';
      this.doShowAddressManager = true;
    },
    editAddressPressed: function editAddressPressed(index) {
      this.addressMode = 'edit';
      this.selectedAddressForEditing = index;
      // this.doShowAddressManager = true
    },
    deleteAddressPressed: function deleteAddressPressed(index) {
      if (index > 0) {
        this.selectedAddress = index - 1;
      } else {
        if (this.addresses.length === 1) {
          this.selectedAddress = null;
        } else {
          this.selectedAddress = index + 1;
        }
      }
      this.addresses.splice(index, 1);
      // this.selectedAddress = index
      // this.doShowAddressManager = true
    },
    shippingAddressSaveNew: function shippingAddressSaveNew(data) {
      this.addresses.push(data);
      this.selectedAddress = this.addresses.length - 1;
      this.doShowAddressManager = false;
    },
    shippingAddressSaveExisting: function shippingAddressSaveExisting(data) {
      this.addresses[this.selectedAddressForEditing] = data;
      this.reactivator++;
      this.addressMode = 'manage';
    },
    changeAddressSelected: function changeAddressSelected(index) {
      this.selectedAddress = index;
    },
    manageAddressPressed: function manageAddressPressed() {
      this.addressMode = 'manage';
      this.doShowAddressManager = true;
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.doShowAddressManager = false;
    },
    shippingAddressCancelledBackToManager: function shippingAddressCancelledBackToManager() {
      this.addressMode = 'manage';
    },

    //
    // PAYMENT
    addPaymentPressed: function addPaymentPressed() {
      this.paymentMode = 'add';
      this.doShowPaymentManager = true;
    },
    editPaymentPressed: function editPaymentPressed(index) {
      this.paymentMode = 'edit';
      this.selectedPaymentForEditing = index;
      // this.doShowAddressManager = true
    },
    deletePaymentPressed: function deletePaymentPressed(index) {
      if (index > 0) {
        this.selectedPayment = index - 1;
      } else {
        if (this.payments.length === 1) {
          this.selectedPayment = null;
        } else {
          this.selectedPayment = index + 1;
        }
      }
      this.payments.splice(index, 1);
      // this.selectedAddress = index
      // this.doShowAddressManager = true
    },
    paymentMethodSaveNew: function paymentMethodSaveNew(data) {
      this.payments.push(data);
      this.selectedPayment = this.payments.length - 1;
      this.doShowPaymentManager = false;
    },
    paymentMethodSaveExisting: function paymentMethodSaveExisting(data) {
      this.payments[this.selectedPaymentForEditing] = data;
      this.reactivator++;
      this.paymentMode = 'manage';
    },
    changePaymentSelected: function changePaymentSelected(index) {
      this.selectedPayment = index;
    },
    managePaymentPressed: function managePaymentPressed() {
      this.paymentMode = 'manage';
      this.doShowPaymentManager = true;
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.doShowPaymentManager = false;
    },

    //
    // SIGN IN
    signInPressed: function signInPressed() {
      this.doShowSignIn = true;
    },
    signInClosed: function signInClosed() {
      this.doShowSignIn = false;
    },
    loginPressed: function loginPressed() {
      this.addresses.push({
        name: 'Sam Bell',
        address1: '821 Washington St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10101',
        country: 'United States',
        phone: '11111111'
      });
      this.addresses.push({
        name: 'Sam Bell',
        address1: '1014 Lincoln St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10114',
        country: 'United States',
        phone: '222222222'
      });
      this.payments.push({
        name: 'Sam Bell',
        number: '1234 5678 1234 1235',
        month: '07',
        year: '20'
      });
      this.selectedAddress = 0;
      this.selectedPayment = 0;
      this.doShowSignIn = false;
    }
  },
  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "21Q6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("/xK5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75288d20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("jWPl");
function injectStyle (ssrContext) {
  __webpack_require__("ue8e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75288d20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75288d20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "21z6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"fixed flexy align-top",staticStyle:{"width":"50%","padding-right":"40px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("CUcu"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Payment information")]),_vm._v(" "),(_vm.selectedPayment === null)?_c('div',{staticStyle:{"padding-top":"12px"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"background-color":"#3a84e8"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add payment method")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"12px"}},[_c('button',{staticStyle:{"font-size":"13px","padding":"3px 8px","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.openSignIn()}}},[_vm._v("Sign in")]),_vm._v(" for 1-click checkout")])]):_c('div',{staticStyle:{"padding-top":"8px"}},[_c('div',[_vm._v(_vm._s(_vm.payments[_vm.selectedPayment].name))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.mutateCardNumber(_vm.payments[_vm.selectedPayment].number)))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.payments[_vm.selectedPayment].month)+" / "+_vm._s(_vm.payments[_vm.selectedPayment].year))]),_vm._v(" "),_c('div',{staticStyle:{"color":"transparent","width":"0","height":"0","overflow":"hidden"}},[_vm._v(_vm._s(_vm.reactivator))]),_vm._v(" "),_c('transition',{attrs:{"name":"popover"}},[(_vm.doShowMethodsList)?_c('div',[_c('div',{staticClass:"popover-curtain",on:{"click":function($event){_vm.doShowMethodsList=false}}}),_vm._v(" "),_c('div',{staticClass:"popover-content",on:{"click":function($event){$event.stopPropagation();_vm.doNothing($event)}}},[_vm._l((_vm.payments),function(payment,i){return _c('div',{key:i,staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":function($event){_vm.choosePressed(i)}}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('div',[_c('strong',[_vm._v(_vm._s(payment.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.month)+" / "+_vm._s(payment.year))])])])}),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px","margin-top":"4px"},on:{"click":_vm.addNewPaymentPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Add new payment")])])]),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":_vm.managePaymentPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Manage payment methods")])])])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.changePressed()}}},[_vm._v("\n            Change\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "23Cc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKgAAABKCAYAAAAvxx89AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAmmSURBVHgB7ZxNdhvFE8BrzH8dzP8AfgN7HIcDRBMOgA0HQGbDxwabE1g5gc0GXlhghQOQhAOgMQcgNuyR4ABJYB83VTMlezR0V3dLI40+6vdePyUz/d3V1dXVPQZQFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRlE0kgSkxxuzhTxfDexjexfBW5fUVhgGGiyRJnkbkt117PML0o1qcAwwP+NELKgNDH+O9cuR7iD8Zhrf50a8x9arltc15HXB+9yuvX2L4Hcp2P8X8LwPztLU7hlchZXHdqd53oRyzMVTfy5j+cNT5sjoGGCfDn/1KWTRWz6Dsm1cwL6hgDJcmnCGGg4B8rVTenwplvOBOq+a3x2W7GNTTeOrX43JCGfjyx/epaQBPGduBdaf3x+Dvh44j/aAS59xTziHMAyMLiY+eJ28rAQ2uNnyP4++ZMChN6qkXDXDMhLTWyZF3xzRAw3UfmFLbxtZ5wO+fmDC8SisKM5tweislpMlMODQYNChRmk6o0yzCOYbqsu3Iv2MaYA51v5yizgMMByYcZ79U2YIATGlPeNV/AKcQz0lEXLKvcpi0h33QBEgd7444z1l4i/NZNOcwfd0pXUy/j4kZX+qXfWgCI6vtcwy7HG8Hw4ln5uw5ymiTI0t9JE1Mz7sYdjjurpG1lXMTY2bX0ANLnpImG2LYN6Um7HrKzyx5dxxxr00859AEQgFHjvjnQpr9yDIIEogTU3bOkZE3P2OGHJfSnBp52T+x1KcrxN+1xL9jhHrB9H3v2xzuWNJcCvG3a3GlifjEknfHyFTHiibCUIg7gFkxpXawVkRI0xEqdeJII7Fbi7vjiT/EcKeWpmsi6mTcK4Fz1htBmGAKjN/+7lrSSBvEXmy9Tc38MX4B7dTiS2P1wtcH//NFQJ/Vb5gR2SRkM2T8mJbpHBbDFdUBJuv0F9Ypr9SnTg/j/FNL8xjT9CEQjP+Qy0g5AJcn2VlO/x4NHOZ5AYGYUtP9KEQhf+Jjy3PJrnP5Osk/6dpjUH5fQxh5vY2esfLuFbwCyoWMBSS4gxvkieN5Dm4BnX3pgKLd1N5qmx/C4iBN7RpAOhToOt5ljufgcujj89y4lXwG4QLqmgA5CPWSCBJQH6Y0pmnGjzdAzfq4IqFZ63g1glttOBO89FXDm9BQu03pjpPy+rC+QlRw7dyvYDqCDzOQoNOzGKYS0EoHUuVndcOsBOb2qJCWPLKzYlxZMeWk+PO9EOXMYyq46vU3yPwCk0e3Y1JokSgBZcEkGyyFxdHkrEwhEhZMss++hDkJZQ1paR+B4J80EUe3MVAfzPX8XCBIQHmQqOPaWLpb6RiCB5xs4BQWgCnddpkQZV9Y2ok3YT7QKtnG/iPsJAnKQXIJZ87v7iUM3N42Wll4qf0Z7MJJm5Qz4FtSlXZPvYniyXAmROnVvRmbgFeDmtLXljlekz30FawnZMq4ltr3Q6/TRdAX3pGrLUT4n8MciHGPNU2IBj0U3i3S7bIwKhsiG0+bFk5THhS4NpukrT+AADzL/32Q2YElJERAXR03EgznFFYbyTMhuWuiTRt20fWEKA8Ft5mNHNxlSbeH0tj8FkGIgLqWuRTcfCK8m8tOc4FYNyJss0paKrWkGW8+JT7CeBcc6Ejy2LNbl7S7dVUw8t3Mxn2bMYRukqzYOoobKw3UgfFcEl5yXIPpu2p2aHlGu/YUZO5XwjGX89yU9w16Fq0oCbzrOFPaRzRz42hKQgRUWtL61Q4y5ScDffDTaqMDGArv0uqZvilvA9H/fS64zPz39tcs90RTKH2if1QVBe/0c0eau6a8Ojn+8oDqRB4al0LJ2/YchAiodK5NttpLXn7IHqXZHeKLy4zlJs6ywDbfSIjSpfZSu0E+F69zUtN4TTj+bRd/e0J8mkikgenwfQDyxGrjovUEIQIackuaZmBdMEdCfBrUubhEGqTveU/ttWmeXEjz1yJOZNgtdAazcbgMflevgLI26UEcOZTatWd5RyZDtuxOZ/Y7xl6woEF94EhHn0YvbIPI/uk+TMeh4yrfwgnaJPFg9SAMOvF4QD45TpdX3tHA3V+hExHSkHlAvBGUk248qB9DuUqMoQONTzx5UPw+lJupLKkBpcbOoByHoInDZR6AvJpVGcFkO1YLvh1Nro7qJwV0xX9gys8rdhzpTjncEfIeGju7jvj7jvjS9z+ub6tEG9KUt8jPa3W85Py6jjS73C9dkNs8MFPY4+b2+y/qf6+taMovCs65vCoDHptOQLHjcm2fiAyNY3x5rGxpGrm3qyitMfWfvlHmi/l24lMTYpR8EbxUrw0qoEuC+Q4+BFO4i+RL4Ak8g9do037R7hHkomhFQFE7ZLg9o4E4Tz7z3vRea1AwD1EwyeGehieCl8nn8H/YAGY66pwaA2RMn+Lv0DxC5/WjuV20XWqw3ZfYB3SqlsakQ7WyiJv9S0FrSzxrjvGR5whr8jD5dGq/3UqCAnoM13wZYwue21YTjEOekY+gdmCCcTfCPGu1kcVSn8CPFY0wgvIT141f+uvghB7ghM74v1fYP6t+KyyIdpZ4pjD0k6Kjx47nFKpL/7crf690KmjiesyeVq/ALZJWBZRATUBHqR0Uyts/DlBq1B7Wboia42mxw11zaDKyPT7Edhd/nXoiwvXEzn5jBHSp7BjzDXyAg9O3bgJMcRT4A71HW3UtBqjQkkkx+Q7YxXRLAjm2s7ihX6wkWxNXALc3xQRaOkObB+3xfwZskhG+f7aKwioK5S09FMCb770mNpToB8U2++6erg1LuxNkX6nfBUOaNYGfSOOgAztfxtMWbguddZNgyt87XcNx3QlPZs6NMF/Dg01x0hNL76oguwwH5yjY90cCuwW/4O9zHMwLl/tmXqAw0abvbSyb7Oo9FkxPomKSfV3Vmjevqst7ZdnfFFbCl8Y72uMoQZ3IAAXAwG840COgzzkS+BO1Lf0bYrVRUZdruFf8pzwNoyX7HuafQuzfqWLBBLqO55hEha907APdMO1JrJSzd2ZBDWOEgvDnzf9CNGAsAYJ5E/VRYWMXl79tGnbdWdnTCN44kHaJ01rtcoU9fob1fhJidhTmgik+jXmM8Q9hA1n547JiEK9x8JJiE5HC8jG1x6Fwu70B9zZRc45Zq/PcirBm0KZmJY+CKU7Jnq2Lz7Yt1vbCQWGvvkb7cQvex3C3co7dcEGF1+CqEMjXuBy/ARd6j6A5NurCcnEz6Breudn4JBWhlQQ4udk5/802IbAL6w8+qlUURVEURVEURVEURVEURVEURVEUZaH8C4DG1xeRcG69AAAAAElFTkSuQmCC"

/***/ }),

/***/ "2JC2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['isPaymentFilled']
});

/***/ }),

/***/ "2TM5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"flexy align-top"},[_c('div',[_c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-vert-l padding-hor-xl"},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Shopping Cart")])]),_vm._v(" "),_c('transition-group',{attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.items),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item large",staticStyle:{"padding-top":"16px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('items', i)}}},[_c('img',{staticStyle:{"width":"40px","padding":"28px 0 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 24px 0 12px"}},[_c('div',{staticStyle:{"padding-top":"6px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"2px","font-size":"14px"}},[_vm._v(_vm._s(item.availability)+", "+_vm._s(item.seller))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"91px","padding-top":"6px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"72px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticStyle:{"min-width":"auto","width":"56px","background-color":"rgba(255,255,255,0.6)","padding":"4px 8px"},attrs:{"name":"quantity","id":"item-quantity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px","padding-top":"2px"}},[(!item.isXPressed)?_c('button',{on:{"click":function($event){_vm.xPressed(i)}}},[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1"},attrs:{"src":__webpack_require__("xLw2")}})]):_vm._e(),_vm._v(" "),(item.isXPressed)?_c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"90","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.xPressed(i)}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-xs rounded",staticStyle:{"position":"relative","width":"160px","transform":"translate(-136px, -16px)","z-index":"120","background-color":"white","box-shadow":"0px 4px 12px rgba(0,0,0,0.0.5)"}},[_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"7px 12px","color":"#409EFF","margin":"0"},on:{"click":function($event){_vm.saveForLaterPressed(i)}}},[_vm._v("Save for later")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"7px 12px","color":"#fd3737","margin":"0"},on:{"click":function($event){_vm.removeItemPressed(i)}}},[_vm._v("Remove from cart")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"7px 12px","color":"silver","margin":"0"},on:{"click":function($event){_vm.xPressed(i)}}},[_vm._v("Cancel")])])]):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"padding-vert-m",staticStyle:{"font-size":"12px","color":"#878D98"}},[_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("The price and availability of items at Amazon.com are subject to change. The Cart is a temporary place to store a list of your items and reflects each item's most recent price. Shopping Cart "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("Learn more")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("Do you have a gift card or promotional code? We'll ask you to enter your claim code when it's time to pay.")])])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[(_vm.later.length > 0)?_c('div',[_c('div',{staticClass:"padding-hor-xl",staticStyle:{"padding-top":"12px"}},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("You saved for later")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('transition-group',{staticClass:"flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.later),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item higher",staticStyle:{"width":"50%","padding-right":"32px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('later', i)}}},[_c('img',{staticStyle:{"width":"40px","padding":"28px 0 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 0 0 12px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"2px","font-size":"14px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"6px"}},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.addFromLaterPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","font-size":"13px","min-width":"88px","padding":"3px 0","border":"1px solid","border-radius":"4px","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',{staticClass:"padding-hor-xl",staticStyle:{"padding-top":"12px"}},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v(_vm._s(_vm.youRecentlyViewed))])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('transition-group',{staticClass:"flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.recent),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item higher",staticStyle:{"width":"50%","padding-right":"32px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('recent', i)}}},[_c('img',{staticStyle:{"width":"40px","padding":"28px 0 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 0 0 12px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"2px","font-size":"14px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"6px"}},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.addFromRecentPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","font-size":"13px","min-width":"88px","padding":"3px 0","border":"1px solid","border-radius":"4px","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',{staticClass:"padding-hor-xl",staticStyle:{"padding-top":"12px"}},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Customers also bought")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('transition-group',{staticClass:"flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.also),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item higher",staticStyle:{"width":"50%","padding-right":"32px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('also', i)}}},[_c('img',{staticStyle:{"width":"40px","padding":"28px 0 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 0 0 12px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"2px","font-size":"14px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"6px"}},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.addFromAlsoPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","font-size":"13px","min-width":"88px","padding":"3px 0","border":"1px solid","border-radius":"4px","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])])],1),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-xl padding-vert-m",staticStyle:{"width":"32%","background-color":"#F5F5F5","min-height":"100vh","position":"sticky","top":"0"}},[_c('div',{staticClass:"padding-hor-m"},[_c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900","padding-top":"8px"}},[_vm._v("Subtotal")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"16px","font-weight":"900"}},[_vm._v(_vm._s(_vm.cart.length)+" item"),(_vm.cart.length > 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(", "+_vm._s(_vm.subtotal)+" ")]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-top":"8px"}},[_c('input',{staticClass:"fixed",staticStyle:{"width":"16px","text-align":"left"},attrs:{"type":"checkbox","id":"gift"}}),_vm._v(" "),_c('label',{attrs:{"for":"gift"}},[_c('div',[_vm._v("This order contains a gift")])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('button',{staticClass:"boxed primary wide properBlue",staticStyle:{"background-color":"#3a84e8"},on:{"click":function($event){_vm.checkoutPressed()}}},[_vm._v("Proceed to Checkout")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"right-column-appear","appear":""}},[_c('div',{staticStyle:{"padding-top":"40px"}},[_c('div',{staticClass:"padding-vert-m padding-hor-xl bordered rounded silver",staticStyle:{"height":"400px","text-align":"center"}},[_c('img',{staticStyle:{"padding-top":"146px"},attrs:{"src":__webpack_require__("Kufr"),"width":"125px"}})])])])],1)])]),_vm._v(" "),(_vm.doShowPreview)?_c('QuickPreview',{attrs:{"selectedForPreview":_vm.selectedForPreview},on:{"close":function($event){_vm.doShowPreview = false},"addToCart":function($event){_vm.addedToCartFromPreview($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Zye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['selectedAddress', 'selectedPayment'],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.selectedAddress !== null && this.selectedPayment !== null;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "38TJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("ere0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0313c640_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("bPdM");
function injectStyle (ssrContext) {
  __webpack_require__("lLKV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0313c640"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0313c640_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Cz1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['selectedAddress', 'addresses', 'reactivator'],
  data: function data() {
    return {
      doShowAddressesList: false
    };
  },

  computed: {
    reactiveAddresses: function reactiveAddresses() {
      return this.addresses;
    }
  },
  methods: {
    addPressed: function addPressed() {
      this.$emit('add');
    },
    changePressed: function changePressed() {
      // if (this.selectedAddress !== null) {
      this.doShowAddressesList = true;
      // }
      // this.$emit('edit')
    },
    choosePressed: function choosePressed(index) {
      this.$emit('change', index);
      this.doShowAddressesList = false;
      //
    },
    addNewAddressPressed: function addNewAddressPressed() {
      this.doShowAddressesList = false;
      this.$emit('add');
    },
    manageAddressesPressed: function manageAddressesPressed() {
      this.doShowAddressesList = false;
      this.$emit('manage');
    },
    doNothing: function doNothing() {
      //
    },

    //
    openSignIn: function openSignIn() {
      this.$emit('signin');
    }
  }
});

/***/ }),

/***/ "3LxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Shipping Address")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"cardName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"cardNumber"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"fullName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"year"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Zis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("b1T5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a99560_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("XY0W");
function injectStyle (ssrContext) {
  __webpack_require__("itN+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23a99560"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a99560_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3dD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__ = __webpack_require__("5CwH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f81e10c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__ = __webpack_require__("xGe7");
function injectStyle (ssrContext) {
  __webpack_require__("oCfW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f81e10c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f81e10c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3fPZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_560df006_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("89O2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_560df006_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3hFP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l"},[_c('div',{staticClass:"padding-vert-l flexy align-top"},[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-l bordered rounded silver"},[_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-xs flexy align-top",attrs:{"id":'cart-item-' + i}},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openPreview('items', i)}}},[_c('button',{staticStyle:{"padding":"40px 12px","color":"white"}},[_vm._v("preview")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-right":"24px"}},[_c('div',{staticStyle:{"font-size":"17px"}},[_c('strong',[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey padding-vert-xs"},[_vm._v(_vm._s(item.availability)+", "+_vm._s(item.seller))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v("$ "+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticStyle:{"min-width":"auto","width":"60px","background-color":"rgba(255,255,255,0.6)"},attrs:{"name":"quantity","id":"item-quantity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"20px"},on:{"click":function($event){_vm.removeItemPressed(i)}}},[_c('button',[_vm._v("x")])])])}),_vm._v(" "),_c('div',{staticClass:"padding-vert-m flexy",staticStyle:{"border-top":"1px solid #eee"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('strong',[_vm._v("$ "+_vm._s(_vm.subtotal))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"120px"}},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.checkoutPressed()}}},[_vm._v("Checkout")])])])],2),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-l bordered rounded flexy",staticStyle:{"flex-wrap":"wrap"}},_vm._l((_vm.recent),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openPreview('recent', i)}}},[_c('button',{staticStyle:{"padding":"40px 12px","color":"white"}},[_vm._v("preview")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$ "+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary mid",on:{"click":function($event){_vm.addFromRecentPressed(i)}}},[_vm._v("Add to cart")])])])])}))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"320px","margin-left":"48px"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-l bordered rounded"},_vm._l((_vm.also),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openPreview('also', i)}}},[_c('button',{staticStyle:{"padding":"40px 12px","color":"white"}},[_vm._v("preview")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$ "+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary mid",on:{"click":function($event){_vm.addFromAlsoPressed(i)}}},[_vm._v("Add to cart")])])])])}))])]),_vm._v(" "),(_vm.doShowPreview)?_c('QuickPreview',{attrs:{"selectedForPreview":_vm.selectedForPreview},on:{"close":function($event){_vm.doShowPreview = false},"addToCart":function($event){_vm.addedToCartFromPreview($event)}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l"},[_c('h1',[_vm._v("Shopping Cart")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v("Subtotal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m padding-hor-l bordered rounded silver",staticStyle:{"height":"110px","text-align":"center"}},[_c('img',{attrs:{"src":__webpack_require__("Kufr"),"width":"125px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l"},[_c('h1',[_vm._v("You recently viewed")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l"},[_c('h1',[_vm._v("Customers also bought")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3tsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("BM8x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__ = __webpack_require__("rCbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__ = __webpack_require__("SdiO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Delivery__ = __webpack_require__("0ABa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__ = __webpack_require__("E5ka");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__ = __webpack_require__("zmbX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__ = __webpack_require__("dYqt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__ = __webpack_require__("ZGgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderSummary__ = __webpack_require__("+VEc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__ = __webpack_require__("mqCD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SignIn__ = __webpack_require__("cRFR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Start: __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
    ShoppingCart: __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__["a" /* default */],
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_3__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_8__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__["a" /* default */],
    SignIn: __WEBPACK_IMPORTED_MODULE_10__SignIn__["a" /* default */]
  },
  data: function data() {
    return {
      currentView: 'Start',
      chosenDelivery: '1',
      reactivator: 0,
      //
      addressMode: null,
      doShowAddressManager: false,
      selectedAddress: null,
      selectedAddressForEditing: null,
      addresses: [],
      //
      // isPaymentFilled: false,
      paymentMode: null,
      doShowPaymentManager: false,
      selectedPayment: null,
      selectedPaymentForEditing: null,
      payments: [],
      //
      doShowSignIn: false,
      //
      cart: [{
        name: 'Sprint: How to Solve Big Problems and Test New Ideas in Just Five Days',
        by: 'Jake Knapp',
        img: __webpack_require__("RVgH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.53,
        quantity: 1
      }, {
        name: 'Hooked: How to Build Habit-Forming Products',
        by: 'Nir Eyal',
        img: __webpack_require__("IBtq"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 18.56,
        quantity: 1
      }],
      alsoItems: [{
        name: 'The Lean Startup: How Today\'s Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses',
        by: 'Eric Ries',
        img: __webpack_require__("xcPX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.29,
        quantity: 1
      }, {
        name: 'The Hard Thing About Hard Things: Building a Business When There Are No Easy Answers',
        by: 'Ben Horowitz',
        img: __webpack_require__("fiE3"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 19.66,
        quantity: 1
      }, {
        name: 'Rework',
        by: 'Jason Fried',
        img: __webpack_require__("7fXA"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 17.68,
        quantity: 1
      }, {
        name: 'Remote: Office Not Required',
        by: 'Jason Fried',
        img: __webpack_require__("LhVL"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 15.59,
        quantity: 1
      }],
      recentItems: [{
        name: 'Beautiful Evidence',
        by: 'Edward R. Tufte',
        img: __webpack_require__("OEdX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 28.87,
        quantity: 1
      }, {
        name: 'About Face: The Essentials of Interaction Design',
        by: 'Alan Cooper',
        img: __webpack_require__("y+PD"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 36.47,
        quantity: 1
      }, {
        name: '100 Things Every Designer Needs to Know About People',
        by: 'Susan Weinschenk',
        img: __webpack_require__("P+u0"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 22.95,
        quantity: 1
      }, {
        name: 'HTML and CSS: Design and Build Websites',
        by: 'Jon Duckett',
        img: __webpack_require__("AqZH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.53,
        quantity: 1
      }],
      extraItems: [{
        name: 'Logo Design Love: A Guide to Creating Iconic Brand Identities, 2nd Edition',
        by: 'David Airey',
        img: __webpack_require__("WOmI"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.05,
        quantity: 1
      }, {
        name: 'Layout Essentials: 100 Design Principles for Using Grids (Design Essentials)',
        by: 'Beth Tondreau',
        img: __webpack_require__("Mvmb"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.76,
        quantity: 1
      }],
      laterItems: [{
        name: 'CSS: The Missing Manual',
        by: 'David Sawyer McFarland',
        img: __webpack_require__("PF3y"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 24.61,
        quantity: 1
      }, {
        name: 'The Principles of Beautiful Web Design: Designing Great Web Sites is Not Rocket Science!',
        by: 'Jason Beaird',
        img: __webpack_require__("jAj8"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.23,
        quantity: 1
      }]
    };
  },

  methods: {
    shoppingCartConfirmed: function shoppingCartConfirmed(items) {
      this.currentView = 'Checkout';
      this.cart = items;
    },
    shoppingCartUpdated: function shoppingCartUpdated(items) {
      this.cart = items;
    },

    //
    // ADDRESS
    addAddressPressed: function addAddressPressed() {
      this.addressMode = 'add';
      this.doShowAddressManager = true;
    },
    editAddressPressed: function editAddressPressed(index) {
      this.addressMode = 'edit';
      this.selectedAddressForEditing = index;
      // this.doShowAddressManager = true
    },
    deleteAddressPressed: function deleteAddressPressed(index) {
      if (index > 0) {
        this.selectedAddress = index - 1;
      } else {
        if (this.addresses.length === 1) {
          this.selectedAddress = null;
        } else {
          this.selectedAddress = index + 1;
        }
      }
      this.addresses.splice(index, 1);
      // this.selectedAddress = index
      // this.doShowAddressManager = true
    },
    shippingAddressSaveNew: function shippingAddressSaveNew(data) {
      this.addresses.push(data);
      this.selectedAddress = this.addresses.length - 1;
      this.doShowAddressManager = false;
    },
    shippingAddressSaveExisting: function shippingAddressSaveExisting(data) {
      this.addresses[this.selectedAddressForEditing] = data;
      this.reactivator++;
      this.addressMode = 'manage';
    },
    changeAddressSelected: function changeAddressSelected(index) {
      this.selectedAddress = index;
    },
    manageAddressPressed: function manageAddressPressed() {
      this.addressMode = 'manage';
      this.doShowAddressManager = true;
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.doShowAddressManager = false;
    },
    shippingAddressCancelledBackToManager: function shippingAddressCancelledBackToManager() {
      this.addressMode = 'manage';
    },

    //
    // PAYMENT
    addPaymentPressed: function addPaymentPressed() {
      this.paymentMode = 'add';
      this.doShowPaymentManager = true;
    },
    editPaymentPressed: function editPaymentPressed(index) {
      this.paymentMode = 'edit';
      this.selectedPaymentForEditing = index;
      // this.doShowAddressManager = true
    },
    deletePaymentPressed: function deletePaymentPressed(index) {
      if (index > 0) {
        this.selectedPayment = index - 1;
      } else {
        if (this.payments.length === 1) {
          this.selectedPayment = null;
        } else {
          this.selectedPayment = index + 1;
        }
      }
      this.payments.splice(index, 1);
      // this.selectedAddress = index
      // this.doShowAddressManager = true
    },
    paymentMethodSaveNew: function paymentMethodSaveNew(data) {
      this.payments.push(data);
      this.selectedPayment = this.payments.length - 1;
      this.doShowPaymentManager = false;
    },
    paymentMethodSaveExisting: function paymentMethodSaveExisting(data) {
      this.payments[this.selectedPaymentForEditing] = data;
      this.reactivator++;
      this.paymentMode = 'manage';
    },
    changePaymentSelected: function changePaymentSelected(index) {
      this.selectedPayment = index;
    },
    managePaymentPressed: function managePaymentPressed() {
      this.paymentMode = 'manage';
      this.doShowPaymentManager = true;
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.doShowPaymentManager = false;
    },
    paymentMethodCancelledBackToManager: function paymentMethodCancelledBackToManager() {
      this.paymentMode = 'manage';
    },

    //
    // SIGN IN
    signInPressed: function signInPressed() {
      this.doShowSignIn = true;
    },
    signInClosed: function signInClosed() {
      this.doShowSignIn = false;
    },
    loginPressed: function loginPressed() {
      this.addresses.push({
        name: 'Sam Bell',
        address1: '821 Washington St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10101',
        country: 'United States',
        phone: '+1 800 555 66 77'
      });
      this.addresses.push({
        name: 'Sam Bell',
        address1: '1014 Lincoln St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10114',
        country: 'United States',
        phone: '+1 800 555 00 11'
      });
      this.payments.push({
        name: 'Sam Bell',
        number: '1234 5678 1234 1235',
        month: '07',
        year: '20'
      });
      this.selectedAddress = 0;
      this.selectedPayment = 0;
      this.doShowSignIn = false;
    }
  },
  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "3vZv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  props: ['cart'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "42Rp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("yxel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a8c225e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("GK1g");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a8c225e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4DeO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Dwj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4E3C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("yF01");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a74a9b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("Zv25");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a74a9b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4F1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedAddress', 'mode', 'addresses'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      address1: { value: '', isValid: true, wasFocused: false },
      city: { value: '', isValid: true, wasFocused: false },
      state: { value: '', isValid: true, wasFocused: false },
      zip: { value: '', isValid: true, wasFocused: false },
      country: { value: '', isValid: true, wasFocused: false },
      phone: { value: '', isValid: true, wasFocused: false },
      //
      shouldComeBackToManager: false,
      //
      scrollable: null,
      didScroll: false,
      doesHaveScrollDown: false
    };
  },

  methods: {
    checkScrollPosition: function checkScrollPosition() {
      this.checkIfCanScroll();
      if (this.scrollable.scrollTop > 10) {
        this.didScroll = true;
      } else {
        this.didScroll = false;
      }
    },
    checkIfCanScroll: function checkIfCanScroll() {
      if (this.scrollable.scrollHeight > this.scrollable.clientHeight && this.scrollable.scrollTop + 10 < this.scrollable.scrollHeight - this.scrollable.clientHeight) {
        this.doesHaveScrollDown = true;
      } else {
        this.doesHaveScrollDown = false;
      }
    },
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      var data = {
        name: this.name.value,
        address1: this.address1.value,
        city: this.city.value,
        state: this.state.value,
        zip: this.zip.value,
        country: this.country.value,
        phone: this.phone.value
      };
      if (this.mode === 'add') {
        this.$emit('saveNew', data);
      } else {
        this.$emit('saveExisting', data);
      }
    },
    cancelPressed: function cancelPressed() {
      if (this.shouldComeBackToManager) {
        this.$emit('backToManager');
      } else {
        this.$emit('cancelled');
      }
    },
    addPressed: function addPressed() {
      var _this = this;

      setTimeout(function () {
        _this.checkIfCanScroll();
      }, 100);
      this.shouldComeBackToManager = false;
      this.$emit('add');
    },
    editSelectedPressed: function editSelectedPressed(index) {
      var _this2 = this;

      setTimeout(function () {
        _this2.checkIfCanScroll();
      }, 100);
      this.checkIfCanScroll();
      this.shouldComeBackToManager = true;
      this.$emit('edit', index);
      this.fillForm();
    },
    deleteSelectedPressed: function deleteSelectedPressed(index) {
      this.$emit('delete', index);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.address1.isValid = true;
      this.city.isValid = true;
      this.state.isValid = true;
      this.zip.isValid = true;
      this.country.isValid = true;
      this.phone.isValid = true;
      //
      this.name.wasFocused = false;
      this.address1.wasFocused = false;
      this.city.wasFocused = false;
      this.state.wasFocused = false;
      this.zip.wasFocused = false;
      this.country.wasFocused = false;
      this.phone.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.address1.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.address1.isValid = false;
      }
      if (this.city.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.city.isValid = false;
      }
      if (this.state.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.state.isValid = false;
      }
      if (this.zip.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.zip.isValid = false;
      }
      if (this.country.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.country.isValid = false;
      }
      if (this.phone.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.phone.isValid = false;
      }
      return hasErrors;
    },
    fillForm: function fillForm() {
      this.name = { value: this.addresses[this.selectedAddress].name, isValid: true, wasFocused: false };
      this.address1 = { value: this.addresses[this.selectedAddress].address1, isValid: true, wasFocused: false };
      this.city = { value: this.addresses[this.selectedAddress].city, isValid: true, wasFocused: false };
      this.state = { value: this.addresses[this.selectedAddress].state, isValid: true, wasFocused: false };
      this.zip = { value: this.addresses[this.selectedAddress].zip, isValid: true, wasFocused: false };
      this.country = { value: this.addresses[this.selectedAddress].country, isValid: true, wasFocused: false };
      this.phone = { value: this.addresses[this.selectedAddress].phone, isValid: true, wasFocused: false };
    }
  },
  watch: {
    selectedAddress: function selectedAddress() {
      this.fillForm();
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.mode === 'edit') {
      this.fillForm();
    }
    setTimeout(function () {
      _this3.scrollable = document.getElementById('watchMeScroll');
      _this3.checkIfCanScroll();
    }, 100);
  }
});

/***/ }),

/***/ "4T8Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['selectedAddress', 'selectedPayment', 'cart'
  // 'delivery'
  ],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.selectedAddress !== null && this.selectedPayment !== null;
    },
    cartSum: function cartSum() {
      var sum = 0;
      for (var i in this.cart) {
        sum += this.cart[i].price * this.cart[i].quantity;
      }
      return sum.toFixed(2);
    },
    deliveryPrice: function deliveryPrice() {
      switch (this.$store.getters.getChosenDelivery) {
        case '0':
          return 0;
        case '1':
          return 0;
        case '2':
          return 6.98;
        case '3':
          return 13.98;
        case '4':
          return 20.98;
        default:
          break;
      }
    },
    beforeTax: function beforeTax() {
      var beforeTaxTemp = 0;
      beforeTaxTemp = parseInt(this.cartSum) + this.deliveryPrice;
      return beforeTaxTemp.toFixed(2);
    },
    tax: function tax() {
      var taxTemp = 0;
      taxTemp = parseInt(this.beforeTax) * 0.18;
      return taxTemp.toFixed(2);
    },
    total: function total() {
      var totalTemp = 0;
      totalTemp = parseInt(this.beforeTax) + parseInt(this.tax);
      return totalTemp.toFixed(2);
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "4Y4D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4gyL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4hi8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4nVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("FJLW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14abbb6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("g+mz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14abbb6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4wU3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "51Xz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("p/ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f45434_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("aOiF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f45434_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "58A6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5CwH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  methods: {
    closePressed: function closePressed() {
      this.$emit('close');
    },
    loginPressed: function loginPressed() {
      this.$emit('login');
    }
  }
});

/***/ }),

/***/ "5F5F":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHCSURBVHgB7ZdBTsJAFIbflIUJK4/ASsKOiLEhrjiB4QRyBG8AN9Aj6A24gXFhqhIYFyZIXNAjsFWkY58hxEwYynszdeP7ki46aaf/l3bmvQIIgiAIgiAI/wet9WGSTGsQCJzLZ76IcnGip7WlqerKQTR/nszmviIj/d7HufB4HL9dAgOSQCVT+JDa+rSWP/iOK4HhjckGmyBK9YEBScCAWVhDLAk7/JoFMCAJxK3GwADcWsMkCVf45ZfqAgMFDJ4ms5v8xgtrOF19ZJ12u5G67tsRvnN2evQCDFgCCFWijPAIWwDZV6Ks8IiXAFIkUWZ4xFsAcUkopYbGGHt/DxYeCSKAOCRsgoZHggkgBRLBwyNBBZDRZKbzWtG0x00G3fikPoTAkApZET8Ldkt4REVwFbIJ3MwLgXDsNjaFxY5KkDfg2iqNAfuT8WoAt+EtsGufj1v1rm/vVITXJ7RvkeL2TvvAFqBW2LIkWALc9qAMCbKAb28TWoK0iEf5f6tvYxYf13uuhQ0MaL+UUXRuDbHaA5fEg35tAhGaQLa6/3Xq1dtskUirsEyBCHkNJONprwKqufo01yEqauj5BEEQBEH4S74B4XVz+BSFIfUAAAAASUVORK5CYII="

/***/ }),

/***/ "5GaQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5N6G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5ba9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e10ad00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("wmCO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e10ad00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5kT6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6/Y/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("wnP2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d87d776_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("mPFI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d87d776_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6DZd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6bJN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("GlC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc35dc3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("+z/p");
function injectStyle (ssrContext) {
  __webpack_require__("QDZD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc35dc3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6h8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-hor-xl padding-vert-m fixed",staticStyle:{"width":"32%","background-color":"#F5F5F5","min-height":"100vh","position":"sticky","top":"0","height":"100%"}},[_c('div',{staticClass:"padding-hor-m",staticStyle:{"padding-top":"20px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"24px"}},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"6px"}},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.98")])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"6px"}},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"24px"}},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"6px"}},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.87")])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"24px","font-weight":"900"}},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$96.85")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide properBlue",class:{properGrey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),_c('transition',{attrs:{"name":"alert"}},[(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m flexy align-top",staticStyle:{"position":"fixed","width":"340px","font-size":"13px","padding-left":"24px","padding-right":"12px","bottom":"80px","right":"32px","background-color":"white","box-shadow":"0px 4px 16px rgba(0,0,0,0.1)","border-radius":"0 6px 6px 0","border-left":"4px solid orange"}},[_c('div',[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"8px"}},[_c('ul',[(_vm.selectedAddress === null)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(_vm.selectedPayment === null)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px","margin-left":"12px"}},[_c('button',{on:{"click":function($event){_vm.showInstructions = false;}}},[_c('img',{staticClass:"button-icon dark",staticStyle:{"width":"16px","opacity":"1"},attrs:{"src":__webpack_require__("5F5F")}})])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m",staticStyle:{"font-size":"12px","color":"#878D98"}},[_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("By placing order, you agree to Amazon's "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("privacy notice")]),_vm._v(" and "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("conditions of use")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("How are shipping costs calculated?")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("You got free shipping on the eligible items in your order! ( "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("Why aren't all my items eligible?")]),_vm._v(")")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6hZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['isPaymentFilled'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "7Njw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['isShippingFilled'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "7d8l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7fXA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rework.674fecc.jpg";

/***/ }),

/***/ "8+ZI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['isShippingFilled', 'isPaymentFilled'],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.isShippingFilled && this.isPaymentFilled;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "89O2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8OTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-m fixed silver rounded",staticStyle:{"width":"300px"}},[_c('h3',[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide",class:{grey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('ul',[(!_vm.isShippingFilled)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentFilled)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.87")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$96.85")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8S4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "8Ug/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-hor-xl fixed",class:{shadowyBottom: _vm.didScroll},staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"24px","z-index":"200","transition":"all .4s"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[(_vm.mode === 'add')?_c('span',[_vm._v("New shipping address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('span',[_vm._v("Edit address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'manage')?_c('span',[_vm._v("Manage shipping addresses")]):_vm._e()]),_vm._v(" "),(this.mode === 'manage')?_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.$emit('cancelled')}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl",class:{roundBottom: _vm.mode === 'manage'},staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"","padding-bottom":"12px"},attrs:{"id":"watchMeScroll"},on:{"scroll":_vm.checkScrollPosition}},[(this.mode === 'manage')?_c('div',[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"flexy",staticStyle:{"padding":"12px 0"}},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"#409EFF"},on:{"click":function($event){_vm.editSelectedPressed(i)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"silver"},on:{"click":function($event){_vm.deleteSelectedPressed(i)}}},[_vm._v("Delete")])])])}),_vm._v(" "),_c('div',{staticClass:"clickable flexy",staticStyle:{"padding":"24px 0","color":"#409EFF","font-weight":"500","font-size":"14px"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("\n            Add new address\n          ")])],2):_vm._e(),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1.value),expression:"address1.value"}],class:{errorInputHighlight: !_vm.address1.isValid && !_vm.address1.wasFocused},attrs:{"type":"text","name":"","id":"addressLine1"},domProps:{"value":(_vm.address1.value)},on:{"focus":function($event){_vm.address1.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address1, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.address1.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.address1.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city.value),expression:"city.value"}],class:{errorInputHighlight: !_vm.city.isValid && !_vm.city.wasFocused},attrs:{"type":"text","name":"","id":"city"},domProps:{"value":(_vm.city.value)},on:{"focus":function($event){_vm.city.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.city, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.city.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.city.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],class:{errorInputHighlight: !_vm.state.isValid && !_vm.state.wasFocused},attrs:{"type":"text","name":"","id":"state"},domProps:{"value":(_vm.state.value)},on:{"focus":function($event){_vm.state.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.state.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.state.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country.value),expression:"country.value"}],class:{errorInputHighlight: !_vm.country.isValid && !_vm.country.wasFocused},on:{"focus":function($event){_vm.country.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.country, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose country...")]),_vm._v(" "),_c('option',{attrs:{"value":"United States"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"Mexico"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"Canada"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"Brazil"}},[_vm._v("Brazil")])]),_vm._v(" "),(!_vm.country.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.country.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zip.value),expression:"zip.value"}],class:{errorInputHighlight: !_vm.zip.isValid && !_vm.zip.wasFocused},attrs:{"type":"text","name":"","id":"zip"},domProps:{"value":(_vm.zip.value)},on:{"focus":function($event){_vm.zip.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zip, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.zip.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.zip.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone.value),expression:"phone.value"}],class:{errorInputHighlight: !_vm.phone.isValid && !_vm.phone.wasFocused},attrs:{"type":"text","name":"","id":"phone"},domProps:{"value":(_vm.phone.value)},on:{"focus":function($event){_vm.phone.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.phone, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.phone.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.phone.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',{staticClass:"fixed padding-hor-xl padding-vert-m",class:{shadowyTop: _vm.doesHaveScrollDown},staticStyle:{"z-index":"200","background-color":"white","text-align":"right","border-radius":"0 0 10px 10px","transition":"all .4s"}},[_c('button',{staticClass:"boxed primary properGrey",staticStyle:{"margin-right":"4px"},on:{"click":function($event){_vm.cancelPressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary properBlue",staticStyle:{"min-width":"120px"},on:{"click":function($event){_vm.savePressed()}}},[_vm._v("Save")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Yzh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedAddress', 'mode', 'addresses'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      address1: { value: '', isValid: true, wasFocused: false },
      city: { value: '', isValid: true, wasFocused: false },
      state: { value: '', isValid: true, wasFocused: false },
      zip: { value: '', isValid: true, wasFocused: false },
      country: { value: '', isValid: true, wasFocused: false },
      phone: { value: '', isValid: true, wasFocused: false },
      //
      shouldComeBackToManager: false
    };
  },

  methods: {
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      var data = {
        name: this.name.value,
        address1: this.address1.value,
        city: this.city.value,
        state: this.state.value,
        zip: this.zip.value,
        country: this.country.value,
        phone: this.phone.value
      };
      if (this.mode === 'add') {
        this.$emit('saveNew', data);
      } else {
        this.$emit('saveExisting', data);
      }
    },
    editSelectedPressed: function editSelectedPressed(index) {
      this.shouldComeBackToManager = true;
      this.$emit('edit', index);
      this.fillForm();
    },
    deleteSelectedPressed: function deleteSelectedPressed(index) {
      this.$emit('delete', index);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.address1.isValid = true;
      this.city.isValid = true;
      this.state.isValid = true;
      this.zip.isValid = true;
      this.country.isValid = true;
      this.phone.isValid = true;
      //
      this.name.wasFocused = false;
      this.address1.wasFocused = false;
      this.city.wasFocused = false;
      this.state.wasFocused = false;
      this.zip.wasFocused = false;
      this.country.wasFocused = false;
      this.phone.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.address1.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.address1.isValid = false;
      }
      if (this.city.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.city.isValid = false;
      }
      if (this.state.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.state.isValid = false;
      }
      if (this.zip.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.zip.isValid = false;
      }
      if (this.country.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.country.isValid = false;
      }
      if (this.phone.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.phone.isValid = false;
      }
      return hasErrors;
    },
    fillForm: function fillForm() {
      this.name = { value: this.addresses[this.selectedAddress].name, isValid: true, wasFocused: false };
      this.address1 = { value: this.addresses[this.selectedAddress].address1, isValid: true, wasFocused: false };
      this.city = { value: this.addresses[this.selectedAddress].city, isValid: true, wasFocused: false };
      this.state = { value: this.addresses[this.selectedAddress].state, isValid: true, wasFocused: false };
      this.zip = { value: this.addresses[this.selectedAddress].zip, isValid: true, wasFocused: false };
      this.country = { value: this.addresses[this.selectedAddress].country, isValid: true, wasFocused: false };
      this.phone = { value: this.addresses[this.selectedAddress].phone, isValid: true, wasFocused: false };
    }
  },
  watch: {
    selectedAddress: function selectedAddress() {
      this.fillForm();
    }
  },
  created: function created() {
    if (this.mode === 'edit') {
      this.fillForm();
    }
  }
});

/***/ }),

/***/ "8lUr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "94xr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "95Jx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATzSURBVHgB7Zz9UdtMEMaXjz8ZMBW8eiuIU0GUCiAV4FRAUgFQAaSCOBXEVIBTQUgFIRXYfMwwAwPk2ckp43hOQjqdtMJ+fjMahHSSkn3u9m737hAhhBBCCCGEEEIIIYQQsoRcXV096SEtsSrEFApgDAUwhgIYQwGMoQDGUABjKIAxFMAYCmAMBTBmXV4gNzc3/YeHh3RlZeXV09NTH5d6OO/pz6wMrl/gmh7nj4+Pv9bW1sYbGxvn0jFW5AUwmUx66+vrfRh1D7/uyoyhKzLFMcJxurm5OfIVyBJxuN+KbTotAAyfwPB7MPwHCTd6Hhc4xmhJR9vb2xfZRQoArq+vUxj9AKeptMMwE2KpBdAaD1+thh+IDcPs20slgPPx+w25miDaEsB8FOTczWcciSwhpgLA+Meu1tcG79ERztT9mg1LO4+JAM7Xa61PJRA1OIw8Quf5Db+OZ0cy2Tfwo7+6urqLcnvSUVrvA2CYPoz/FaeJBALjHyG4OoHRp2XKqxgQYgAhDqQkC9kJI4LdU8NJYEer0S2efwfDB0W0TogzCJE8V7YtAVrLBcHfH8B4Qwk3vqYUXocaX1E3pe/Qd0lHaEUANT7+04cSiKv5b8u6nCL0HfqurojQeDOLaPyLvDKuXzlwiTnRJBzOT/HcKO85NxD4LjktciFcUF3jKzDmUZHxFXVL+M439e3Ov2um9BgG/qn/hpxnVKQjMaYxldHh7rsONxit/VtbW/+XLX95eXkCw+97bg1Ro9/7nkHuZyKeVvCiW4A277rGd3yqUrjgmwMN+nw3IHKlb8SmEQHQ9M8kAjDouEr5IlelETcqRur5xlAMiS4AmvRAagRZM0yrDjk1qVd0X6Pi+WtOtNqjq1CaaAGxwv7Kw0S0vN2i++gfdiTSt2LRhACpRAAu47JKeZf7eS7VkOR865cY0YQAUZozauvEdx0u7rMz9l80pe36nUTCvrUlRjSRDdXmnEpNsqDKgxp7ACHGrlxSdi6hIPo1S11HbwEagUoE8hJmM+9P5U/AlUj5d+YJ0BcjogugwzoNoKQ+vdvb2/887x9JIDrxPn/NubPFaQEu2fVOInB3d/fe8/5xSPCkaQdfnAB3loohjYXbqFkDnfWSekyREtj23UDaYVh2pgvG/4KUxsB3D33JT/F03i8+GYfaNoyQ7OrB0N45YzXoc+/XaUstU2B8vZ6IIY2rDAMeVpkK9DCF735dlFZ287472WhIO1uc/yiatnTp6Nyh60JNSdYVwc2GRZmQUTRl4eYCkrwyCzUlCRdwWMcdQTxd3XD2XK6nDG4RWHDQFpvW5oSdCB8lEBVBa+18FFyFbBasIMhrnVY3aECEE/XnNeKExM1yHVcRQmu9zozps9KRmp9hsjbUdZxftVZLPYY4TiHq+XwnjSAuub+/T3H6RgL2FCzF4twII6R/yFrW/G6ZEJZmdXSVxVJtsnALs/JQ16ET711YoWBBZ3ZJ6igJvlyF+CJ2BCf6QunUNlXXGgYGQuhesbdwO1GSiFUw7wOKcP3DIU7fxO4j3H6CT5o+5ya9EkCMXbeqYSd088XMngJtXee+1AYFKIGuBYUYKU4Tt1k7mW0hM7tlpjOJuXGZZS5tC0Dm4F9NXDIogDEUwBgKYAwFMIYCGEMBjKEAxlAAYyiAMRTAGApgDAUghBBCCCGEEEIIIYQQ0gK/Ad0Xq8XNFl30AAAAAElFTkSuQmCC"

/***/ }),

/***/ "98UA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "99Cl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("LrT4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13afe69c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("+Iun");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13afe69c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Aai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("8S4N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3319dd8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("SuVL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3319dd8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9S4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9YTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedAddress'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      address1: { value: '', isValid: true, wasFocused: false },
      // address2: '',
      city: { value: '', isValid: true, wasFocused: false },
      state: { value: '', isValid: true, wasFocused: false },
      zip: { value: '', isValid: true, wasFocused: false },
      country: { value: '', isValid: true, wasFocused: false },
      phone: { value: '', isValid: true, wasFocused: false }
    };
  },

  methods: {
    savePressed: function savePressed() {
      var data = {
        name: this.name.value,
        address1: this.address1.value,
        // address2: this.address2,
        city: this.city.value,
        state: this.state.value,
        zip: this.zip.value,
        country: this.country.value,
        phone: this.phone.value
      };
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      this.$emit('confirmed', data);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.address1.isValid = true;
      this.city.isValid = true;
      this.state.isValid = true;
      this.zip.isValid = true;
      this.country.isValid = true;
      this.phone.isValid = true;
      //
      this.name.wasFocused = false;
      this.address1.wasFocused = false;
      this.city.wasFocused = false;
      this.state.wasFocused = false;
      this.zip.wasFocused = false;
      this.country.wasFocused = false;
      this.phone.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.address1.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.address1.isValid = false;
      }
      if (this.city.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.city.isValid = false;
      }
      if (this.state.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.state.isValid = false;
      }
      if (this.zip.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.zip.isValid = false;
      }
      if (this.country.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.country.isValid = false;
      }
      if (this.phone.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.phone.isValid = false;
      }
      return hasErrors;
    }
  },
  created: function created() {
    if (this.selectedAddress !== null) {
      this.name = { value: this.selectedAddress.name, isValid: true, wasFocused: false };
      this.address1 = { value: this.selectedAddress.address1, isValid: true, wasFocused: false
        // this.address2 = this.selectedAddress.address2
      };this.city = { value: this.selectedAddress.city, isValid: true, wasFocused: false };
      this.state = { value: this.selectedAddress.state, isValid: true, wasFocused: false };
      this.zip = { value: this.selectedAddress.zip, isValid: true, wasFocused: false };
      this.country = { value: this.selectedAddress.country, isValid: true, wasFocused: false };
      this.phone = { value: this.selectedAddress.phone, isValid: true, wasFocused: false };
    }
  }
});

/***/ }),

/***/ "9gs6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("vc5r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2812f8ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("BIXo");
function injectStyle (ssrContext) {
  __webpack_require__("El9d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2812f8ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2812f8ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A8d0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("kaQ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a380a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("GxRr");
function injectStyle (ssrContext) {
  __webpack_require__("EiFi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a380a7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a380a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AFMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"menu-button-container"},[_c('button',{staticClass:"round text-grey",class:{fab: _vm.$route.name === 'HelloWorld'},staticStyle:{"background-color":"white","box-shadow":"0px 4px 16px rgba(0,0,0,0.1)"},on:{"click":function($event){_vm.openManager()}}},[(_vm.isHome)?_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"0.6"},attrs:{"src":__webpack_require__("RMmP")}}):_c('span',[_vm._v(_vm._s(_vm.selectedVersion))])])]),_vm._v(" "),_c('transition',{attrs:{"name":"toggleShade"}},[(_vm.toggleManager)?_c('div',{staticClass:"shade",on:{"click":function($event){_vm.toggleManager = !_vm.toggleManager}}}):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"toggleManager"}},[(_vm.toggleManager)?_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-m prototype-header",class:{shadowy: _vm.didScroll},staticStyle:{"flex":"0 0 auto","min-height":"56px","z-index":"100","transition":"all .4s"}},[_c('h3',{staticStyle:{"font-size":"22px","padding-left":"8px"}},[_vm._v("Prototype manager")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px","height":"24px"},on:{"click":function($event){_vm.toggleManager = !_vm.toggleManager}}},[_c('button',[_c('img',{staticClass:"button-icon dark",attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto","overflow-y":"scroll"},attrs:{"id":"watchMeScroll"},on:{"scroll":_vm.checkScrollPosition}},[_c('ul',{staticClass:"list borderless",staticStyle:{"margin-top":"24px"}},[_c('li',{class:{selected: _vm.$route.name === 'HelloWorld'},on:{"click":function($event){_vm.goHome()}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("Home")]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Project Meta")])])])]),_vm._v(" "),_vm._l((_vm.managerProps.iterations),function(iteration,i){return _c('div',{key:i},[_c('div',{},[_c('h4',[_vm._v(_vm._s(iteration.description))])]),_vm._v(" "),_c('ul',{staticClass:"list borderless"},_vm._l((iteration.versions),function(version,j){return _c('li',{key:j,class:{selected: _vm.isSelected(iteration.name,version.name)},on:{"click":function($event){_vm.openPrototype(iteration.name,version.name)}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(iteration.name)+_vm._s(version.name))]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(version.description))])])])}))])})],2)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ATFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: null,
      showFullDescription: false,
      selectedFormat: 'kindle',
      selectedTab: 'description',
      isBeingAddedToCart: false
    };
  },

  props: ['selectedForPreview'],
  methods: {
    closePressed: function closePressed() {
      this.$emit('close');
    },
    doThis: function doThis() {
      console.log('hi');
    },
    addPressed: function addPressed() {
      var _this = this;

      this.isBeingAddedToCart = true;
      setTimeout(function () {
        _this.$emit('addToCart', _this.item);
      }, 500);
    }
  },
  created: function created() {
    this.item = this.selectedForPreview;
  }
});

/***/ }),

/***/ "AjtT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Payment Method")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"cardName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"cardNumber"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"fullName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"year"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Amz6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"border-bottom":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","border-radius":"10px 10px 0 0"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[_vm._v("Payment information")])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"16px","padding-bottom":"40px"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"cardName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n            Shouldn't be empty\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number.value),expression:"number.value"}],class:{errorInputHighlight: !_vm.number.isValid && !_vm.number.wasFocused},attrs:{"type":"text","name":"","id":"cardNumber"},domProps:{"value":(_vm.number.value)},on:{"focus":function($event){_vm.number.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.number, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.number.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.number.wasFocused}},[_vm._v("\n            Shouldn't be empty\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month.value),expression:"month.value"}],class:{errorInputHighlight: !_vm.month.isValid && !_vm.month.wasFocused},on:{"focus":function($event){_vm.month.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.month, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose month...")]),_vm._v(" "),_c('option',[_vm._v("01")]),_vm._v(" "),_c('option',[_vm._v("02")]),_vm._v(" "),_c('option',[_vm._v("03")]),_vm._v(" "),_c('option',[_vm._v("04")]),_vm._v(" "),_c('option',[_vm._v("05")]),_vm._v(" "),_c('option',[_vm._v("06")]),_vm._v(" "),_c('option',[_vm._v("07")]),_vm._v(" "),_c('option',[_vm._v("08")]),_vm._v(" "),_c('option',[_vm._v("09")]),_vm._v(" "),_c('option',[_vm._v("10")]),_vm._v(" "),_c('option',[_vm._v("11")]),_vm._v(" "),_c('option',[_vm._v("12")])]),_vm._v(" "),(!_vm.month.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.month.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year.value),expression:"year.value"}],class:{errorInputHighlight: !_vm.year.isValid && !_vm.year.wasFocused},on:{"focus":function($event){_vm.year.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.year, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose year...")]),_vm._v(" "),_c('option',[_vm._v("17")]),_vm._v(" "),_c('option',[_vm._v("18")]),_vm._v(" "),_c('option',[_vm._v("19")]),_vm._v(" "),_c('option',[_vm._v("20")]),_vm._v(" "),_c('option',[_vm._v("21")]),_vm._v(" "),_c('option',[_vm._v("22")]),_vm._v(" "),_c('option',[_vm._v("23")]),_vm._v(" "),_c('option',[_vm._v("24")]),_vm._v(" "),_c('option',[_vm._v("25")]),_vm._v(" "),_c('option',[_vm._v("26")]),_vm._v(" "),_c('option',[_vm._v("27")])]),_vm._v(" "),(!_vm.year.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.year.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",staticStyle:{"border-top":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","padding-top":"10px","text-align":"right","border-radius":"0 0 10px 10px"}},[_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary",staticStyle:{"min-width":"120px"},on:{"click":_vm.savePressed}},[_vm._v("Save")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AqZH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/html.efee64d.jpg";

/***/ }),

/***/ "B6lM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEyl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
    };
  }
});

/***/ }),

/***/ "BIXo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Shipping Address")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"fullName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"addressLine1"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine2"}},[_vm._v("Address Line 2")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"addressLine2"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"city"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"state"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"zip"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',[_c('option',{attrs:{"value":"volvo"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"saab"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"mercedes"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"audi"}},[_vm._v("Brazil")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"phone"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BM8x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27deb0d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("svPt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27deb0d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BMjb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378d85c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("9S4n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378d85c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BbUQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("U1kL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b4b6bbf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("sbM0");
function injectStyle (ssrContext) {
  __webpack_require__("qgrU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b4b6bbf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b4b6bbf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bhh6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3238b078_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("IxyL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3238b078_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BslS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  // props: [
  //   'cart'
  // ],
  data: function data() {
    return {};
  },

  computed: {
    cart: function cart() {
      return this.$store.getters.getCart;
    }
  },
  methods: {
    editPressed: function editPressed() {
      // window.scroll({
      //   top: 0,
      //   left: 0,
      //   behavior: 'smooth'
      // })
      // this.$emit('edit')
      this.$router.push({ name: 'ShoppingCart' });
    }
  }
});

/***/ }),

/***/ "C1EQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("3vZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_917dbb04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("c8IJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_917dbb04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CKiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("yIPt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f7a72e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("R0Mz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f7a72e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CTio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_B3_vue__ = __webpack_require__("IWN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a0e1ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_B3_vue__ = __webpack_require__("Ni2v");
function injectStyle (ssrContext) {
  __webpack_require__("Sbt8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14a0e1ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_B3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a0e1ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_B3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CUcu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "CsoH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a2e5fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("yR8Z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a2e5fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CySp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/envision.3a328fc.jpg";

/***/ }),

/***/ "D/U2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-hor-xl fixed",class:{shadowyBottom: _vm.didScroll},staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"24px","z-index":"200","transition":"all .4s"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[(_vm.mode === 'add')?_c('span',[_vm._v("New payment information")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('span',[_vm._v("Edit payment information")]):_vm._e(),_vm._v(" "),(_vm.mode === 'manage')?_c('span',[_vm._v("Manage payment information")]):_vm._e()]),_vm._v(" "),(this.mode === 'manage')?_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.$emit('cancelled')}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl",class:{roundBottom: _vm.mode === 'manage'},staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"","padding-bottom":"12px"},attrs:{"id":"watchMeScroll"},on:{"scroll":_vm.checkScrollPosition}},[(this.mode === 'manage')?_c('div',[_vm._l((_vm.payments),function(payment,i){return _c('div',{key:i,staticClass:"flexy",staticStyle:{"padding":"12px 0"}},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(payment.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.month)+" / "+_vm._s(payment.year))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"#409EFF"},on:{"click":function($event){_vm.editSelectedPressed(i)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"silver"},on:{"click":function($event){_vm.deleteSelectedPressed(i)}}},[_vm._v("Delete")])])])}),_vm._v(" "),_c('div',{staticClass:"clickable flexy",staticStyle:{"padding":"24px 0 12px","color":"#409EFF","font-weight":"500","font-size":"14px"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("\n            Add new payment method\n          ")])],2):_vm._e(),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"cardName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number.value),expression:"number.value"}],class:{errorInputHighlight: !_vm.number.isValid && !_vm.number.wasFocused},attrs:{"type":"text","name":"","id":"cardNumber"},domProps:{"value":(_vm.number.value)},on:{"focus":function($event){_vm.number.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.number, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.number.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.number.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month.value),expression:"month.value"}],class:{errorInputHighlight: !_vm.month.isValid && !_vm.month.wasFocused},on:{"focus":function($event){_vm.month.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.month, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose month...")]),_vm._v(" "),_c('option',[_vm._v("01")]),_vm._v(" "),_c('option',[_vm._v("02")]),_vm._v(" "),_c('option',[_vm._v("03")]),_vm._v(" "),_c('option',[_vm._v("04")]),_vm._v(" "),_c('option',[_vm._v("05")]),_vm._v(" "),_c('option',[_vm._v("06")]),_vm._v(" "),_c('option',[_vm._v("07")]),_vm._v(" "),_c('option',[_vm._v("08")]),_vm._v(" "),_c('option',[_vm._v("09")]),_vm._v(" "),_c('option',[_vm._v("10")]),_vm._v(" "),_c('option',[_vm._v("11")]),_vm._v(" "),_c('option',[_vm._v("12")])]),_vm._v(" "),(!_vm.month.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.month.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year.value),expression:"year.value"}],class:{errorInputHighlight: !_vm.year.isValid && !_vm.year.wasFocused},on:{"focus":function($event){_vm.year.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.year, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose year...")]),_vm._v(" "),_c('option',[_vm._v("17")]),_vm._v(" "),_c('option',[_vm._v("18")]),_vm._v(" "),_c('option',[_vm._v("19")]),_vm._v(" "),_c('option',[_vm._v("20")]),_vm._v(" "),_c('option',[_vm._v("21")]),_vm._v(" "),_c('option',[_vm._v("22")]),_vm._v(" "),_c('option',[_vm._v("23")]),_vm._v(" "),_c('option',[_vm._v("24")]),_vm._v(" "),_c('option',[_vm._v("25")]),_vm._v(" "),_c('option',[_vm._v("26")]),_vm._v(" "),_c('option',[_vm._v("27")])]),_vm._v(" "),(!_vm.year.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.year.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])])]):_vm._e()]),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',{staticClass:"fixed padding-hor-xl padding-vert-m",class:{shadowyTop: _vm.doesHaveScrollDown},staticStyle:{"z-index":"200","background-color":"white","text-align":"right","border-radius":"0 0 10px 10px","transition":"all .4s"}},[_c('button',{staticClass:"boxed primary properGrey",staticStyle:{"margin-right":"4px"},on:{"click":function($event){_vm.cancelPressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary properBlue",staticStyle:{"min-width":"120px"},on:{"click":_vm.savePressed}},[_vm._v("Save")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D4mk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shipping address")]),_vm._v(" "),(!_vm.isShippingFilled)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add shipping address")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Sam Bell")]),_vm._v(" "),_c('div',[_vm._v("821 Washington St")]),_vm._v(" "),_c('div',[_vm._v("Ashland, Illinois, United States")]),_vm._v(" "),_c('div',[_vm._v("1 555 374 82 96")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DBC8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DfNI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DmS9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-m black flexy",staticStyle:{"height":"80px"}},[_c('div',[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'Start'}}},[_vm._v("Amazon ")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px"}},[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_vm._v("Cart")])])]),_vm._v(" "),(_vm.currentView === 'Start')?_c('Start'):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShoppingCart')?_c('ShoppingCart',{attrs:{"cart":_vm.cart,"alsoItems":_vm.alsoItems,"recentItems":_vm.recentItems,"extraItems":_vm.extraItems},on:{"confirmed":function($event){_vm.shoppingCartConfirmed($event)}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShippingAddress')?_c('ShippingAddress',{on:{"confirmed":function($event){_vm.shippingAddressConfirmed()},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'PaymentMethod')?_c('PaymentMethod',{on:{"confirmed":function($event){_vm.paymentMethodConfirmed()},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ExtraSignup')?_c('ExtraSignup'):_vm._e(),_vm._v(" "),(_vm.currentView === 'Checkout')?_c('div',{attrs:{"id":"checkout"}},[_c('div',{staticClass:"padding-hor-l"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flexy align-top"},[_c('div',[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{attrs:{"isShippingFilled":_vm.isShippingFilled},on:{"edit":function($event){_vm.currentView = 'ShippingAddress'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('PaymentMethodMin',{attrs:{"isPaymentFilled":_vm.isPaymentFilled},on:{"edit":function($event){_vm.currentView = 'PaymentMethod'}}})],1),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch"},[_c('ShoppingCartMin',{attrs:{"cart":_vm.cart},on:{"edit":function($event){_vm.currentView = 'ShoppingCart'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('Delivery',{attrs:{"chosenDelivery":_vm.chosenDelivery}})],1)]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('OrderSummary',{attrs:{"isShippingFilled":_vm.isShippingFilled,"isPaymentFilled":_vm.isPaymentFilled},on:{"placed":function($event){_vm.currentView = 'ExtraSignup'}}})],1)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l flexy"},[_c('h1',[_vm._v("Checkout")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E5ka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("4F1G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff4c93c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("EB37");
function injectStyle (ssrContext) {
  __webpack_require__("QetE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff4c93c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff4c93c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EB37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-hor-xl fixed",class:{shadowyBottom: _vm.didScroll},staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"24px","z-index":"200","transition":"all .4s"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[(_vm.mode === 'add')?_c('span',[_vm._v("New shipping address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('span',[_vm._v("Edit address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'manage')?_c('span',[_vm._v("Manage shipping addresses")]):_vm._e()]),_vm._v(" "),(this.mode === 'manage')?_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.$emit('cancelled')}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl",class:{roundBottom: _vm.mode === 'manage'},staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"","padding-bottom":"12px"},attrs:{"id":"watchMeScroll"},on:{"scroll":_vm.checkScrollPosition}},[(this.mode === 'manage')?_c('div',[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"flexy",staticStyle:{"padding":"12px 0"}},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"#409EFF"},on:{"click":function($event){_vm.editSelectedPressed(i)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"silver"},on:{"click":function($event){_vm.deleteSelectedPressed(i)}}},[_vm._v("Delete")])])])}),_vm._v(" "),_c('div',{staticClass:"clickable flexy",staticStyle:{"padding":"24px 0","color":"#409EFF","font-weight":"500","font-size":"14px"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("\n            Add new address\n          ")])],2):_vm._e(),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1.value),expression:"address1.value"}],class:{errorInputHighlight: !_vm.address1.isValid && !_vm.address1.wasFocused},attrs:{"type":"text","name":"","id":"addressLine1"},domProps:{"value":(_vm.address1.value)},on:{"focus":function($event){_vm.address1.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address1, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.address1.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.address1.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city.value),expression:"city.value"}],class:{errorInputHighlight: !_vm.city.isValid && !_vm.city.wasFocused},attrs:{"type":"text","name":"","id":"city"},domProps:{"value":(_vm.city.value)},on:{"focus":function($event){_vm.city.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.city, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.city.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.city.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],class:{errorInputHighlight: !_vm.state.isValid && !_vm.state.wasFocused},attrs:{"type":"text","name":"","id":"state"},domProps:{"value":(_vm.state.value)},on:{"focus":function($event){_vm.state.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.state.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.state.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country.value),expression:"country.value"}],class:{errorInputHighlight: !_vm.country.isValid && !_vm.country.wasFocused},on:{"focus":function($event){_vm.country.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.country, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose country...")]),_vm._v(" "),_c('option',{attrs:{"value":"United States"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"Mexico"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"Canada"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"Brazil"}},[_vm._v("Brazil")])]),_vm._v(" "),(!_vm.country.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.country.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zip.value),expression:"zip.value"}],class:{errorInputHighlight: !_vm.zip.isValid && !_vm.zip.wasFocused},attrs:{"type":"text","name":"","id":"zip"},domProps:{"value":(_vm.zip.value)},on:{"focus":function($event){_vm.zip.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zip, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.zip.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.zip.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone.value),expression:"phone.value"}],class:{errorInputHighlight: !_vm.phone.isValid && !_vm.phone.wasFocused},attrs:{"type":"text","name":"","id":"phone"},domProps:{"value":(_vm.phone.value)},on:{"focus":function($event){_vm.phone.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.phone, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.phone.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.phone.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',{staticClass:"fixed padding-hor-xl padding-vert-m",class:{shadowyTop: _vm.doesHaveScrollDown},staticStyle:{"z-index":"200","background-color":"white","text-align":"right","border-radius":"0 0 10px 10px","transition":"all .4s"}},[_c('button',{staticClass:"boxed primary properGrey",staticStyle:{"margin-right":"4px"},on:{"click":function($event){_vm.cancelPressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary properBlue",staticStyle:{"min-width":"120px"},on:{"click":function($event){_vm.savePressed()}}},[_vm._v("Save")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EBf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['isShippingFilled']
});

/***/ }),

/***/ "EHf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['isShippingFilled', 'isPaymentFilled'],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.isShippingFilled && this.isPaymentFilled;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "EV1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['selectedAddress'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "Efea":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  methods: {
    closePressed: function closePressed() {
      this.$emit('close');
    },
    loginPressed: function loginPressed() {
      this.$emit('login');
    }
  }
});

/***/ }),

/***/ "EiFi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EiU5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EirK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "El9d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EpYW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"flexy align-top"},[_c('div',[_c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-vert-l padding-hor-xl"},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Shopping Cart")])]),_vm._v(" "),_c('transition-group',{attrs:{"name":"cart-list-ani","tag":"div"}},_vm._l((_vm.items),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item large",staticStyle:{"padding-top":"16px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('items', i)}}},[_c('img',{staticStyle:{"width":"40px","padding":"28px 0 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 24px 0 12px"}},[_c('div',{staticStyle:{"padding-top":"6px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"2px","font-size":"14px"}},[_vm._v(_vm._s(item.availability)+", "+_vm._s(item.seller))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"91px","padding-top":"6px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"72px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticStyle:{"min-width":"auto","width":"56px","background-color":"rgba(255,255,255,0.6)","padding":"4px 8px"},attrs:{"name":"quantity","id":"item-quantity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px","padding-top":"2px"}},[(!item.isXPressed)?_c('button',{on:{"click":function($event){_vm.xPressed(i)}}},[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1"},attrs:{"src":__webpack_require__("xLw2")}})]):_vm._e(),_vm._v(" "),(item.isXPressed)?_c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"90","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.xPressed(i)}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-xs rounded",staticStyle:{"position":"relative","width":"160px","transform":"translate(-136px, -16px)","z-index":"120","background-color":"white","box-shadow":"0px 4px 12px rgba(0,0,0,0.0.5)"}},[_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"7px 12px","color":"#409EFF","margin":"0"},on:{"click":function($event){_vm.saveForLaterPressed(i)}}},[_vm._v("Save for later")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"7px 12px","color":"#fd3737","margin":"0"},on:{"click":function($event){_vm.removeItemPressed(i)}}},[_vm._v("Remove from cart")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"7px 12px","color":"silver","margin":"0"},on:{"click":function($event){_vm.xPressed(i)}}},[_vm._v("Cancel")])])]):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"padding-vert-m",staticStyle:{"font-size":"12px","color":"#878D98"}},[_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("The price and availability of items at Amazon.com are subject to change. The Cart is a temporary place to store a list of your items and reflects each item's most recent price. Shopping Cart "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("Learn more")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("Do you have a gift card or promotional code? We'll ask you to enter your claim code when it's time to pay.")])])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[(_vm.later.length > 0)?_c('div',[_c('div',{staticClass:"padding-hor-xl",staticStyle:{"padding-top":"12px"}},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("You saved for later")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('transition-group',{staticClass:"flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.later),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item higher fixed",staticStyle:{"width":"50%","padding-right":"32px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('later', i)}}},[_c('img',{staticStyle:{"width":"40px","padding":"28px 0 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 0 0 12px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"6px"}},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.addFromLaterPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","font-size":"13px","min-width":"88px","padding":"3px 0","border":"1px solid","border-radius":"4px","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',{staticClass:"padding-hor-xl",staticStyle:{"padding-top":"12px"}},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v(_vm._s(_vm.youRecentlyViewed))])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('transition-group',{staticClass:"flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.recent),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item higher fixed",staticStyle:{"width":"50%","padding-right":"32px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('recent', i)}}},[_c('img',{staticStyle:{"width":"40px","padding":"28px 0 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 0 0 12px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"6px"}},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.addFromRecentPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","font-size":"13px","min-width":"88px","padding":"3px 0","border":"1px solid","border-radius":"4px","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',{staticClass:"padding-hor-xl",staticStyle:{"padding-top":"12px"}},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Customers also bought")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('transition-group',{staticClass:"flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.also),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item higher fixed",staticStyle:{"width":"50%","padding-right":"32px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('also', i)}}})]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 0 0 12px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"6px"}},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.addFromAlsoPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","font-size":"13px","min-width":"88px","padding":"3px 0","border":"1px solid","border-radius":"4px","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])])],1),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-xl padding-vert-m",staticStyle:{"width":"32%","background-color":"#F5F5F5","min-height":"100vh","position":"sticky","top":"0"}},[_c('div',{staticClass:"padding-hor-m"},[_c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900","padding-top":"8px"}},[_vm._v("Subtotal")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"16px","font-weight":"900"}},[_vm._v(_vm._s(_vm.cart.length)+" item"),(_vm.cart.length > 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(", "+_vm._s(_vm.subtotal)+" ")]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-top":"8px"}},[_c('input',{staticClass:"fixed",staticStyle:{"width":"16px","text-align":"left"},attrs:{"type":"checkbox","id":"gift"}}),_vm._v(" "),_c('label',{attrs:{"for":"gift"}},[_c('div',[_vm._v("This order contains a gift")])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('button',{staticClass:"boxed primary wide properBlue",staticStyle:{"background-color":"#3a84e8"},on:{"click":function($event){_vm.checkoutPressed()}}},[_vm._v("Proceed to Checkout")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"right-column-appear","appear":""}},[_c('div',{staticStyle:{"padding-top":"40px"}},[_c('div',{staticClass:"padding-vert-m padding-hor-xl bordered rounded silver",staticStyle:{"height":"400px","text-align":"center"}},[_c('img',{staticStyle:{"padding-top":"146px"},attrs:{"src":__webpack_require__("Kufr"),"width":"125px"}})])])])],1)])]),_vm._v(" "),(_vm.doShowPreview)?_c('QuickPreview',{attrs:{"selectedForPreview":_vm.selectedForPreview},on:{"close":function($event){_vm.doShowPreview = false},"addToCart":function($event){_vm.addedToCartFromPreview($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EwRc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100vh","overflow":"auto"}},[_c('div',{staticClass:"padding-hor-l padding-vert-m black flexy",staticStyle:{"height":"80px","background-color":"#232f3e"}},[_c('div',[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'Start'}}},[_vm._v("Amazon")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px"}},[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_vm._v("Cart")])])]),_vm._v(" "),(_vm.currentView === 'Start')?_c('Start'):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShoppingCart')?_c('ShoppingCart',{attrs:{"cart":_vm.cart,"alsoItems":_vm.alsoItems,"recentItems":_vm.recentItems,"extraItems":_vm.extraItems},on:{"confirmed":function($event){_vm.shoppingCartConfirmed($event)}}}):_vm._e(),_vm._v(" "),(_vm.doShowAddressManager)?_c('ShippingAddress',{attrs:{"mode":_vm.addressMode,"addresses":_vm.addresses,"selectedAddress":_vm.selectedAddressForEditing},on:{"add":function($event){_vm.addAddressPressed()},"edit":function($event){_vm.editAddressPressed($event)},"delete":function($event){_vm.deleteAddressPressed($event)},"saveNew":function($event){_vm.shippingAddressSaveNew($event)},"saveExisting":function($event){_vm.shippingAddressSaveExisting($event)},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.doShowPaymentManager)?_c('PaymentMethod',{attrs:{"selectedPayment":_vm.selectedPayment},on:{"confirmed":function($event){_vm.paymentMethodConfirmed($event)},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ExtraSignup')?_c('ExtraSignup'):_vm._e(),_vm._v(" "),(_vm.currentView === 'Checkout')?_c('div',{attrs:{"id":"checkout"}},[_c('div',{staticClass:"padding-hor-l"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flexy align-top"},[_c('div',[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{attrs:{"selectedAddress":_vm.selectedAddress,"addresses":_vm.addresses,"reactivator":_vm.reactivator},on:{"add":function($event){_vm.addAddressPressed()},"change":function($event){_vm.changeAddressSelected($event)},"manage":function($event){_vm.manageAddressPressed()}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('PaymentMethodMin',{attrs:{"selectedPayment":_vm.selectedPayment},on:{"edit":function($event){_vm.editPaymentPressed()}}})],1),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch"},[_c('ShoppingCartMin',{attrs:{"cart":_vm.cart},on:{"edit":function($event){_vm.currentView = 'ShoppingCart'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('Delivery',{attrs:{"chosenDelivery":_vm.chosenDelivery}})],1)]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('OrderSummary',{attrs:{"selectedAddress":_vm.selectedAddress,"selectedPayment":_vm.selectedPayment},on:{"placed":function($event){_vm.currentView = 'ExtraSignup'}}})],1)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l flexy"},[_c('h1',[_vm._v("Checkout")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FJLW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "FUWf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("BEyl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c204c3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("dzH3");
function injectStyle (ssrContext) {
  __webpack_require__("y6fU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c204c3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c204c3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FXfW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("3Cz1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e19c5678_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("j+zK");
function injectStyle (ssrContext) {
  __webpack_require__("NZtO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e19c5678"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e19c5678_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FwLG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  },

  computed: {
    delivery: {
      get: function get() {
        return this.$store.getters.getChosenDelivery;
      },
      set: function set(newValue) {
        this.$store.dispatch('setChosenDelivery', newValue);
      }
    }
  }
});

/***/ }),

/***/ "G9wb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("gHVA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ee10dc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("zPMU");
function injectStyle (ssrContext) {
  __webpack_require__("4hi8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ee10dc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ee10dc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GENp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("Oldj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2bbff4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("lWte");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2bbff4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GEoq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shopping cart")]),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"60px"}},[_c('img',{attrs:{"src":item.img,"width":"40px"}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',[_vm._v("Quantity: "+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.editPressed()}}},[_vm._v("Edit")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GHM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['selectedAddress', 'selectedPayment'],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.selectedPayment !== null && this.selectedPayment !== null;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "GK1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-m fixed silver rounded",staticStyle:{"width":"300px"}},[_c('h3',[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide",class:{grey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('ul',[(!_vm.isShippingFilled)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentFilled)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.87")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$96.85")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GMrb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("uesK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__ = __webpack_require__("XLsW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__ = __webpack_require__("Uqi0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShippingAddress__ = __webpack_require__("HoO1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingAddressMin__ = __webpack_require__("Z8sD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentMethod__ = __webpack_require__("XYcd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentMethodMin__ = __webpack_require__("zxRT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OrderSummary__ = __webpack_require__("P7Lt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ExtraSignup__ = __webpack_require__("ZgzS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Start: __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
    ShoppingCart: __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__["a" /* default */],
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_3__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_4__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_5__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_6__PaymentMethodMin__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_7__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_8__ExtraSignup__["a" /* default */]
  },
  name: 'A2',
  data: function data() {
    return {
      currentView: 'Start',
      didAcceptShoppingCart: false,
      isShippingFilled: false,
      isPaymentFilled: false,
      cart: [{
        name: 'Echo Dot (2nd Generation) - Black',
        price: 49.99,
        quantity: 1
      }, {
        name: 'Fire TV Stick with Alexa Voice Remote | Streaming Media Player',
        price: 39.99,
        quantity: 1
      }]
    };
  },

  methods: {
    shoppingCartConfirmed: function shoppingCartConfirmed() {
      this.didAcceptShoppingCart = true;
      if (this.isShippingFilled && this.isPaymentFilled) {
        this.currentView = 'OrderSummary';
      } else if (this.isShippingFilled) {
        this.currentView = 'PaymentMethod';
      } else {
        this.currentView = 'ShippingAddress';
      }
    },
    shippingAddressConfirmed: function shippingAddressConfirmed() {
      this.currentView = 'PaymentMethod';
      this.isShippingFilled = true;
    },
    paymentMethodConfirmed: function paymentMethodConfirmed() {
      this.currentView = 'OrderSummary';
      this.isPaymentFilled = true;
    }
  }
});

/***/ }),

/***/ "GQsc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("7Njw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e54efcb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("03OD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e54efcb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GXlk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("dqjm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caf45dbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("u4yN");
function injectStyle (ssrContext) {
  __webpack_require__("/KXV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-caf45dbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caf45dbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GdNK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"},on:{"click":function($event){_vm.closePressed()}}},[_c('div',{staticClass:"modal-container flexy align-stretch",staticStyle:{"max-width":"720px","max-height":"100vh","flex-direction":"column","margin":"0 auto","padding":"24px 0"},on:{"click":function($event){$event.stopPropagation();_vm.doThis()}}},[_c('div',{staticClass:"flexy padding-hor-xl fixed",class:{shadowyBottom: _vm.didScroll},staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"24px","z-index":"200","transition":"all .4s"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[_vm._v("Quick Preview")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.closePressed()}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl padding-vert-m roundBottom",staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"","padding-bottom":"12px"},attrs:{"id":"watchMeScroll"},on:{"scroll":_vm.checkScrollPosition}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"200px"}},[_c('img',{attrs:{"src":_vm.item.img,"width":"200px"}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"24px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),_c('div',[_vm._v("by "+_vm._s(_vm.item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',{staticStyle:{"color":"#ff9900","font-size":"18px"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"13px"}},[_vm._v("249 customer reviews")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"13px"}},[_vm._v("#1 Bestseller in Industrial Product Design")])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"16px","width":"80%"}},[_c('div',{staticClass:"fixed padding-hor-m padding-vert-s bordered rounded unselected",class:{selected: _vm.selectedFormat === 'kindle'},staticStyle:{"width":"32%","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'kindle'}}},[_c('div',{staticClass:"bookType",staticStyle:{"font-size":"13px"}},[_vm._v("Kindle book")]),_vm._v(" "),_c('div',{staticClass:"bookPrice",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("$17.63")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-m padding-vert-s bordered rounded unselected",class:{selected: _vm.selectedFormat === 'hardcover'},staticStyle:{"width":"32%","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'hardcover'}}},[_c('div',{staticClass:"bookType",staticStyle:{"font-size":"13px"}},[_vm._v("Hardcover")]),_vm._v(" "),_c('div',{staticClass:"bookPrice",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("$18.89")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-m padding-vert-s bordered rounded unselected",class:{selected: _vm.selectedFormat === 'paperback'},staticStyle:{"width":"32%","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'paperback'}}},[_c('div',{staticClass:"bookType",staticStyle:{"font-size":"13px"}},[_vm._v("Paperback")]),_vm._v(" "),_c('div',{staticClass:"bookPrice",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("$55.77")])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px","width":"80%"}},[(!_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed primary properBlue wide",on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed subtle-primary wide",staticStyle:{"background-color":"#b3ffb3","color":"green","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy rounded"},[_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'description'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none","border-top-left-radius":"6px","border-bottom-left-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'description'}}},[_vm._v("\n              Description\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'editors'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none"},on:{"click":function($event){_vm.selectedTab = 'editors'}}},[_vm._v("\n              Editorial reviews\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'user'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-top-right-radius":"6px","border-bottom-right-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'user'}}},[_vm._v("\n              User reviews\n            ")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-xs"},[(_vm.selectedTab === 'description')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Why do some products capture widespread attention while others flop? What makes us engage with certain products out of sheer habit? Is there a pattern underlying how technologies hook us?")]),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Nir Eyal answers these questions (and many more) by explaining the Hook Model—a four-step process embedded into the products of many successful companies to subtly encourage customer behavior. Through consecutive “hook cycles,” these products reach their ultimate goal of bringing users back again and again without depending on costly advertising or aggressive messaging.")]):_vm._e(),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Hooked is based on Eyal’s years of research, consulting, and practical experience. He wrote the book he wished had been available to him as a start-up founder—not abstract theory, but a how-to guide for building better products. Hooked is written for product managers, designers, marketers, start-up founders, and anyone who seeks to understand how products influence our behavior.")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'editors')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Publisher's Weekly")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Eric Ries, author of The Lean Startup")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Boris Veldhuijzen van Zanten, founder of The Next Web ")])])])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'user')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GhId":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__ = __webpack_require__("je40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1774bfd5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__ = __webpack_require__("LFo5");
function injectStyle (ssrContext) {
  __webpack_require__("5kT6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1774bfd5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1774bfd5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gi0k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-hor-l fixed flexy align-top",staticStyle:{"width":"50%"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("lzwN"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Shipping address")]),_vm._v(" "),(_vm.selectedAddress === null)?_c('div',{staticStyle:{"padding-top":"12px","position":"relative"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"background-color":"#3a84e8"},on:{"click":_vm.addPressed}},[_vm._v("Add shipping address")]),_vm._v(" "),(!_vm.isSignedIn)?_c('div',{staticStyle:{"font-size":"14px","padding-top":"12px"}},[_c('button',{staticStyle:{"font-size":"13px","padding":"3px 8px","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.openSignIn()}}},[_vm._v("Sign in")]),_vm._v(" for 1-click checkout")]):_vm._e()]):_c('div',{staticStyle:{"padding-top":"8px"}},[_c('div',[_vm._v(_vm._s(_vm.addresses[_vm.selectedAddress].name))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.addresses[_vm.selectedAddress].address1)+" ")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.addresses[_vm.selectedAddress].city)+", "+_vm._s(_vm.addresses[_vm.selectedAddress].state)+", "+_vm._s(_vm.addresses[_vm.selectedAddress].country))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.addresses[_vm.selectedAddress].phone))]),_vm._v(" "),_c('div',{staticStyle:{"color":"transparent","width":"0","height":"0","overflow":"hidden"}},[_vm._v(_vm._s(_vm.reactivator))]),_vm._v(" "),_c('transition',{attrs:{"name":"popover"}},[(_vm.doShowAddressesList)?_c('div',[_c('div',{staticClass:"popover-curtain",on:{"click":function($event){_vm.doShowAddressesList=false}}}),_vm._v(" "),_c('div',{staticClass:"popover-content",on:{"click":function($event){$event.stopPropagation();_vm.doNothing($event)}}},[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":function($event){_vm.choosePressed(i)}}},[_c('div',{class:{selectedItem: i === _vm.selectedAddress},staticStyle:{"padding":"12px 24px"}},[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])])])}),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px","margin-top":"4px"},on:{"click":_vm.addNewAddressPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Add new address")])])]),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":_vm.manageAddressesPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Manage addresses")])])])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"10px"}},[_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":_vm.changePressed}},[_vm._v("\n            Change\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GlC6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['selectedPayment', 'payments', 'reactivator'],
  data: function data() {
    return {
      doShowMethodsList: false
    };
  },

  computed: {
    isSignedIn: function isSignedIn() {
      return this.$store.getters.getIsSignedIn;
    }
  },
  methods: {
    addPressed: function addPressed() {
      this.$emit('add');
    },
    changePressed: function changePressed() {
      this.doShowMethodsList = true;
    },
    choosePressed: function choosePressed(index) {
      this.$store.dispatch('setSelectedPayment', index);
      this.doShowMethodsList = false;
      //
    },
    addNewPaymentPressed: function addNewPaymentPressed() {
      this.doShowMethodsList = false;
      this.$emit('add');
    },
    managePaymentPressed: function managePaymentPressed() {
      this.doShowMethodsList = false;
      this.$emit('manage');
    },

    //
    doNothing: function doNothing() {
      //
    },
    mutateCardNumber: function mutateCardNumber(number) {
      var safeString = '**** **** **** ';
      var lastChars = number.slice(number.length - 4, number.length);
      safeString = safeString + lastChars;
      return safeString;
    },

    //
    openSignIn: function openSignIn() {
      this.$emit('signin');
    }
  }
});

/***/ }),

/***/ "Gndd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("XY0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e0bb140_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("0PkL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e0bb140_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gv1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("i4wA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41dcf4fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("g871");
function injectStyle (ssrContext) {
  __webpack_require__("6DZd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41dcf4fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41dcf4fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GxRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l"},[_c('div',{staticClass:"padding-vert-l flexy align-top"},[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-l bordered rounded silver"},[_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-xs flexy align-top",attrs:{"id":'cart-item-' + i}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('img',{attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-right":"24px"}},[_c('div',{staticStyle:{"font-size":"17px"}},[_c('strong',[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey padding-vert-xs"},[_vm._v(_vm._s(item.availability)+", "+_vm._s(item.seller))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v("$ "+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticStyle:{"min-width":"auto","width":"60px","background-color":"rgba(255,255,255,0.6)"},attrs:{"name":"quantity","id":"item-quantity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"20px"},on:{"click":function($event){_vm.removeItemPressed(i)}}},[_c('button',[_vm._v("x")])])])}),_vm._v(" "),_c('div',{staticClass:"padding-vert-m flexy",staticStyle:{"border-top":"1px solid #eee"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('strong',[_vm._v("$ "+_vm._s(_vm.subtotal))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"120px"}},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.checkoutPressed()}}},[_vm._v("Checkout")])])])],2),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-l bordered rounded flexy",staticStyle:{"flex-wrap":"wrap"}},_vm._l((_vm.recent),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('img',{attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$ "+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary mid",on:{"click":function($event){_vm.addFromRecentPressed(i)}}},[_vm._v("Add to cart")])])])])}))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"320px","margin-left":"48px"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-l bordered rounded"},_vm._l((_vm.also),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('img',{attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$ "+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary mid",on:{"click":function($event){_vm.addFromAlsoPressed(i)}}},[_vm._v("Add to cart")])])])])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l"},[_c('h1',[_vm._v("Shopping Cart")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v("Subtotal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m padding-hor-l bordered rounded silver",staticStyle:{"height":"110px","text-align":"center"}},[_c('img',{attrs:{"src":__webpack_require__("Kufr"),"width":"125px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l"},[_c('h1',[_vm._v("You recently viewed")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l"},[_c('h1',[_vm._v("Customers also bought")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GxlM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("U6op");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f3162a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("pC72");
function injectStyle (ssrContext) {
  __webpack_require__("7d8l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f3162a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f3162a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H+KV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("4T8Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec04c8e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("U+4/");
function injectStyle (ssrContext) {
  __webpack_require__("jiSs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec04c8e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec04c8e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H+X6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("fcn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__ = __webpack_require__("GXlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__ = __webpack_require__("hBqG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Delivery__ = __webpack_require__("4nVM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__ = __webpack_require__("qqvF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__ = __webpack_require__("qQk4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__ = __webpack_require__("0+KD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__ = __webpack_require__("6/Y/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderSummary__ = __webpack_require__("KGeF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__ = __webpack_require__("P83h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Start: __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
    ShoppingCart: __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__["a" /* default */],
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_3__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_8__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__["a" /* default */]
  },
  data: function data() {
    return {
      currentView: 'Start',
      chosenDelivery: '1',
      //
      doShowAddressManager: false,
      selectedAddress: null,
      //
      // isPaymentFilled: false,
      doShowPaymentManager: false,
      selectedPayment: null,
      //
      cart: [{
        name: 'Beautiful Evidence',
        by: 'Edward R. Tufte',
        img: __webpack_require__("OEdX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 28.87,
        quantity: 1
      }, {
        name: 'Hooked: How to Build Habit-Forming Products',
        by: 'Nir Eyal',
        img: __webpack_require__("IBtq"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 18.56,
        quantity: 1
      }],
      alsoItems: [{
        name: 'Sprint: How to Solve Big Problems and Test New Ideas in Just Five Days',
        by: 'Jake Knapp',
        img: __webpack_require__("RVgH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.53,
        quantity: 1
      }, {
        name: 'The Lean Startup: How Today\'s Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses',
        by: 'Eric Ries',
        img: __webpack_require__("xcPX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.29,
        quantity: 1
      }, {
        name: 'The Hard Thing About Hard Things: Building a Business When There Are No Easy Answers',
        by: 'Ben Horowitz',
        img: __webpack_require__("fiE3"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 19.66,
        quantity: 1
      }, {
        name: 'Rework',
        by: 'Jason Fried',
        img: __webpack_require__("7fXA"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 17.68,
        quantity: 1
      }, {
        name: 'Remote: Office Not Required',
        by: 'Jason Fried',
        img: __webpack_require__("LhVL"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 15.59,
        quantity: 1
      }],
      recentItems: [{
        name: 'Envisioning Information',
        by: 'Edward R. Tufte',
        img: __webpack_require__("CySp"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 34.96,
        quantity: 1
      }, {
        name: 'About Face: The Essentials of Interaction Design',
        by: 'Alan Cooper',
        img: __webpack_require__("y+PD"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 36.47,
        quantity: 1
      }, {
        name: '100 Things Every Designer Needs to Know About People',
        by: 'Susan Weinschenk',
        img: __webpack_require__("P+u0"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 22.95,
        quantity: 1
      }, {
        name: 'HTML and CSS: Design and Build Websites',
        by: 'Jon Duckett',
        img: __webpack_require__("AqZH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.53,
        quantity: 1
      }],
      extraItems: [{
        name: 'CSS: The Missing Manual',
        by: 'David Sawyer McFarland',
        img: __webpack_require__("PF3y"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 24.61,
        quantity: 1
      }, {
        name: 'The Principles of Beautiful Web Design: Designing Great Web Sites is Not Rocket Science!',
        by: 'Jason Beaird',
        img: __webpack_require__("jAj8"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.23,
        quantity: 1
      }, {
        name: 'Logo Design Love: A Guide to Creating Iconic Brand Identities, 2nd Edition',
        by: 'David Airey',
        img: __webpack_require__("WOmI"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.05,
        quantity: 1
      }, {
        name: 'Layout Essentials: 100 Design Principles for Using Grids (Design Essentials)',
        by: 'Beth Tondreau',
        img: __webpack_require__("Mvmb"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.76,
        quantity: 1
      }]
    };
  },

  methods: {
    shoppingCartConfirmed: function shoppingCartConfirmed(items) {
      this.currentView = 'Checkout';
      this.cart = items;
    },

    //
    // ADDRESS
    editAddressPressed: function editAddressPressed() {
      this.doShowAddressManager = true;
    },
    shippingAddressConfirmed: function shippingAddressConfirmed(data) {
      this.selectedAddress = data;
      this.doShowAddressManager = false;
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.doShowAddressManager = false;
    },

    //
    // PAYMENT
    editPaymentPressed: function editPaymentPressed() {
      this.doShowPaymentManager = true;
    },
    paymentMethodConfirmed: function paymentMethodConfirmed(data) {
      this.selectedPayment = data;
      this.doShowPaymentManager = false;
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.doShowPaymentManager = false;
    }
    //

  },
  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "H3ey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_C1_vue__ = __webpack_require__("H+X6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bcf5028_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_C1_vue__ = __webpack_require__("Z1JO");
function injectStyle (ssrContext) {
  __webpack_require__("4gyL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bcf5028"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_C1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bcf5028_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_C1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HFP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("8+ZI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219165cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("h0Dd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219165cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HG1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: null,
      showFullDescription: false,
      selectedFormat: 'kindle',
      selectedTab: 'description',
      isBeingAddedToCart: false
    };
  },

  props: ['selectedForPreview'],
  methods: {
    closePressed: function closePressed() {
      this.$emit('close');
    },
    doThis: function doThis() {
      console.log('hi');
    },
    addPressed: function addPressed() {
      var _this = this;

      this.isBeingAddedToCart = true;
      setTimeout(function () {
        _this.$emit('addToCart', _this.item);
      }, 500);
    }
  },
  created: function created() {
    this.item = this.selectedForPreview;
  }
});

/***/ }),

/***/ "HJtG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_074ea63c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("nwX0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_074ea63c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HUrK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f725c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("d2qd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f725c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HVXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedPayment'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      number: { value: '', isValid: true, wasFocused: false },
      month: { value: '', isValid: true, wasFocused: false },
      year: { value: '', isValid: true, wasFocused: false }
    };
  },

  methods: {
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      this.$emit('confirmed', {
        name: this.name.value,
        number: this.number.value,
        month: this.month.value,
        year: this.year.value
      });
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.number.isValid = true;
      this.month.isValid = true;
      this.year.isValid = true;
      //
      this.name.wasFocused = false;
      this.number.wasFocused = false;
      this.month.wasFocused = false;
      this.year.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.number.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.number.isValid = false;
      }
      if (this.month.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.month.isValid = false;
      }
      if (this.year.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.year.isValid = false;
      }
      return hasErrors;
    }
  },
  created: function created() {
    if (this.selectedPayment !== null) {
      this.name = { value: this.selectedPayment.name, isValid: true, wasFocused: false };
      this.number = { value: this.selectedPayment.number, isValid: true, wasFocused: false };
      this.month = { value: this.selectedPayment.month, isValid: true, wasFocused: false };
      this.year = { value: this.selectedPayment.year, isValid: true, wasFocused: false };
    }
  }
});

/***/ }),

/***/ "HXuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("ONaI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d64002_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("oKvw");
function injectStyle (ssrContext) {
  __webpack_require__("dycf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64d64002"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d64002_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HYxI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HoO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("hEid");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a344404a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("iD5A");
function injectStyle (ssrContext) {
  __webpack_require__("mDN9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a344404a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a344404a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HxM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.doShowAddressManager)?_c('ShippingAddress',{attrs:{"mode":_vm.addressMode,"addresses":_vm.addresses,"selectedAddress":_vm.selectedAddressForEditing},on:{"add":function($event){_vm.addAddressPressed()},"edit":function($event){_vm.editAddressPressed($event)},"delete":function($event){_vm.deleteAddressPressed($event)},"saveNew":function($event){_vm.shippingAddressSaveNew($event)},"saveExisting":function($event){_vm.shippingAddressSaveExisting($event)},"backToManager":function($event){_vm.shippingAddressCancelledBackToManager()},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.doShowPaymentManager)?_c('PaymentMethod',{attrs:{"mode":_vm.paymentMode,"payments":_vm.payments,"selectedPayment":_vm.selectedPaymentForEditing},on:{"add":function($event){_vm.addPaymentPressed()},"edit":function($event){_vm.editPaymentPressed($event)},"delete":function($event){_vm.deletePaymentPressed($event)},"saveNew":function($event){_vm.paymentMethodSaveNew($event)},"saveExisting":function($event){_vm.paymentMethodSaveExisting($event)},"backToManager":function($event){_vm.paymentMethodCancelledBackToManager()},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),_c('div',[_c('div',[_c('div',{staticClass:"flexy align-stretch",staticStyle:{"flex-direction":"row-reverse"}},[_c('OrderSummary',{staticClass:"dimmy",class:{dimmed: _vm.selectedAddress === null || _vm.selectedPayment === null},attrs:{"selectedAddress":_vm.selectedAddress,"selectedPayment":_vm.selectedPayment,"cart":_vm.cart,"delivery":_vm.chosenDelivery},on:{"placed":function($event){_vm.placeOrderPressed()}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{staticClass:"dimmy",class:{dimmed: _vm.selectedAddress !== null && _vm.selectedPayment === null},attrs:{"selectedAddress":_vm.selectedAddress,"addresses":_vm.addresses,"reactivator":_vm.reactivator},on:{"add":function($event){_vm.addAddressPressed()},"signin":function($event){_vm.signInPressed()},"manage":function($event){_vm.manageAddressPressed()}}}),_vm._v(" "),_c('PaymentMethodMin',{staticClass:"dimmy",class:{dimmed: _vm.selectedAddress === null},attrs:{"selectedPayment":_vm.selectedPayment,"payments":_vm.payments,"reactivator":_vm.reactivator},on:{"add":function($event){_vm.addPaymentPressed()},"signin":function($event){_vm.signInPressed()},"manage":function($event){_vm.managePaymentPressed()}}})],1),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch",staticStyle:{"padding-top":"32px"}},[_c('ShoppingCartMin',{staticClass:"dimmy",class:{dimmed: _vm.selectedAddress === null || _vm.selectedPayment === null}}),_vm._v(" "),_c('Delivery',{class:{dimmed: _vm.selectedAddress === null || _vm.selectedPayment === null}})],1)]),_vm._v(" "),(_vm.doShowSignIn)?_c('SignIn',{on:{"close":function($event){_vm.signInClosed()},"login":_vm.loginPressed}}):_vm._e()],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I1tf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I5m+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA4SURBVHgBncxJDgAgEAJBns7PMUY9mOgscKYLkih/xJyJrPisidxxE3nHRSSOE6QWfxDC2UYYfQZp8BcAHV6DkQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "I9ng":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IBtq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hooked.bae4db8.jpg";

/***/ }),

/***/ "IC3a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IRmQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['selectedAddress', 'addresses', 'reactivator'],
  data: function data() {
    return {
      doShowAddressesList: false
    };
  },

  computed: {
    reactiveAddresses: function reactiveAddresses() {
      return this.addresses;
    }
  },
  methods: {
    addPressed: function addPressed() {
      this.$emit('add');
    },
    changePressed: function changePressed() {
      if (this.selectedAddress !== null) {
        this.doShowAddressesList = true;
      }
      // this.$emit('edit')
    },
    choosePressed: function choosePressed(index) {
      this.$emit('change', index);
      this.doShowAddressesList = false;
      //
    },
    addNewAddressPressed: function addNewAddressPressed() {
      this.doShowAddressesList = false;
      this.$emit('add');
    },
    manageAddressesPressed: function manageAddressesPressed() {
      this.doShowAddressesList = false;
      this.$emit('manage');
    },
    doNothing: function doNothing() {
      //
    }
  }
});

/***/ }),

/***/ "IRqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("nEFq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc762b4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("u8JT");
function injectStyle (ssrContext) {
  __webpack_require__("lX17")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc762b4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc762b4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ITb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IWN0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("c2UB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__ = __webpack_require__("lo5v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__ = __webpack_require__("j5y5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Delivery__ = __webpack_require__("pzLF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__ = __webpack_require__("OBtp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__ = __webpack_require__("GQsc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__ = __webpack_require__("kZbF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__ = __webpack_require__("QAeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderSummary__ = __webpack_require__("42Rp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__ = __webpack_require__("kAOK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Start: __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
    ShoppingCart: __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__["a" /* default */],
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_3__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_8__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__["a" /* default */]
  },
  data: function data() {
    return {
      currentView: 'Start',
      chosenDelivery: '1',
      isShippingFilled: false,
      isPaymentFilled: false,
      cart: [{
        name: 'Beautiful Evidence',
        by: 'Edward R. Tufte',
        img: __webpack_require__("OEdX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 28.87,
        quantity: 1
      }, {
        name: 'Hooked: How to Build Habit-Forming Products',
        by: 'Nir Eyal',
        img: __webpack_require__("IBtq"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 18.56,
        quantity: 1
      }],
      alsoItems: [{
        name: 'Sprint: How to Solve Big Problems and Test New Ideas in Just Five Days',
        by: 'Jake Knapp',
        img: __webpack_require__("RVgH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.53,
        quantity: 1
      }, {
        name: 'The Lean Startup: How Today\'s Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses',
        by: 'Eric Ries',
        img: __webpack_require__("xcPX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.29,
        quantity: 1
      }, {
        name: 'The Hard Thing About Hard Things: Building a Business When There Are No Easy Answers',
        by: 'Ben Horowitz',
        img: __webpack_require__("fiE3"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 19.66,
        quantity: 1
      }, {
        name: 'Rework',
        by: 'Jason Fried',
        img: __webpack_require__("7fXA"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 17.68,
        quantity: 1
      }, {
        name: 'Remote: Office Not Required',
        by: 'Jason Fried',
        img: __webpack_require__("LhVL"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 15.59,
        quantity: 1
      }],
      recentItems: [{
        name: 'Envisioning Information',
        by: 'Edward R. Tufte',
        img: __webpack_require__("CySp"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 34.96,
        quantity: 1
      }, {
        name: 'About Face: The Essentials of Interaction Design',
        by: 'Alan Cooper',
        img: __webpack_require__("y+PD"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 36.47,
        quantity: 1
      }, {
        name: '100 Things Every Designer Needs to Know About People',
        by: 'Susan Weinschenk',
        img: __webpack_require__("P+u0"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 22.95,
        quantity: 1
      }, {
        name: 'HTML and CSS: Design and Build Websites',
        by: 'Jon Duckett',
        img: __webpack_require__("AqZH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.53,
        quantity: 1
      }],
      extraItems: [{
        name: 'CSS: The Missing Manual',
        by: 'David Sawyer McFarland',
        img: __webpack_require__("PF3y"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 24.61,
        quantity: 1
      }, {
        name: 'The Principles of Beautiful Web Design: Designing Great Web Sites is Not Rocket Science!',
        by: 'Jason Beaird',
        img: __webpack_require__("jAj8"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.23,
        quantity: 1
      }, {
        name: 'Logo Design Love: A Guide to Creating Iconic Brand Identities, 2nd Edition',
        by: 'David Airey',
        img: __webpack_require__("WOmI"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.05,
        quantity: 1
      }, {
        name: 'Layout Essentials: 100 Design Principles for Using Grids (Design Essentials)',
        by: 'Beth Tondreau',
        img: __webpack_require__("Mvmb"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.76,
        quantity: 1
      }]
    };
  },

  methods: {
    shoppingCartConfirmed: function shoppingCartConfirmed(items) {
      this.currentView = 'Checkout';
      this.cart = items;
    },
    shippingAddressConfirmed: function shippingAddressConfirmed(items) {
      this.isShippingFilled = true;
      this.currentView = 'Checkout';
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.currentView = 'Checkout';
    },
    paymentMethodConfirmed: function paymentMethodConfirmed() {
      this.isPaymentFilled = true;
      this.currentView = 'Checkout';
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.currentView = 'Checkout';
    }
  },
  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "ImmR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iu2J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IuSU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['selectedPayment'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "IxyL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J2LK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-m black flexy",staticStyle:{"height":"80px"}},[_c('div',[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'Start'}}},[_vm._v("Amazon")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px"}},[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_vm._v("Cart")])])]),_vm._v(" "),(_vm.currentView === 'Start')?_c('Start'):_vm._e(),_vm._v(" "),(_vm.currentView !== 'Start')?_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed silver",staticStyle:{"width":"360px","height":"100vh"},attrs:{"id":"sidebar"}},[_c('div',{staticClass:"clickable-children"},[_c('div',{class:{selected: _vm.currentView === 'ShoppingCart', disabled: !_vm.didAcceptShoppingCart && _vm.currentView !== 'ShoppingCart'},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_c('ShoppingCartMin',{attrs:{"cart":_vm.cart,"didAcceptShoppingCart":_vm.didAcceptShoppingCart}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{class:{selected: _vm.currentView === 'ShippingAddress', disabled: !_vm.isShippingFilled && _vm.currentView !== 'ShippingAddress'},on:{"click":function($event){_vm.currentView = 'ShippingAddress'}}},[_c('ShippingAddressMin',{attrs:{"isShippingFilled":_vm.isShippingFilled}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{class:{selected: _vm.currentView === 'PaymentMethod', disabled: !_vm.isShippingFilled && _vm.currentView !== 'PaymentMethod'},on:{"click":function($event){_vm.currentView = 'PaymentMethod'}}},[_c('PaymentMethodMin',{attrs:{"isPaymentFilled":_vm.isPaymentFilled}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{class:{selected: _vm.currentView === 'OrderSummary', disabled: !_vm.isShippingFilled && !_vm.isPaymentFilled && _vm.currentView !== 'OrderSummary'},on:{"click":function($event){_vm.currentView = 'OrderSummary'}}},[_vm._m(0)])])]),_vm._v(" "),_c('div',{attrs:{"id":"mainContent"}},[(_vm.currentView === 'ShoppingCart')?_c('ShoppingCart',{attrs:{"cart":_vm.cart},on:{"confirmed":function($event){_vm.shoppingCartConfirmed()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShippingAddress')?_c('ShippingAddress',{on:{"confirmed":function($event){_vm.shippingAddressConfirmed()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'PaymentMethod')?_c('PaymentMethod',{on:{"confirmed":function($event){_vm.paymentMethodConfirmed()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'OrderSummary')?_c('OrderSummary',{attrs:{"isShippingFilled":_vm.isShippingFilled,"isPaymentFilled":_vm.isPaymentFilled},on:{"placed":function($event){_vm.currentView = 'ExtraSignup'}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ExtraSignup')?_c('ExtraSignup'):_vm._e()],1)]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m padding-hor-xl"},[_c('h3',[_vm._v("Summary")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J72T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "JFzI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JUjC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("t613");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7775dce2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("3hFP");
function injectStyle (ssrContext) {
  __webpack_require__("cZFJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7775dce2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7775dce2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JX1u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JZPZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_B2_vue__ = __webpack_require__("T5lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e47f6a6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_B2_vue__ = __webpack_require__("tQ0M");
function injectStyle (ssrContext) {
  __webpack_require__("iziJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e47f6a6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_B2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e47f6a6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_B2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jh+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "JkvD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: null,
      showFullDescription: false,
      selectedFormat: 'kindle',
      selectedTab: 'description',
      isBeingAddedToCart: false
    };
  },

  props: ['selectedForPreview'],
  methods: {
    closePressed: function closePressed() {
      this.$emit('close');
    },
    doThis: function doThis() {
      console.log('hi');
    },
    addPressed: function addPressed() {
      var _this = this;

      this.isBeingAddedToCart = true;
      setTimeout(function () {
        _this.$emit('addToCart', _this.item);
      }, 500);
    }
  },
  created: function created() {
    this.item = this.selectedForPreview;
  }
});

/***/ }),

/***/ "JnL8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  props: ['cart'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "JwWF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KD+B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KFMe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("iLfo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c0da6ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("ncgl");
function injectStyle (ssrContext) {
  __webpack_require__("fhVA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c0da6ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c0da6ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KGeF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("UoUA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_193800f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("kGAi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_193800f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KLNC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("IRmQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d555c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("u4Iz");
function injectStyle (ssrContext) {
  __webpack_require__("I1tf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01d555c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d555c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KNSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_C2a_vue__ = __webpack_require__("dZ6T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f1a8e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_C2a_vue__ = __webpack_require__("hV7U");
function injectStyle (ssrContext) {
  __webpack_require__("JwWF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21f1a8e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_C2a_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f1a8e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_C2a_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KcfH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: null,
      showFullDescription: false,
      selectedFormat: 'kindle',
      selectedTab: 'description',
      isBeingAddedToCart: false
    };
  },

  props: ['selectedForPreview'],
  methods: {
    closePressed: function closePressed() {
      this.$emit('close');
    },
    doThis: function doThis() {
      console.log('hi');
    },
    addPressed: function addPressed() {
      var _this = this;

      this.isBeingAddedToCart = true;
      setTimeout(function () {
        _this.$emit('addToCart', _this.item);
      }, 500);
    }
  },
  created: function created() {
    this.item = this.selectedForPreview;
  }
});

/***/ }),

/***/ "Kez7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__ = __webpack_require__("qZYA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22268a74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__ = __webpack_require__("UaVh");
function injectStyle (ssrContext) {
  __webpack_require__("n6PW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22268a74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22268a74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kn1t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraSignup_vue__ = __webpack_require__("sLjn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a18781_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("an4j");
function injectStyle (ssrContext) {
  __webpack_require__("z4bv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraSignup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a18781_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ku6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['selectedPayment', 'payments', 'reactivator'],
  data: function data() {
    return {
      doShowMethodsList: false
    };
  },

  methods: {
    addPressed: function addPressed() {
      this.$emit('add');
    },
    changePressed: function changePressed() {
      this.doShowMethodsList = true;
    },
    choosePressed: function choosePressed(index) {
      this.$emit('change', index);
      this.doShowMethodsList = false;
      //
    },
    addNewPaymentPressed: function addNewPaymentPressed() {
      this.doShowMethodsList = false;
      this.$emit('add');
    },
    managePaymentPressed: function managePaymentPressed() {
      this.doShowMethodsList = false;
      this.$emit('manage');
    },

    //
    doNothing: function doNothing() {
      //
    },
    mutateCardNumber: function mutateCardNumber(number) {
      var safeString = '**** **** **** ';
      var lastChars = number.slice(number.length - 4, number.length);
      safeString = safeString + lastChars;
      return safeString;
    },

    //
    openSignIn: function openSignIn() {
      this.$emit('signin');
    }
  }
});

/***/ }),

/***/ "Kufr":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "L/rg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("sg//");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6dcf3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("w9Vr");
function injectStyle (ssrContext) {
  __webpack_require__("j6Am")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6dcf3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LBmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PrototypeManager',
  props: ['managerProps'],
  data: function data() {
    return {
      scrollable: null,
      didScroll: false,
      toggleManager: false
    };
  },

  computed: {
    selectedVersion: function selectedVersion() {
      if (this.$route.name === 'ShoppingCart' || this.$route.name === 'Start' || this.$route.name === 'Checkout' || this.$route.name === 'Complete') {
        return 'D2';
      } else if (this.$route.name === 'ShoppingCart2' || this.$route.name === 'Start2' || this.$route.name === 'Checkout2' || this.$route.name === 'Complete2') {
        return 'D3';
      } else {
        return this.$route.name;
      }
    },
    isHome: function isHome() {
      return this.$route.name === 'HelloWorld';
    }
  },
  methods: {
    checkScrollPosition: function checkScrollPosition() {
      if (this.scrollable.scrollTop > 10) {
        this.didScroll = true;
      } else {
        this.didScroll = false;
      }
    },
    openManager: function openManager() {
      var _this = this;

      this.toggleManager = true;
      setTimeout(function () {
        _this.scrollable = document.getElementById('watchMeScroll');
      }, 500);
    },
    openPrototype: function openPrototype(iteration, version) {
      this.toggleManager = false;
      this.$router.push('/' + iteration + '/' + version);
    },
    goHome: function goHome() {
      this.toggleManager = false;
      this.$router.push('/');
    },
    isSelected: function isSelected(iteration, version) {
      if (this.$route.name === 'ShoppingCart' || this.$route.name === 'Start' || this.$route.name === 'Checkout' || this.$route.name === 'Complete') {
        return iteration + '' + version === 'D2';
      } else if (this.$route.name === 'ShoppingCart2' || this.$route.name === 'Start2' || this.$route.name === 'Checkout2' || this.$route.name === 'Complete2') {
        return iteration + '' + version === 'D3';
      } else {
        return this.$route.name === iteration + '' + version;
      }
    }
  },
  created: function created() {
    //
  }
});

/***/ }),

/***/ "LFo5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticStyle:{"max-width":"800px","margin":"5vh auto","background-color":"white","border-radius":"2px","box-shadow":"0px 12px 36px rgba(0,0,0,0.1)"}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"height":"7vh","border-bottom":"1px solid silver"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.closePressed()}}},[_c('button',[_vm._v("x")])])]),_vm._v(" "),_c('div',{staticStyle:{"max-height":"80vh","overflow":"auto"}},[_c('div',{staticClass:"flexy align-top padding-hor-l padding-vert-l"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"220px"}},[_c('img',{attrs:{"src":_vm.item.img,"width":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.item.name))])]),_vm._v(" "),_c('div',[_vm._v("by "+_vm._s(_vm.item.by))]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"padding-vert-s flexy"},[_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'kindle'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'kindle'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Kindle book")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$17.63")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'hardcover'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'hardcover'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Hardcover")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$18.89")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'paperback'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'paperback'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Paperback")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$55.77")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add to cart")])])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l padding-hor-l"},[_c('div',{staticClass:"flexy rounded"},[_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'description'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none","border-top-left-radius":"6px","border-bottom-left-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'description'}}},[_vm._v("\n            Description\n          ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'editors'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none"},on:{"click":function($event){_vm.selectedTab = 'editors'}}},[_vm._v("\n            Editorial reviews\n          ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'user'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-top-right-radius":"6px","border-bottom-right-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'user'}}},[_vm._v("\n            User reviews\n          ")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-xs"},[(_vm.selectedTab === 'description')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Why do some products capture widespread attention while others flop? What makes us engage with certain products out of sheer habit? Is there a pattern underlying how technologies hook us?")]),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Nir Eyal answers these questions (and many more) by explaining the Hook Model—a four-step process embedded into the products of many successful companies to subtly encourage customer behavior. Through consecutive “hook cycles,” these products reach their ultimate goal of bringing users back again and again without depending on costly advertising or aggressive messaging.")]):_vm._e(),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Hooked is based on Eyal’s years of research, consulting, and practical experience. He wrote the book he wished had been available to him as a start-up founder—not abstract theory, but a how-to guide for building better products. Hooked is written for product managers, designers, marketers, start-up founders, and anyone who seeks to understand how products influence our behavior.")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'editors')?_c('div',[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'user')?_c('div',[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7)]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Quick Preview")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-s"},[_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-m",staticStyle:{"background-color":"pink","display":"inline-block"}},[_vm._v("#1 Bestseller in Industrial Product Design")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Publisher's Weekly")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Eric Ries, author of The Lean Startup")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Boris Veldhuijzen van Zanten, founder of The Next Web ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lge5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LhVL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/remote.2922494.jpg";

/***/ }),

/***/ "Lm8A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("ri21");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f9d4f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("Z5AA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f9d4f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LnCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['isShippingFilled'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "Lqm+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LrT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['isShippingFilled', 'isPaymentFilled'],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.isShippingFilled && this.isPaymentFilled;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "Lz4B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['selectedPayment', 'payments', 'reactivator'],
  data: function data() {
    return {
      doShowMethodsList: false
    };
  },

  methods: {
    addPressed: function addPressed() {
      this.$emit('add');
    },
    changePressed: function changePressed() {
      this.doShowMethodsList = true;
    },
    choosePressed: function choosePressed(index) {
      this.$emit('change', index);
      this.doShowMethodsList = false;
      //
    },
    addNewPaymentPressed: function addNewPaymentPressed() {
      this.doShowMethodsList = false;
      this.$emit('add');
    },
    managePaymentPressed: function managePaymentPressed() {
      this.doShowMethodsList = false;
      this.$emit('manage');
    },

    //
    doNothing: function doNothing() {
      //
    },
    mutateCardNumber: function mutateCardNumber(number) {
      var safeString = '**** **** **** ';
      var lastChars = number.slice(number.length - 4, number.length);
      safeString = safeString + lastChars;
      return safeString;
    },

    //
    openSignIn: function openSignIn() {
      this.$emit('signin');
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12320a18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("v5qv");
function injectStyle (ssrContext) {
  __webpack_require__("DBC8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12320a18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MIjC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_C2b_vue__ = __webpack_require__("WpJu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f94c9be0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_C2b_vue__ = __webpack_require__("EwRc");
function injectStyle (ssrContext) {
  __webpack_require__("bz1L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f94c9be0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_C2b_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f94c9be0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_C2b_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MgcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("tqbw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df2453a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("t70U");
function injectStyle (ssrContext) {
  __webpack_require__("X7Jf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5df2453a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df2453a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mvmb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/layout.1a19dfd.jpg";

/***/ }),

/***/ "N5XW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NCXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4_firebase__["initializeApp"]({
      apiKey: 'AIzaSyB1aiQ128dfj5nspFdMQk8EdH28V7M67EI',
      authDomain: 'checkout-redesign-89a9e.firebaseapp.com',
      databaseURL: 'https://checkout-redesign-89a9e.firebaseio.com',
      projectId: 'checkout-redesign-89a9e',
      storageBucket: 'checkout-redesign-89a9e.appspot.com',
      messagingSenderId: '685302588169'
    });
  }
});

/***/ }),

/***/ "NZtO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NgNI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: null,
      showFullDescription: false,
      selectedFormat: 'kindle',
      selectedTab: 'description',
      isBeingAddedToCart: false,
      //
      scrollable: null,
      didScroll: false
    };
  },

  props: ['selectedForPreview'],
  methods: {
    checkScrollPosition: function checkScrollPosition() {
      if (this.scrollable.scrollTop > 10) {
        this.didScroll = true;
      } else {
        this.didScroll = false;
      }
    },
    closePressed: function closePressed() {
      this.$emit('close');
    },
    doThis: function doThis() {
      console.log('hi');
    },
    addPressed: function addPressed() {
      var _this = this;

      this.isBeingAddedToCart = true;
      setTimeout(function () {
        _this.$emit('addToCart', _this.item);
      }, 500);
    }
  },
  created: function created() {
    var _this2 = this;

    this.item = this.selectedForPreview;
    setTimeout(function () {
      _this2.scrollable = document.getElementById('watchMeScroll');
    }, 100);
  }
});

/***/ }),

/***/ "Ngiv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__ = __webpack_require__("ATFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42de18ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__ = __webpack_require__("iZkV");
function injectStyle (ssrContext) {
  __webpack_require__("SWuk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42de18ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42de18ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ni2v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100vh","overflow":"auto"}},[_c('div',{staticClass:"padding-hor-l padding-vert-m black flexy",staticStyle:{"height":"80px","background-color":"#232f3e"}},[_c('div',[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'Start'}}},[_vm._v("Amazon")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px"}},[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_vm._v("Cart")])])]),_vm._v(" "),(_vm.currentView === 'Start')?_c('Start'):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShoppingCart')?_c('ShoppingCart',{attrs:{"cart":_vm.cart,"alsoItems":_vm.alsoItems,"recentItems":_vm.recentItems,"extraItems":_vm.extraItems},on:{"confirmed":function($event){_vm.shoppingCartConfirmed($event)}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShippingAddress')?_c('ShippingAddress',{on:{"confirmed":function($event){_vm.shippingAddressConfirmed()},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'PaymentMethod')?_c('PaymentMethod',{on:{"confirmed":function($event){_vm.paymentMethodConfirmed()},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ExtraSignup')?_c('ExtraSignup'):_vm._e(),_vm._v(" "),(_vm.currentView === 'Checkout')?_c('div',{attrs:{"id":"checkout"}},[_c('div',{staticClass:"padding-hor-l"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flexy align-top"},[_c('div',[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{attrs:{"isShippingFilled":_vm.isShippingFilled},on:{"edit":function($event){_vm.currentView = 'ShippingAddress'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('PaymentMethodMin',{attrs:{"isPaymentFilled":_vm.isPaymentFilled},on:{"edit":function($event){_vm.currentView = 'PaymentMethod'}}})],1),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch"},[_c('ShoppingCartMin',{attrs:{"cart":_vm.cart},on:{"edit":function($event){_vm.currentView = 'ShoppingCart'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('Delivery',{attrs:{"chosenDelivery":_vm.chosenDelivery}})],1)]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('OrderSummary',{attrs:{"isShippingFilled":_vm.isShippingFilled,"isPaymentFilled":_vm.isPaymentFilled},on:{"placed":function($event){_vm.currentView = 'ExtraSignup'}}})],1)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l flexy"},[_c('h1',[_vm._v("Checkout")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NoGu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__ = __webpack_require__("xL07");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  components: {
    QuickPreview: __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__["a" /* default */]
  },
  props: ['cart', 'alsoItems', 'recentItems', 'extraItems'],
  data: function data() {
    return {
      items: [],
      also: [],
      recent: [],
      extra: [],
      later: [],
      doShowPreview: false,
      selectedForPreview: null,
      youRecentlyViewed: 'You recently viewed'
    };
  },

  computed: {
    subtotal: function subtotal() {
      var result = 0;
      for (var i in this.items) {
        result += this.items[i].price * this.items[i].quantity;
      }
      return result.toFixed(2);
    }
  },
  methods: {
    checkoutPressed: function checkoutPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('confirmed', this.items);
    },
    removeItemPressed: function removeItemPressed(index) {
      this.items.splice(index, 1);
    },
    xPressed: function xPressed(index) {
      this.items[index].isXPressed = !this.items[index].isXPressed;
      this.youRecentlyViewed = this.youRecentlyViewed + ' ';
      // this.also.splice(index, 1)
      // for (let i in this.items) {
      //   let currentItem = this.items[i]
      //   currentItem['updated'] = Math.random() * (100 - 5) + 5
      //   console.log(currentItem['updated'])
      // }
    },
    saveForLaterPressed: function saveForLaterPressed(index) {
      var tempItem = this.items[index];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.later.push(this.items[index]);
      this.items.splice(index, 1);
    },
    addFromLaterPressed: function addFromLaterPressed(index) {
      var _this = this;

      this.later[index].isBeingAddedToCart = true;
      this.items.push(this.later[index]);
      setTimeout(function () {
        _this.later.splice(index, 1);
      }, 500);
    },
    addFromAlsoPressed: function addFromAlsoPressed(index) {
      var _this2 = this;

      this.also[index].isBeingAddedToCart = true;
      this.items.push(this.also[index]);
      setTimeout(function () {
        _this2.also.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this2.extra.length > 0) {
          _this2.also.push(_this2.extra[0]);
          _this2.extra.splice(0, 1);
        }
      }, 1000);
    },
    addFromRecentPressed: function addFromRecentPressed(index) {
      var _this3 = this;

      this.recent[index].isBeingAddedToCart = true;
      this.items.push(this.recent[index]);
      setTimeout(function () {
        _this3.recent.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this3.extra.length > 0) {
          _this3.recent.push(_this3.extra[0]);
          _this3.extra.splice(0, 1);
        }
      }, 1000);
      // var rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.right, rect.bottom, rect.left);
      // let lastIndex = this.items.length - 1
      // let lastItem = document.getElementById('cart-item-' + lastIndex)
      // console.log(lastItem)
      // console.log('cart-item-' + lastIndex)
      // let rect = lastItem.getBoundingClientRect()
      // console.log(rect)
      // let position = 0 + (this.items.length * 136)
      // window.scroll({
      //   top: position,
      //   left: 0,
      //   behavior: 'smooth'
      // })
    },
    addedToCartFromPreview: function addedToCartFromPreview(item) {
      if (item.section === 'items') {
        this.items[item.index].quantity = this.items[item.index].quantity + 1;
      } else if (item.section === 'recent') {
        this.addFromRecentPressed(item.index);
      } else if (item.section === 'also') {
        this.addFromAlsoPressed(item.index);
      } else if (item.section === 'later') {
        this.addFromLaterPressed(item.index);
      }
      this.doShowPreview = false;
    },
    openPreview: function openPreview(section, index) {
      if (section === 'items') {
        this.doShowPreview = true;
        this.selectedForPreview = this.items[index];
      } else if (section === 'recent') {
        this.doShowPreview = true;
        this.selectedForPreview = this.recent[index];
      } else if (section === 'also') {
        this.doShowPreview = true;
        this.selectedForPreview = this.also[index];
      } else if (section === 'later') {
        this.doShowPreview = true;
        this.selectedForPreview = this.later[index];
      }
      this.selectedForPreview['section'] = section;
      this.selectedForPreview['index'] = index;
    }
  },
  created: function created() {
    for (var i in this.cart) {
      var tempItem = this.cart[i];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.items.push(tempItem);
    }
    for (var _i in this.alsoItems) {
      var _tempItem = this.alsoItems[_i];
      _tempItem['isBeingAddedToCart'] = false;
      this.also.push(_tempItem);
    }
    for (var _i2 in this.recentItems) {
      var _tempItem2 = this.recentItems[_i2];
      _tempItem2['isBeingAddedToCart'] = false;
      this.recent.push(_tempItem2);
    }
    for (var _i3 in this.extraItems) {
      var _tempItem3 = this.extraItems[_i3];
      _tempItem3['isBeingAddedToCart'] = false;
      this.extra.push(_tempItem3);
    }
  }
});

/***/ }),

/***/ "NzJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-hor-xl fixed",class:{shadowyBottom: _vm.didScroll},staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"24px","z-index":"200","transition":"all .4s"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[(_vm.mode === 'add')?_c('span',[_vm._v("New payment information")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('span',[_vm._v("Edit payment information")]):_vm._e(),_vm._v(" "),(_vm.mode === 'manage')?_c('span',[_vm._v("Manage payment information")]):_vm._e()]),_vm._v(" "),(this.mode === 'manage')?_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.$emit('cancelled')}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl",class:{roundBottom: _vm.mode === 'manage'},staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"","padding-bottom":"12px"},attrs:{"id":"watchMeScroll"},on:{"scroll":_vm.checkScrollPosition}},[(this.mode === 'manage')?_c('div',[_vm._l((_vm.payments),function(payment,i){return _c('div',{key:i,staticClass:"flexy",staticStyle:{"padding":"12px 0"}},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(payment.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.month)+" / "+_vm._s(payment.year))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"#409EFF"},on:{"click":function($event){_vm.editSelectedPressed(i)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"silver"},on:{"click":function($event){_vm.deleteSelectedPressed(i)}}},[_vm._v("Delete")])])])}),_vm._v(" "),_c('div',{staticClass:"clickable flexy",staticStyle:{"padding":"24px 0 12px","color":"#409EFF","font-weight":"500","font-size":"14px"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("\n            Add new payment method\n          ")])],2):_vm._e(),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"cardName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number.value),expression:"number.value"}],class:{errorInputHighlight: !_vm.number.isValid && !_vm.number.wasFocused},attrs:{"type":"text","name":"","id":"cardNumber"},domProps:{"value":(_vm.number.value)},on:{"focus":function($event){_vm.number.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.number, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.number.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.number.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month.value),expression:"month.value"}],class:{errorInputHighlight: !_vm.month.isValid && !_vm.month.wasFocused},on:{"focus":function($event){_vm.month.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.month, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose month...")]),_vm._v(" "),_c('option',[_vm._v("01")]),_vm._v(" "),_c('option',[_vm._v("02")]),_vm._v(" "),_c('option',[_vm._v("03")]),_vm._v(" "),_c('option',[_vm._v("04")]),_vm._v(" "),_c('option',[_vm._v("05")]),_vm._v(" "),_c('option',[_vm._v("06")]),_vm._v(" "),_c('option',[_vm._v("07")]),_vm._v(" "),_c('option',[_vm._v("08")]),_vm._v(" "),_c('option',[_vm._v("09")]),_vm._v(" "),_c('option',[_vm._v("10")]),_vm._v(" "),_c('option',[_vm._v("11")]),_vm._v(" "),_c('option',[_vm._v("12")])]),_vm._v(" "),(!_vm.month.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.month.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year.value),expression:"year.value"}],class:{errorInputHighlight: !_vm.year.isValid && !_vm.year.wasFocused},on:{"focus":function($event){_vm.year.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.year, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose year...")]),_vm._v(" "),_c('option',[_vm._v("17")]),_vm._v(" "),_c('option',[_vm._v("18")]),_vm._v(" "),_c('option',[_vm._v("19")]),_vm._v(" "),_c('option',[_vm._v("20")]),_vm._v(" "),_c('option',[_vm._v("21")]),_vm._v(" "),_c('option',[_vm._v("22")]),_vm._v(" "),_c('option',[_vm._v("23")]),_vm._v(" "),_c('option',[_vm._v("24")]),_vm._v(" "),_c('option',[_vm._v("25")]),_vm._v(" "),_c('option',[_vm._v("26")]),_vm._v(" "),_c('option',[_vm._v("27")])]),_vm._v(" "),(!_vm.year.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.year.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])])]):_vm._e()]),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',{staticClass:"fixed padding-hor-xl padding-vert-m",class:{shadowyTop: _vm.doesHaveScrollDown},staticStyle:{"z-index":"200","background-color":"white","text-align":"right","border-radius":"0 0 10px 10px","transition":"all .4s"}},[_c('button',{staticClass:"boxed primary properGrey",staticStyle:{"margin-right":"4px"},on:{"click":function($event){_vm.cancelPressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary properBlue",staticStyle:{"min-width":"120px"},on:{"click":_vm.savePressed}},[_vm._v("Save")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OBtp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("izy8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05286e9d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("m1iD");
function injectStyle (ssrContext) {
  __webpack_require__("ImmR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05286e9d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05286e9d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OEdX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/evidence.1d5559d.jpg";

/***/ }),

/***/ "ONaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  props: ['cart'],
  data: function data() {
    return {};
  },

  methods: {
    editPressed: function editPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('edit');
    }
  }
});

/***/ }),

/***/ "Oldj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  props: ['cart'],
  data: function data() {
    return {};
  },

  methods: {
    editPressed: function editPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('edit');
    }
  }
});

/***/ }),

/***/ "P+u0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/100.826a75a.jpg";

/***/ }),

/***/ "P0kv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-hello-container hello padding-vert-s padding-hor-xl"},[_c('div',{staticClass:"padding-vert-l padding-hor-l",staticStyle:{"max-width":"400px","margin":"0 auto"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"padding-vert-m"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',{staticClass:"fixed text-grey",staticStyle:{"width":"140px"}},[_vm._v("Latest versions")]),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"tag":"a","to":"/D/3"}},[_vm._v("D3: Extra screen, cherries on top")])],1)])]),_vm._v(" "),_vm._m(3)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l"},[_c('h1',{staticStyle:{"font-size":"32px","font-weight":"900"}},[_vm._v("Amazon Checkout Redesign Concept")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',{staticClass:"fixed text-grey",staticStyle:{"width":"140px"}},[_vm._v("Platform")]),_vm._v(" "),_c('div',[_vm._v("Desktop")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',{staticClass:"fixed text-grey",staticStyle:{"width":"140px"}},[_vm._v("Latest iteration")]),_vm._v(" "),_c('div',[_vm._v("Shipping and payment design")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs"},[_c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',{staticClass:"fixed text-grey",staticStyle:{"width":"140px"}},[_vm._v("Created by")]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"http://twitter.com/andgordy","target":"_blank"}},[_vm._v("And Gordy")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',{staticClass:"fixed text-grey",staticStyle:{"width":"140px"}},[_vm._v("Latest update")]),_vm._v(" "),_c('div',[_vm._v("Jan 8")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P7Lt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("oXD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e863653_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("ie/i");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e863653_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P83h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bab92c84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("IC3a");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bab92c84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PF3y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/css.2bcaf6c.jpg";

/***/ }),

/***/ "PZli":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PaQA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad8a3d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("tocp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad8a3d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PjnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_867938cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("g3bU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_867938cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Po17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: null,
      showFullDescription: false,
      selectedFormat: 'kindle',
      selectedTab: 'description',
      isBeingAddedToCart: false
    };
  },

  props: ['selectedForPreview'],
  methods: {
    closePressed: function closePressed() {
      this.$emit('close');
    },
    doThis: function doThis() {
      console.log('hi');
    },
    addPressed: function addPressed() {
      var _this = this;

      this.isBeingAddedToCart = true;
      setTimeout(function () {
        _this.$emit('addToCart', _this.item);
      }, 500);
    }
  },
  created: function created() {
    this.item = this.selectedForPreview;
  }
});

/***/ }),

/***/ "PrLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QAeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("Wmg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b740ab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("qicr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b740ab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QDZD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QcrA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.doShowAddressManager)?_c('ShippingAddress',{attrs:{"mode":_vm.addressMode,"addresses":_vm.addresses,"selectedAddress":_vm.selectedAddressForEditing},on:{"add":function($event){_vm.addAddressPressed()},"edit":function($event){_vm.editAddressPressed($event)},"delete":function($event){_vm.deleteAddressPressed($event)},"saveNew":function($event){_vm.shippingAddressSaveNew($event)},"saveExisting":function($event){_vm.shippingAddressSaveExisting($event)},"backToManager":function($event){_vm.shippingAddressCancelledBackToManager()},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.doShowPaymentManager)?_c('PaymentMethod',{attrs:{"mode":_vm.paymentMode,"payments":_vm.payments,"selectedPayment":_vm.selectedPaymentForEditing},on:{"add":function($event){_vm.addPaymentPressed()},"edit":function($event){_vm.editPaymentPressed($event)},"delete":function($event){_vm.deletePaymentPressed($event)},"saveNew":function($event){_vm.paymentMethodSaveNew($event)},"saveExisting":function($event){_vm.paymentMethodSaveExisting($event)},"backToManager":function($event){_vm.paymentMethodCancelledBackToManager()},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),_c('div',[_c('div',[_c('div',{staticClass:"flexy align-stretch",staticStyle:{"flex-direction":"row-reverse"}},[_c('OrderSummary',{class:{dimmed: _vm.selectedAddress === null || _vm.selectedPayment === null},attrs:{"selectedAddress":_vm.selectedAddress,"selectedPayment":_vm.selectedPayment,"cart":_vm.cart,"delivery":_vm.chosenDelivery},on:{"placed":function($event){_vm.placeOrderPressed()}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{class:{dimmed: _vm.selectedAddress !== null && _vm.selectedPayment === null},attrs:{"selectedAddress":_vm.selectedAddress,"addresses":_vm.addresses,"reactivator":_vm.reactivator},on:{"add":function($event){_vm.addAddressPressed()},"signin":function($event){_vm.signInPressed()},"manage":function($event){_vm.manageAddressPressed()}}}),_vm._v(" "),_c('PaymentMethodMin',{class:{dimmed: _vm.selectedAddress === null},attrs:{"selectedPayment":_vm.selectedPayment,"payments":_vm.payments,"reactivator":_vm.reactivator},on:{"add":function($event){_vm.addPaymentPressed()},"signin":function($event){_vm.signInPressed()},"manage":function($event){_vm.managePaymentPressed()}}})],1),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch",staticStyle:{"padding-top":"32px"}},[_c('ShoppingCartMin',{class:{dimmed: _vm.selectedAddress === null || _vm.selectedPayment === null}}),_vm._v(" "),_c('Delivery',{class:{dimmed: _vm.selectedAddress === null || _vm.selectedPayment === null}})],1)]),_vm._v(" "),(_vm.doShowSignIn)?_c('SignIn',{on:{"close":function($event){_vm.signInClosed()},"login":_vm.loginPressed}}):_vm._e()],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QdQY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__ = __webpack_require__("Efea");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b29988c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__ = __webpack_require__("ecvi");
function injectStyle (ssrContext) {
  __webpack_require__("N5XW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b29988c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b29988c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QetE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qr6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-hor-l fixed flexy align-top",staticStyle:{"width":"50%"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("lzwN"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Shipping address")]),_vm._v(" "),(_vm.selectedAddress === null)?_c('div',{staticStyle:{"padding-top":"12px","position":"relative"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"background-color":"#3a84e8"},on:{"click":_vm.addPressed}},[_vm._v("Add shipping address")]),_vm._v(" "),(!_vm.isSignedIn)?_c('div',{staticStyle:{"font-size":"14px","padding-top":"12px"}},[_c('button',{staticStyle:{"font-size":"13px","padding":"3px 8px","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.openSignIn()}}},[_vm._v("Sign in")]),_vm._v(" for 1-click checkout")]):_vm._e()]):_c('div',{staticStyle:{"padding-top":"8px"}},[_c('div',[_vm._v(_vm._s(_vm.addresses[_vm.selectedAddress].name))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.addresses[_vm.selectedAddress].address1)+" ")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.addresses[_vm.selectedAddress].city)+", "+_vm._s(_vm.addresses[_vm.selectedAddress].state)+", "+_vm._s(_vm.addresses[_vm.selectedAddress].country))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.addresses[_vm.selectedAddress].phone))]),_vm._v(" "),_c('div',{staticStyle:{"color":"transparent","width":"0","height":"0","overflow":"hidden"}},[_vm._v(_vm._s(_vm.reactivator))]),_vm._v(" "),_c('transition',{attrs:{"name":"popover"}},[(_vm.doShowAddressesList)?_c('div',[_c('div',{staticClass:"popover-curtain",on:{"click":function($event){_vm.doShowAddressesList=false}}}),_vm._v(" "),_c('div',{staticClass:"popover-content",on:{"click":function($event){$event.stopPropagation();_vm.doNothing($event)}}},[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":function($event){_vm.choosePressed(i)}}},[_c('div',{class:{selectedItem: i === _vm.selectedAddress},staticStyle:{"padding":"12px 24px"}},[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])])])}),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px","margin-top":"4px"},on:{"click":_vm.addNewAddressPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Add new address")])])]),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":_vm.manageAddressesPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Manage addresses")])])])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"10px"}},[_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":_vm.changePressed}},[_vm._v("\n            Change\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R0Mz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"1"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"1")},on:{"change":function($event){_vm.chosenDelivery="1"}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"2"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"2")},on:{"change":function($event){_vm.chosenDelivery="2"}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"3"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"3")},on:{"change":function($event){_vm.chosenDelivery="3"}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"4"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"4")},on:{"change":function($event){_vm.chosenDelivery="4"}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"5"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"5")},on:{"change":function($event){_vm.chosenDelivery="5"}}}),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',[_vm._v("FREE shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',[_vm._v("$6.98 - Standart shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("$13.98 - Two-Day Shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',[_vm._v("$20.98 - One-Day Shipping")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R0pv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedPayment'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      number: { value: '', isValid: true, wasFocused: false },
      month: { value: '', isValid: true, wasFocused: false },
      year: { value: '', isValid: true, wasFocused: false }
    };
  },

  methods: {
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      this.$emit('confirmed', {
        name: this.name.value,
        number: this.number.value,
        month: this.month.value,
        year: this.year.value
      });
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.number.isValid = true;
      this.month.isValid = true;
      this.year.isValid = true;
      //
      this.name.wasFocused = false;
      this.number.wasFocused = false;
      this.month.wasFocused = false;
      this.year.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.number.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.number.isValid = false;
      }
      if (this.month.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.month.isValid = false;
      }
      if (this.year.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.year.isValid = false;
      }
      return hasErrors;
    }
  },
  created: function created() {
    if (this.selectedPayment !== null) {
      this.name = { value: this.selectedPayment.name, isValid: true, wasFocused: false };
      this.number = { value: this.selectedPayment.number, isValid: true, wasFocused: false };
      this.month = { value: this.selectedPayment.month, isValid: true, wasFocused: false };
      this.year = { value: this.selectedPayment.year, isValid: true, wasFocused: false };
    }
  }
});

/***/ }),

/***/ "R4sD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "RMmP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABxSURBVHgB7dXRDYAwCEVRcALdwM2cwRGctG5gN8AygLaxSWuTexLCDwnw9UQAAADwyMy2VJe1F3x37j4teCCktkofUVWXt4FJ8mbpJ+YGSh7YU53Snh9/CACMjSSuQxI7khgAviOJ65DEjiQGAAD4qRtuwpSVxu98KwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "RVgH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sprint.4db9f47.jpg";

/***/ }),

/***/ "RVx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-m black flexy",staticStyle:{"height":"80px"}},[_c('div',[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'Start'}}},[_vm._v("Amazon ")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px"}},[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_vm._v("Cart")])])]),_vm._v(" "),(_vm.currentView === 'Start')?_c('Start'):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShoppingCart')?_c('ShoppingCart',{attrs:{"cart":_vm.cart},on:{"confirmed":function($event){_vm.shoppingCartConfirmed()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShippingAddress')?_c('ShippingAddress',{on:{"confirmed":function($event){_vm.shippingAddressConfirmed()},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'PaymentMethod')?_c('PaymentMethod',{on:{"confirmed":function($event){_vm.paymentMethodConfirmed()},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ExtraSignup')?_c('ExtraSignup'):_vm._e(),_vm._v(" "),(_vm.currentView === 'Checkout')?_c('div',{attrs:{"id":"checkout"}},[_c('div',{staticClass:"padding-hor-l"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flexy align-top"},[_c('div',[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{attrs:{"isShippingFilled":_vm.isShippingFilled},on:{"edit":function($event){_vm.currentView = 'ShippingAddress'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('PaymentMethodMin',{attrs:{"isPaymentFilled":_vm.isPaymentFilled},on:{"edit":function($event){_vm.currentView = 'PaymentMethod'}}})],1),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch"},[_c('ShoppingCartMin',{attrs:{"cart":_vm.cart},on:{"edit":function($event){_vm.currentView = 'ShoppingCart'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('Delivery',{attrs:{"chosenDelivery":_vm.chosenDelivery}})],1)]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('OrderSummary',{attrs:{"isShippingFilled":_vm.isShippingFilled,"isPaymentFilled":_vm.isPaymentFilled},on:{"placed":function($event){_vm.currentView = 'ExtraSignup'}}})],1)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l flexy"},[_c('h1',[_vm._v("Checkout")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RtV/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RvTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("tSVD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3552373f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("D/U2");
function injectStyle (ssrContext) {
  __webpack_require__("58A6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3552373f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3552373f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S1BV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__ = __webpack_require__("isfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bc64dce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__ = __webpack_require__("1pjW");
function injectStyle (ssrContext) {
  __webpack_require__("Lge5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bc64dce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bc64dce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S8Pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"},on:{"click":function($event){_vm.closePressed()}}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"800px","margin":"5vh auto","background-color":"white","border-radius":"2px","box-shadow":"0px 12px 36px rgba(0,0,0,0.1)"},on:{"click":function($event){$event.stopPropagation();_vm.doThis()}}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"height":"7vh","border-bottom":"1px solid #DDE1EB"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[_vm._v("Quick Preview")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.closePressed()}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticStyle:{"max-height":"80vh","overflow":"auto"}},[_c('div',{staticClass:"flexy align-top padding-hor-l padding-vert-l"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"220px"}},[_c('img',{attrs:{"src":_vm.item.img,"width":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.item.name))])]),_vm._v(" "),_c('div',[_vm._v("by "+_vm._s(_vm.item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-m",staticStyle:{"background-color":"pink","display":"inline-block"}},[_vm._v("#1 Bestseller in Industrial Product Design")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s flexy"},[_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'kindle'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'kindle'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Kindle book")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$17.63")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'hardcover'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'hardcover'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Hardcover")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$18.89")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'paperback'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'paperback'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Paperback")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$55.77")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[(!_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed subtle-primary",staticStyle:{"background-color":"#b3ffb3","color":"green","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l padding-hor-l"},[_c('div',{staticClass:"flexy rounded"},[_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'description'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none","border-top-left-radius":"6px","border-bottom-left-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'description'}}},[_vm._v("\n              Description\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'editors'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none"},on:{"click":function($event){_vm.selectedTab = 'editors'}}},[_vm._v("\n              Editorial reviews\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'user'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-top-right-radius":"6px","border-bottom-right-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'user'}}},[_vm._v("\n              User reviews\n            ")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-xs"},[(_vm.selectedTab === 'description')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Why do some products capture widespread attention while others flop? What makes us engage with certain products out of sheer habit? Is there a pattern underlying how technologies hook us?")]),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Nir Eyal answers these questions (and many more) by explaining the Hook Model—a four-step process embedded into the products of many successful companies to subtly encourage customer behavior. Through consecutive “hook cycles,” these products reach their ultimate goal of bringing users back again and again without depending on costly advertising or aggressive messaging.")]):_vm._e(),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Hooked is based on Eyal’s years of research, consulting, and practical experience. He wrote the book he wished had been available to him as a start-up founder—not abstract theory, but a how-to guide for building better products. Hooked is written for product managers, designers, marketers, start-up founders, and anyone who seeks to understand how products influence our behavior.")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'editors')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Publisher's Weekly")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Eric Ries, author of The Lean Startup")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Boris Veldhuijzen van Zanten, founder of The Next Web ")])])])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'user')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SEN9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SKvP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SPtR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l",staticStyle:{"background-color":"#f1f3f7"}},[_c('div',{staticClass:"padding-vert-l flexy align-top"},[_c('div',[_c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l rounded silver",staticStyle:{"padding":"12px 40px","background-color":"white","box-shadow":"0px 7px 24px rgba(0,0,0,0.1)"}},[_c('div',{},[_c('h1',{staticStyle:{"padding":"24px 0","font-size":"24px","font-weight":"600","border-bottom":"1px solid #EBEEF5"}},[_vm._v("Shopping Cart")])]),_vm._v(" "),_c('transition-group',{staticStyle:{"padding":"12px 0"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.items),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item large"},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('items', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-right":"24px","padding-top":"4px"}},[_c('div',{staticStyle:{"font-size":"16px","font-weight":"500"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey padding-vert-xs"},[_vm._v(_vm._s(item.availability)+", "+_vm._s(item.seller))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px","padding-top":"8px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticStyle:{"min-width":"auto","width":"60px","background-color":"rgba(255,255,255,0.6)"},attrs:{"name":"quantity","id":"item-quantity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"20px","margin-right":"12px","padding-top":"6px"}},[(!item.isXPressed)?_c('button',{on:{"click":function($event){_vm.xPressed(i)}}},[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1"},attrs:{"src":__webpack_require__("5F5F")}})]):_vm._e(),_vm._v(" "),(item.isXPressed)?_c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"90","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.xPressed(i)}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-xs rounded",staticStyle:{"position":"relative","width":"160px","transform":"translate(-130px, -12px)","z-index":"120","background-color":"white","box-shadow":"0px 4px 12px rgba(0,0,0,0.0.5)"}},[_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"#409EFF","margin":"0"},on:{"click":function($event){_vm.saveForLaterPressed(i)}}},[_vm._v("Save for later")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"#fd3737","margin":"0"},on:{"click":function($event){_vm.removeItemPressed(i)}}},[_vm._v("Remove from cart")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"silver","margin":"0"},on:{"click":function($event){_vm.xPressed(i)}}},[_vm._v("Cancel")])])]):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"padding-vert-m flexy",staticStyle:{"padding-top":"24px","padding-bottom":"32px","border-top":"1px solid #EBEEF5"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"102px"}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"16px","font-weight":"500"}},[_vm._v("Subtotal")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v("$"+_vm._s(_vm.subtotal))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"132px"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"padding":"12px 29px"},on:{"click":function($event){_vm.checkoutPressed()}}},[_vm._v("Checkout")])])])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',[_c('transition',{attrs:{"name":"later-fade"}},[(_vm.later.length > 0)?_c('div',{staticStyle:{"padding":"12px 32px"}},[_c('div',[_c('h2',{staticStyle:{"padding":"32px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v("You saved for later")])]),_vm._v(" "),_c('transition-group',{staticClass:"padding-vert-m flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.later),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('later', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromLaterPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"12px 32px"}},[_c('div',[_c('h2',{staticStyle:{"padding":"32px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v(_vm._s(_vm.youRecentlyViewed))])]),_vm._v(" "),_c('transition-group',{staticClass:"padding-vert-m flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.recent),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('recent', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromRecentPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)],1)])],1),_vm._v(" "),_c('transition',{attrs:{"name":"right-column-appear","appear":""}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"320px","margin-left":"48px"}},[_c('div',{staticClass:"padding-vert-m padding-hor-xl bordered rounded silver",staticStyle:{"height":"224px","text-align":"center"}},[_c('img',{staticStyle:{"padding-top":"56px"},attrs:{"src":__webpack_require__("Kufr"),"width":"125px"}})]),_vm._v(" "),_c('div',[_c('h2',{staticStyle:{"padding":"42px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v("Customers also bought")])]),_vm._v(" "),_c('div',{},[_c('transition-group',{attrs:{"name":"list-ani"}},_vm._l((_vm.also),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item"},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('also', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromAlsoPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])])],1),_vm._v(" "),(_vm.doShowPreview)?_c('QuickPreview',{attrs:{"selectedForPreview":_vm.selectedForPreview},on:{"close":function($event){_vm.doShowPreview = false},"addToCart":function($event){_vm.addedToCartFromPreview($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SWuk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sbt8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SdiO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("gR2r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d454237e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("+lDr");
function injectStyle (ssrContext) {
  __webpack_require__("4DeO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d454237e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d454237e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SeUj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sld/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("NCXa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5187ffb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("bCzD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5187ffb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sqcr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedAddress', 'mode', 'addresses'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      address1: { value: '', isValid: true, wasFocused: false },
      city: { value: '', isValid: true, wasFocused: false },
      state: { value: '', isValid: true, wasFocused: false },
      zip: { value: '', isValid: true, wasFocused: false },
      country: { value: '', isValid: true, wasFocused: false },
      phone: { value: '', isValid: true, wasFocused: false },
      //
      shouldComeBackToManager: false,
      //
      scrollable: null,
      didScroll: false,
      doesHaveScrollDown: false
    };
  },

  methods: {
    checkScrollPosition: function checkScrollPosition() {
      this.checkIfCanScroll();
      if (this.scrollable.scrollTop > 10) {
        this.didScroll = true;
      } else {
        this.didScroll = false;
      }
    },
    checkIfCanScroll: function checkIfCanScroll() {
      if (this.scrollable.scrollHeight > this.scrollable.clientHeight && this.scrollable.scrollTop + 10 < this.scrollable.scrollHeight - this.scrollable.clientHeight) {
        this.doesHaveScrollDown = true;
      } else {
        this.doesHaveScrollDown = false;
      }
    },
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      var data = {
        name: this.name.value,
        address1: this.address1.value,
        city: this.city.value,
        state: this.state.value,
        zip: this.zip.value,
        country: this.country.value,
        phone: this.phone.value
      };
      if (this.mode === 'add') {
        this.$emit('saveNew', data);
      } else {
        this.$emit('saveExisting', data);
      }
    },
    cancelPressed: function cancelPressed() {
      if (this.shouldComeBackToManager) {
        this.$emit('backToManager');
      } else {
        this.$emit('cancelled');
      }
    },
    addPressed: function addPressed() {
      var _this = this;

      setTimeout(function () {
        _this.checkIfCanScroll();
      }, 100);
      this.shouldComeBackToManager = true;
      this.$emit('add');
      this.clearForm();
    },
    editSelectedPressed: function editSelectedPressed(index) {
      var _this2 = this;

      setTimeout(function () {
        _this2.checkIfCanScroll();
      }, 100);
      this.checkIfCanScroll();
      this.shouldComeBackToManager = true;
      this.$emit('edit', index);
      this.fillForm();
    },
    deleteSelectedPressed: function deleteSelectedPressed(index) {
      this.$emit('delete', index);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.address1.isValid = true;
      this.city.isValid = true;
      this.state.isValid = true;
      this.zip.isValid = true;
      this.country.isValid = true;
      this.phone.isValid = true;
      //
      this.name.wasFocused = false;
      this.address1.wasFocused = false;
      this.city.wasFocused = false;
      this.state.wasFocused = false;
      this.zip.wasFocused = false;
      this.country.wasFocused = false;
      this.phone.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.address1.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.address1.isValid = false;
      }
      if (this.city.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.city.isValid = false;
      }
      if (this.state.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.state.isValid = false;
      }
      if (this.zip.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.zip.isValid = false;
      }
      if (this.country.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.country.isValid = false;
      }
      if (this.phone.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.phone.isValid = false;
      }
      return hasErrors;
    },
    fillForm: function fillForm() {
      this.name = { value: this.addresses[this.selectedAddress].name, isValid: true, wasFocused: false };
      this.address1 = { value: this.addresses[this.selectedAddress].address1, isValid: true, wasFocused: false };
      this.city = { value: this.addresses[this.selectedAddress].city, isValid: true, wasFocused: false };
      this.state = { value: this.addresses[this.selectedAddress].state, isValid: true, wasFocused: false };
      this.zip = { value: this.addresses[this.selectedAddress].zip, isValid: true, wasFocused: false };
      this.country = { value: this.addresses[this.selectedAddress].country, isValid: true, wasFocused: false };
      this.phone = { value: this.addresses[this.selectedAddress].phone, isValid: true, wasFocused: false };
    },
    clearForm: function clearForm() {
      this.name = { value: '', isValid: true, wasFocused: false };
      this.address1 = { value: '', isValid: true, wasFocused: false };
      this.city = { value: '', isValid: true, wasFocused: false };
      this.state = { value: '', isValid: true, wasFocused: false };
      this.zip = { value: '', isValid: true, wasFocused: false };
      this.country = { value: '', isValid: true, wasFocused: false };
      this.phone = { value: '', isValid: true, wasFocused: false };
    }
  },
  watch: {
    selectedAddress: function selectedAddress() {
      this.fillForm();
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.mode === 'edit') {
      this.fillForm();
    }
    setTimeout(function () {
      _this3.scrollable = document.getElementById('watchMeScroll');
      _this3.checkIfCanScroll();
    }, 100);
  }
});

/***/ }),

/***/ "SsKr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SuVL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"1"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"1")},on:{"change":function($event){_vm.chosenDelivery="1"}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"2"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"2")},on:{"change":function($event){_vm.chosenDelivery="2"}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"3"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"3")},on:{"change":function($event){_vm.chosenDelivery="3"}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"4"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"4")},on:{"change":function($event){_vm.chosenDelivery="4"}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"5"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"5")},on:{"change":function($event){_vm.chosenDelivery="5"}}}),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',[_vm._v("FREE shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',[_vm._v("$6.98 - Standart shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("$13.98 - Two-Day Shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',[_vm._v("$20.98 - One-Day Shipping")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T4Tn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-hor-xl fixed",class:{shadowyBottom: _vm.didScroll},staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"24px","z-index":"200","transition":"all .4s"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[(_vm.mode === 'add')?_c('span',[_vm._v("New payment information")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('span',[_vm._v("Edit payment information")]):_vm._e(),_vm._v(" "),(_vm.mode === 'manage')?_c('span',[_vm._v("Manage payment information")]):_vm._e()]),_vm._v(" "),(this.mode === 'manage')?_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.$emit('cancelled')}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl",class:{roundBottom: _vm.mode === 'manage'},staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"","padding-bottom":"12px"},attrs:{"id":"watchMeScroll"},on:{"scroll":_vm.checkScrollPosition}},[(this.mode === 'manage')?_c('div',[_vm._l((_vm.payments),function(payment,i){return _c('div',{key:i,staticClass:"flexy",staticStyle:{"padding":"12px 0"}},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(payment.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.month)+" / "+_vm._s(payment.year))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"#409EFF"},on:{"click":function($event){_vm.editSelectedPressed(i)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"silver"},on:{"click":function($event){_vm.deleteSelectedPressed(i)}}},[_vm._v("Delete")])])])}),_vm._v(" "),_c('div',{staticClass:"clickable flexy",staticStyle:{"padding":"24px 0 12px","color":"#409EFF","font-weight":"500","font-size":"14px"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("\n            Add new payment method\n          ")])],2):_vm._e(),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"cardName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number.value),expression:"number.value"}],class:{errorInputHighlight: !_vm.number.isValid && !_vm.number.wasFocused},attrs:{"type":"text","name":"","id":"cardNumber"},domProps:{"value":(_vm.number.value)},on:{"focus":function($event){_vm.number.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.number, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.number.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.number.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month.value),expression:"month.value"}],class:{errorInputHighlight: !_vm.month.isValid && !_vm.month.wasFocused},on:{"focus":function($event){_vm.month.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.month, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose month...")]),_vm._v(" "),_c('option',[_vm._v("01")]),_vm._v(" "),_c('option',[_vm._v("02")]),_vm._v(" "),_c('option',[_vm._v("03")]),_vm._v(" "),_c('option',[_vm._v("04")]),_vm._v(" "),_c('option',[_vm._v("05")]),_vm._v(" "),_c('option',[_vm._v("06")]),_vm._v(" "),_c('option',[_vm._v("07")]),_vm._v(" "),_c('option',[_vm._v("08")]),_vm._v(" "),_c('option',[_vm._v("09")]),_vm._v(" "),_c('option',[_vm._v("10")]),_vm._v(" "),_c('option',[_vm._v("11")]),_vm._v(" "),_c('option',[_vm._v("12")])]),_vm._v(" "),(!_vm.month.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.month.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year.value),expression:"year.value"}],class:{errorInputHighlight: !_vm.year.isValid && !_vm.year.wasFocused},on:{"focus":function($event){_vm.year.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.year, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose year...")]),_vm._v(" "),_c('option',[_vm._v("17")]),_vm._v(" "),_c('option',[_vm._v("18")]),_vm._v(" "),_c('option',[_vm._v("19")]),_vm._v(" "),_c('option',[_vm._v("20")]),_vm._v(" "),_c('option',[_vm._v("21")]),_vm._v(" "),_c('option',[_vm._v("22")]),_vm._v(" "),_c('option',[_vm._v("23")]),_vm._v(" "),_c('option',[_vm._v("24")]),_vm._v(" "),_c('option',[_vm._v("25")]),_vm._v(" "),_c('option',[_vm._v("26")]),_vm._v(" "),_c('option',[_vm._v("27")])]),_vm._v(" "),(!_vm.year.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.year.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])])]):_vm._e()]),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',{staticClass:"fixed padding-hor-xl padding-vert-m",class:{shadowyTop: _vm.doesHaveScrollDown},staticStyle:{"z-index":"200","background-color":"white","text-align":"right","border-radius":"0 0 10px 10px","transition":"all .4s"}},[_c('button',{staticClass:"boxed primary properGrey",staticStyle:{"margin-right":"4px"},on:{"click":function($event){_vm.cancelPressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary properBlue",staticStyle:{"min-width":"120px"},on:{"click":_vm.savePressed}},[_vm._v("Save")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T5lq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("g979");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__ = __webpack_require__("JUjC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__ = __webpack_require__("Gndd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Delivery__ = __webpack_require__("CKiF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__ = __webpack_require__("G9wb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__ = __webpack_require__("WMRT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__ = __webpack_require__("FUWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__ = __webpack_require__("1blU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderSummary__ = __webpack_require__("99Cl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__ = __webpack_require__("CsoH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Start: __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
    ShoppingCart: __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__["a" /* default */],
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_3__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_8__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__["a" /* default */]
  },
  data: function data() {
    return {
      currentView: 'Start',
      chosenDelivery: '1',
      isShippingFilled: false,
      isPaymentFilled: false,
      cart: [{
        name: 'Beautiful Evidence',
        by: 'Edward R. Tufte',
        img: __webpack_require__("OEdX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 28.87,
        quantity: 1
      }, {
        name: 'Hooked: How to Build Habit-Forming Products',
        by: 'Nir Eyal',
        img: __webpack_require__("IBtq"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 18.56,
        quantity: 1
      }],
      alsoItems: [{
        name: 'Sprint: How to Solve Big Problems and Test New Ideas in Just Five Days',
        by: 'Jake Knapp',
        img: __webpack_require__("RVgH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.53,
        quantity: 1
      }, {
        name: 'The Lean Startup: How Today\'s Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses',
        by: 'Eric Ries',
        img: __webpack_require__("xcPX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.29,
        quantity: 1
      }, {
        name: 'The Hard Thing About Hard Things: Building a Business When There Are No Easy Answers',
        by: 'Ben Horowitz',
        img: __webpack_require__("fiE3"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 19.66,
        quantity: 1
      }, {
        name: 'Rework',
        by: 'Jason Fried',
        img: __webpack_require__("7fXA"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 17.68,
        quantity: 1
      }, {
        name: 'Remote: Office Not Required',
        by: 'Jason Fried',
        img: __webpack_require__("LhVL"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 15.59,
        quantity: 1
      }],
      recentItems: [{
        name: 'Envisioning Information',
        by: 'Edward R. Tufte',
        img: __webpack_require__("CySp"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 34.96,
        quantity: 1
      }, {
        name: 'About Face: The Essentials of Interaction Design',
        by: 'Alan Cooper',
        img: __webpack_require__("y+PD"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 36.47,
        quantity: 1
      }, {
        name: '100 Things Every Designer Needs to Know About People',
        by: 'Susan Weinschenk',
        img: __webpack_require__("P+u0"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 22.95,
        quantity: 1
      }, {
        name: 'HTML and CSS: Design and Build Websites',
        by: 'Jon Duckett',
        img: __webpack_require__("AqZH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.53,
        quantity: 1
      }],
      extraItems: [{
        name: 'CSS: The Missing Manual',
        by: 'David Sawyer McFarland',
        img: __webpack_require__("PF3y"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 24.61,
        quantity: 1
      }, {
        name: 'The Principles of Beautiful Web Design: Designing Great Web Sites is Not Rocket Science!',
        by: 'Jason Beaird',
        img: __webpack_require__("jAj8"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.23,
        quantity: 1
      }, {
        name: 'Logo Design Love: A Guide to Creating Iconic Brand Identities, 2nd Edition',
        by: 'David Airey',
        img: __webpack_require__("WOmI"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.05,
        quantity: 1
      }, {
        name: 'Layout Essentials: 100 Design Principles for Using Grids (Design Essentials)',
        by: 'Beth Tondreau',
        img: __webpack_require__("Mvmb"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.76,
        quantity: 1
      }]
    };
  },

  methods: {
    shoppingCartConfirmed: function shoppingCartConfirmed(items) {
      this.currentView = 'Checkout';
      this.cart = items;
    },
    shippingAddressConfirmed: function shippingAddressConfirmed(items) {
      this.isShippingFilled = true;
      this.currentView = 'Checkout';
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.currentView = 'Checkout';
    },
    paymentMethodConfirmed: function paymentMethodConfirmed() {
      this.isPaymentFilled = true;
      this.currentView = 'Checkout';
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.currentView = 'Checkout';
    }
  },
  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "TIZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l fixed flexy align-top",staticStyle:{"width":"50%"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("+TgY"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900","padding-bottom":"8px"}},[_vm._v("Shopping cart")]),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"flexy align-top",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"64px","margin-right":"16px"}},[_c('img',{attrs:{"src":item.img,"width":"64px"}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"font-size":"14px","padding-top":"6px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("x"+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.editPressed()}}},[_vm._v("Edit")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TOBd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Payment information")]),_vm._v(" "),(!_vm.isPaymentFilled)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add payment method")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Sam Bell")]),_vm._v(" "),_c('div',[_vm._v("**** **** **** 5457")]),_vm._v(" "),_c('div',[_vm._v("07 / 20")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TiC/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tvuf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U+4/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-hor-xl padding-vert-m fixed",staticStyle:{"width":"32%","background-color":"#F5F5F5","min-height":"100vh","position":"sticky","top":"0","height":"100%"}},[_c('div',{staticClass:"padding-hor-m",staticStyle:{"padding-top":"20px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"24px"}},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$"+_vm._s(_vm.cartSum))])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"6px"}},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$"+_vm._s(_vm.deliveryPrice === 0 ? '6.98' : _vm.deliveryPrice))])]),_vm._v(" "),(_vm.deliveryPrice === 0)?_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"6px"}},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"24px"}},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$"+_vm._s(_vm.beforeTax))])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"6px"}},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$"+_vm._s(_vm.tax))])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"24px","font-weight":"900"}},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$"+_vm._s(_vm.total))])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide properBlue",class:{properGrey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),_c('transition',{attrs:{"name":"alert"}},[(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m flexy align-top",staticStyle:{"position":"fixed","width":"340px","font-size":"13px","padding-left":"24px","padding-right":"12px","bottom":"80px","right":"32px","background-color":"white","box-shadow":"0px 4px 16px rgba(0,0,0,0.1)","border-radius":"0 6px 6px 0","border-left":"4px solid orange"}},[_c('div',[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"8px"}},[_c('ul',[(_vm.selectedAddress === null)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(_vm.selectedPayment === null)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px","margin-left":"12px"}},[_c('button',{on:{"click":function($event){_vm.showInstructions = false;}}},[_c('img',{staticClass:"button-icon dark",staticStyle:{"width":"16px","opacity":"1"},attrs:{"src":__webpack_require__("5F5F")}})])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m",staticStyle:{"font-size":"12px","color":"#878D98"}},[_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("By placing order, you agree to Amazon's "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("privacy notice")]),_vm._v(" and "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("conditions of use")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("How are shipping costs calculated?")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("You got free shipping on the eligible items in your order! ( "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("Why aren't all my items eligible?")]),_vm._v(")")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U1kL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__ = __webpack_require__("fifm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  components: {
    QuickPreview: __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__["a" /* default */]
  },
  // props: [
  // 'cart',
  // 'alsoItems',
  // 'recentItems',
  // 'extraItems',
  // 'laterItems'
  // ],
  data: function data() {
    return {
      items: [],
      also: [],
      recent: [],
      extra: [],
      later: [],
      doShowPreview: false,
      selectedForPreview: null,
      youRecentlyViewed: 'You recently viewed'
    };
  },

  computed: {
    cart: function cart() {
      return this.$store.getters.getCart;
    },
    alsoItems: function alsoItems() {
      return this.$store.getters.getAlso;
    },
    recentItems: function recentItems() {
      return this.$store.getters.getRecent;
    },
    extraItems: function extraItems() {
      return this.$store.getters.getExtra;
    },
    laterItems: function laterItems() {
      return this.$store.getters.getLater;
    },
    subtotal: function subtotal() {
      var result = 0;
      for (var i in this.items) {
        result += this.items[i].price * this.items[i].quantity;
      }
      return result.toFixed(2);
    }
  },
  methods: {
    checkoutPressed: function checkoutPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      // this.$emit('confirmed', this.items)
      this.$router.push({ name: 'Checkout2' });
    },
    removeItemPressed: function removeItemPressed(index) {
      this.items.splice(index, 1);
      //
      this.$store.dispatch('setCart', this.items);
    },
    xPressed: function xPressed(index) {
      this.items[index].isXPressed = !this.items[index].isXPressed;
      this.youRecentlyViewed = this.youRecentlyViewed + ' ';
      // this.also.splice(index, 1)
      // for (let i in this.items) {
      //   let currentItem = this.items[i]
      //   currentItem['updated'] = Math.random() * (100 - 5) + 5
      //   console.log(currentItem['updated'])
      // }
    },
    saveForLaterPressed: function saveForLaterPressed(index) {
      var tempItem = this.items[index];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.later.push(this.items[index]);
      this.items.splice(index, 1);
      //
      this.$store.dispatch('setCart', this.items);
      this.$store.dispatch('setLater', this.later);
    },
    addFromLaterPressed: function addFromLaterPressed(index) {
      var _this = this;

      this.later[index].isBeingAddedToCart = true;
      this.items.push(this.later[index]);
      setTimeout(function () {
        _this.later.splice(index, 1);
        _this.$store.dispatch('setLater', _this.later);
      }, 500);
      //
      this.$store.dispatch('setCart', this.items);
      // this.$emit('updated', this.items)
    },
    addFromAlsoPressed: function addFromAlsoPressed(index) {
      var _this2 = this;

      this.also[index].isBeingAddedToCart = true;
      this.items.push(this.also[index]);
      setTimeout(function () {
        _this2.also.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this2.extra.length > 0) {
          _this2.also.push(_this2.extra[0]);
          _this2.extra.splice(0, 1);
          _this2.$store.dispatch('setAlso', _this2.also);
          _this2.$store.dispatch('setExtra', _this2.extra);
        }
      }, 1000);
      // this.$emit('updated', this.items)
      this.$store.dispatch('setCart', this.items);
    },
    addFromRecentPressed: function addFromRecentPressed(index) {
      var _this3 = this;

      this.recent[index].isBeingAddedToCart = true;
      this.items.push(this.recent[index]);
      setTimeout(function () {
        _this3.recent.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this3.extra.length > 0) {
          _this3.recent.push(_this3.extra[0]);
          _this3.extra.splice(0, 1);
          _this3.$store.dispatch('setRecent', _this3.recent);
          _this3.$store.dispatch('setExtra', _this3.extra);
        }
      }, 1000);
      // this.$emit('updated', this.items)
      this.$store.dispatch('setCart', this.items);
      // var rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.right, rect.bottom, rect.left);
      // let lastIndex = this.items.length - 1
      // let lastItem = document.getElementById('cart-item-' + lastIndex)
      // console.log(lastItem)
      // console.log('cart-item-' + lastIndex)
      // let rect = lastItem.getBoundingClientRect()
      // console.log(rect)
      // let position = 0 + (this.items.length * 136)
      // window.scroll({
      //   top: position,
      //   left: 0,
      //   behavior: 'smooth'
      // })
    },
    addedToCartFromPreview: function addedToCartFromPreview(item) {
      if (item.section === 'items') {
        this.items[item.index].quantity = this.items[item.index].quantity + 1;
      } else if (item.section === 'recent') {
        this.addFromRecentPressed(item.index);
      } else if (item.section === 'also') {
        this.addFromAlsoPressed(item.index);
      } else if (item.section === 'later') {
        this.addFromLaterPressed(item.index);
      }
      this.doShowPreview = false;
      // this.$emit('updated', this.items)
    },
    openPreview: function openPreview(section, index) {
      if (section === 'items') {
        this.doShowPreview = true;
        this.selectedForPreview = this.items[index];
      } else if (section === 'recent') {
        this.doShowPreview = true;
        this.selectedForPreview = this.recent[index];
      } else if (section === 'also') {
        this.doShowPreview = true;
        this.selectedForPreview = this.also[index];
      } else if (section === 'later') {
        this.doShowPreview = true;
        this.selectedForPreview = this.later[index];
      }
      this.selectedForPreview['section'] = section;
      this.selectedForPreview['index'] = index;
    }
  },
  created: function created() {
    for (var i in this.cart) {
      var tempItem = this.cart[i];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.items.push(tempItem);
    }
    for (var _i in this.alsoItems) {
      var _tempItem = this.alsoItems[_i];
      _tempItem['isBeingAddedToCart'] = false;
      this.also.push(_tempItem);
    }
    for (var _i2 in this.recentItems) {
      var _tempItem2 = this.recentItems[_i2];
      _tempItem2['isBeingAddedToCart'] = false;
      this.recent.push(_tempItem2);
    }
    for (var _i3 in this.extraItems) {
      var _tempItem3 = this.extraItems[_i3];
      _tempItem3['isBeingAddedToCart'] = false;
      this.extra.push(_tempItem3);
    }
    for (var _i4 in this.laterItems) {
      var _tempItem4 = this.laterItems[_i4];
      _tempItem4['isBeingAddedToCart'] = false;
      this.later.push(_tempItem4);
    }
  }
});

/***/ }),

/***/ "U4YK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-hor-l fixed flexy align-top",staticStyle:{"width":"50%"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("lzwN"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Shipping address")]),_vm._v(" "),(_vm.selectedAddress === null)?_c('div',{staticStyle:{"padding-top":"12px"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"background-color":"#3a84e8"},on:{"click":_vm.addPressed}},[_vm._v("Add shipping address")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"12px"}},[_c('button',{staticStyle:{"font-size":"13px","padding":"3px 8px","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.openSignIn()}}},[_vm._v("Sign in")]),_vm._v(" for 1-click checkout")])]):_c('div',{staticStyle:{"padding-top":"8px"}},[_c('div',[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].name))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].address1)+" ")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].city)+", "+_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].state)+", "+_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].country))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].phone))]),_vm._v(" "),_c('div',{staticStyle:{"color":"transparent","width":"0","height":"0","overflow":"hidden"}},[_vm._v(_vm._s(_vm.reactivator))]),_vm._v(" "),_c('transition',{attrs:{"name":"popover"}},[(_vm.doShowAddressesList)?_c('div',[_c('div',{staticClass:"popover-curtain",on:{"click":function($event){_vm.doShowAddressesList=false}}}),_vm._v(" "),_c('div',{staticClass:"popover-content",on:{"click":function($event){$event.stopPropagation();_vm.doNothing($event)}}},[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":function($event){_vm.choosePressed(i)}}},[_c('div',{class:{selectedItem: i === _vm.selectedAddress},staticStyle:{"padding":"12px 24px"}},[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])])])}),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px","margin-top":"4px"},on:{"click":_vm.addNewAddressPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Add new address")])])]),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":_vm.manageAddressesPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Manage addresses")])])])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"10px"}},[_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":_vm.changePressed}},[_vm._v("\n            Change\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U6op":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "U7Tg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("6hZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8e12f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("XtQL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8e12f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U8N9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("mFaW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5eccdf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("Gi0k");
function injectStyle (ssrContext) {
  __webpack_require__("oQPp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5eccdf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5eccdf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UHEZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be73644_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("94xr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be73644_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UXL6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UaVh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"},on:{"click":function($event){_vm.closePressed()}}},[_c('div',{staticClass:"modal-container flexy align-stretch",staticStyle:{"max-width":"720px","max-height":"100vh","flex-direction":"column","margin":"0 auto","padding":"24px 0"},on:{"click":function($event){$event.stopPropagation();_vm.doThis()}}},[_c('div',{staticClass:"flexy padding-hor-xl fixed",class:{shadowyBottom: _vm.didScroll},staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"24px","z-index":"200","transition":"all .4s"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[_vm._v("Quick Preview")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.closePressed()}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl padding-vert-m roundBottom",staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"","padding-bottom":"12px"},attrs:{"id":"watchMeScroll"},on:{"scroll":_vm.checkScrollPosition}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"200px"}},[_c('img',{attrs:{"src":_vm.item.img,"width":"200px"}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"24px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),_c('div',[_vm._v("by "+_vm._s(_vm.item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',{staticStyle:{"color":"#ff9900","font-size":"18px"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"13px"}},[_vm._v("249 customer reviews")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"13px"}},[_vm._v("#1 Bestseller in Industrial Product Design")])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"16px","width":"80%"}},[_c('div',{staticClass:"fixed padding-hor-m padding-vert-s bordered rounded unselected",class:{selected: _vm.selectedFormat === 'kindle'},staticStyle:{"width":"32%","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'kindle'}}},[_c('div',{staticClass:"bookType",staticStyle:{"font-size":"13px"}},[_vm._v("Kindle book")]),_vm._v(" "),_c('div',{staticClass:"bookPrice",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("$17.63")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-m padding-vert-s bordered rounded unselected",class:{selected: _vm.selectedFormat === 'hardcover'},staticStyle:{"width":"32%","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'hardcover'}}},[_c('div',{staticClass:"bookType",staticStyle:{"font-size":"13px"}},[_vm._v("Hardcover")]),_vm._v(" "),_c('div',{staticClass:"bookPrice",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("$18.89")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-m padding-vert-s bordered rounded unselected",class:{selected: _vm.selectedFormat === 'paperback'},staticStyle:{"width":"32%","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'paperback'}}},[_c('div',{staticClass:"bookType",staticStyle:{"font-size":"13px"}},[_vm._v("Paperback")]),_vm._v(" "),_c('div',{staticClass:"bookPrice",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("$55.77")])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px","width":"80%"}},[(!_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed primary properBlue wide",on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed subtle-primary wide",staticStyle:{"background-color":"#b3ffb3","color":"green","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy rounded"},[_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'description'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none","border-top-left-radius":"6px","border-bottom-left-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'description'}}},[_vm._v("\n              Description\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'editors'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none"},on:{"click":function($event){_vm.selectedTab = 'editors'}}},[_vm._v("\n              Editorial reviews\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'user'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-top-right-radius":"6px","border-bottom-right-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'user'}}},[_vm._v("\n              User reviews\n            ")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-xs"},[(_vm.selectedTab === 'description')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Why do some products capture widespread attention while others flop? What makes us engage with certain products out of sheer habit? Is there a pattern underlying how technologies hook us?")]),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Nir Eyal answers these questions (and many more) by explaining the Hook Model—a four-step process embedded into the products of many successful companies to subtly encourage customer behavior. Through consecutive “hook cycles,” these products reach their ultimate goal of bringing users back again and again without depending on costly advertising or aggressive messaging.")]):_vm._e(),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Hooked is based on Eyal’s years of research, consulting, and practical experience. He wrote the book he wished had been available to him as a start-up founder—not abstract theory, but a how-to guide for building better products. Hooked is written for product managers, designers, marketers, start-up founders, and anyone who seeks to understand how products influence our behavior.")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'editors')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Publisher's Weekly")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Eric Ries, author of The Lean Startup")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Boris Veldhuijzen van Zanten, founder of The Next Web ")])])])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'user')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UoUA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['isShippingFilled', 'isPaymentFilled'],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.isShippingFilled && this.isPaymentFilled;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "Uqi0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("1s+U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_784bd002_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("bUjv");
function injectStyle (ssrContext) {
  __webpack_require__("4Dwj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-784bd002"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_784bd002_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UwYX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("yRkS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31962a93_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("z+yW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31962a93_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VL/s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__ = __webpack_require__("KcfH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a84b415_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__ = __webpack_require__("j1i0");
function injectStyle (ssrContext) {
  __webpack_require__("keH/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a84b415"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a84b415_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VZ47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['isPaymentFilled'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "ViXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "Vo6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("R0pv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de21644_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("vnW9");
function injectStyle (ssrContext) {
  __webpack_require__("n0oH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5de21644"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de21644_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VoS0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("ae5B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1f04d7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("sa46");
function injectStyle (ssrContext) {
  __webpack_require__("5N6G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1f04d7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1f04d7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vr5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D2_vue__ = __webpack_require__("adbi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79bcde46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D2_vue__ = __webpack_require__("zQPw");
function injectStyle (ssrContext) {
  __webpack_require__("SKvP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79bcde46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79bcde46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vtux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"border-bottom":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","border-radius":"10px 10px 0 0"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[(_vm.mode === 'add')?_c('span',[_vm._v("New payment information")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('span',[_vm._v("Edit payment information")]):_vm._e(),_vm._v(" "),(_vm.mode === 'manage')?_c('span',[_vm._v("Manage payment information")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.$emit('cancelled')}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",class:{roundBottom: _vm.mode === 'manage'},staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"16px","padding-bottom":"24px"}},[(this.mode === 'manage')?_c('div',[_vm._l((_vm.payments),function(payment,i){return _c('div',{key:i,staticClass:"flexy",staticStyle:{"padding":"12px 0"}},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(payment.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.month)+" / "+_vm._s(payment.year))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"#409EFF"},on:{"click":function($event){_vm.editSelectedPressed(i)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"silver"},on:{"click":function($event){_vm.deleteSelectedPressed(i)}}},[_vm._v("Delete")])])])}),_vm._v(" "),_c('div',{staticClass:"clickable flexy",staticStyle:{"padding":"24px 0 12px","color":"#409EFF","font-weight":"500","font-size":"14px"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("\n            Add new payment method\n          ")])],2):_vm._e(),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"cardName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number.value),expression:"number.value"}],class:{errorInputHighlight: !_vm.number.isValid && !_vm.number.wasFocused},attrs:{"type":"text","name":"","id":"cardNumber"},domProps:{"value":(_vm.number.value)},on:{"focus":function($event){_vm.number.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.number, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.number.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.number.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month.value),expression:"month.value"}],class:{errorInputHighlight: !_vm.month.isValid && !_vm.month.wasFocused},on:{"focus":function($event){_vm.month.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.month, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose month...")]),_vm._v(" "),_c('option',[_vm._v("01")]),_vm._v(" "),_c('option',[_vm._v("02")]),_vm._v(" "),_c('option',[_vm._v("03")]),_vm._v(" "),_c('option',[_vm._v("04")]),_vm._v(" "),_c('option',[_vm._v("05")]),_vm._v(" "),_c('option',[_vm._v("06")]),_vm._v(" "),_c('option',[_vm._v("07")]),_vm._v(" "),_c('option',[_vm._v("08")]),_vm._v(" "),_c('option',[_vm._v("09")]),_vm._v(" "),_c('option',[_vm._v("10")]),_vm._v(" "),_c('option',[_vm._v("11")]),_vm._v(" "),_c('option',[_vm._v("12")])]),_vm._v(" "),(!_vm.month.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.month.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year.value),expression:"year.value"}],class:{errorInputHighlight: !_vm.year.isValid && !_vm.year.wasFocused},on:{"focus":function($event){_vm.year.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.year, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose year...")]),_vm._v(" "),_c('option',[_vm._v("17")]),_vm._v(" "),_c('option',[_vm._v("18")]),_vm._v(" "),_c('option',[_vm._v("19")]),_vm._v(" "),_c('option',[_vm._v("20")]),_vm._v(" "),_c('option',[_vm._v("21")]),_vm._v(" "),_c('option',[_vm._v("22")]),_vm._v(" "),_c('option',[_vm._v("23")]),_vm._v(" "),_c('option',[_vm._v("24")]),_vm._v(" "),_c('option',[_vm._v("25")]),_vm._v(" "),_c('option',[_vm._v("26")]),_vm._v(" "),_c('option',[_vm._v("27")])]),_vm._v(" "),(!_vm.year.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.year.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])])]):_vm._e()]),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',{staticClass:"padding-hor-l",staticStyle:{"border-top":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","padding-top":"10px","text-align":"right","border-radius":"0 0 10px 10px"}},[_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary",staticStyle:{"min-width":"120px"},on:{"click":_vm.savePressed}},[_vm._v("Save")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WDex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("Lz4B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3370ecfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("mw+P");
function injectStyle (ssrContext) {
  __webpack_require__("bOPb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3370ecfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WL8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D1_vue__ = __webpack_require__("3tsk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11cd99e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D1_vue__ = __webpack_require__("1I9a");
function injectStyle (ssrContext) {
  __webpack_require__("EiU5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11cd99e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11cd99e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WMRT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("a4P+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd521a74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("D4mk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd521a74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WOmI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.64b3c31.jpg";

/***/ }),

/***/ "WUyK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3_vue__ = __webpack_require__("jgXS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca7bab4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3_vue__ = __webpack_require__("nptb");
function injectStyle (ssrContext) {
  __webpack_require__("SEN9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ca7bab4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca7bab4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WYhM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("Sqcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cce8bdc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("8Ug/");
function injectStyle (ssrContext) {
  __webpack_require__("B6lM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cce8bdc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cce8bdc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WjQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("mWGt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d907de70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("tdBL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d907de70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wmg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['isPaymentFilled'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "WpJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("xhMT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__ = __webpack_require__("1jdv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__ = __webpack_require__("Lm8A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Delivery__ = __webpack_require__("wqnM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__ = __webpack_require__("MgcM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__ = __webpack_require__("KLNC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__ = __webpack_require__("Vo6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__ = __webpack_require__("XmDK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderSummary__ = __webpack_require__("HFP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__ = __webpack_require__("BMjb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Start: __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
    ShoppingCart: __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__["a" /* default */],
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_3__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_8__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__["a" /* default */]
  },
  data: function data() {
    return {
      currentView: 'Start',
      chosenDelivery: '1',
      //
      doShowAddressManager: false,
      selectedAddress: null,
      selectedAddressForEditing: null,
      addressMode: null,
      //
      // isPaymentFilled: false,
      reactivator: 0,
      addresses: [],
      doShowPaymentManager: false,
      selectedPayment: null,
      //
      cart: [{
        name: 'Beautiful Evidence',
        by: 'Edward R. Tufte',
        img: __webpack_require__("OEdX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 28.87,
        quantity: 1
      }, {
        name: 'Hooked: How to Build Habit-Forming Products',
        by: 'Nir Eyal',
        img: __webpack_require__("IBtq"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 18.56,
        quantity: 1
      }],
      alsoItems: [{
        name: 'Sprint: How to Solve Big Problems and Test New Ideas in Just Five Days',
        by: 'Jake Knapp',
        img: __webpack_require__("RVgH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.53,
        quantity: 1
      }, {
        name: 'The Lean Startup: How Today\'s Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses',
        by: 'Eric Ries',
        img: __webpack_require__("xcPX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.29,
        quantity: 1
      }, {
        name: 'The Hard Thing About Hard Things: Building a Business When There Are No Easy Answers',
        by: 'Ben Horowitz',
        img: __webpack_require__("fiE3"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 19.66,
        quantity: 1
      }, {
        name: 'Rework',
        by: 'Jason Fried',
        img: __webpack_require__("7fXA"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 17.68,
        quantity: 1
      }, {
        name: 'Remote: Office Not Required',
        by: 'Jason Fried',
        img: __webpack_require__("LhVL"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 15.59,
        quantity: 1
      }],
      recentItems: [{
        name: 'Envisioning Information',
        by: 'Edward R. Tufte',
        img: __webpack_require__("CySp"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 34.96,
        quantity: 1
      }, {
        name: 'About Face: The Essentials of Interaction Design',
        by: 'Alan Cooper',
        img: __webpack_require__("y+PD"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 36.47,
        quantity: 1
      }, {
        name: '100 Things Every Designer Needs to Know About People',
        by: 'Susan Weinschenk',
        img: __webpack_require__("P+u0"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 22.95,
        quantity: 1
      }, {
        name: 'HTML and CSS: Design and Build Websites',
        by: 'Jon Duckett',
        img: __webpack_require__("AqZH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.53,
        quantity: 1
      }],
      extraItems: [{
        name: 'CSS: The Missing Manual',
        by: 'David Sawyer McFarland',
        img: __webpack_require__("PF3y"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 24.61,
        quantity: 1
      }, {
        name: 'The Principles of Beautiful Web Design: Designing Great Web Sites is Not Rocket Science!',
        by: 'Jason Beaird',
        img: __webpack_require__("jAj8"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.23,
        quantity: 1
      }, {
        name: 'Logo Design Love: A Guide to Creating Iconic Brand Identities, 2nd Edition',
        by: 'David Airey',
        img: __webpack_require__("WOmI"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.05,
        quantity: 1
      }, {
        name: 'Layout Essentials: 100 Design Principles for Using Grids (Design Essentials)',
        by: 'Beth Tondreau',
        img: __webpack_require__("Mvmb"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.76,
        quantity: 1
      }]
    };
  },

  methods: {
    shoppingCartConfirmed: function shoppingCartConfirmed(items) {
      this.currentView = 'Checkout';
      this.cart = items;
    },

    //
    // ADDRESS
    addAddressPressed: function addAddressPressed() {
      this.addressMode = 'add';
      this.doShowAddressManager = true;
    },
    editAddressPressed: function editAddressPressed(index) {
      this.addressMode = 'edit';
      this.selectedAddressForEditing = index;
      // this.doShowAddressManager = true
    },
    deleteAddressPressed: function deleteAddressPressed(index) {
      if (index > 0) {
        this.selectedAddress = index - 1;
      } else {
        if (this.addresses.length === 1) {
          this.selectedAddress = null;
        } else {
          this.selectedAddress = index + 1;
        }
      }
      this.addresses.splice(index, 1);
      // this.selectedAddress = index
      // this.doShowAddressManager = true
    },
    shippingAddressSaveNew: function shippingAddressSaveNew(data) {
      this.addresses.push(data);
      this.selectedAddress = this.addresses.length - 1;
      this.doShowAddressManager = false;
    },
    shippingAddressSaveExisting: function shippingAddressSaveExisting(data) {
      this.addresses[this.selectedAddressForEditing] = data;
      this.reactivator++;
      this.addressMode = 'manage';
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.doShowAddressManager = false;
    },
    changeAddressSelected: function changeAddressSelected(index) {
      this.selectedAddress = index;
    },
    manageAddressPressed: function manageAddressPressed() {
      this.addressMode = 'manage';
      this.doShowAddressManager = true;
    },

    //
    // PAYMENT
    editPaymentPressed: function editPaymentPressed() {
      this.doShowPaymentManager = true;
    },
    paymentMethodConfirmed: function paymentMethodConfirmed(data) {
      this.selectedPayment = data;
      this.doShowPaymentManager = false;
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.doShowPaymentManager = false;
    }
    //

  },
  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "Wuw7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shipping address")]),_vm._v(" "),(_vm.selectedAddress === null)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add shipping address")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v(_vm._s(_vm.selectedAddress.name))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selectedAddress.address1)+" ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selectedAddress.city)+", "+_vm._s(_vm.selectedAddress.state)+", "+_vm._s(_vm.selectedAddress.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selectedAddress.phone))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X7Jf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XHsM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("iUlw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f5a07de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("ypnT");
function injectStyle (ssrContext) {
  __webpack_require__("I9ng")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f5a07de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f5a07de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XLsW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("kvIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e057f2fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("pRtm");
function injectStyle (ssrContext) {
  __webpack_require__("b8gm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e057f2fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e057f2fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XOT9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['isPaymentFilled'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "XY0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  props: ['cart'],
  data: function data() {
    return {};
  },

  methods: {
    editPressed: function editPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('edit');
    }
  }
});

/***/ }),

/***/ "XY0W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l",staticStyle:{"background-color":"#f1f3f7"}},[_c('div',{staticClass:"padding-vert-l flexy align-top"},[_c('div',[_c('transition',{attrs:{"name":"cart-appear","appear":"","disappear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l rounded silver",staticStyle:{"padding":"12px 48px","background-color":"white","box-shadow":"0px 7px 24px rgba(0,0,0,0.1)","border-radius":"12px"}},[_c('div',{},[_c('h1',{staticStyle:{"padding":"24px 0 12px","font-size":"28px","font-weight":"600"}},[_vm._v("Shopping Cart")])]),_vm._v(" "),_c('transition-group',{staticStyle:{"padding":"12px 0"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.items),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item large"},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"100px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('items', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"40px 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-right":"24px","padding-top":"0px"}},[_c('div',{staticStyle:{"font-size":"17px","font-weight":"500"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"6px"}},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"6px"}},[_vm._v(_vm._s(item.availability)+", "+_vm._s(item.seller))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px","padding-top":"8px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticStyle:{"min-width":"auto","width":"60px","background-color":"rgba(255,255,255,0.6)"},attrs:{"name":"quantity","id":"item-quantity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"20px","margin-right":"12px","padding-top":"6px"}},[(!item.isXPressed)?_c('button',{on:{"click":function($event){_vm.xPressed(i)}}},[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1"},attrs:{"src":__webpack_require__("5F5F")}})]):_vm._e(),_vm._v(" "),(item.isXPressed)?_c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"90","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.xPressed(i)}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-xs rounded",staticStyle:{"position":"relative","width":"160px","transform":"translate(-130px, -12px)","z-index":"120","background-color":"white","box-shadow":"0px 4px 12px rgba(0,0,0,0.0.5)"}},[_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"#409EFF","margin":"0"},on:{"click":function($event){_vm.saveForLaterPressed(i)}}},[_vm._v("Save for later")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"#fd3737","margin":"0"},on:{"click":function($event){_vm.removeItemPressed(i)}}},[_vm._v("Remove from cart")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"silver","margin":"0"},on:{"click":function($event){_vm.xPressed(i)}}},[_vm._v("Cancel")])])]):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"padding-vert-m flexy",staticStyle:{"padding-top":"24px","padding-bottom":"32px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"124px"}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"16px","font-weight":"500"}},[_vm._v("Subtotal")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v("$"+_vm._s(_vm.subtotal))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"132px"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"padding":"12px 29px"},on:{"click":function($event){_vm.checkoutPressed()}}},[_vm._v("Checkout")])])])],1)])],1),_vm._v(" "),_c('transition',{attrs:{"name":"right-column-appear","appear":""}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"30%","margin-left":"48px"}},[_c('div',{staticClass:"padding-vert-m padding-hor-xl bordered rounded silver",staticStyle:{"height":"400px","text-align":"center"}},[_c('img',{staticStyle:{"padding-top":"146px"},attrs:{"src":__webpack_require__("Kufr"),"width":"125px"}})])])])],1),_vm._v(" "),_c('div',{staticClass:"padding-vert-l flexy align-top"},[_c('div',[_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',[_c('transition',{attrs:{"name":"later-fade"}},[(_vm.later.length > 0)?_c('div',{staticStyle:{"padding":"12px 32px"}},[_c('h2',{staticStyle:{"padding":"32px 0px 24px","font-size":"24px"}},[_vm._v("You saved for later")]),_vm._v(" "),_c('transition-group',{staticClass:"padding-vert-m flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.later),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"100px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('later', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromLaterPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"12px 32px"}},[_c('h2',{staticStyle:{"padding":"54px 0px 24px","font-size":"24px"}},[_vm._v(_vm._s(_vm.youRecentlyViewed))]),_vm._v(" "),_c('transition-group',{staticClass:"padding-vert-m flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.recent),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"100px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('recent', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromRecentPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)],1)])],1),_vm._v(" "),_c('transition',{attrs:{"name":"right-column-appear","appear":""}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"30%","margin-left":"48px","padding":"12px 32px"}},[_c('div',[_c('h2',{staticStyle:{"padding":"32px 0px 24px","font-size":"24px"}},[_vm._v("Customers also bought")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m"},[_c('transition-group',{attrs:{"name":"list-ani"}},_vm._l((_vm.also),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item"},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"100px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('also', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"32px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromAlsoPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])])],1),_vm._v(" "),(_vm.doShowPreview)?_c('QuickPreview',{attrs:{"selectedForPreview":_vm.selectedForPreview},on:{"close":function($event){_vm.doShowPreview = false},"addToCart":function($event){_vm.addedToCartFromPreview($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XYcd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("ZgmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8756bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("AjtT");
function injectStyle (ssrContext) {
  __webpack_require__("JX1u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f8756bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8756bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xk6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkout_vue__ = __webpack_require__("cq8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a49b3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkout_vue__ = __webpack_require__("QcrA");
function injectStyle (ssrContext) {
  __webpack_require__("4Y4D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06a49b3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a49b3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XmDK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("jEiK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb9536c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("ZCcX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb9536c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XtQL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Payment information")]),_vm._v(" "),(!_vm.isPaymentFilled)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add payment method")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Sam Bell")]),_vm._v(" "),_c('div',[_vm._v("**** **** **** 5457")]),_vm._v(" "),_c('div',[_vm._v("07 / 20")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YASv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"border-bottom":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","border-radius":"10px 10px 0 0"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[_vm._v("New shipping address")])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"16px","padding-bottom":"40px"}},[_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1.value),expression:"address1.value"}],class:{errorInputHighlight: !_vm.address1.isValid && !_vm.address1.wasFocused},attrs:{"type":"text","name":"","id":"addressLine1"},domProps:{"value":(_vm.address1.value)},on:{"focus":function($event){_vm.address1.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address1, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.address1.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.address1.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city.value),expression:"city.value"}],class:{errorInputHighlight: !_vm.city.isValid && !_vm.city.wasFocused},attrs:{"type":"text","name":"","id":"city"},domProps:{"value":(_vm.city.value)},on:{"focus":function($event){_vm.city.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.city, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.city.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.city.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],class:{errorInputHighlight: !_vm.state.isValid && !_vm.state.wasFocused},attrs:{"type":"text","name":"","id":"state"},domProps:{"value":(_vm.state.value)},on:{"focus":function($event){_vm.state.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.state.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.state.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flexy"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country.value),expression:"country.value"}],class:{errorInputHighlight: !_vm.country.isValid && !_vm.country.wasFocused},on:{"focus":function($event){_vm.country.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.country, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose country...")]),_vm._v(" "),_c('option',{attrs:{"value":"United States"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"Mexico"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"Canada"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"Brazil"}},[_vm._v("Brazil")])]),_vm._v(" "),(!_vm.country.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.country.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zip.value),expression:"zip.value"}],class:{errorInputHighlight: !_vm.zip.isValid && !_vm.zip.wasFocused},attrs:{"type":"text","name":"","id":"zip"},domProps:{"value":(_vm.zip.value)},on:{"focus":function($event){_vm.zip.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zip, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.zip.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.zip.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone.value),expression:"phone.value"}],class:{errorInputHighlight: !_vm.phone.isValid && !_vm.phone.wasFocused},attrs:{"type":"text","name":"","id":"phone"},domProps:{"value":(_vm.phone.value)},on:{"focus":function($event){_vm.phone.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.phone, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.phone.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.phone.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",staticStyle:{"border-top":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","padding-top":"10px","text-align":"right","border-radius":"0 0 10px 10px"}},[_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary",staticStyle:{"min-width":"120px"},on:{"click":_vm.savePressed}},[_vm._v("Save")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YGZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
    };
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__ = __webpack_require__("gORT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_A_1_A1_vue__ = __webpack_require__("YcjA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_A_2_A2_vue__ = __webpack_require__("ry8j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_B_1_B1_vue__ = __webpack_require__("uLoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_B_2_B2_vue__ = __webpack_require__("JZPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_B_3_B3_vue__ = __webpack_require__("CTio");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_C_1_C1_vue__ = __webpack_require__("H3ey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_C_2a_C2a_vue__ = __webpack_require__("KNSo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_C_2b_C2b_vue__ = __webpack_require__("MIjC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_C_3_C3_vue__ = __webpack_require__("vOl4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_D_1_D1_vue__ = __webpack_require__("WL8G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_D_2_D2_vue__ = __webpack_require__("Vr5B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_D_3_D3_vue__ = __webpack_require__("WUyK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_D_2_Start_vue__ = __webpack_require__("PjnU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_D_2_ShoppingCart_vue__ = __webpack_require__("qtk4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_D_2_Checkout_vue__ = __webpack_require__("Xk6L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_D_2_ExtraSignup_vue__ = __webpack_require__("5ba9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_D_3_Start_vue__ = __webpack_require__("oO6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_D_3_ShoppingCart_vue__ = __webpack_require__("BbUQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_D_3_Checkout_vue__ = __webpack_require__("ttiq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_D_3_ExtraSignup_vue__ = __webpack_require__("Kn1t");















//




//





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'HelloWorld',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__["a" /* default */]
  }, {
    path: '/A/1',
    name: 'A1',
    component: __WEBPACK_IMPORTED_MODULE_3__components_A_1_A1_vue__["a" /* default */]
  }, {
    path: '/A/2',
    name: 'A2',
    component: __WEBPACK_IMPORTED_MODULE_4__components_A_2_A2_vue__["a" /* default */]
  }, {
    path: '/B/1',
    name: 'B1',
    component: __WEBPACK_IMPORTED_MODULE_5__components_B_1_B1_vue__["a" /* default */]
  }, {
    path: '/B/2',
    name: 'B2',
    component: __WEBPACK_IMPORTED_MODULE_6__components_B_2_B2_vue__["a" /* default */]
  }, {
    path: '/B/3',
    name: 'B3',
    component: __WEBPACK_IMPORTED_MODULE_7__components_B_3_B3_vue__["a" /* default */]
  }, {
    path: '/C/1',
    name: 'C1',
    component: __WEBPACK_IMPORTED_MODULE_8__components_C_1_C1_vue__["a" /* default */]
  }, {
    path: '/C/2a',
    name: 'C2a',
    component: __WEBPACK_IMPORTED_MODULE_9__components_C_2a_C2a_vue__["a" /* default */]
  }, {
    path: '/C/2b',
    name: 'C2b',
    component: __WEBPACK_IMPORTED_MODULE_10__components_C_2b_C2b_vue__["a" /* default */]
  }, {
    path: '/C/3',
    name: 'C3',
    component: __WEBPACK_IMPORTED_MODULE_11__components_C_3_C3_vue__["a" /* default */]
  }, {
    path: '/D/1',
    name: 'D1',
    component: __WEBPACK_IMPORTED_MODULE_12__components_D_1_D1_vue__["a" /* default */]
  }, {
    path: '/D/2',
    redirect: '/D/2/start',
    name: 'D2',
    component: __WEBPACK_IMPORTED_MODULE_13__components_D_2_D2_vue__["a" /* default */],
    children: [{
      path: '/D/2/start',
      name: 'Start',
      component: __WEBPACK_IMPORTED_MODULE_15__components_D_2_Start_vue__["a" /* default */]
    }, {
      path: '/D/2/cart',
      name: 'ShoppingCart',
      component: __WEBPACK_IMPORTED_MODULE_16__components_D_2_ShoppingCart_vue__["a" /* default */]
    }, {
      path: '/D/2/checkout',
      name: 'Checkout',
      component: __WEBPACK_IMPORTED_MODULE_17__components_D_2_Checkout_vue__["a" /* default */]
    }, {
      path: '/D/2/complete',
      name: 'Complete',
      component: __WEBPACK_IMPORTED_MODULE_18__components_D_2_ExtraSignup_vue__["a" /* default */]
    }]
  }, {
    path: '/D/3',
    redirect: '/D/3/start',
    name: 'D3',
    component: __WEBPACK_IMPORTED_MODULE_14__components_D_3_D3_vue__["a" /* default */],
    children: [{
      path: '/D/3/start',
      name: 'Start2',
      component: __WEBPACK_IMPORTED_MODULE_19__components_D_3_Start_vue__["a" /* default */]
    }, {
      path: '/D/3/cart',
      name: 'ShoppingCart2',
      component: __WEBPACK_IMPORTED_MODULE_20__components_D_3_ShoppingCart_vue__["a" /* default */]
    }, {
      path: '/D/3/checkout',
      name: 'Checkout2',
      component: __WEBPACK_IMPORTED_MODULE_21__components_D_3_Checkout_vue__["a" /* default */]
    }, {
      path: '/D/3/complete',
      name: 'Complete2',
      component: __WEBPACK_IMPORTED_MODULE_22__components_D_3_ExtraSignup_vue__["a" /* default */]
    }]
  }]
}));

/***/ }),

/***/ "YcjA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A1_vue__ = __webpack_require__("mKQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fd2bcac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A1_vue__ = __webpack_require__("RVx7");
function injectStyle (ssrContext) {
  __webpack_require__("5GaQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fd2bcac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fd2bcac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YfkC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shopping cart")]),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"60px"}},[_c('img',{attrs:{"src":item.img,"width":"40px"}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',[_vm._v("Quantity: "+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.editPressed()}}},[_vm._v("Edit")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z1JO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100vh","overflow":"auto"}},[_c('div',{staticClass:"padding-hor-l padding-vert-m black flexy",staticStyle:{"height":"80px","background-color":"#232f3e"}},[_c('div',[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'Start'}}},[_vm._v("Amazon")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px"}},[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_vm._v("Cart")])])]),_vm._v(" "),(_vm.currentView === 'Start')?_c('Start'):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShoppingCart')?_c('ShoppingCart',{attrs:{"cart":_vm.cart,"alsoItems":_vm.alsoItems,"recentItems":_vm.recentItems,"extraItems":_vm.extraItems},on:{"confirmed":function($event){_vm.shoppingCartConfirmed($event)}}}):_vm._e(),_vm._v(" "),(_vm.doShowAddressManager)?_c('ShippingAddress',{attrs:{"selectedAddress":_vm.selectedAddress},on:{"confirmed":function($event){_vm.shippingAddressConfirmed($event)},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.doShowPaymentManager)?_c('PaymentMethod',{attrs:{"selectedPayment":_vm.selectedPayment},on:{"confirmed":function($event){_vm.paymentMethodConfirmed($event)},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ExtraSignup')?_c('ExtraSignup'):_vm._e(),_vm._v(" "),(_vm.currentView === 'Checkout')?_c('div',{attrs:{"id":"checkout"}},[_c('div',{staticClass:"padding-hor-l"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flexy align-top"},[_c('div',[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{attrs:{"selectedAddress":_vm.selectedAddress},on:{"edit":function($event){_vm.editAddressPressed()}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('PaymentMethodMin',{attrs:{"selectedPayment":_vm.selectedPayment},on:{"edit":function($event){_vm.editPaymentPressed()}}})],1),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch"},[_c('ShoppingCartMin',{attrs:{"cart":_vm.cart},on:{"edit":function($event){_vm.currentView = 'ShoppingCart'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('Delivery',{attrs:{"chosenDelivery":_vm.chosenDelivery}})],1)]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('OrderSummary',{attrs:{"selectedAddress":_vm.selectedAddress,"selectedPayment":_vm.selectedPayment},on:{"placed":function($event){_vm.currentView = 'ExtraSignup'}}})],1)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l flexy"},[_c('h1',[_vm._v("Checkout")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z5AA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shopping cart")]),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"60px"}},[_c('img',{attrs:{"src":item.img,"width":"40px"}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',[_vm._v("Quantity: "+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.editPressed()}}},[_vm._v("Edit")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z8sD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("EBf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e104c0b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("sBnd");
function injectStyle (ssrContext) {
  __webpack_require__("1qWs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e104c0b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e104c0b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZCcX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Payment information")]),_vm._v(" "),(_vm.selectedPayment === null)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add payment method")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v(_vm._s(_vm.selectedPayment.name))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selectedPayment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selectedPayment.month)+" / "+_vm._s(_vm.selectedPayment.year))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZDDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['selectedAddress', 'addresses', 'reactivator'],
  data: function data() {
    return {
      doShowAddressesList: false
    };
  },

  computed: {
    reactiveAddresses: function reactiveAddresses() {
      return this.addresses;
    }
  },
  methods: {
    addPressed: function addPressed() {
      this.$emit('add');
    },
    changePressed: function changePressed() {
      // if (this.selectedAddress !== null) {
      this.doShowAddressesList = true;
      // }
      // this.$emit('edit')
    },
    choosePressed: function choosePressed(index) {
      this.$emit('change', index);
      this.doShowAddressesList = false;
      //
    },
    addNewAddressPressed: function addNewAddressPressed() {
      this.doShowAddressesList = false;
      this.$emit('add');
    },
    manageAddressesPressed: function manageAddressesPressed() {
      this.doShowAddressesList = false;
      this.$emit('manage');
    },
    doNothing: function doNothing() {
      //
    },

    //
    openSignIn: function openSignIn() {
      this.$emit('signin');
    }
  }
});

/***/ }),

/***/ "ZGgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("Ku6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5584b9b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("21z6");
function injectStyle (ssrContext) {
  __webpack_require__("ptBG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5584b9b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZgmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
    };
  }
});

/***/ }),

/***/ "ZgzS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57f8843d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("ITb0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57f8843d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zu+v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"},on:{"click":function($event){_vm.closePressed()}}},[_c('div',{staticClass:"modal-container flexy align-stretch",staticStyle:{"max-width":"720px","max-height":"100vh","flex-direction":"column","margin":"0 auto","padding":"24px 0"},on:{"click":function($event){$event.stopPropagation();_vm.doThis()}}},[_c('div',{staticClass:"flexy padding-hor-xl fixed",class:{shadowyBottom: _vm.didScroll},staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"24px","z-index":"200","transition":"all .4s"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[_vm._v("Quick Preview")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.closePressed()}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl padding-vert-m roundBottom",staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"","padding-bottom":"12px"},attrs:{"id":"watchMeScroll"},on:{"scroll":_vm.checkScrollPosition}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"200px"}},[_c('img',{attrs:{"src":_vm.item.img,"width":"200px"}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"24px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),_c('div',[_vm._v("by "+_vm._s(_vm.item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',{staticStyle:{"color":"#ff9900","font-size":"18px"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"13px"}},[_vm._v("249 customer reviews")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"13px"}},[_vm._v("#1 Bestseller in Industrial Product Design")])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"16px","width":"80%"}},[_c('div',{staticClass:"fixed padding-hor-m padding-vert-s bordered rounded unselected",class:{selected: _vm.selectedFormat === 'kindle'},staticStyle:{"width":"32%","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'kindle'}}},[_c('div',{staticClass:"bookType",staticStyle:{"font-size":"13px"}},[_vm._v("Kindle book")]),_vm._v(" "),_c('div',{staticClass:"bookPrice",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("$17.63")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-m padding-vert-s bordered rounded unselected",class:{selected: _vm.selectedFormat === 'hardcover'},staticStyle:{"width":"32%","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'hardcover'}}},[_c('div',{staticClass:"bookType",staticStyle:{"font-size":"13px"}},[_vm._v("Hardcover")]),_vm._v(" "),_c('div',{staticClass:"bookPrice",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("$18.89")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-m padding-vert-s bordered rounded unselected",class:{selected: _vm.selectedFormat === 'paperback'},staticStyle:{"width":"32%","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'paperback'}}},[_c('div',{staticClass:"bookType",staticStyle:{"font-size":"13px"}},[_vm._v("Paperback")]),_vm._v(" "),_c('div',{staticClass:"bookPrice",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("$55.77")])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px","width":"80%"}},[(!_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed primary properBlue wide",on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed subtle-primary wide",staticStyle:{"background-color":"#b3ffb3","color":"green","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy rounded"},[_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'description'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none","border-top-left-radius":"6px","border-bottom-left-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'description'}}},[_vm._v("\n              Description\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'editors'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none"},on:{"click":function($event){_vm.selectedTab = 'editors'}}},[_vm._v("\n              Editorial reviews\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'user'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-top-right-radius":"6px","border-bottom-right-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'user'}}},[_vm._v("\n              User reviews\n            ")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-xs"},[(_vm.selectedTab === 'description')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Why do some products capture widespread attention while others flop? What makes us engage with certain products out of sheer habit? Is there a pattern underlying how technologies hook us?")]),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Nir Eyal answers these questions (and many more) by explaining the Hook Model—a four-step process embedded into the products of many successful companies to subtly encourage customer behavior. Through consecutive “hook cycles,” these products reach their ultimate goal of bringing users back again and again without depending on costly advertising or aggressive messaging.")]):_vm._e(),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Hooked is based on Eyal’s years of research, consulting, and practical experience. He wrote the book he wished had been available to him as a start-up founder—not abstract theory, but a how-to guide for building better products. Hooked is written for product managers, designers, marketers, start-up founders, and anyone who seeks to understand how products influence our behavior.")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'editors')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Publisher's Weekly")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Eric Ries, author of The Lean Startup")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Boris Veldhuijzen van Zanten, founder of The Next Web ")])])])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'user')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zv25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"1"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"1")},on:{"change":function($event){_vm.chosenDelivery="1"}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"2"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"2")},on:{"change":function($event){_vm.chosenDelivery="2"}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"3"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"3")},on:{"change":function($event){_vm.chosenDelivery="3"}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"4"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"4")},on:{"change":function($event){_vm.chosenDelivery="4"}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"5"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"5")},on:{"change":function($event){_vm.chosenDelivery="5"}}}),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',[_vm._v("FREE shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',[_vm._v("$6.98 - Standart shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("$13.98 - Two-Day Shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',[_vm._v("$20.98 - One-Day Shipping")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a4P+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['isShippingFilled'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "aOiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-m fixed silver rounded",staticStyle:{"width":"300px"}},[_c('h3',[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide",class:{grey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('ul',[(!_vm.isShippingFilled)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentFilled)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.87")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$96.85")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "adbi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShoppingCartMin__ = __webpack_require__("g6Ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Delivery__ = __webpack_require__("cJ1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShippingAddress__ = __webpack_require__("jC9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShippingAddressMin__ = __webpack_require__("U8N9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentMethod__ = __webpack_require__("RvTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentMethodMin__ = __webpack_require__("6bJN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderSummary__ = __webpack_require__("21Q6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExtraSignup__ = __webpack_require__("5ba9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SignIn__ = __webpack_require__("QdQY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Start from './Start'
// import ShoppingCart from './ShoppingCart'










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    // Start,
    // ShoppingCart,
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_0__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_2__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_3__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_4__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_5__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_1__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_6__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_7__ExtraSignup__["a" /* default */],
    SignIn: __WEBPACK_IMPORTED_MODULE_8__SignIn__["a" /* default */]
  },
  data: function data() {
    return {
      // addressMode: null,
      // doShowAddressManager: false,
      // selectedAddress: null,
      // selectedAddressForEditing: null,
      // addresses: [],
      //
      // paymentMode: null,
      // doShowPaymentManager: false,
      // selectedPayment: null,
      // selectedPaymentForEditing: null,
      // payments: [],
      //
      // doShowSignIn: false,
      //
    };
  },

  computed: {
    cart: function cart() {
      return this.$store.getters.getCart;
    }
  },
  methods: {
    // shoppingCartConfirmed (items) {
    //   this.currentView = 'Checkout'
    //   this.cart = items
    // },
    // shoppingCartUpdated (items) {
    //   this.cart = items
    // },
    //
    // ADDRESS
    addAddressPressed: function addAddressPressed() {
      this.addressMode = 'add';
      this.doShowAddressManager = true;
    },
    editAddressPressed: function editAddressPressed(index) {
      this.addressMode = 'edit';
      this.selectedAddressForEditing = index;
      // this.doShowAddressManager = true
    },
    deleteAddressPressed: function deleteAddressPressed(index) {
      if (index > 0) {
        this.selectedAddress = index - 1;
      } else {
        if (this.addresses.length === 1) {
          this.selectedAddress = null;
        } else {
          this.selectedAddress = index + 1;
        }
      }
      this.addresses.splice(index, 1);
      // this.selectedAddress = index
      // this.doShowAddressManager = true
    },
    shippingAddressSaveNew: function shippingAddressSaveNew(data) {
      this.addresses.push(data);
      this.selectedAddress = this.addresses.length - 1;
      this.doShowAddressManager = false;
    },
    shippingAddressSaveExisting: function shippingAddressSaveExisting(data) {
      this.addresses[this.selectedAddressForEditing] = data;
      this.reactivator++;
      this.addressMode = 'manage';
    },
    changeAddressSelected: function changeAddressSelected(index) {
      this.selectedAddress = index;
    },
    manageAddressPressed: function manageAddressPressed() {
      this.addressMode = 'manage';
      this.doShowAddressManager = true;
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.doShowAddressManager = false;
    },
    shippingAddressCancelledBackToManager: function shippingAddressCancelledBackToManager() {
      this.addressMode = 'manage';
    },

    //
    // PAYMENT
    addPaymentPressed: function addPaymentPressed() {
      this.paymentMode = 'add';
      this.doShowPaymentManager = true;
    },
    editPaymentPressed: function editPaymentPressed(index) {
      this.paymentMode = 'edit';
      this.selectedPaymentForEditing = index;
      // this.doShowAddressManager = true
    },
    deletePaymentPressed: function deletePaymentPressed(index) {
      if (index > 0) {
        this.selectedPayment = index - 1;
      } else {
        if (this.payments.length === 1) {
          this.selectedPayment = null;
        } else {
          this.selectedPayment = index + 1;
        }
      }
      this.payments.splice(index, 1);
      // this.selectedAddress = index
      // this.doShowAddressManager = true
    },
    paymentMethodSaveNew: function paymentMethodSaveNew(data) {
      this.payments.push(data);
      this.selectedPayment = this.payments.length - 1;
      this.doShowPaymentManager = false;
    },
    paymentMethodSaveExisting: function paymentMethodSaveExisting(data) {
      this.payments[this.selectedPaymentForEditing] = data;
      this.reactivator++;
      this.paymentMode = 'manage';
    },
    changePaymentSelected: function changePaymentSelected(index) {
      this.selectedPayment = index;
    },
    managePaymentPressed: function managePaymentPressed() {
      this.paymentMode = 'manage';
      this.doShowPaymentManager = true;
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.doShowPaymentManager = false;
    },
    paymentMethodCancelledBackToManager: function paymentMethodCancelledBackToManager() {
      this.paymentMode = 'manage';
    },

    //
    // SIGN IN
    signInPressed: function signInPressed() {
      this.doShowSignIn = true;
    },
    signInClosed: function signInClosed() {
      this.doShowSignIn = false;
    },
    loginPressed: function loginPressed() {
      this.addresses.push({
        name: 'Sam Bell',
        address1: '821 Washington St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10101',
        country: 'United States',
        phone: '+1 800 555 66 77'
      });
      this.addresses.push({
        name: 'Sam Bell',
        address1: '1014 Lincoln St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10114',
        country: 'United States',
        phone: '+1 800 555 00 11'
      });
      this.payments.push({
        name: 'Sam Bell',
        number: '1234 5678 1234 1235',
        month: '07',
        year: '20'
      });
      this.selectedAddress = 0;
      this.selectedPayment = 0;
      this.doShowSignIn = false;
    },

    // DELIVERY
    changeDelivery: function changeDelivery(index) {
      this.chosenDelivery = index;
    }
  },
  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "ae5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  // props: [
  //   'cart'
  // ],
  data: function data() {
    return {};
  },

  computed: {
    cart: function cart() {
      return this.$store.getters.getCart;
    }
  },
  methods: {
    editPressed: function editPressed() {
      // window.scroll({
      //   top: 0,
      //   left: 0,
      //   behavior: 'smooth'
      // })
      // this.$emit('edit')
      this.$router.push({ name: 'ShoppingCart2' });
    }
  }
});

/***/ }),

/***/ "ak8E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("HVXZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df9096fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("Amz6");
function injectStyle (ssrContext) {
  __webpack_require__("98UA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df9096fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df9096fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "an4j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"flexy align-top padding-vert-l",staticStyle:{"max-width":"540px","margin":"0 auto"}},[_c('div',{staticClass:"flexy fixed align-top",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("+Gg3"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Your order is placed!")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"6px"}},[_vm._v("Order number: 109-0072999-1233390")]),_vm._v(" "),(_vm.isSignedIn)?_c('div',{staticStyle:{"padding-top":"6px"}},[_vm._v("An email confirmation has been sent to you.")]):_vm._e(),_vm._v(" "),(!_vm.isSignedIn)?_c('div',[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900","padding-top":"32px"}},[_vm._v("Get email notifications")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"8px","line-height":"1.3"}},[_vm._v("Enter your email to create Amazon account, save your purchases, use 1-click checkout for next purchases together with many other Amazon user’s benefits.")]),_vm._v(" "),(!_vm.hasRegistered)?_c('div',[_c('div',{staticStyle:{"padding-top":"8px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],class:{errorInputHighlight: !_vm.isValid && !_vm.wasFocused},staticStyle:{"width":"300px"},attrs:{"type":"text","name":"","id":"fullName","placeholder":"Enter your email"},domProps:{"value":(_vm.email)},on:{"focus":function($event){_vm.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(!_vm.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"8px"}},[_c('button',{staticClass:"boxed primary properBlue",class:{properGrey: _vm.isProcessing},staticStyle:{"width":"300px"},on:{"click":function($event){_vm.createPressed()}}},[(!_vm.isProcessing)?_c('span',[_vm._v("Create account")]):_c('span',[_vm._v("Processing")])])])]):_c('div',{staticStyle:{"padding-top":"16px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top",staticStyle:{"padding-left":"24px","padding-right":"12px","bottom":"80px","right":"32px","background-color":"white","border-radius":"0 6px 6px 0","border-left":"4px solid orange"}},[_vm._v("\n              Account created! An email with further instructions has been sent to you.\n            ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"32px"}},[_c('button',{staticStyle:{"font-size":"13px","padding":"3px 8px","color":"#3a84e8","border":"1px solid","border-radius":"4px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"#3a84e8"},attrs:{"href":"https://itunes.apple.com/us/app/amazon-shopping-made-easy/id297606951","target":"_blank"}},[_vm._v("Get Amazon app")])]),_vm._v(" to get shipment notifications on your mobile device\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "avoe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l",staticStyle:{"background-color":"#f1f3f7"}},[_c('div',{staticClass:"padding-vert-l flexy align-top"},[_c('div',[_c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l rounded silver",staticStyle:{"padding":"12px 40px","background-color":"white","box-shadow":"0px 7px 24px rgba(0,0,0,0.1)"}},[_c('div',{},[_c('h1',{staticStyle:{"padding":"24px 0","font-size":"24px","font-weight":"600","border-bottom":"1px solid #EBEEF5"}},[_vm._v("Shopping Cart")])]),_vm._v(" "),_c('transition-group',{staticStyle:{"padding":"12px 0"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.items),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item large"},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('items', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-right":"24px","padding-top":"4px"}},[_c('div',{staticStyle:{"font-size":"16px","font-weight":"500"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey padding-vert-xs"},[_vm._v(_vm._s(item.availability)+", "+_vm._s(item.seller))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px","padding-top":"8px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticStyle:{"min-width":"auto","width":"60px","background-color":"rgba(255,255,255,0.6)"},attrs:{"name":"quantity","id":"item-quantity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"20px","margin-right":"12px","padding-top":"6px"}},[(!item.isXPressed)?_c('button',{on:{"click":function($event){_vm.xPressed(i)}}},[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1"},attrs:{"src":__webpack_require__("5F5F")}})]):_vm._e(),_vm._v(" "),(item.isXPressed)?_c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"90","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.xPressed(i)}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-xs rounded",staticStyle:{"position":"relative","width":"160px","transform":"translate(-130px, -12px)","z-index":"120","background-color":"white","box-shadow":"0px 4px 12px rgba(0,0,0,0.0.5)"}},[_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"#409EFF","margin":"0"},on:{"click":function($event){_vm.saveForLaterPressed(i)}}},[_vm._v("Save for later")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"#fd3737","margin":"0"},on:{"click":function($event){_vm.removeItemPressed(i)}}},[_vm._v("Remove from cart")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"silver","margin":"0"},on:{"click":function($event){_vm.xPressed(i)}}},[_vm._v("Cancel")])])]):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"padding-vert-m flexy",staticStyle:{"padding-top":"24px","padding-bottom":"32px","border-top":"1px solid #EBEEF5"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"102px"}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"16px","font-weight":"500"}},[_vm._v("Subtotal")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v("$"+_vm._s(_vm.subtotal))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"132px"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"padding":"12px 29px"},on:{"click":function($event){_vm.checkoutPressed()}}},[_vm._v("Checkout")])])])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',[_c('transition',{attrs:{"name":"later-fade"}},[(_vm.later.length > 0)?_c('div',{staticStyle:{"padding":"12px 32px"}},[_c('div',[_c('h2',{staticStyle:{"padding":"32px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v("You saved for later")])]),_vm._v(" "),_c('transition-group',{staticClass:"padding-vert-m flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.later),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('later', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromLaterPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"12px 32px"}},[_c('div',[_c('h2',{staticStyle:{"padding":"32px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v(_vm._s(_vm.youRecentlyViewed))])]),_vm._v(" "),_c('transition-group',{staticClass:"padding-vert-m flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.recent),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('recent', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromRecentPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)],1)])],1),_vm._v(" "),_c('transition',{attrs:{"name":"right-column-appear","appear":""}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"320px","margin-left":"48px"}},[_c('div',{staticClass:"padding-vert-m padding-hor-xl bordered rounded silver",staticStyle:{"height":"224px","text-align":"center"}},[_c('img',{staticStyle:{"padding-top":"56px"},attrs:{"src":__webpack_require__("Kufr"),"width":"125px"}})]),_vm._v(" "),_c('div',[_c('h2',{staticStyle:{"padding":"42px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v("Customers also bought")])]),_vm._v(" "),_c('div',{},[_c('transition-group',{attrs:{"name":"list-ani"}},_vm._l((_vm.also),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item"},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('also', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromAlsoPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])])],1),_vm._v(" "),(_vm.doShowPreview)?_c('QuickPreview',{attrs:{"selectedForPreview":_vm.selectedForPreview},on:{"close":function($event){_vm.doShowPreview = false},"addToCart":function($event){_vm.addedToCartFromPreview($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b1T5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__ = __webpack_require__("hBuF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  components: {
    QuickPreview: __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__["a" /* default */]
  },
  props: ['cart', 'alsoItems', 'recentItems', 'extraItems', 'laterItems'],
  data: function data() {
    return {
      items: [],
      also: [],
      recent: [],
      extra: [],
      later: [],
      doShowPreview: false,
      selectedForPreview: null,
      youRecentlyViewed: 'You recently viewed'
    };
  },

  computed: {
    subtotal: function subtotal() {
      var result = 0;
      for (var i in this.items) {
        result += this.items[i].price * this.items[i].quantity;
      }
      return result.toFixed(2);
    }
  },
  methods: {
    checkoutPressed: function checkoutPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('confirmed', this.items);
    },
    removeItemPressed: function removeItemPressed(index) {
      this.items.splice(index, 1);
    },
    xPressed: function xPressed(index) {
      this.items[index].isXPressed = !this.items[index].isXPressed;
      this.youRecentlyViewed = this.youRecentlyViewed + ' ';
      // this.also.splice(index, 1)
      // for (let i in this.items) {
      //   let currentItem = this.items[i]
      //   currentItem['updated'] = Math.random() * (100 - 5) + 5
      //   console.log(currentItem['updated'])
      // }
    },
    saveForLaterPressed: function saveForLaterPressed(index) {
      var tempItem = this.items[index];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.later.push(this.items[index]);
      this.items.splice(index, 1);
    },
    addFromLaterPressed: function addFromLaterPressed(index) {
      var _this = this;

      this.later[index].isBeingAddedToCart = true;
      this.items.push(this.later[index]);
      setTimeout(function () {
        _this.later.splice(index, 1);
      }, 500);
    },
    addFromAlsoPressed: function addFromAlsoPressed(index) {
      var _this2 = this;

      this.also[index].isBeingAddedToCart = true;
      this.items.push(this.also[index]);
      setTimeout(function () {
        _this2.also.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this2.extra.length > 0) {
          _this2.also.push(_this2.extra[0]);
          _this2.extra.splice(0, 1);
        }
      }, 1000);
    },
    addFromRecentPressed: function addFromRecentPressed(index) {
      var _this3 = this;

      this.recent[index].isBeingAddedToCart = true;
      this.items.push(this.recent[index]);
      setTimeout(function () {
        _this3.recent.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this3.extra.length > 0) {
          _this3.recent.push(_this3.extra[0]);
          _this3.extra.splice(0, 1);
        }
      }, 1000);
      // var rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.right, rect.bottom, rect.left);
      // let lastIndex = this.items.length - 1
      // let lastItem = document.getElementById('cart-item-' + lastIndex)
      // console.log(lastItem)
      // console.log('cart-item-' + lastIndex)
      // let rect = lastItem.getBoundingClientRect()
      // console.log(rect)
      // let position = 0 + (this.items.length * 136)
      // window.scroll({
      //   top: position,
      //   left: 0,
      //   behavior: 'smooth'
      // })
    },
    addedToCartFromPreview: function addedToCartFromPreview(item) {
      if (item.section === 'items') {
        this.items[item.index].quantity = this.items[item.index].quantity + 1;
      } else if (item.section === 'recent') {
        this.addFromRecentPressed(item.index);
      } else if (item.section === 'also') {
        this.addFromAlsoPressed(item.index);
      } else if (item.section === 'later') {
        this.addFromLaterPressed(item.index);
      }
      this.doShowPreview = false;
    },
    openPreview: function openPreview(section, index) {
      if (section === 'items') {
        this.doShowPreview = true;
        this.selectedForPreview = this.items[index];
      } else if (section === 'recent') {
        this.doShowPreview = true;
        this.selectedForPreview = this.recent[index];
      } else if (section === 'also') {
        this.doShowPreview = true;
        this.selectedForPreview = this.also[index];
      } else if (section === 'later') {
        this.doShowPreview = true;
        this.selectedForPreview = this.later[index];
      }
      this.selectedForPreview['section'] = section;
      this.selectedForPreview['index'] = index;
    }
  },
  created: function created() {
    for (var i in this.cart) {
      var tempItem = this.cart[i];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.items.push(tempItem);
    }
    for (var _i in this.alsoItems) {
      var _tempItem = this.alsoItems[_i];
      _tempItem['isBeingAddedToCart'] = false;
      this.also.push(_tempItem);
    }
    for (var _i2 in this.recentItems) {
      var _tempItem2 = this.recentItems[_i2];
      _tempItem2['isBeingAddedToCart'] = false;
      this.recent.push(_tempItem2);
    }
    for (var _i3 in this.extraItems) {
      var _tempItem3 = this.extraItems[_i3];
      _tempItem3['isBeingAddedToCart'] = false;
      this.extra.push(_tempItem3);
    }
    for (var _i4 in this.laterItems) {
      var _tempItem4 = this.laterItems[_i4];
      _tempItem4['isBeingAddedToCart'] = false;
      this.later.push(_tempItem4);
    }
  }
});

/***/ }),

/***/ "b8gm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bCzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"1"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"1")},on:{"change":function($event){_vm.chosenDelivery="1"}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"2"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"2")},on:{"change":function($event){_vm.chosenDelivery="2"}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"3"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"3")},on:{"change":function($event){_vm.chosenDelivery="3"}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"4"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"4")},on:{"change":function($event){_vm.chosenDelivery="4"}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"5"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"5")},on:{"change":function($event){_vm.chosenDelivery="5"}}}),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',[_vm._v("FREE shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',[_vm._v("$6.98 - Standart shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("$13.98 - Two-Day Shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',[_vm._v("$20.98 - One-Day Shipping")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bOPb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bPdM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shipping address")]),_vm._v(" "),(_vm.selectedAddress === null)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":_vm.addPressed}},[_vm._v("+ Add shipping address")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].name))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].address1)+" ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].city)+", "+_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].state)+", "+_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].phone))]),_vm._v(" "),_c('div',{staticStyle:{"color":"transparent","width":"0","height":"0","overflow":"hidden"}},[_vm._v(_vm._s(_vm.reactivator))]),_vm._v(" "),(_vm.doShowAddressesList)?_c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"100","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.doShowAddressesList=false}}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","z-index":"101","display":"inline-block","background-color":"white","box-shadow":"0 8px 18px rgba(0,0,0,0.2)","border-radius":"6px","padding":"8px 0","transform":"translate(0,-100px)"},on:{"click":function($event){$event.stopPropagation();_vm.doNothing($event)}}},[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"hoverableItem clickable flexy",staticStyle:{"border-bottom":"1px solid #DDE1EB"},on:{"click":function($event){_vm.choosePressed(i)}}},[_c('div',{staticClass:"fixed checkmark",class:{selected: i === _vm.selectedAddress},staticStyle:{"width":"72px","height":"24px","text-align":"center","color":"#409EFF"}},[_c('span',{})]),_vm._v(" "),_c('div',{staticStyle:{"padding":"12px 24px 12px 0"}},[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px","text-align":"center","font-size":"14px","color":"#409EFF"},on:{"click":function($event){$event.stopPropagation();_vm.editPressed(i)}}},[_vm._v("Edit")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"center","font-size":"14px","color":"tomato","margin-right":"12px"},on:{"click":function($event){$event.stopPropagation();_vm.deletePressed(i)}}},[_vm._v("Delete")])])}),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",on:{"click":_vm.addNewAddressPressed}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"72px","text-align":"center","color":"#409EFF"}}),_vm._v(" "),_vm._m(0)])],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":_vm.changePressed}},[_vm._v("Change")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"16px 24px 16px 0"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Add new address")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bUjv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-s padding-hor-xl"},[_vm._m(0),_vm._v(" "),(_vm.didAcceptShoppingCart)?_c('div',{staticClass:"text-grey"},_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-xs flexy"},[_vm._m(1,true),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"20px"}},[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"50px"}},[_vm._v("$"+_vm._s(item.price))])])})):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs"},[_c('h3',[_vm._v("Shopping cart")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed",staticStyle:{"width":"40px"}},[_c('img',{attrs:{"src":__webpack_require__("R4sD"),"width":"24px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bvAK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("unr+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0172bbbf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("YfkC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0172bbbf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bxCS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bz1L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c2UB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74a20959_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("iZiJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74a20959_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c6bX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAA0CAYAAAAg5t6HAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAImSURBVHgB7ZuBVcIwEIb/OoFugJvUDdzAbiAbgBvoBOAE6gRlBDeoG8AGZ2LTZ5CerylN7lr6vcejD/ru/qY/aXIJGRkwDHdZlu0wca4wHCtcAEM2WG7MmmPiDNlglkdMnGzAPqzh1vRlX5goQzvMssTMKcaY1+a1p1PsZ9eYKL0dZn52B/P20vKVbazZZW1cosvO6sNml/Vgii4zuitqZ4EhMIHWTII1RobRXDDXssFQTMll0d3lJdoyiQqMhCTu8pItmGQVRkIyd3kJSyZhDuUkdZeXNGeSllBOcnd5iUsamcuMtntG8ztiM0aXid9kcQEBqLjBKkR0xGjaMFoLpGQMLiNNQyHiO9I3KEGNuzxBFSNoAWFUucsTtWREPUMYde5yolROylW6yxOnrvSj0l0N2lzm3NWmp+qiJ8Yy2xEKy9gPLvdfXp1WeTS5jBQ/uY8gBX0ZSZRw+qLBZaNxVwPxZWxJgtyVISFU30ltJeugzTPRn5I+TtgOetiG7jRK6jAL1dUKLWWe4K1ZSR1mcftgd5Dno88+tuQN5niCPOIFgJmZmZmLg+oVppJ+p032uMCZxIorirmA1T9Tlt7/LIkVVxTiKwc+OQKJFVcc4tctfYJnBLHiNiSfGjVY1R1OO5jR+A0CiBW3QWqkb+lSDu5TJ4sV9wfJBvvscM4O4cSKKwvxG1Z8CgQSK64KiK/zW9boSay4KqB6GFC6i9m74xxnEivuN0euRNMZ4JjwAAAAAElFTkSuQmCC"

/***/ }),

/***/ "c8IJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shopping cart")]),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top"},[_vm._m(0,true),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',[_vm._v("Quantity: "+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Edit")])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed",staticStyle:{"width":"60px"}},[_c('img',{attrs:{"src":__webpack_require__("R4sD"),"width":"40px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cJ1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("FwLG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc93a28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("+InE");
function injectStyle (ssrContext) {
  __webpack_require__("sHcn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fc93a28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc93a28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cRFR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__ = __webpack_require__("ivi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8ce34a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__ = __webpack_require__("vPAu");
function injectStyle (ssrContext) {
  __webpack_require__("4wU3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a8ce34a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8ce34a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cZ98":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cZFJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cq8v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShoppingCartMin__ = __webpack_require__("g6Ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Delivery__ = __webpack_require__("cJ1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShippingAddress__ = __webpack_require__("jC9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShippingAddressMin__ = __webpack_require__("U8N9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentMethod__ = __webpack_require__("RvTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentMethodMin__ = __webpack_require__("6bJN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderSummary__ = __webpack_require__("21Q6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SignIn__ = __webpack_require__("QdQY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_0__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_2__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_3__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_4__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_5__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_1__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_6__OrderSummary__["a" /* default */],
    SignIn: __WEBPACK_IMPORTED_MODULE_7__SignIn__["a" /* default */]
  },
  data: function data() {
    return {
      addressMode: null,
      doShowAddressManager: false,
      selectedAddressForEditing: null,
      //
      paymentMode: null,
      doShowPaymentManager: false,
      selectedPaymentForEditing: null,
      //
      doShowSignIn: false,
      //
      reactivator: 0
      //
      // chosenDelivery: 1
    };
  },

  computed: {
    addresses: function addresses() {
      return this.$store.getters.getAddresses;
    },
    payments: function payments() {
      return this.$store.getters.getPayments;
    },

    //
    cart: function cart() {
      return this.$store.getters.getCart;
    },
    alsoItems: function alsoItems() {
      return this.$store.getters.getAlso;
    },
    recentItems: function recentItems() {
      return this.$store.getters.getRecent;
    },
    extraItems: function extraItems() {
      return this.$store.getters.getExtra;
    },
    laterItems: function laterItems() {
      return this.$store.getters.getLater;
    },

    //
    selectedAddress: function selectedAddress() {
      return this.$store.getters.getSelectedAddress;
    },
    selectedPayment: function selectedPayment() {
      return this.$store.getters.getSelectedPayment;
    },
    chosenDelivery: function chosenDelivery() {
      return this.$store.getters.getChosenDelivery;
    }
  },
  methods: {
    //
    // SHIPPING ADDRESS
    addAddressPressed: function addAddressPressed() {
      this.addressMode = 'add';
      this.doShowAddressManager = true;
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.doShowAddressManager = false;
    },
    manageAddressPressed: function manageAddressPressed() {
      this.addressMode = 'manage';
      this.doShowAddressManager = true;
    },
    shippingAddressSaveNew: function shippingAddressSaveNew(address) {
      this.$store.dispatch('setNewAddress', address);
      this.$store.dispatch('setSelectedAddress', this.addresses.length - 1);
      this.doShowAddressManager = false;
    },
    shippingAddressSaveExisting: function shippingAddressSaveExisting(address) {
      // this.addresses[this.selectedAddressForEditing] = data
      this.$store.dispatch('setExistingAddress', { address: address, index: this.selectedAddressForEditing });
      this.reactivator++;
      this.addressMode = 'manage';
    },
    editAddressPressed: function editAddressPressed(index) {
      this.selectedAddressForEditing = index;
      this.addressMode = 'edit';
    },
    deleteAddressPressed: function deleteAddressPressed(index) {
      if (this.addresses.length === 1) {
        this.$store.dispatch('setSelectedAddress', null);
      } else {
        this.$store.dispatch('setSelectedAddress', 0);
      }
      this.$store.dispatch('setRemoveAddress', index);
    },
    shippingAddressCancelledBackToManager: function shippingAddressCancelledBackToManager() {
      this.addressMode = 'manage';
    },

    //
    // PAYMENT METHOD
    addPaymentPressed: function addPaymentPressed() {
      this.paymentMode = 'add';
      this.doShowPaymentManager = true;
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.doShowPaymentManager = false;
    },
    managePaymentPressed: function managePaymentPressed() {
      this.paymentMode = 'manage';
      this.doShowPaymentManager = true;
    },
    paymentMethodSaveNew: function paymentMethodSaveNew(payment) {
      this.$store.dispatch('setNewPayment', payment);
      this.$store.dispatch('setSelectedPayment', this.payments.length - 1);
      this.doShowPaymentManager = false;
    },
    paymentMethodSaveExisting: function paymentMethodSaveExisting(payment) {
      this.$store.dispatch('setExistingPayment', { payment: payment, index: this.selectedPaymentForEditing });
      this.reactivator++;
      this.paymentMode = 'manage';
    },
    editPaymentPressed: function editPaymentPressed(index) {
      this.selectedPaymentForEditing = index;
      this.paymentMode = 'edit';
    },
    deletePaymentPressed: function deletePaymentPressed(index) {
      if (this.payments.length === 1) {
        this.$store.dispatch('setSelectedPayment', null);
      } else {
        this.$store.dispatch('setSelectedPayment', 0);
      }
      this.$store.dispatch('setRemovePayment', index);
    },
    paymentMethodCancelledBackToManager: function paymentMethodCancelledBackToManager() {
      this.paymentMode = 'manage';
    },

    //
    // SIGN IN
    signInPressed: function signInPressed() {
      this.doShowSignIn = true;
    },
    signInClosed: function signInClosed() {
      this.doShowSignIn = false;
    },
    loginPressed: function loginPressed() {
      this.$store.dispatch('setNewAddress', {
        name: 'Sam Bell',
        address1: '821 Washington St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10101',
        country: 'United States',
        phone: '+1 800 555 66 77' });
      this.$store.dispatch('setNewAddress', {
        name: 'Sam Bell',
        address1: '1014 Lincoln St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10114',
        country: 'United States',
        phone: '+1 800 555 00 11' });
      this.$store.dispatch('setNewPayment', {
        name: 'Sam Bell',
        number: '1234 5678 1234 1235',
        month: '07',
        year: '20' });
      this.$store.dispatch('setSelectedAddress', 0);
      this.$store.dispatch('setSelectedPayment', 0);
      this.$store.dispatch('setIsSignedIn', true);
      this.doShowSignIn = false;
    },

    //
    placeOrderPressed: function placeOrderPressed() {
      this.$router.push({ name: 'Complete' });
    }
  }
});

/***/ }),

/***/ "d/j3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__ = __webpack_require__("1gmF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  components: {
    QuickPreview: __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__["a" /* default */]
  },
  // props: [
  // 'cart',
  // 'alsoItems',
  // 'recentItems',
  // 'extraItems',
  // 'laterItems'
  // ],
  data: function data() {
    return {
      items: [],
      also: [],
      recent: [],
      extra: [],
      later: [],
      doShowPreview: false,
      selectedForPreview: null,
      youRecentlyViewed: 'You recently viewed'
    };
  },

  computed: {
    cart: function cart() {
      return this.$store.getters.getCart;
    },
    alsoItems: function alsoItems() {
      return this.$store.getters.getAlso;
    },
    recentItems: function recentItems() {
      return this.$store.getters.getRecent;
    },
    extraItems: function extraItems() {
      return this.$store.getters.getExtra;
    },
    laterItems: function laterItems() {
      return this.$store.getters.getLater;
    },
    subtotal: function subtotal() {
      var result = 0;
      for (var i in this.items) {
        result += this.items[i].price * this.items[i].quantity;
      }
      return result.toFixed(2);
    }
  },
  methods: {
    checkoutPressed: function checkoutPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      // this.$emit('confirmed', this.items)
      this.$router.push({ name: 'Checkout' });
    },
    removeItemPressed: function removeItemPressed(index) {
      this.items.splice(index, 1);
      //
      this.$store.dispatch('setCart', this.items);
    },
    xPressed: function xPressed(index) {
      this.items[index].isXPressed = !this.items[index].isXPressed;
      this.youRecentlyViewed = this.youRecentlyViewed + ' ';
      // this.also.splice(index, 1)
      // for (let i in this.items) {
      //   let currentItem = this.items[i]
      //   currentItem['updated'] = Math.random() * (100 - 5) + 5
      //   console.log(currentItem['updated'])
      // }
    },
    saveForLaterPressed: function saveForLaterPressed(index) {
      var tempItem = this.items[index];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.later.push(this.items[index]);
      this.items.splice(index, 1);
      //
      this.$store.dispatch('setCart', this.items);
      this.$store.dispatch('setLater', this.later);
    },
    addFromLaterPressed: function addFromLaterPressed(index) {
      var _this = this;

      this.later[index].isBeingAddedToCart = true;
      this.items.push(this.later[index]);
      setTimeout(function () {
        _this.later.splice(index, 1);
        _this.$store.dispatch('setLater', _this.later);
      }, 500);
      //
      this.$store.dispatch('setCart', this.items);
      // this.$emit('updated', this.items)
    },
    addFromAlsoPressed: function addFromAlsoPressed(index) {
      var _this2 = this;

      this.also[index].isBeingAddedToCart = true;
      this.items.push(this.also[index]);
      setTimeout(function () {
        _this2.also.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this2.extra.length > 0) {
          _this2.also.push(_this2.extra[0]);
          _this2.extra.splice(0, 1);
          _this2.$store.dispatch('setAlso', _this2.also);
          _this2.$store.dispatch('setExtra', _this2.extra);
        }
      }, 1000);
      // this.$emit('updated', this.items)
      this.$store.dispatch('setCart', this.items);
    },
    addFromRecentPressed: function addFromRecentPressed(index) {
      var _this3 = this;

      this.recent[index].isBeingAddedToCart = true;
      this.items.push(this.recent[index]);
      setTimeout(function () {
        _this3.recent.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this3.extra.length > 0) {
          _this3.recent.push(_this3.extra[0]);
          _this3.extra.splice(0, 1);
          _this3.$store.dispatch('setRecent', _this3.recent);
          _this3.$store.dispatch('setExtra', _this3.extra);
        }
      }, 1000);
      // this.$emit('updated', this.items)
      this.$store.dispatch('setCart', this.items);
      // var rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.right, rect.bottom, rect.left);
      // let lastIndex = this.items.length - 1
      // let lastItem = document.getElementById('cart-item-' + lastIndex)
      // console.log(lastItem)
      // console.log('cart-item-' + lastIndex)
      // let rect = lastItem.getBoundingClientRect()
      // console.log(rect)
      // let position = 0 + (this.items.length * 136)
      // window.scroll({
      //   top: position,
      //   left: 0,
      //   behavior: 'smooth'
      // })
    },
    addedToCartFromPreview: function addedToCartFromPreview(item) {
      if (item.section === 'items') {
        this.items[item.index].quantity = this.items[item.index].quantity + 1;
      } else if (item.section === 'recent') {
        this.addFromRecentPressed(item.index);
      } else if (item.section === 'also') {
        this.addFromAlsoPressed(item.index);
      } else if (item.section === 'later') {
        this.addFromLaterPressed(item.index);
      }
      this.doShowPreview = false;
      // this.$emit('updated', this.items)
    },
    openPreview: function openPreview(section, index) {
      if (section === 'items') {
        this.doShowPreview = true;
        this.selectedForPreview = this.items[index];
      } else if (section === 'recent') {
        this.doShowPreview = true;
        this.selectedForPreview = this.recent[index];
      } else if (section === 'also') {
        this.doShowPreview = true;
        this.selectedForPreview = this.also[index];
      } else if (section === 'later') {
        this.doShowPreview = true;
        this.selectedForPreview = this.later[index];
      }
      this.selectedForPreview['section'] = section;
      this.selectedForPreview['index'] = index;
    }
  },
  created: function created() {
    for (var i in this.cart) {
      var tempItem = this.cart[i];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.items.push(tempItem);
    }
    for (var _i in this.alsoItems) {
      var _tempItem = this.alsoItems[_i];
      _tempItem['isBeingAddedToCart'] = false;
      this.also.push(_tempItem);
    }
    for (var _i2 in this.recentItems) {
      var _tempItem2 = this.recentItems[_i2];
      _tempItem2['isBeingAddedToCart'] = false;
      this.recent.push(_tempItem2);
    }
    for (var _i3 in this.extraItems) {
      var _tempItem3 = this.extraItems[_i3];
      _tempItem3['isBeingAddedToCart'] = false;
      this.extra.push(_tempItem3);
    }
    for (var _i4 in this.laterItems) {
      var _tempItem4 = this.laterItems[_i4];
      _tempItem4['isBeingAddedToCart'] = false;
      this.later.push(_tempItem4);
    }
  }
});

/***/ }),

/***/ "d/mW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  props: ['cart'],
  data: function data() {
    return {};
  },

  methods: {
    editPressed: function editPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('edit');
    }
  }
});

/***/ }),

/***/ "d2qd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dBG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: null,
      showFullDescription: false,
      selectedFormat: 'kindle',
      selectedTab: 'description',
      isBeingAddedToCart: false,
      //
      scrollable: null,
      didScroll: false
    };
  },

  props: ['selectedForPreview'],
  methods: {
    checkScrollPosition: function checkScrollPosition() {
      if (this.scrollable.scrollTop > 10) {
        this.didScroll = true;
      } else {
        this.didScroll = false;
      }
    },
    closePressed: function closePressed() {
      this.$emit('close');
    },
    doThis: function doThis() {
      console.log('hi');
    },
    addPressed: function addPressed() {
      var _this = this;

      this.isBeingAddedToCart = true;
      setTimeout(function () {
        _this.$emit('addToCart', _this.item);
      }, 500);
    }
  },
  created: function created() {
    var _this2 = this;

    this.item = this.selectedForPreview;
    setTimeout(function () {
      _this2.scrollable = document.getElementById('watchMeScroll');
    }, 100);
  }
});

/***/ }),

/***/ "dYqt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("llUQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67a7d57e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("T4Tn");
function injectStyle (ssrContext) {
  __webpack_require__("hQ4D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67a7d57e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67a7d57e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dZ6T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("UHEZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__ = __webpack_require__("mled");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__ = __webpack_require__("GENp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Delivery__ = __webpack_require__("4E3C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__ = __webpack_require__("pszf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__ = __webpack_require__("38TJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__ = __webpack_require__("ak8E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__ = __webpack_require__("ohWE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderSummary__ = __webpack_require__("1RU4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__ = __webpack_require__("Bhh6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Start: __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
    ShoppingCart: __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__["a" /* default */],
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_3__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_8__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__["a" /* default */]
  },
  data: function data() {
    return {
      currentView: 'Start',
      chosenDelivery: '1',
      //
      doShowAddressManager: false,
      selectedAddress: null,
      selectedAddressForEditing: null,
      addressMode: null,
      //
      // isPaymentFilled: false,
      reactivator: 0,
      addresses: [],
      doShowPaymentManager: false,
      selectedPayment: null,
      //
      cart: [{
        name: 'Beautiful Evidence',
        by: 'Edward R. Tufte',
        img: __webpack_require__("OEdX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 28.87,
        quantity: 1
      }, {
        name: 'Hooked: How to Build Habit-Forming Products',
        by: 'Nir Eyal',
        img: __webpack_require__("IBtq"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 18.56,
        quantity: 1
      }],
      alsoItems: [{
        name: 'Sprint: How to Solve Big Problems and Test New Ideas in Just Five Days',
        by: 'Jake Knapp',
        img: __webpack_require__("RVgH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.53,
        quantity: 1
      }, {
        name: 'The Lean Startup: How Today\'s Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses',
        by: 'Eric Ries',
        img: __webpack_require__("xcPX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.29,
        quantity: 1
      }, {
        name: 'The Hard Thing About Hard Things: Building a Business When There Are No Easy Answers',
        by: 'Ben Horowitz',
        img: __webpack_require__("fiE3"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 19.66,
        quantity: 1
      }, {
        name: 'Rework',
        by: 'Jason Fried',
        img: __webpack_require__("7fXA"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 17.68,
        quantity: 1
      }, {
        name: 'Remote: Office Not Required',
        by: 'Jason Fried',
        img: __webpack_require__("LhVL"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 15.59,
        quantity: 1
      }],
      recentItems: [{
        name: 'Envisioning Information',
        by: 'Edward R. Tufte',
        img: __webpack_require__("CySp"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 34.96,
        quantity: 1
      }, {
        name: 'About Face: The Essentials of Interaction Design',
        by: 'Alan Cooper',
        img: __webpack_require__("y+PD"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 36.47,
        quantity: 1
      }, {
        name: '100 Things Every Designer Needs to Know About People',
        by: 'Susan Weinschenk',
        img: __webpack_require__("P+u0"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 22.95,
        quantity: 1
      }, {
        name: 'HTML and CSS: Design and Build Websites',
        by: 'Jon Duckett',
        img: __webpack_require__("AqZH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.53,
        quantity: 1
      }],
      extraItems: [{
        name: 'CSS: The Missing Manual',
        by: 'David Sawyer McFarland',
        img: __webpack_require__("PF3y"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 24.61,
        quantity: 1
      }, {
        name: 'The Principles of Beautiful Web Design: Designing Great Web Sites is Not Rocket Science!',
        by: 'Jason Beaird',
        img: __webpack_require__("jAj8"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.23,
        quantity: 1
      }, {
        name: 'Logo Design Love: A Guide to Creating Iconic Brand Identities, 2nd Edition',
        by: 'David Airey',
        img: __webpack_require__("WOmI"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.05,
        quantity: 1
      }, {
        name: 'Layout Essentials: 100 Design Principles for Using Grids (Design Essentials)',
        by: 'Beth Tondreau',
        img: __webpack_require__("Mvmb"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.76,
        quantity: 1
      }]
    };
  },

  methods: {
    shoppingCartConfirmed: function shoppingCartConfirmed(items) {
      this.currentView = 'Checkout';
      this.cart = items;
    },

    //
    // ADDRESS
    addAddressPressed: function addAddressPressed() {
      this.addressMode = 'add';
      this.doShowAddressManager = true;
    },
    editAddressPressed: function editAddressPressed(index) {
      this.addressMode = 'edit';
      this.selectedAddressForEditing = index;
      this.doShowAddressManager = true;
    },
    deleteAddressPressed: function deleteAddressPressed(index) {
      // if (index > 0) {
      //   this.selectedAddress = index - 1
      // } else {
      //   if (this.addresses.length === 1) {
      //     this.selectedAddress = null
      //   } else {
      //     this.selectedAddress = index + 1
      //   }
      // }
      if (this.addresses.length === 1) {
        this.selectedAddress = null;
      } else {
        if (index < this.selectedAddress) {
          this.selectedAddress--;
        } else if (index === this.selectedAddress) {
          this.selectedAddress = 0;
        }
      }
      this.addresses.splice(index, 1);
      this.reactivator++;
      // this.selectedAddress = index
      // this.doShowAddressManager = true
    },
    shippingAddressSaveNew: function shippingAddressSaveNew(data) {
      this.addresses.push(data);
      this.selectedAddress = this.addresses.length - 1;
      this.doShowAddressManager = false;
    },
    shippingAddressSaveExisting: function shippingAddressSaveExisting(data) {
      this.addresses[this.selectedAddressForEditing] = data;
      this.reactivator++;
      this.doShowAddressManager = false;
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.doShowAddressManager = false;
    },
    changeAddressSelected: function changeAddressSelected(index) {
      this.selectedAddress = index;
    },
    manageAddressPressed: function manageAddressPressed() {
      this.addressMode = 'manage';
      this.doShowAddressManager = true;
    },

    //
    // PAYMENT
    editPaymentPressed: function editPaymentPressed() {
      this.doShowPaymentManager = true;
    },
    paymentMethodConfirmed: function paymentMethodConfirmed(data) {
      this.selectedPayment = data;
      this.doShowPaymentManager = false;
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.doShowPaymentManager = false;
    }
    //

  },
  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "dqjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__ = __webpack_require__("VL/s");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  components: {
    QuickPreview: __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__["a" /* default */]
  },
  props: ['cart', 'alsoItems', 'recentItems', 'extraItems'],
  data: function data() {
    return {
      items: [],
      also: [],
      recent: [],
      extra: [],
      later: [],
      doShowPreview: false,
      selectedForPreview: null,
      youRecentlyViewed: 'You recently viewed'
    };
  },

  computed: {
    subtotal: function subtotal() {
      var result = 0;
      for (var i in this.items) {
        result += this.items[i].price * this.items[i].quantity;
      }
      return result.toFixed(2);
    }
  },
  methods: {
    checkoutPressed: function checkoutPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('confirmed', this.items);
    },
    removeItemPressed: function removeItemPressed(index) {
      this.items.splice(index, 1);
    },
    xPressed: function xPressed(index) {
      this.items[index].isXPressed = !this.items[index].isXPressed;
      this.youRecentlyViewed = this.youRecentlyViewed + ' ';
      // this.also.splice(index, 1)
      // for (let i in this.items) {
      //   let currentItem = this.items[i]
      //   currentItem['updated'] = Math.random() * (100 - 5) + 5
      //   console.log(currentItem['updated'])
      // }
    },
    saveForLaterPressed: function saveForLaterPressed(index) {
      var tempItem = this.items[index];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.later.push(this.items[index]);
      this.items.splice(index, 1);
    },
    addFromLaterPressed: function addFromLaterPressed(index) {
      var _this = this;

      this.later[index].isBeingAddedToCart = true;
      this.items.push(this.later[index]);
      setTimeout(function () {
        _this.later.splice(index, 1);
      }, 500);
    },
    addFromAlsoPressed: function addFromAlsoPressed(index) {
      var _this2 = this;

      this.also[index].isBeingAddedToCart = true;
      this.items.push(this.also[index]);
      setTimeout(function () {
        _this2.also.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this2.extra.length > 0) {
          _this2.also.push(_this2.extra[0]);
          _this2.extra.splice(0, 1);
        }
      }, 1000);
    },
    addFromRecentPressed: function addFromRecentPressed(index) {
      var _this3 = this;

      this.recent[index].isBeingAddedToCart = true;
      this.items.push(this.recent[index]);
      setTimeout(function () {
        _this3.recent.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this3.extra.length > 0) {
          _this3.recent.push(_this3.extra[0]);
          _this3.extra.splice(0, 1);
        }
      }, 1000);
      // var rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.right, rect.bottom, rect.left);
      // let lastIndex = this.items.length - 1
      // let lastItem = document.getElementById('cart-item-' + lastIndex)
      // console.log(lastItem)
      // console.log('cart-item-' + lastIndex)
      // let rect = lastItem.getBoundingClientRect()
      // console.log(rect)
      // let position = 0 + (this.items.length * 136)
      // window.scroll({
      //   top: position,
      //   left: 0,
      //   behavior: 'smooth'
      // })
    },
    addedToCartFromPreview: function addedToCartFromPreview(item) {
      if (item.section === 'items') {
        this.items[item.index].quantity = this.items[item.index].quantity + 1;
      } else if (item.section === 'recent') {
        this.addFromRecentPressed(item.index);
      } else if (item.section === 'also') {
        this.addFromAlsoPressed(item.index);
      } else if (item.section === 'later') {
        this.addFromLaterPressed(item.index);
      }
      this.doShowPreview = false;
    },
    openPreview: function openPreview(section, index) {
      if (section === 'items') {
        this.doShowPreview = true;
        this.selectedForPreview = this.items[index];
      } else if (section === 'recent') {
        this.doShowPreview = true;
        this.selectedForPreview = this.recent[index];
      } else if (section === 'also') {
        this.doShowPreview = true;
        this.selectedForPreview = this.also[index];
      } else if (section === 'later') {
        this.doShowPreview = true;
        this.selectedForPreview = this.later[index];
      }
      this.selectedForPreview['section'] = section;
      this.selectedForPreview['index'] = index;
    }
  },
  created: function created() {
    for (var i in this.cart) {
      var tempItem = this.cart[i];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.items.push(tempItem);
    }
    for (var _i in this.alsoItems) {
      var _tempItem = this.alsoItems[_i];
      _tempItem['isBeingAddedToCart'] = false;
      this.also.push(_tempItem);
    }
    for (var _i2 in this.recentItems) {
      var _tempItem2 = this.recentItems[_i2];
      _tempItem2['isBeingAddedToCart'] = false;
      this.recent.push(_tempItem2);
    }
    for (var _i3 in this.extraItems) {
      var _tempItem3 = this.extraItems[_i3];
      _tempItem3['isBeingAddedToCart'] = false;
      this.extra.push(_tempItem3);
    }
  }
});

/***/ }),

/***/ "dycf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dzH3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Shipping Address")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"cardName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"cardNumber"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"fullName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"year"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e218":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("eLkx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1338b902_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("Vtux");
function injectStyle (ssrContext) {
  __webpack_require__("eTRL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1338b902"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1338b902_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eAwv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eLkx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedPayment', 'mode', 'payments'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      number: { value: '', isValid: true, wasFocused: false },
      month: { value: '', isValid: true, wasFocused: false },
      year: { value: '', isValid: true, wasFocused: false },
      //
      shouldComeBackToManager: false
    };
  },

  methods: {
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      var data = {
        name: this.name.value,
        number: this.number.value,
        month: this.month.value,
        year: this.year.value
      };
      if (this.mode === 'add') {
        this.$emit('saveNew', data);
      } else {
        this.$emit('saveExisting', data);
      }
    },
    addPressed: function addPressed() {
      this.shouldComeBackToManager = false;
      this.$emit('add');
    },
    editSelectedPressed: function editSelectedPressed(index) {
      this.shouldComeBackToManager = true;
      this.$emit('edit', index);
      this.fillForm();
    },
    deleteSelectedPressed: function deleteSelectedPressed(index) {
      this.$emit('delete', index);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.number.isValid = true;
      this.month.isValid = true;
      this.year.isValid = true;
      //
      this.name.wasFocused = false;
      this.number.wasFocused = false;
      this.month.wasFocused = false;
      this.year.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.number.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.number.isValid = false;
      }
      if (this.month.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.month.isValid = false;
      }
      if (this.year.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.year.isValid = false;
      }
      return hasErrors;
    },
    fillForm: function fillForm() {
      this.name = { value: this.payments[this.selectedPayment].name, isValid: true, wasFocused: false };
      this.number = { value: this.payments[this.selectedPayment].number, isValid: true, wasFocused: false };
      this.month = { value: this.payments[this.selectedPayment].month, isValid: true, wasFocused: false };
      this.year = { value: this.payments[this.selectedPayment].year, isValid: true, wasFocused: false };
    }
  },
  created: function created() {
    if (this.mode === 'edit') {
      this.fillForm();
    }
  },

  watch: {
    selectedPayment: function selectedPayment() {
      this.fillForm();
    }
  }
});

/***/ }),

/***/ "eTRL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eYnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  props: ['cart'],
  data: function data() {
    return {};
  },

  methods: {
    editPressed: function editPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('edit');
    }
  }
});

/***/ }),

/***/ "ecvi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"400px","margin":"5vh auto","border-radius":"2px","box-shadow":"0px 12px 36px rgba(0,0,0,0.1)"}},[_c('div',{staticClass:"flexy padding-hor-xl",staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"16px"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[_vm._v("Sign in")])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl",staticStyle:{"max-height":"80vh","overflow":"auto","background-color":"white"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","name":"","id":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl padding-vert-l",staticStyle:{"background-color":"white","flex":"0 0 auto","text-align":"right","border-radius":"0 0 10px 10px","padding-top":"24px"}},[_c('button',{staticClass:"boxed primary properGrey",staticStyle:{"margin-right":"4px"},on:{"click":function($event){_vm.closePressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary properBlue",staticStyle:{"min-width":"120px"},on:{"click":function($event){_vm.loginPressed()}}},[_vm._v("Login")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ere0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['selectedAddress', 'addresses', 'reactivator'],
  data: function data() {
    return {
      doShowAddressesList: false
    };
  },

  computed: {
    reactiveAddresses: function reactiveAddresses() {
      return this.addresses;
    }
  },
  methods: {
    addPressed: function addPressed() {
      this.$emit('add');
    },
    changePressed: function changePressed() {
      this.doShowAddressesList = true;
    },
    editPressed: function editPressed(index) {
      this.$emit('edit', index);
      this.doShowAddressesList = false;
    },
    deletePressed: function deletePressed(index) {
      if (this.addresses.length === 1) {
        this.doShowAddressesList = false;
      }
      this.$emit('delete', index);
      // this.doShowAddressesList = false
    },
    choosePressed: function choosePressed(index) {
      this.$emit('change', index);
      this.doShowAddressesList = false;
    },
    addNewAddressPressed: function addNewAddressPressed() {
      this.doShowAddressesList = false;
      this.$emit('add');
    },

    // manageAddressesPressed () {
    //   this.doShowAddressesList = false
    //   this.$emit('manage')
    // },
    doNothing: function doNothing() {
      //
    }
  }
});

/***/ }),

/***/ "fGQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("LnCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5553832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("ux34");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5553832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fcn5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395baa58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("Lqm+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395baa58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fhVA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fiE3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hard.3620c1c.jpg";

/***/ }),

/***/ "fifm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__ = __webpack_require__("NgNI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a96b629c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__ = __webpack_require__("Zu+v");
function injectStyle (ssrContext) {
  __webpack_require__("qpED")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a96b629c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a96b629c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fp8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g+mz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"1"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"1")},on:{"change":function($event){_vm.chosenDelivery="1"}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"2"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"2")},on:{"change":function($event){_vm.chosenDelivery="2"}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"3"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"3")},on:{"change":function($event){_vm.chosenDelivery="3"}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"4"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"4")},on:{"change":function($event){_vm.chosenDelivery="4"}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"5"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"5")},on:{"change":function($event){_vm.chosenDelivery="5"}}}),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',[_vm._v("FREE shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',[_vm._v("$6.98 - Standart shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("$13.98 - Two-Day Shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',[_vm._v("$20.98 - One-Day Shipping")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g3bU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g6Ja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("BslS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb22387c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("TIZz");
function injectStyle (ssrContext) {
  __webpack_require__("oHZF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bb22387c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb22387c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g871":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Shipping Address")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"cardName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"cardNumber"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"fullName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"year"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g979":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_408552d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("PrLU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_408552d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gB41":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gHVA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
    };
  }
});

/***/ }),

/***/ "gORT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__ = __webpack_require__("07PK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4b60f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__("P0kv");
function injectStyle (ssrContext) {
  __webpack_require__("bxCS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b4b60f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4b60f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gR2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  props: ['cart'],
  data: function data() {
    return {};
  },

  methods: {
    editPressed: function editPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('edit');
    }
  }
});

/***/ }),

/***/ "glVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__ = __webpack_require__("v7Jy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  components: {
    QuickPreview: __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__["a" /* default */]
  },
  props: ['cart', 'alsoItems', 'recentItems', 'extraItems'],
  data: function data() {
    return {
      items: [],
      also: [],
      recent: [],
      extra: [],
      later: [],
      doShowPreview: false,
      selectedForPreview: null,
      youRecentlyViewed: 'You recently viewed'
    };
  },

  computed: {
    subtotal: function subtotal() {
      var result = 0;
      for (var i in this.items) {
        result += this.items[i].price * this.items[i].quantity;
      }
      return result.toFixed(2);
    }
  },
  methods: {
    checkoutPressed: function checkoutPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('confirmed', this.items);
    },
    removeItemPressed: function removeItemPressed(index) {
      this.items.splice(index, 1);
    },
    xPressed: function xPressed(index) {
      this.items[index].isXPressed = !this.items[index].isXPressed;
      this.youRecentlyViewed = this.youRecentlyViewed + ' ';
      // this.also.splice(index, 1)
      // for (let i in this.items) {
      //   let currentItem = this.items[i]
      //   currentItem['updated'] = Math.random() * (100 - 5) + 5
      //   console.log(currentItem['updated'])
      // }
    },
    saveForLaterPressed: function saveForLaterPressed(index) {
      var tempItem = this.items[index];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.later.push(this.items[index]);
      this.items.splice(index, 1);
    },
    addFromLaterPressed: function addFromLaterPressed(index) {
      var _this = this;

      this.later[index].isBeingAddedToCart = true;
      this.items.push(this.later[index]);
      setTimeout(function () {
        _this.later.splice(index, 1);
      }, 500);
    },
    addFromAlsoPressed: function addFromAlsoPressed(index) {
      var _this2 = this;

      this.also[index].isBeingAddedToCart = true;
      this.items.push(this.also[index]);
      setTimeout(function () {
        _this2.also.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this2.extra.length > 0) {
          _this2.also.push(_this2.extra[0]);
          _this2.extra.splice(0, 1);
        }
      }, 1000);
    },
    addFromRecentPressed: function addFromRecentPressed(index) {
      var _this3 = this;

      this.recent[index].isBeingAddedToCart = true;
      this.items.push(this.recent[index]);
      setTimeout(function () {
        _this3.recent.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this3.extra.length > 0) {
          _this3.recent.push(_this3.extra[0]);
          _this3.extra.splice(0, 1);
        }
      }, 1000);
      // var rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.right, rect.bottom, rect.left);
      // let lastIndex = this.items.length - 1
      // let lastItem = document.getElementById('cart-item-' + lastIndex)
      // console.log(lastItem)
      // console.log('cart-item-' + lastIndex)
      // let rect = lastItem.getBoundingClientRect()
      // console.log(rect)
      // let position = 0 + (this.items.length * 136)
      // window.scroll({
      //   top: position,
      //   left: 0,
      //   behavior: 'smooth'
      // })
    },
    addedToCartFromPreview: function addedToCartFromPreview(item) {
      if (item.section === 'items') {
        this.items[item.index].quantity = this.items[item.index].quantity + 1;
      } else if (item.section === 'recent') {
        this.addFromRecentPressed(item.index);
      } else if (item.section === 'also') {
        this.addFromAlsoPressed(item.index);
      } else if (item.section === 'later') {
        this.addFromLaterPressed(item.index);
      }
      this.doShowPreview = false;
    },
    openPreview: function openPreview(section, index) {
      if (section === 'items') {
        this.doShowPreview = true;
        this.selectedForPreview = this.items[index];
      } else if (section === 'recent') {
        this.doShowPreview = true;
        this.selectedForPreview = this.recent[index];
      } else if (section === 'also') {
        this.doShowPreview = true;
        this.selectedForPreview = this.also[index];
      } else if (section === 'later') {
        this.doShowPreview = true;
        this.selectedForPreview = this.later[index];
      }
      this.selectedForPreview['section'] = section;
      this.selectedForPreview['index'] = index;
    }
  },
  created: function created() {
    for (var i in this.cart) {
      var tempItem = this.cart[i];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.items.push(tempItem);
    }
    for (var _i in this.alsoItems) {
      var _tempItem = this.alsoItems[_i];
      _tempItem['isBeingAddedToCart'] = false;
      this.also.push(_tempItem);
    }
    for (var _i2 in this.recentItems) {
      var _tempItem2 = this.recentItems[_i2];
      _tempItem2['isBeingAddedToCart'] = false;
      this.recent.push(_tempItem2);
    }
    for (var _i3 in this.extraItems) {
      var _tempItem3 = this.extraItems[_i3];
      _tempItem3['isBeingAddedToCart'] = false;
      this.extra.push(_tempItem3);
    }
  }
});

/***/ }),

/***/ "h+0h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("lwod");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02fc9900_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("NzJi");
function injectStyle (ssrContext) {
  __webpack_require__("swTv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02fc9900"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02fc9900_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h0Dd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-m fixed silver rounded",staticStyle:{"width":"300px"}},[_c('h3',[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide",class:{grey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('ul',[(!_vm.isShippingFilled)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentFilled)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.87")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$96.85")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h8Hu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hBqG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("d/mW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba45500_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("+sb+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba45500_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hBuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__ = __webpack_require__("JkvD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78af0f5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__ = __webpack_require__("S8Pp");
function injectStyle (ssrContext) {
  __webpack_require__("8lUr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78af0f5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78af0f5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hEid":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
    };
  }
});

/***/ }),

/***/ "hQ4D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hV7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100vh","overflow":"auto"}},[_c('div',{staticClass:"padding-hor-l padding-vert-m black flexy",staticStyle:{"height":"80px","background-color":"#232f3e"}},[_c('div',[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'Start'}}},[_vm._v("Amazon")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px"}},[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_vm._v("Cart")])])]),_vm._v(" "),(_vm.currentView === 'Start')?_c('Start'):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShoppingCart')?_c('ShoppingCart',{attrs:{"cart":_vm.cart,"alsoItems":_vm.alsoItems,"recentItems":_vm.recentItems,"extraItems":_vm.extraItems},on:{"confirmed":function($event){_vm.shoppingCartConfirmed($event)}}}):_vm._e(),_vm._v(" "),(_vm.doShowAddressManager)?_c('ShippingAddress',{attrs:{"mode":_vm.addressMode,"addresses":_vm.addresses,"selectedAddress":_vm.selectedAddressForEditing},on:{"edit":function($event){_vm.editAddressPressed($event)},"delete":function($event){_vm.deleteAddressPressed($event)},"saveNew":function($event){_vm.shippingAddressSaveNew($event)},"saveExisting":function($event){_vm.shippingAddressSaveExisting($event)},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.doShowPaymentManager)?_c('PaymentMethod',{attrs:{"selectedPayment":_vm.selectedPayment},on:{"confirmed":function($event){_vm.paymentMethodConfirmed($event)},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ExtraSignup')?_c('ExtraSignup'):_vm._e(),_vm._v(" "),(_vm.currentView === 'Checkout')?_c('div',{attrs:{"id":"checkout"}},[_c('div',{staticClass:"padding-hor-l"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flexy align-top"},[_c('div',[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{attrs:{"selectedAddress":_vm.selectedAddress,"addresses":_vm.addresses,"reactivator":_vm.reactivator},on:{"add":function($event){_vm.addAddressPressed()},"edit":function($event){_vm.editAddressPressed($event)},"delete":function($event){_vm.deleteAddressPressed($event)},"change":function($event){_vm.changeAddressSelected($event)},"manage":function($event){_vm.manageAddressPressed()}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('PaymentMethodMin',{attrs:{"selectedPayment":_vm.selectedPayment},on:{"edit":function($event){_vm.editPaymentPressed()}}})],1),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch"},[_c('ShoppingCartMin',{attrs:{"cart":_vm.cart},on:{"edit":function($event){_vm.currentView = 'ShoppingCart'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('Delivery',{attrs:{"chosenDelivery":_vm.chosenDelivery}})],1)]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('OrderSummary',{attrs:{"selectedAddress":_vm.selectedAddress,"selectedPayment":_vm.selectedPayment},on:{"placed":function($event){_vm.currentView = 'ExtraSignup'}}})],1)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l flexy"},[_c('h1',[_vm._v("Checkout")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "htAW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("GHM9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb4875a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("pDTe");
function injectStyle (ssrContext) {
  __webpack_require__("cZ98")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bb4875a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb4875a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i4wA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
    };
  }
});

/***/ }),

/***/ "i7oi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__ = __webpack_require__("Ngiv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  components: {
    QuickPreview: __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__["a" /* default */]
  },
  props: ['cart', 'alsoItems', 'recentItems', 'extraItems'],
  data: function data() {
    return {
      items: [],
      also: [],
      recent: [],
      extra: [],
      later: [],
      doShowPreview: false,
      selectedForPreview: null,
      youRecentlyViewed: 'You recently viewed'
    };
  },

  computed: {
    subtotal: function subtotal() {
      var result = 0;
      for (var i in this.items) {
        result += this.items[i].price * this.items[i].quantity;
      }
      return result.toFixed(2);
    }
  },
  methods: {
    checkoutPressed: function checkoutPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('confirmed', this.items);
    },
    removeItemPressed: function removeItemPressed(index) {
      this.items.splice(index, 1);
    },
    xPressed: function xPressed(index) {
      this.items[index].isXPressed = !this.items[index].isXPressed;
      this.youRecentlyViewed = this.youRecentlyViewed + ' ';
      // this.also.splice(index, 1)
      // for (let i in this.items) {
      //   let currentItem = this.items[i]
      //   currentItem['updated'] = Math.random() * (100 - 5) + 5
      //   console.log(currentItem['updated'])
      // }
    },
    saveForLaterPressed: function saveForLaterPressed(index) {
      var tempItem = this.items[index];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.later.push(this.items[index]);
      this.items.splice(index, 1);
    },
    addFromLaterPressed: function addFromLaterPressed(index) {
      var _this = this;

      this.later[index].isBeingAddedToCart = true;
      this.items.push(this.later[index]);
      setTimeout(function () {
        _this.later.splice(index, 1);
      }, 500);
    },
    addFromAlsoPressed: function addFromAlsoPressed(index) {
      var _this2 = this;

      this.also[index].isBeingAddedToCart = true;
      this.items.push(this.also[index]);
      setTimeout(function () {
        _this2.also.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this2.extra.length > 0) {
          _this2.also.push(_this2.extra[0]);
          _this2.extra.splice(0, 1);
        }
      }, 1000);
    },
    addFromRecentPressed: function addFromRecentPressed(index) {
      var _this3 = this;

      this.recent[index].isBeingAddedToCart = true;
      this.items.push(this.recent[index]);
      setTimeout(function () {
        _this3.recent.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this3.extra.length > 0) {
          _this3.recent.push(_this3.extra[0]);
          _this3.extra.splice(0, 1);
        }
      }, 1000);
      // var rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.right, rect.bottom, rect.left);
      // let lastIndex = this.items.length - 1
      // let lastItem = document.getElementById('cart-item-' + lastIndex)
      // console.log(lastItem)
      // console.log('cart-item-' + lastIndex)
      // let rect = lastItem.getBoundingClientRect()
      // console.log(rect)
      // let position = 0 + (this.items.length * 136)
      // window.scroll({
      //   top: position,
      //   left: 0,
      //   behavior: 'smooth'
      // })
    },
    addedToCartFromPreview: function addedToCartFromPreview(item) {
      if (item.section === 'items') {
        this.items[item.index].quantity = this.items[item.index].quantity + 1;
      } else if (item.section === 'recent') {
        this.addFromRecentPressed(item.index);
      } else if (item.section === 'also') {
        this.addFromAlsoPressed(item.index);
      } else if (item.section === 'later') {
        this.addFromLaterPressed(item.index);
      }
      this.doShowPreview = false;
    },
    openPreview: function openPreview(section, index) {
      if (section === 'items') {
        this.doShowPreview = true;
        this.selectedForPreview = this.items[index];
      } else if (section === 'recent') {
        this.doShowPreview = true;
        this.selectedForPreview = this.recent[index];
      } else if (section === 'also') {
        this.doShowPreview = true;
        this.selectedForPreview = this.also[index];
      } else if (section === 'later') {
        this.doShowPreview = true;
        this.selectedForPreview = this.later[index];
      }
      this.selectedForPreview['section'] = section;
      this.selectedForPreview['index'] = index;
    }
  },
  created: function created() {
    for (var i in this.cart) {
      var tempItem = this.cart[i];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.items.push(tempItem);
    }
    for (var _i in this.alsoItems) {
      var _tempItem = this.alsoItems[_i];
      _tempItem['isBeingAddedToCart'] = false;
      this.also.push(_tempItem);
    }
    for (var _i2 in this.recentItems) {
      var _tempItem2 = this.recentItems[_i2];
      _tempItem2['isBeingAddedToCart'] = false;
      this.recent.push(_tempItem2);
    }
    for (var _i3 in this.extraItems) {
      var _tempItem3 = this.extraItems[_i3];
      _tempItem3['isBeingAddedToCart'] = false;
      this.extra.push(_tempItem3);
    }
  }
});

/***/ }),

/***/ "iD5A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Shipping Address")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"fullName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"addressLine1"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine2"}},[_vm._v("Address Line 2")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"addressLine2"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"city"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"state"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"zip"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',[_c('option',{attrs:{"value":"volvo"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"saab"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"mercedes"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"audi"}},[_vm._v("Brazil")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"phone"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iF1G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iLfo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  },

  computed: {
    delivery: {
      get: function get() {
        return this.$store.getters.getChosenDelivery;
      },
      set: function set(newValue) {
        this.$store.dispatch('setChosenDelivery', newValue);
      }
    }
  }
});

/***/ }),

/***/ "iUlw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedAddress', 'mode', 'addresses'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      address1: { value: '', isValid: true, wasFocused: false },
      city: { value: '', isValid: true, wasFocused: false },
      state: { value: '', isValid: true, wasFocused: false },
      zip: { value: '', isValid: true, wasFocused: false },
      country: { value: '', isValid: true, wasFocused: false },
      phone: { value: '', isValid: true, wasFocused: false },
      //
      shouldComeBackToManager: false
    };
  },

  methods: {
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      var data = {
        name: this.name.value,
        address1: this.address1.value,
        city: this.city.value,
        state: this.state.value,
        zip: this.zip.value,
        country: this.country.value,
        phone: this.phone.value
      };
      if (this.mode === 'add') {
        this.$emit('saveNew', data);
      } else {
        this.$emit('saveExisting', data);
      }
    },
    cancelPressed: function cancelPressed() {
      if (this.shouldComeBackToManager) {
        this.$emit('backToManager');
      } else {
        this.$emit('cancelled');
      }
    },
    addPressed: function addPressed() {
      this.shouldComeBackToManager = false;
      this.$emit('add');
    },
    editSelectedPressed: function editSelectedPressed(index) {
      this.shouldComeBackToManager = true;
      this.$emit('edit', index);
      this.fillForm();
    },
    deleteSelectedPressed: function deleteSelectedPressed(index) {
      this.$emit('delete', index);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.address1.isValid = true;
      this.city.isValid = true;
      this.state.isValid = true;
      this.zip.isValid = true;
      this.country.isValid = true;
      this.phone.isValid = true;
      //
      this.name.wasFocused = false;
      this.address1.wasFocused = false;
      this.city.wasFocused = false;
      this.state.wasFocused = false;
      this.zip.wasFocused = false;
      this.country.wasFocused = false;
      this.phone.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.address1.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.address1.isValid = false;
      }
      if (this.city.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.city.isValid = false;
      }
      if (this.state.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.state.isValid = false;
      }
      if (this.zip.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.zip.isValid = false;
      }
      if (this.country.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.country.isValid = false;
      }
      if (this.phone.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.phone.isValid = false;
      }
      return hasErrors;
    },
    fillForm: function fillForm() {
      this.name = { value: this.addresses[this.selectedAddress].name, isValid: true, wasFocused: false };
      this.address1 = { value: this.addresses[this.selectedAddress].address1, isValid: true, wasFocused: false };
      this.city = { value: this.addresses[this.selectedAddress].city, isValid: true, wasFocused: false };
      this.state = { value: this.addresses[this.selectedAddress].state, isValid: true, wasFocused: false };
      this.zip = { value: this.addresses[this.selectedAddress].zip, isValid: true, wasFocused: false };
      this.country = { value: this.addresses[this.selectedAddress].country, isValid: true, wasFocused: false };
      this.phone = { value: this.addresses[this.selectedAddress].phone, isValid: true, wasFocused: false };
    }
  },
  watch: {
    selectedAddress: function selectedAddress() {
      this.fillForm();
    }
  },
  created: function created() {
    if (this.mode === 'edit') {
      this.fillForm();
    }
  }
});

/***/ }),

/***/ "iZiJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iZkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"},on:{"click":function($event){_vm.closePressed()}}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"800px","margin":"5vh auto","background-color":"white","border-radius":"2px","box-shadow":"0px 12px 36px rgba(0,0,0,0.1)"},on:{"click":function($event){$event.stopPropagation();_vm.doThis()}}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"height":"7vh","border-bottom":"1px solid #DDE1EB"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[_vm._v("You recently viewed")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.closePressed()}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticStyle:{"max-height":"80vh","overflow":"auto"}},[_c('div',{staticClass:"flexy align-top padding-hor-l padding-vert-l"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"220px"}},[_c('img',{attrs:{"src":_vm.item.img,"width":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.item.name))])]),_vm._v(" "),_c('div',[_vm._v("by "+_vm._s(_vm.item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-m",staticStyle:{"background-color":"pink","display":"inline-block"}},[_vm._v("#1 Bestseller in Industrial Product Design")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s flexy"},[_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'kindle'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'kindle'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Kindle book")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$17.63")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'hardcover'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'hardcover'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Hardcover")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$18.89")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'paperback'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'paperback'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Paperback")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$55.77")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[(!_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed subtle-primary",staticStyle:{"background-color":"#b3ffb3","color":"green","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l padding-hor-l"},[_c('div',{staticClass:"flexy rounded"},[_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'description'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none","border-top-left-radius":"6px","border-bottom-left-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'description'}}},[_vm._v("\n              Description\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'editors'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none"},on:{"click":function($event){_vm.selectedTab = 'editors'}}},[_vm._v("\n              Editorial reviews\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'user'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-top-right-radius":"6px","border-bottom-right-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'user'}}},[_vm._v("\n              User reviews\n            ")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-xs"},[(_vm.selectedTab === 'description')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Why do some products capture widespread attention while others flop? What makes us engage with certain products out of sheer habit? Is there a pattern underlying how technologies hook us?")]),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Nir Eyal answers these questions (and many more) by explaining the Hook Model—a four-step process embedded into the products of many successful companies to subtly encourage customer behavior. Through consecutive “hook cycles,” these products reach their ultimate goal of bringing users back again and again without depending on costly advertising or aggressive messaging.")]):_vm._e(),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Hooked is based on Eyal’s years of research, consulting, and practical experience. He wrote the book he wished had been available to him as a start-up founder—not abstract theory, but a how-to guide for building better products. Hooked is written for product managers, designers, marketers, start-up founders, and anyone who seeks to understand how products influence our behavior.")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'editors')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Publisher's Weekly")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Eric Ries, author of The Lean Startup")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Boris Veldhuijzen van Zanten, founder of The Next Web ")])])])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'user')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ie/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Oder surmmary")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"}),_vm._v(" "),_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"240px"},attrs:{"id":"delivery"}},[_c('h3',[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"1"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"1")},on:{"change":function($event){_vm.chosenDelivery="1"}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"2"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"2")},on:{"change":function($event){_vm.chosenDelivery="2"}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"3"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"3")},on:{"change":function($event){_vm.chosenDelivery="3"}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"4"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"4")},on:{"change":function($event){_vm.chosenDelivery="4"}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"5"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"5")},on:{"change":function($event){_vm.chosenDelivery="5"}}}),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px"},attrs:{"id":"delivery"}}),_vm._v(" "),_c('div',{attrs:{"id":"summary"}},[_c('h3',[_vm._v("Summary")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary",class:{grey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('ul',[(!_vm.isShippingFilled)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentFilled)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',[_vm._v("FREE shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',[_vm._v("$6.98 - Standart shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("$13.98 - Two-Day Shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',[_vm._v("$20.98 - One-Day Shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.87")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$96.85")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "isfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  methods: {
    closePressed: function closePressed() {
      this.$emit('close');
    },
    loginPressed: function loginPressed() {
      this.$emit('login');
    }
  }
});

/***/ }),

/***/ "itN+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ivi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  methods: {
    closePressed: function closePressed() {
      this.$emit('close');
    },
    loginPressed: function loginPressed() {
      this.$emit('login');
    }
  }
});

/***/ }),

/***/ "iziJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "izy8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
    };
  }
});

/***/ }),

/***/ "j+zK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',{staticStyle:{"font-size":"19px"}},[_vm._v("Shipping address")]),_vm._v(" "),(_vm.selectedAddress === null)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":_vm.addPressed}},[_vm._v("Add shipping address")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"12px"}},[_c('button',{staticStyle:{"color":"#409EFF","border-bottom":"1px dashed","border-radius":"0","cursor":"pointer"},on:{"click":function($event){_vm.openSignIn()}}},[_vm._v("Sign in")]),_vm._v(" for 1-click checkout")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].address1)+" ")]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].city)+", "+_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].state)+", "+_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].country))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].phone))]),_vm._v(" "),_c('div',{staticStyle:{"color":"transparent","width":"0","height":"0","overflow":"hidden"}},[_vm._v(_vm._s(_vm.reactivator))]),_vm._v(" "),_c('transition',{attrs:{"name":"popover"}},[(_vm.doShowAddressesList)?_c('div',[_c('div',{staticClass:"popover-curtain",on:{"click":function($event){_vm.doShowAddressesList=false}}}),_vm._v(" "),_c('div',{staticClass:"popover-content",on:{"click":function($event){$event.stopPropagation();_vm.doNothing($event)}}},[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":function($event){_vm.choosePressed(i)}}},[_c('div',{class:{selectedItem: i === _vm.selectedAddress},staticStyle:{"padding":"12px 24px"}},[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])])])}),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px","margin-top":"4px"},on:{"click":_vm.addNewAddressPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Add new address")])])]),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":_vm.manageAddressesPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Manage addresses")])])])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticStyle:{"color":"#409EFF","border-bottom":"1px dashed","border-radius":"0"},on:{"click":_vm.changePressed}},[_vm._v("Change")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j1i0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"},on:{"click":function($event){_vm.closePressed()}}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"800px","margin":"5vh auto","background-color":"white","border-radius":"2px","box-shadow":"0px 12px 36px rgba(0,0,0,0.1)"},on:{"click":function($event){$event.stopPropagation();_vm.doThis()}}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"height":"7vh","border-bottom":"1px solid #DDE1EB"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[_vm._v("You recently viewed")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.closePressed()}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticStyle:{"max-height":"80vh","overflow":"auto"}},[_c('div',{staticClass:"flexy align-top padding-hor-l padding-vert-l"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"220px"}},[_c('img',{attrs:{"src":_vm.item.img,"width":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.item.name))])]),_vm._v(" "),_c('div',[_vm._v("by "+_vm._s(_vm.item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-m",staticStyle:{"background-color":"pink","display":"inline-block"}},[_vm._v("#1 Bestseller in Industrial Product Design")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s flexy"},[_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'kindle'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'kindle'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Kindle book")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$17.63")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'hardcover'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'hardcover'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Hardcover")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$18.89")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'paperback'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'paperback'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Paperback")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$55.77")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[(!_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed subtle-primary",staticStyle:{"background-color":"#b3ffb3","color":"green","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l padding-hor-l"},[_c('div',{staticClass:"flexy rounded"},[_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'description'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none","border-top-left-radius":"6px","border-bottom-left-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'description'}}},[_vm._v("\n              Description\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'editors'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none"},on:{"click":function($event){_vm.selectedTab = 'editors'}}},[_vm._v("\n              Editorial reviews\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'user'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-top-right-radius":"6px","border-bottom-right-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'user'}}},[_vm._v("\n              User reviews\n            ")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-xs"},[(_vm.selectedTab === 'description')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Why do some products capture widespread attention while others flop? What makes us engage with certain products out of sheer habit? Is there a pattern underlying how technologies hook us?")]),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Nir Eyal answers these questions (and many more) by explaining the Hook Model—a four-step process embedded into the products of many successful companies to subtly encourage customer behavior. Through consecutive “hook cycles,” these products reach their ultimate goal of bringing users back again and again without depending on costly advertising or aggressive messaging.")]):_vm._e(),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Hooked is based on Eyal’s years of research, consulting, and practical experience. He wrote the book he wished had been available to him as a start-up founder—not abstract theory, but a how-to guide for building better products. Hooked is written for product managers, designers, marketers, start-up founders, and anyone who seeks to understand how products influence our behavior.")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'editors')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Publisher's Weekly")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Eric Ries, author of The Lean Startup")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Boris Veldhuijzen van Zanten, founder of The Next Web ")])])])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'user')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j5y5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__ = __webpack_require__("eYnU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aa4a6c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__ = __webpack_require__("GEoq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCartMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aa4a6c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCartMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j6Am":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jAj8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/beauty.857a8ef.jpg";

/***/ }),

/***/ "jC9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("oNnB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e61aa8c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("1+5K");
function injectStyle (ssrContext) {
  __webpack_require__("JFzI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e61aa8c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e61aa8c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jEiK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['selectedPayment'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "jWPl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-hor-xl padding-vert-m fixed",staticStyle:{"width":"32%","background-color":"#F5F5F5","min-height":"100vh","position":"sticky","top":"0","height":"100%"}},[_c('div',{staticClass:"padding-hor-m",staticStyle:{"padding-top":"20px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"24px"}},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$"+_vm._s(_vm.cartSum))])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"6px"}},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$"+_vm._s(_vm.deliveryPrice === 0 ? '6.98' : _vm.deliveryPrice))])]),_vm._v(" "),(_vm.deliveryPrice === 0)?_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"6px"}},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"24px"}},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$"+_vm._s(_vm.beforeTax))])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"6px"}},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$"+_vm._s(_vm.tax))])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"padding-top":"24px","font-weight":"900"}},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$"+_vm._s(_vm.total))])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide properBlue",class:{properGrey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),_c('transition',{attrs:{"name":"alert"}},[(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m flexy align-top",staticStyle:{"position":"fixed","width":"340px","font-size":"13px","padding-left":"24px","padding-right":"12px","bottom":"80px","right":"32px","background-color":"white","box-shadow":"0px 4px 16px rgba(0,0,0,0.1)","border-radius":"0 6px 6px 0","border-left":"4px solid orange"}},[_c('div',[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"8px"}},[_c('ul',[(_vm.selectedAddress === null)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(_vm.selectedPayment === null)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px","margin-left":"12px"}},[_c('button',{on:{"click":function($event){_vm.showInstructions = false;}}},[_c('img',{staticClass:"button-icon dark",staticStyle:{"width":"16px","opacity":"1"},attrs:{"src":__webpack_require__("5F5F")}})])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m",staticStyle:{"font-size":"12px","color":"#878D98"}},[_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("By placing order, you agree to Amazon's "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("privacy notice")]),_vm._v(" and "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("conditions of use")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("How are shipping costs calculated?")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("You got free shipping on the eligible items in your order! ( "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("Why aren't all my items eligible?")]),_vm._v(")")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jZJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("JnL8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_697bb738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("sq3h");
function injectStyle (ssrContext) {
  __webpack_require__("KD+B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-697bb738"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_697bb738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "je40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: null,
      showFullDescription: false,
      selectedFormat: 'kindle',
      selectedTab: 'description'
    };
  },

  props: ['selectedForPreview'],
  methods: {
    closePressed: function closePressed() {
      this.$emit('close');
    },
    addPressed: function addPressed() {
      this.$emit('addToCart', this.item);
    }
  },
  created: function created() {
    this.item = this.selectedForPreview;
  }
});

/***/ }),

/***/ "jgXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShoppingCartMin__ = __webpack_require__("VoS0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Delivery__ = __webpack_require__("KFMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShippingAddress__ = __webpack_require__("WYhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShippingAddressMin__ = __webpack_require__("pi1L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentMethod__ = __webpack_require__("h+0h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentMethodMin__ = __webpack_require__("L/rg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderSummary__ = __webpack_require__("H+KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExtraSignup__ = __webpack_require__("Kn1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SignIn__ = __webpack_require__("S1BV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Start from './Start'
// import ShoppingCart from './ShoppingCart'










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    // Start,
    // ShoppingCart,
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_0__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_2__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_3__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_4__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_5__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_1__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_6__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_7__ExtraSignup__["a" /* default */],
    SignIn: __WEBPACK_IMPORTED_MODULE_8__SignIn__["a" /* default */]
  },
  data: function data() {
    return {
      // addressMode: null,
      // doShowAddressManager: false,
      // selectedAddress: null,
      // selectedAddressForEditing: null,
      // addresses: [],
      //
      // paymentMode: null,
      // doShowPaymentManager: false,
      // selectedPayment: null,
      // selectedPaymentForEditing: null,
      // payments: [],
      //
      // doShowSignIn: false,
      //
    };
  },

  computed: {
    cart: function cart() {
      return this.$store.getters.getCart;
    }
  },
  methods: {
    // shoppingCartConfirmed (items) {
    //   this.currentView = 'Checkout'
    //   this.cart = items
    // },
    // shoppingCartUpdated (items) {
    //   this.cart = items
    // },
    //
    // ADDRESS
    addAddressPressed: function addAddressPressed() {
      this.addressMode = 'add';
      this.doShowAddressManager = true;
    },
    editAddressPressed: function editAddressPressed(index) {
      this.addressMode = 'edit';
      this.selectedAddressForEditing = index;
      // this.doShowAddressManager = true
    },
    deleteAddressPressed: function deleteAddressPressed(index) {
      if (index > 0) {
        this.selectedAddress = index - 1;
      } else {
        if (this.addresses.length === 1) {
          this.selectedAddress = null;
        } else {
          this.selectedAddress = index + 1;
        }
      }
      this.addresses.splice(index, 1);
      // this.selectedAddress = index
      // this.doShowAddressManager = true
    },
    shippingAddressSaveNew: function shippingAddressSaveNew(data) {
      this.addresses.push(data);
      this.selectedAddress = this.addresses.length - 1;
      this.doShowAddressManager = false;
    },
    shippingAddressSaveExisting: function shippingAddressSaveExisting(data) {
      this.addresses[this.selectedAddressForEditing] = data;
      this.reactivator++;
      this.addressMode = 'manage';
    },
    changeAddressSelected: function changeAddressSelected(index) {
      this.selectedAddress = index;
    },
    manageAddressPressed: function manageAddressPressed() {
      this.addressMode = 'manage';
      this.doShowAddressManager = true;
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.doShowAddressManager = false;
    },
    shippingAddressCancelledBackToManager: function shippingAddressCancelledBackToManager() {
      this.addressMode = 'manage';
    },

    //
    // PAYMENT
    addPaymentPressed: function addPaymentPressed() {
      this.paymentMode = 'add';
      this.doShowPaymentManager = true;
    },
    editPaymentPressed: function editPaymentPressed(index) {
      this.paymentMode = 'edit';
      this.selectedPaymentForEditing = index;
      // this.doShowAddressManager = true
    },
    deletePaymentPressed: function deletePaymentPressed(index) {
      if (index > 0) {
        this.selectedPayment = index - 1;
      } else {
        if (this.payments.length === 1) {
          this.selectedPayment = null;
        } else {
          this.selectedPayment = index + 1;
        }
      }
      this.payments.splice(index, 1);
      // this.selectedAddress = index
      // this.doShowAddressManager = true
    },
    paymentMethodSaveNew: function paymentMethodSaveNew(data) {
      this.payments.push(data);
      this.selectedPayment = this.payments.length - 1;
      this.doShowPaymentManager = false;
    },
    paymentMethodSaveExisting: function paymentMethodSaveExisting(data) {
      this.payments[this.selectedPaymentForEditing] = data;
      this.reactivator++;
      this.paymentMode = 'manage';
    },
    changePaymentSelected: function changePaymentSelected(index) {
      this.selectedPayment = index;
    },
    managePaymentPressed: function managePaymentPressed() {
      this.paymentMode = 'manage';
      this.doShowPaymentManager = true;
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.doShowPaymentManager = false;
    },
    paymentMethodCancelledBackToManager: function paymentMethodCancelledBackToManager() {
      this.paymentMode = 'manage';
    },

    //
    // SIGN IN
    signInPressed: function signInPressed() {
      this.doShowSignIn = true;
    },
    signInClosed: function signInClosed() {
      this.doShowSignIn = false;
    },
    loginPressed: function loginPressed() {
      this.addresses.push({
        name: 'Sam Bell',
        address1: '821 Washington St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10101',
        country: 'United States',
        phone: '+1 800 555 66 77'
      });
      this.addresses.push({
        name: 'Sam Bell',
        address1: '1014 Lincoln St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10114',
        country: 'United States',
        phone: '+1 800 555 00 11'
      });
      this.payments.push({
        name: 'Sam Bell',
        number: '1234 5678 1234 1235',
        month: '07',
        year: '20'
      });
      this.selectedAddress = 0;
      this.selectedPayment = 0;
      this.doShowSignIn = false;
    },

    // DELIVERY
    changeDelivery: function changeDelivery(index) {
      this.chosenDelivery = index;
    }
  },
  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "jiSs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jku2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m fixed flexy align-top",staticStyle:{"width":"50%","padding-right":"40px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("y93l"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"1"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"1")},on:{"change":function($event){_vm.chosenDelivery="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"2"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"2")},on:{"change":function($event){_vm.chosenDelivery="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("FREE shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"3"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"3")},on:{"change":function($event){_vm.chosenDelivery="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("$6.98 - Standart shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"4"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"4")},on:{"change":function($event){_vm.chosenDelivery="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("$13.98 - Two-Day Shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"5"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"5")},on:{"change":function($event){_vm.chosenDelivery="5"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("$20.98 - One-Day Shipping")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jpC7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kAOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_764cc3ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("HYxI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_764cc3ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kGAi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-m fixed silver rounded",staticStyle:{"width":"300px"}},[_c('h3',[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide",class:{grey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('ul',[(!_vm.isShippingFilled)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentFilled)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.87")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$96.85")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kZbF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("+jl9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c6aa404_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("yPM7");
function injectStyle (ssrContext) {
  __webpack_require__("SeUj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c6aa404"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c6aa404_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kaQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  props: ['cart', 'alsoItems', 'recentItems', 'extraItems'],
  data: function data() {
    return {
      items: [],
      also: [],
      recent: [],
      extra: []
    };
  },

  computed: {
    subtotal: function subtotal() {
      var result = 0;
      for (var i in this.items) {
        result += this.items[i].price * this.items[i].quantity;
      }
      return result.toFixed(2);
    }
  },
  methods: {
    checkoutPressed: function checkoutPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('confirmed', this.items);
    },
    removeItemPressed: function removeItemPressed(index) {
      this.items.splice(index, 1);
    },
    addFromAlsoPressed: function addFromAlsoPressed(index) {
      this.items.push(this.also[index]);
      this.also.splice(index, 1);
      if (this.extra.length > 0) {
        this.also.push(this.extra[0]);
        this.extra.splice(0, 1);
      }
    },
    addFromRecentPressed: function addFromRecentPressed(index) {
      this.items.push(this.recent[index]);
      this.recent.splice(index, 1);
      if (this.extra.length > 0) {
        this.recent.push(this.extra[0]);
        this.extra.splice(0, 1);
      }
      // var rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.right, rect.bottom, rect.left);
      // let lastIndex = this.items.length - 1
      // let lastItem = document.getElementById('cart-item-' + lastIndex)
      // console.log(lastItem)
      // console.log('cart-item-' + lastIndex)
      // let rect = lastItem.getBoundingClientRect()
      // console.log(rect)
      // let position = 0 + (this.items.length * 136)
      // window.scroll({
      //   top: position,
      //   left: 0,
      //   behavior: 'smooth'
      // })
    }
  },
  created: function created() {
    for (var i in this.cart) {
      this.items.push(this.cart[i]);
    }
    for (var _i in this.alsoItems) {
      this.also.push(this.alsoItems[_i]);
    }
    for (var _i2 in this.recentItems) {
      this.recent.push(this.recentItems[_i2]);
    }
    for (var _i3 in this.extraItems) {
      this.extra.push(this.extraItems[_i3]);
    }
  }
});

/***/ }),

/***/ "keH/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kvIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  props: ['cart'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "l8fn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lLKV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lWte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shopping cart")]),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"60px"}},[_c('img',{attrs:{"src":item.img,"width":"40px"}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',[_vm._v("Quantity: "+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.editPressed()}}},[_vm._v("Edit")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lX17":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "llUQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedPayment', 'mode', 'payments'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      number: { value: '', isValid: true, wasFocused: false },
      month: { value: '', isValid: true, wasFocused: false },
      year: { value: '', isValid: true, wasFocused: false },
      //
      shouldComeBackToManager: false,
      //
      scrollable: null,
      didScroll: false,
      doesHaveScrollDown: false
    };
  },

  methods: {
    checkScrollPosition: function checkScrollPosition() {
      this.checkIfCanScroll();
      if (this.scrollable.scrollTop > 10) {
        this.didScroll = true;
      } else {
        this.didScroll = false;
      }
    },
    checkIfCanScroll: function checkIfCanScroll() {
      if (this.scrollable.scrollHeight > this.scrollable.clientHeight && this.scrollable.scrollTop + 10 < this.scrollable.scrollHeight - this.scrollable.clientHeight) {
        this.doesHaveScrollDown = true;
      } else {
        this.doesHaveScrollDown = false;
      }
    },
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      var data = {
        name: this.name.value,
        number: this.number.value,
        month: this.month.value,
        year: this.year.value
      };
      if (this.mode === 'add') {
        this.$emit('saveNew', data);
      } else {
        this.$emit('saveExisting', data);
      }
    },
    cancelPressed: function cancelPressed() {
      if (this.shouldComeBackToManager) {
        this.$emit('backToManager');
      } else {
        this.$emit('cancelled');
      }
    },
    addPressed: function addPressed() {
      var _this = this;

      setTimeout(function () {
        _this.checkIfCanScroll();
      }, 100);
      this.shouldComeBackToManager = false;
      this.$emit('add');
    },
    editSelectedPressed: function editSelectedPressed(index) {
      var _this2 = this;

      setTimeout(function () {
        _this2.checkIfCanScroll();
      }, 100);
      this.shouldComeBackToManager = true;
      this.$emit('edit', index);
      this.fillForm();
    },
    deleteSelectedPressed: function deleteSelectedPressed(index) {
      this.$emit('delete', index);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.number.isValid = true;
      this.month.isValid = true;
      this.year.isValid = true;
      //
      this.name.wasFocused = false;
      this.number.wasFocused = false;
      this.month.wasFocused = false;
      this.year.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.number.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.number.isValid = false;
      }
      if (this.month.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.month.isValid = false;
      }
      if (this.year.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.year.isValid = false;
      }
      return hasErrors;
    },
    fillForm: function fillForm() {
      this.name = { value: this.payments[this.selectedPayment].name, isValid: true, wasFocused: false };
      this.number = { value: this.payments[this.selectedPayment].number, isValid: true, wasFocused: false };
      this.month = { value: this.payments[this.selectedPayment].month, isValid: true, wasFocused: false };
      this.year = { value: this.payments[this.selectedPayment].year, isValid: true, wasFocused: false };
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.mode === 'edit') {
      this.fillForm();
    }
    setTimeout(function () {
      _this3.scrollable = document.getElementById('watchMeScroll');
      _this3.checkIfCanScroll();
    }, 100);
  },

  watch: {
    selectedPayment: function selectedPayment() {
      this.fillForm();
    }
  }
});

/***/ }),

/***/ "lnAX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['selectedAddress', 'addresses', 'reactivator'],
  data: function data() {
    return {
      doShowAddressesList: false
    };
  },

  computed: {
    isSignedIn: function isSignedIn() {
      return this.$store.getters.getIsSignedIn;
    }
  },
  methods: {
    addPressed: function addPressed() {
      this.$emit('add');
    },
    changePressed: function changePressed() {
      // if (this.selectedAddress !== null) {
      this.doShowAddressesList = true;
      // }
      // this.$emit('edit')
    },
    choosePressed: function choosePressed(index) {
      this.$store.dispatch('setSelectedAddress', index);
      this.doShowAddressesList = false;
    },
    addNewAddressPressed: function addNewAddressPressed() {
      this.doShowAddressesList = false;
      this.$emit('add');
    },
    manageAddressesPressed: function manageAddressesPressed() {
      this.doShowAddressesList = false;
      this.$emit('manage');
    },
    doNothing: function doNothing() {
      //
    },

    //
    openSignIn: function openSignIn() {
      this.$emit('signin');
    }
  }
});

/***/ }),

/***/ "lo5v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("NoGu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c07bf01_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("avoe");
function injectStyle (ssrContext) {
  __webpack_require__("wE/f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c07bf01"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c07bf01_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lwod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedPayment', 'mode', 'payments'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      number: { value: '', isValid: true, wasFocused: false },
      month: { value: '', isValid: true, wasFocused: false },
      year: { value: '', isValid: true, wasFocused: false },
      //
      shouldComeBackToManager: false,
      //
      scrollable: null,
      didScroll: false,
      doesHaveScrollDown: false
    };
  },

  methods: {
    checkScrollPosition: function checkScrollPosition() {
      this.checkIfCanScroll();
      if (this.scrollable.scrollTop > 10) {
        this.didScroll = true;
      } else {
        this.didScroll = false;
      }
    },
    checkIfCanScroll: function checkIfCanScroll() {
      if (this.scrollable.scrollHeight > this.scrollable.clientHeight && this.scrollable.scrollTop + 10 < this.scrollable.scrollHeight - this.scrollable.clientHeight) {
        this.doesHaveScrollDown = true;
      } else {
        this.doesHaveScrollDown = false;
      }
    },
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      var data = {
        name: this.name.value,
        number: this.number.value,
        month: this.month.value,
        year: this.year.value
      };
      if (this.mode === 'add') {
        this.$emit('saveNew', data);
      } else {
        this.$emit('saveExisting', data);
      }
    },
    cancelPressed: function cancelPressed() {
      if (this.shouldComeBackToManager) {
        this.$emit('backToManager');
      } else {
        this.$emit('cancelled');
      }
    },
    addPressed: function addPressed() {
      var _this = this;

      setTimeout(function () {
        _this.checkIfCanScroll();
      }, 100);
      this.shouldComeBackToManager = false;
      this.$emit('add');
      this.clearForm();
    },
    editSelectedPressed: function editSelectedPressed(index) {
      var _this2 = this;

      setTimeout(function () {
        _this2.checkIfCanScroll();
      }, 100);
      this.shouldComeBackToManager = true;
      this.$emit('edit', index);
      this.fillForm();
    },
    deleteSelectedPressed: function deleteSelectedPressed(index) {
      this.$emit('delete', index);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.number.isValid = true;
      this.month.isValid = true;
      this.year.isValid = true;
      //
      this.name.wasFocused = false;
      this.number.wasFocused = false;
      this.month.wasFocused = false;
      this.year.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.number.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.number.isValid = false;
      }
      if (this.month.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.month.isValid = false;
      }
      if (this.year.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.year.isValid = false;
      }
      return hasErrors;
    },
    fillForm: function fillForm() {
      this.name = { value: this.payments[this.selectedPayment].name, isValid: true, wasFocused: false };
      this.number = { value: this.payments[this.selectedPayment].number, isValid: true, wasFocused: false };
      this.month = { value: this.payments[this.selectedPayment].month, isValid: true, wasFocused: false };
      this.year = { value: this.payments[this.selectedPayment].year, isValid: true, wasFocused: false };
    },
    clearForm: function clearForm() {
      this.name = { value: '', isValid: true, wasFocused: false };
      this.number = { value: '', isValid: true, wasFocused: false };
      this.month = { value: '', isValid: true, wasFocused: false };
      this.year = { value: '', isValid: true, wasFocused: false };
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.mode === 'edit') {
      this.fillForm();
    }
    setTimeout(function () {
      _this3.scrollable = document.getElementById('watchMeScroll');
      _this3.checkIfCanScroll();
    }, 100);
  },

  watch: {
    selectedPayment: function selectedPayment() {
      this.fillForm();
    }
  }
});

/***/ }),

/***/ "lwwg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c559d56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("/YnR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c559d56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lzwN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "m1iD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Shipping Address")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"fullName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"addressLine1"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine2"}},[_vm._v("Address Line 2")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"addressLine2"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"city"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"state"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"zip"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',[_c('option',{attrs:{"value":"volvo"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"saab"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"mercedes"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"audi"}},[_vm._v("Brazil")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"phone"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mDN9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mFaW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['selectedAddress', 'addresses', 'reactivator'],
  data: function data() {
    return {
      doShowAddressesList: false
    };
  },

  computed: {
    isSignedIn: function isSignedIn() {
      return this.$store.getters.getIsSignedIn;
    }
  },
  methods: {
    addPressed: function addPressed() {
      this.$emit('add');
    },
    changePressed: function changePressed() {
      // if (this.selectedAddress !== null) {
      this.doShowAddressesList = true;
      // }
      // this.$emit('edit')
    },
    choosePressed: function choosePressed(index) {
      this.$store.dispatch('setSelectedAddress', index);
      this.doShowAddressesList = false;
    },
    addNewAddressPressed: function addNewAddressPressed() {
      this.doShowAddressesList = false;
      this.$emit('add');
    },
    manageAddressesPressed: function manageAddressesPressed() {
      this.doShowAddressesList = false;
      this.$emit('manage');
    },
    doNothing: function doNothing() {
      //
    },

    //
    openSignIn: function openSignIn() {
      this.$emit('signin');
    }
  }
});

/***/ }),

/***/ "mKQJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("lwwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__ = __webpack_require__("jZJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__ = __webpack_require__("C1EQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Delivery__ = __webpack_require__("Sld/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__ = __webpack_require__("IRqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__ = __webpack_require__("WjQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__ = __webpack_require__("Gv1q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__ = __webpack_require__("U7Tg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderSummary__ = __webpack_require__("51Xz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__ = __webpack_require__("HJtG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Start: __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
    ShoppingCart: __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__["a" /* default */],
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_3__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_8__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__["a" /* default */]
  },
  data: function data() {
    return {
      currentView: 'Start',
      chosenDelivery: '1',
      isShippingFilled: false,
      isPaymentFilled: false,
      cart: [{
        name: 'Echo Dot (2nd Generation) - Black',
        price: 49.99,
        quantity: 1
      }, {
        name: 'Fire TV Stick with Alexa Voice Remote | Streaming Media Player',
        price: 39.99,
        quantity: 1
      }]
    };
  },

  methods: {
    shoppingCartConfirmed: function shoppingCartConfirmed() {
      this.currentView = 'Checkout';
    },
    shippingAddressConfirmed: function shippingAddressConfirmed() {
      this.isShippingFilled = true;
      this.currentView = 'Checkout';
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.currentView = 'Checkout';
    },
    paymentMethodConfirmed: function paymentMethodConfirmed() {
      this.isPaymentFilled = true;
      this.currentView = 'Checkout';
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.currentView = 'Checkout';
    }
  }
});

/***/ }),

/***/ "mPFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Payment information")]),_vm._v(" "),(_vm.selectedPayment === null)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add payment method")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v(_vm._s(_vm.selectedPayment.name))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selectedPayment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selectedPayment.month)+" / "+_vm._s(_vm.selectedPayment.year))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mWGt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShippingAddressMin',
  props: ['isShippingFilled'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "mled":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("glVO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43655848_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("ywve");
function injectStyle (ssrContext) {
  __webpack_require__("eAwv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43655848"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43655848_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mqCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_704dcb7f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__ = __webpack_require__("0S+M");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_704dcb7f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mw+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',{staticStyle:{"font-size":"19px"}},[_vm._v("Payment information")]),_vm._v(" "),(_vm.selectedPayment === null)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add payment method")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"12px"}},[_c('button',{staticStyle:{"color":"#409EFF","border-bottom":"1px dashed","border-radius":"0","cursor":"pointer"},on:{"click":function($event){_vm.openSignIn()}}},[_vm._v("Sign in")]),_vm._v(" for 1-click checkout")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v(_vm._s(_vm.payments[_vm.selectedPayment].name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.mutateCardNumber(_vm.payments[_vm.selectedPayment].number)))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.payments[_vm.selectedPayment].month)+" / "+_vm._s(_vm.payments[_vm.selectedPayment].year))]),_vm._v(" "),_c('div',{staticStyle:{"color":"transparent","width":"0","height":"0","overflow":"hidden"}},[_vm._v(_vm._s(_vm.reactivator))]),_vm._v(" "),_c('transition',{attrs:{"name":"popover"}},[(_vm.doShowMethodsList)?_c('div',[_c('div',{staticClass:"popover-curtain",on:{"click":function($event){_vm.doShowMethodsList=false}}}),_vm._v(" "),_c('div',{staticClass:"popover-content",on:{"click":function($event){$event.stopPropagation();_vm.doNothing($event)}}},[_vm._l((_vm.payments),function(payment,i){return _c('div',{key:i,staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":function($event){_vm.choosePressed(i)}}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('div',[_c('strong',[_vm._v(_vm._s(payment.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.month)+" / "+_vm._s(payment.year))])])])}),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px","margin-top":"4px"},on:{"click":_vm.addNewPaymentPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Add new payment")])])]),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":_vm.managePaymentPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Manage payment methods")])])])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticStyle:{"color":"#409EFF","border-bottom":"1px dashed","border-radius":"0"},on:{"click":function($event){_vm.changePressed()}}},[_vm._v("Change")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mwoX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"1"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"1")},on:{"change":function($event){_vm.chosenDelivery="1"}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"2"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"2")},on:{"change":function($event){_vm.chosenDelivery="2"}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"3"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"3")},on:{"change":function($event){_vm.chosenDelivery="3"}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"4"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"4")},on:{"change":function($event){_vm.chosenDelivery="4"}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"5"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"5")},on:{"change":function($event){_vm.chosenDelivery="5"}}}),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',[_vm._v("FREE shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',[_vm._v("$6.98 - Standart shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("$13.98 - Two-Day Shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',[_vm._v("$20.98 - One-Day Shipping")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n0oH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n6PW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nEFq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
    };
  }
});

/***/ }),

/***/ "ncgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m fixed flexy align-top",staticStyle:{"width":"50%","padding-right":"40px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("y93l"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery),expression:"delivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"0"},domProps:{"checked":_vm._q(_vm.delivery,"0")},on:{"change":function($event){_vm.delivery="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery),expression:"delivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"1"},domProps:{"checked":_vm._q(_vm.delivery,"1")},on:{"change":function($event){_vm.delivery="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("FREE shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery),expression:"delivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"2"},domProps:{"checked":_vm._q(_vm.delivery,"2")},on:{"change":function($event){_vm.delivery="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("$6.98 - Standart shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery),expression:"delivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"3"},domProps:{"checked":_vm._q(_vm.delivery,"3")},on:{"change":function($event){_vm.delivery="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("$13.98 - Two-Day Shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-bottom":"14px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery),expression:"delivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"4"},domProps:{"checked":_vm._q(_vm.delivery,"4")},on:{"change":function($event){_vm.delivery="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"3px","font-size":"14px"}},[_vm._v("$20.98 - One-Day Shipping")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nptb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100vh","overflow":"auto"}},[_c('div',{staticStyle:{"background-color":"#24303D","color":"white"}},[_c('div',{staticClass:"flexy",staticStyle:{"height":"60px","position":"relative","align-items":"flex-start"},attrs:{"id":"first"}},[_c('div',{staticClass:"fixed padding-hor-l",staticStyle:{"width":"140px","cursor":"pointer","padding-top":"12px"},on:{"click":function($event){_vm.$router.push({name: 'Start2'})}}},[_c('img',{staticStyle:{"width":"84px"},attrs:{"src":__webpack_require__("23Cc"),"alt":""}})]),_vm._v(" "),_c('transition',{attrs:{"name":"lineonecheckout"}},[(_vm.$route.name !== 'Start2' && _vm.$route.name !== 'ShoppingCart2' && _vm.$route.name !== 'Complete2')?_c('div',{staticStyle:{"position":"absolute","margin-top":"12px","padding-top":"4px","padding-bottom":"4px","margin-left":"132px","padding-left":"21px","color":"#FF9900","font-size":"19px","font-weight":"500","border-left":"1px solid rgba(255,255,255,0.2)"}},[_vm._v("Checkout")]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"lineoneinit"}},[(_vm.$route.name === 'Start2' || _vm.$route.name === 'ShoppingCart2' || _vm.$route.name === 'Complete2')?_c('div',{staticClass:"flexy padding-hor-m lineoneinit"},[_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"width":"48px","height":"35px","background-color":"#f3f3f3","border-right":"1px solid d1d1d1","color":"#666","border-radius":"5px 0 0 5px","text-align":"center","cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n            All\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("/kAr"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"white","height":"35px","cursor":"text"}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","background-color":"#FFB647","height":"35px","line-height":"35px","border-radius":"0 5px 5px 0","text-align":"center","padding-top":"4px","cursor":"pointer"}},[_c('img',{staticStyle:{"width":"21px"},attrs:{"src":__webpack_require__("+h5J"),"alt":""}})])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"lineoneinit"}},[(_vm.$route.name === 'Start2' || _vm.$route.name === 'ShoppingCart2' || _vm.$route.name === 'Complete2')?_c('div',{staticClass:"fixed padding-hor-l flexy align-center lineoneinit",staticStyle:{"width":"140px","cursor":"pointer"},on:{"click":function($event){_vm.$router.push({name:'ShoppingCart2'})}}},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',[_c('img',{staticStyle:{"width":"38px","padding-top":"6px"},attrs:{"src":__webpack_require__("c6bX"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","top":"-1px","left":"11px","width":"24px","text-align":"center","color":"#FF9900","font-weight":"900","font-size":"16px"}},[_vm._v(_vm._s(_vm.cart.length))])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"18px","font-weight":"900"}},[_vm._v("\n          cart\n        ")])]):_vm._e()])],1),_vm._v(" "),_c('transition',{attrs:{"name":"linetwo"}},[(_vm.$route.name === 'Start2' || _vm.$route.name === 'ShoppingCart2' || _vm.$route.name === 'Complete2')?_c('div',{staticClass:"flexy align-center linetwo-container",attrs:{"id":"second"}},[_c('div',{staticClass:"fixed padding-hor-l flexy align-center",staticStyle:{"width":"140px","cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n          Departments\n        ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"flexy padding-hor-m align-center",staticStyle:{"opacity":"0.6","font-size":"13px"}},[_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right"}},[_vm._v("\n            Browsing History\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("My Amazon.com")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Today's Deals")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Gift Cards")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Registry")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Sell")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Help")])]),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-l flexy align-center",staticStyle:{"cursor":"pointer","font-size":"13px","font-weight":"900"},on:{"click":function($event){_vm.$route.name = 'ShoppingCart2'}}},[_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"cursor":"pointer","padding-right":"24px"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n            Account & Lists\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-right":"24px"}},[_vm._v("Orders")]),_vm._v(" "),_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n            Try Prime\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})])])]):_vm._e()])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nw8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"},on:{"click":function($event){_vm.closePressed()}}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"800px","margin":"5vh auto","background-color":"white","border-radius":"2px","box-shadow":"0px 12px 36px rgba(0,0,0,0.1)"},on:{"click":function($event){$event.stopPropagation();_vm.doThis()}}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"height":"7vh","border-bottom":"1px solid #DDE1EB"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[_vm._v("You recently viewed")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.closePressed()}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticStyle:{"max-height":"80vh","overflow":"auto"}},[_c('div',{staticClass:"flexy align-top padding-hor-l padding-vert-l"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"220px"}},[_c('img',{attrs:{"src":_vm.item.img,"width":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.item.name))])]),_vm._v(" "),_c('div',[_vm._v("by "+_vm._s(_vm.item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-m",staticStyle:{"background-color":"pink","display":"inline-block"}},[_vm._v("#1 Bestseller in Industrial Product Design")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s flexy"},[_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'kindle'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'kindle'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Kindle book")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$17.63")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'hardcover'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'hardcover'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Hardcover")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$18.89")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'paperback'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'paperback'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Paperback")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$55.77")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[(!_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed subtle-primary",staticStyle:{"background-color":"#b3ffb3","color":"green","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l padding-hor-l"},[_c('div',{staticClass:"flexy rounded"},[_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'description'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none","border-top-left-radius":"6px","border-bottom-left-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'description'}}},[_vm._v("\n              Description\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'editors'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none"},on:{"click":function($event){_vm.selectedTab = 'editors'}}},[_vm._v("\n              Editorial reviews\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'user'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-top-right-radius":"6px","border-bottom-right-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'user'}}},[_vm._v("\n              User reviews\n            ")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-xs"},[(_vm.selectedTab === 'description')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Why do some products capture widespread attention while others flop? What makes us engage with certain products out of sheer habit? Is there a pattern underlying how technologies hook us?")]),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Nir Eyal answers these questions (and many more) by explaining the Hook Model—a four-step process embedded into the products of many successful companies to subtly encourage customer behavior. Through consecutive “hook cycles,” these products reach their ultimate goal of bringing users back again and again without depending on costly advertising or aggressive messaging.")]):_vm._e(),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Hooked is based on Eyal’s years of research, consulting, and practical experience. He wrote the book he wished had been available to him as a start-up founder—not abstract theory, but a how-to guide for building better products. Hooked is written for product managers, designers, marketers, start-up founders, and anyone who seeks to understand how products influence our behavior.")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'editors')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Publisher's Weekly")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Eric Ries, author of The Lean Startup")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Boris Veldhuijzen van Zanten, founder of The Next Web ")])])])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'user')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nwX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oCfW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oHZF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oKvw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',{staticStyle:{"font-size":"19px"}},[_vm._v("Shopping cart")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"60px"}},[_c('img',{attrs:{"src":item.img,"width":"40px"}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v("Quantity: "+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{},[_c('button',{staticStyle:{"color":"#409EFF","border-bottom":"1px dashed","border-radius":"0"},on:{"click":function($event){_vm.editPressed()}}},[_vm._v("Edit")])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oNnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedAddress', 'mode', 'addresses'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      address1: { value: '', isValid: true, wasFocused: false },
      city: { value: '', isValid: true, wasFocused: false },
      state: { value: '', isValid: true, wasFocused: false },
      zip: { value: '', isValid: true, wasFocused: false },
      country: { value: '', isValid: true, wasFocused: false },
      phone: { value: '', isValid: true, wasFocused: false },
      //
      shouldComeBackToManager: false,
      //
      scrollable: null,
      didScroll: false,
      doesHaveScrollDown: false
    };
  },

  methods: {
    checkScrollPosition: function checkScrollPosition() {
      this.checkIfCanScroll();
      if (this.scrollable.scrollTop > 10) {
        this.didScroll = true;
      } else {
        this.didScroll = false;
      }
    },
    checkIfCanScroll: function checkIfCanScroll() {
      if (this.scrollable.scrollHeight > this.scrollable.clientHeight && this.scrollable.scrollTop + 10 < this.scrollable.scrollHeight - this.scrollable.clientHeight) {
        this.doesHaveScrollDown = true;
      } else {
        this.doesHaveScrollDown = false;
      }
    },
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      var data = {
        name: this.name.value,
        address1: this.address1.value,
        city: this.city.value,
        state: this.state.value,
        zip: this.zip.value,
        country: this.country.value,
        phone: this.phone.value
      };
      if (this.mode === 'add') {
        this.$emit('saveNew', data);
      } else {
        this.$emit('saveExisting', data);
      }
    },
    cancelPressed: function cancelPressed() {
      if (this.shouldComeBackToManager) {
        this.$emit('backToManager');
      } else {
        this.$emit('cancelled');
      }
    },
    addPressed: function addPressed() {
      var _this = this;

      setTimeout(function () {
        _this.checkIfCanScroll();
      }, 100);
      this.shouldComeBackToManager = true;
      this.$emit('add');
      this.clearForm();
    },
    editSelectedPressed: function editSelectedPressed(index) {
      var _this2 = this;

      setTimeout(function () {
        _this2.checkIfCanScroll();
      }, 100);
      this.checkIfCanScroll();
      this.shouldComeBackToManager = true;
      this.$emit('edit', index);
      this.fillForm();
    },
    deleteSelectedPressed: function deleteSelectedPressed(index) {
      this.$emit('delete', index);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.address1.isValid = true;
      this.city.isValid = true;
      this.state.isValid = true;
      this.zip.isValid = true;
      this.country.isValid = true;
      this.phone.isValid = true;
      //
      this.name.wasFocused = false;
      this.address1.wasFocused = false;
      this.city.wasFocused = false;
      this.state.wasFocused = false;
      this.zip.wasFocused = false;
      this.country.wasFocused = false;
      this.phone.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.address1.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.address1.isValid = false;
      }
      if (this.city.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.city.isValid = false;
      }
      if (this.state.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.state.isValid = false;
      }
      if (this.zip.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.zip.isValid = false;
      }
      if (this.country.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.country.isValid = false;
      }
      if (this.phone.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.phone.isValid = false;
      }
      return hasErrors;
    },
    fillForm: function fillForm() {
      this.name = { value: this.addresses[this.selectedAddress].name, isValid: true, wasFocused: false };
      this.address1 = { value: this.addresses[this.selectedAddress].address1, isValid: true, wasFocused: false };
      this.city = { value: this.addresses[this.selectedAddress].city, isValid: true, wasFocused: false };
      this.state = { value: this.addresses[this.selectedAddress].state, isValid: true, wasFocused: false };
      this.zip = { value: this.addresses[this.selectedAddress].zip, isValid: true, wasFocused: false };
      this.country = { value: this.addresses[this.selectedAddress].country, isValid: true, wasFocused: false };
      this.phone = { value: this.addresses[this.selectedAddress].phone, isValid: true, wasFocused: false };
    },
    clearForm: function clearForm() {
      this.name = { value: '', isValid: true, wasFocused: false };
      this.address1 = { value: '', isValid: true, wasFocused: false };
      this.city = { value: '', isValid: true, wasFocused: false };
      this.state = { value: '', isValid: true, wasFocused: false };
      this.zip = { value: '', isValid: true, wasFocused: false };
      this.country = { value: '', isValid: true, wasFocused: false };
      this.phone = { value: '', isValid: true, wasFocused: false };
    }
  },
  watch: {
    selectedAddress: function selectedAddress() {
      this.fillForm();
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.mode === 'edit') {
      this.fillForm();
    }
    setTimeout(function () {
      _this3.scrollable = document.getElementById('watchMeScroll');
      _this3.checkIfCanScroll();
    }, 100);
  }
});

/***/ }),

/***/ "oO6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a8165b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("fp8s");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a8165b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oQPp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oVmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShoppingCartMin__ = __webpack_require__("VoS0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Delivery__ = __webpack_require__("KFMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShippingAddress__ = __webpack_require__("WYhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShippingAddressMin__ = __webpack_require__("pi1L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentMethod__ = __webpack_require__("h+0h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentMethodMin__ = __webpack_require__("L/rg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderSummary__ = __webpack_require__("H+KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SignIn__ = __webpack_require__("S1BV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_0__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_2__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_3__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_4__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_5__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_1__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_6__OrderSummary__["a" /* default */],
    SignIn: __WEBPACK_IMPORTED_MODULE_7__SignIn__["a" /* default */]
  },
  data: function data() {
    return {
      addressMode: null,
      doShowAddressManager: false,
      selectedAddressForEditing: null,
      //
      paymentMode: null,
      doShowPaymentManager: false,
      selectedPaymentForEditing: null,
      //
      doShowSignIn: false,
      //
      reactivator: 0
      //
      // chosenDelivery: 1
    };
  },

  computed: {
    addresses: function addresses() {
      return this.$store.getters.getAddresses;
    },
    payments: function payments() {
      return this.$store.getters.getPayments;
    },

    //
    cart: function cart() {
      return this.$store.getters.getCart;
    },
    alsoItems: function alsoItems() {
      return this.$store.getters.getAlso;
    },
    recentItems: function recentItems() {
      return this.$store.getters.getRecent;
    },
    extraItems: function extraItems() {
      return this.$store.getters.getExtra;
    },
    laterItems: function laterItems() {
      return this.$store.getters.getLater;
    },

    //
    selectedAddress: function selectedAddress() {
      return this.$store.getters.getSelectedAddress;
    },
    selectedPayment: function selectedPayment() {
      return this.$store.getters.getSelectedPayment;
    },
    chosenDelivery: function chosenDelivery() {
      return this.$store.getters.getChosenDelivery;
    }
  },
  methods: {
    //
    // SHIPPING ADDRESS
    addAddressPressed: function addAddressPressed() {
      this.addressMode = 'add';
      this.doShowAddressManager = true;
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.doShowAddressManager = false;
    },
    manageAddressPressed: function manageAddressPressed() {
      this.addressMode = 'manage';
      this.doShowAddressManager = true;
    },
    shippingAddressSaveNew: function shippingAddressSaveNew(address) {
      this.$store.dispatch('setNewAddress', address);
      this.$store.dispatch('setSelectedAddress', this.addresses.length - 1);
      this.doShowAddressManager = false;
    },
    shippingAddressSaveExisting: function shippingAddressSaveExisting(address) {
      // this.addresses[this.selectedAddressForEditing] = data
      this.$store.dispatch('setExistingAddress', { address: address, index: this.selectedAddressForEditing });
      this.reactivator++;
      this.addressMode = 'manage';
    },
    editAddressPressed: function editAddressPressed(index) {
      this.selectedAddressForEditing = index;
      this.addressMode = 'edit';
    },
    deleteAddressPressed: function deleteAddressPressed(index) {
      if (this.addresses.length === 1) {
        this.$store.dispatch('setSelectedAddress', null);
      } else {
        this.$store.dispatch('setSelectedAddress', 0);
      }
      this.$store.dispatch('setRemoveAddress', index);
    },
    shippingAddressCancelledBackToManager: function shippingAddressCancelledBackToManager() {
      this.addressMode = 'manage';
    },

    //
    // PAYMENT METHOD
    addPaymentPressed: function addPaymentPressed() {
      this.paymentMode = 'add';
      this.doShowPaymentManager = true;
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.doShowPaymentManager = false;
    },
    managePaymentPressed: function managePaymentPressed() {
      this.paymentMode = 'manage';
      this.doShowPaymentManager = true;
    },
    paymentMethodSaveNew: function paymentMethodSaveNew(payment) {
      this.$store.dispatch('setNewPayment', payment);
      this.$store.dispatch('setSelectedPayment', this.payments.length - 1);
      this.doShowPaymentManager = false;
    },
    paymentMethodSaveExisting: function paymentMethodSaveExisting(payment) {
      this.$store.dispatch('setExistingPayment', { payment: payment, index: this.selectedPaymentForEditing });
      this.reactivator++;
      this.paymentMode = 'manage';
    },
    editPaymentPressed: function editPaymentPressed(index) {
      this.selectedPaymentForEditing = index;
      this.paymentMode = 'edit';
    },
    deletePaymentPressed: function deletePaymentPressed(index) {
      if (this.payments.length === 1) {
        this.$store.dispatch('setSelectedPayment', null);
      } else {
        this.$store.dispatch('setSelectedPayment', 0);
      }
      this.$store.dispatch('setRemovePayment', index);
    },
    paymentMethodCancelledBackToManager: function paymentMethodCancelledBackToManager() {
      this.paymentMode = 'manage';
    },

    //
    // SIGN IN
    signInPressed: function signInPressed() {
      this.doShowSignIn = true;
    },
    signInClosed: function signInClosed() {
      this.doShowSignIn = false;
    },
    loginPressed: function loginPressed() {
      this.$store.dispatch('setNewAddress', {
        name: 'Sam Bell',
        address1: '821 Washington St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10101',
        country: 'United States',
        phone: '+1 800 555 66 77' });
      this.$store.dispatch('setNewAddress', {
        name: 'Sam Bell',
        address1: '1014 Lincoln St',
        city: 'Ashland',
        state: 'Illinois',
        zip: '10114',
        country: 'United States',
        phone: '+1 800 555 00 11' });
      this.$store.dispatch('setNewPayment', {
        name: 'Sam Bell',
        number: '1234 5678 1234 1235',
        month: '07',
        year: '20' });
      this.$store.dispatch('setSelectedAddress', 0);
      this.$store.dispatch('setSelectedPayment', 0);
      this.$store.dispatch('setIsSignedIn', true);
      this.doShowSignIn = false;
    },

    //
    placeOrderPressed: function placeOrderPressed() {
      this.$store.dispatch('setCart', []);
      this.$router.push({ name: 'Complete2' });
    }
  }
});

/***/ }),

/***/ "oXD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false,
      chosenDelivery: 1
    };
  },

  props: ['isShippingFilled', 'isPaymentFilled'],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.isShippingFilled && this.isPaymentFilled;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "ohRh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ohWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("IuSU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13afa9ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("ziAO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13afa9ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    //
    cart: [{
      name: 'Sprint: How to Solve Big Problems and Test New Ideas in Just Five Days',
      by: 'Jake Knapp',
      img: __webpack_require__("RVgH"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 14.53,
      quantity: 1
    }, {
      name: 'Hooked: How to Build Habit-Forming Products',
      by: 'Nir Eyal',
      img: __webpack_require__("IBtq"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 18.56,
      quantity: 1
    }],
    also: [{
      name: 'The Lean Startup: How Today\'s Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses',
      by: 'Eric Ries',
      img: __webpack_require__("xcPX"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 20.29,
      quantity: 1
    }, {
      name: 'The Hard Thing About Hard Things: Building a Business When There Are No Easy Answers',
      by: 'Ben Horowitz',
      img: __webpack_require__("fiE3"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 19.66,
      quantity: 1
    }, {
      name: 'Rework',
      by: 'Jason Fried',
      img: __webpack_require__("7fXA"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 17.68,
      quantity: 1
    }, {
      name: 'Remote: Office Not Required',
      by: 'Jason Fried',
      img: __webpack_require__("LhVL"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 15.59,
      quantity: 1
    }],
    recent: [{
      name: 'Beautiful Evidence',
      by: 'Edward R. Tufte',
      img: __webpack_require__("OEdX"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 28.87,
      quantity: 1
    }, {
      name: 'About Face: The Essentials of Interaction Design',
      by: 'Alan Cooper',
      img: __webpack_require__("y+PD"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 36.47,
      quantity: 1
    }, {
      name: '100 Things Every Designer Needs to Know About People',
      by: 'Susan Weinschenk',
      img: __webpack_require__("P+u0"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 22.95,
      quantity: 1
    }, {
      name: 'HTML and CSS: Design and Build Websites',
      by: 'Jon Duckett',
      img: __webpack_require__("AqZH"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 20.53,
      quantity: 1
    }],
    extra: [{
      name: 'Logo Design Love: A Guide to Creating Iconic Brand Identities, 2nd Edition',
      by: 'David Airey',
      img: __webpack_require__("WOmI"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 31.05,
      quantity: 1
    }, {
      name: 'Layout Essentials: 100 Design Principles for Using Grids (Design Essentials)',
      by: 'Beth Tondreau',
      img: __webpack_require__("Mvmb"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 14.76,
      quantity: 1
    }],
    later: [{
      name: 'CSS: The Missing Manual',
      by: 'David Sawyer McFarland',
      img: __webpack_require__("PF3y"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 24.61,
      quantity: 1
    }, {
      name: 'The Principles of Beautiful Web Design: Designing Great Web Sites is Not Rocket Science!',
      by: 'Jason Beaird',
      img: __webpack_require__("jAj8"),
      seller: 'Amazon',
      availability: 'In Stock',
      price: 31.23,
      quantity: 1
    }],
    //
    addresses: [],
    payments: [],
    //
    selectedAddress: null,
    selectedPayment: null,
    chosenDelivery: '0',
    isSignedIn: false
    //
  },
  getters: {
    getCart: function getCart(state) {
      return state.cart;
    },
    getAlso: function getAlso(state) {
      return state.also;
    },
    getRecent: function getRecent(state) {
      return state.recent;
    },
    getExtra: function getExtra(state) {
      return state.extra;
    },
    getLater: function getLater(state) {
      return state.later;
    },
    //
    getAddresses: function getAddresses(state) {
      return state.addresses;
    },
    getPayments: function getPayments(state) {
      return state.payments;
    },
    //
    getSelectedAddress: function getSelectedAddress(state) {
      return state.selectedAddress;
    },
    getSelectedPayment: function getSelectedPayment(state) {
      return state.selectedPayment;
    },
    getChosenDelivery: function getChosenDelivery(state) {
      return state.chosenDelivery;
    },
    getIsSignedIn: function getIsSignedIn(state) {
      return state.isSignedIn;
    }
  },
  mutations: {
    //
    changeCart: function changeCart(state, payload) {
      state.cart = payload;
    },
    changeLater: function changeLater(state, payload) {
      state.later = payload;
    },
    changeAlso: function changeAlso(state, payload) {
      state.also = payload;
    },
    changeExtra: function changeExtra(state, payload) {
      state.extra = payload;
    },
    changeRecent: function changeRecent(state, payload) {
      state.recent = payload;
    },

    //
    addNewAddress: function addNewAddress(state, payload) {
      state.addresses.push(payload);
    },
    changeSelectedAddress: function changeSelectedAddress(state, payload) {
      state.selectedAddress = payload;
    },
    changeExistingAddress: function changeExistingAddress(state, payload) {
      state.addresses[payload.index] = payload.address;
    },
    removeAddress: function removeAddress(state, payload) {
      state.addresses.splice(payload, 1);
    },

    //
    addNewPayment: function addNewPayment(state, payload) {
      state.payments.push(payload);
    },
    changeSelectedPayment: function changeSelectedPayment(state, payload) {
      state.selectedPayment = payload;
    },
    changeExistingPayment: function changeExistingPayment(state, payload) {
      state.payments[payload.index] = payload.payment;
    },
    removePayment: function removePayment(state, payload) {
      state.payments.splice(payload, 1);
    },

    //
    changeChosenDelivery: function changeChosenDelivery(state, payload) {
      state.chosenDelivery = payload;
    },
    changeIsSignedIn: function changeIsSignedIn(state, payload) {
      state.isSignedIn = payload;
    }
  },
  actions: {
    //
    setCart: function setCart(_ref, payload) {
      var commit = _ref.commit;

      commit('changeCart', payload);
    },
    setLater: function setLater(_ref2, payload) {
      var commit = _ref2.commit;

      commit('changeLater', payload);
    },
    setAlso: function setAlso(_ref3, payload) {
      var commit = _ref3.commit;

      commit('changeAlso', payload);
    },
    setExtra: function setExtra(_ref4, payload) {
      var commit = _ref4.commit;

      commit('changeExtra', payload);
    },
    setRecent: function setRecent(_ref5, payload) {
      var commit = _ref5.commit;

      commit('changeRecent', payload);
    },

    //
    setNewAddress: function setNewAddress(_ref6, payload) {
      var commit = _ref6.commit;

      commit('addNewAddress', payload);
    },
    setSelectedAddress: function setSelectedAddress(_ref7, payload) {
      var commit = _ref7.commit;

      commit('changeSelectedAddress', payload);
    },
    setExistingAddress: function setExistingAddress(_ref8, payload) {
      var commit = _ref8.commit;

      commit('changeExistingAddress', payload);
    },
    setRemoveAddress: function setRemoveAddress(_ref9, payload) {
      var commit = _ref9.commit;

      commit('removeAddress', payload);
    },

    //
    setNewPayment: function setNewPayment(_ref10, payload) {
      var commit = _ref10.commit;

      commit('addNewPayment', payload);
    },
    setSelectedPayment: function setSelectedPayment(_ref11, payload) {
      var commit = _ref11.commit;

      commit('changeSelectedPayment', payload);
    },
    setExistingPayment: function setExistingPayment(_ref12, payload) {
      var commit = _ref12.commit;

      commit('changeExistingPayment', payload);
    },
    setRemovePayment: function setRemovePayment(_ref13, payload) {
      var commit = _ref13.commit;

      commit('removePayment', payload);
    },

    //
    setChosenDelivery: function setChosenDelivery(_ref14, payload) {
      var commit = _ref14.commit;

      commit('changeChosenDelivery', payload);
    },
    setIsSignedIn: function setIsSignedIn(_ref15, payload) {
      var commit = _ref15.commit;

      commit('changeIsSignedIn', payload);
    }
  }
});

/***/ }),

/***/ "p/ip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['isShippingFilled', 'isPaymentFilled'],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.isShippingFilled && this.isPaymentFilled;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "pC72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',{staticStyle:{"font-size":"19px"}},[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"1"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"1")},on:{"change":function($event){_vm.chosenDelivery="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"2"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"2")},on:{"change":function($event){_vm.chosenDelivery="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v("FREE shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"3"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"3")},on:{"change":function($event){_vm.chosenDelivery="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v("$6.98 - Standart shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"4"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"4")},on:{"change":function($event){_vm.chosenDelivery="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v("$13.98 - Two-Day Shipping")])])]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"5"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"5")},on:{"change":function($event){_vm.chosenDelivery="5"}}}),_vm._v(" "),_c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px"}},[_vm._v("$20.98 - One-Day Shipping")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pDTe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-hor-l padding-vert-m fixed silver rounded",staticStyle:{"width":"32%","background-color":"white","box-shadow":"0px 7px 24px rgba(0,0,0,0.1)","border-radius":"12px"}},[_c('div',{staticClass:"padding-hor-m"},[_c('h1',{staticStyle:{"padding-top":"12px","padding-bottom":"12px","font-size":"28px","font-weight":"600"}},[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.98")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.87")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$96.85")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide",class:{grey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('ul',[(!_vm.isShippingFilled)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentFilled)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]):_c('div',{staticClass:"padding-vert-s"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pRtm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-l bordered rounded"},_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy"},[_vm._m(1,true),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v("$ "+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"20px"}},[_vm._v("x")])])})),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Checkout")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l flexy"},[_c('h1',[_vm._v("Shopping Cart")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('img',{attrs:{"src":__webpack_require__("R4sD"),"width":"75px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pi1L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("lnAX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde9b03a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("Qr6a");
function injectStyle (ssrContext) {
  __webpack_require__("UXL6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dde9b03a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde9b03a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pszf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("8Yzh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7724303c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("vHvh");
function injectStyle (ssrContext) {
  __webpack_require__("/YkI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7724303c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7724303c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ptBG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pzLF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("J72T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12551e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("vpkY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12551e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qIRn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qQk4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("EV1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1a291f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("Wuw7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1a291f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qZYA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: null,
      showFullDescription: false,
      selectedFormat: 'kindle',
      selectedTab: 'description',
      isBeingAddedToCart: false,
      //
      scrollable: null,
      didScroll: false
    };
  },

  props: ['selectedForPreview'],
  methods: {
    checkScrollPosition: function checkScrollPosition() {
      if (this.scrollable.scrollTop > 10) {
        this.didScroll = true;
      } else {
        this.didScroll = false;
      }
    },
    closePressed: function closePressed() {
      this.$emit('close');
    },
    doThis: function doThis() {
      console.log('hi');
    },
    addPressed: function addPressed() {
      var _this = this;

      this.isBeingAddedToCart = true;
      setTimeout(function () {
        _this.$emit('addToCart', _this.item);
      }, 500);
    }
  },
  created: function created() {
    var _this2 = this;

    this.item = this.selectedForPreview;
    setTimeout(function () {
      _this2.scrollable = document.getElementById('watchMeScroll');
    }, 100);
  }
});

/***/ }),

/***/ "qgrU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qicr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Payment information")]),_vm._v(" "),(!_vm.isPaymentFilled)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add payment method")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Sam Bell")]),_vm._v(" "),_c('div',[_vm._v("**** **** **** 5457")]),_vm._v(" "),_c('div',[_vm._v("07 / 20")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qpED":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qqvF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__ = __webpack_require__("9YTJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36281cdc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__ = __webpack_require__("YASv");
function injectStyle (ssrContext) {
  __webpack_require__("ohRh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36281cdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36281cdc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qtk4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("d/j3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b989a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("EpYW");
function injectStyle (ssrContext) {
  __webpack_require__("r6L8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46b989a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b989a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r6L8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rCbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__ = __webpack_require__("sHl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbb0b0fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__ = __webpack_require__("2TM5");
function injectStyle (ssrContext) {
  __webpack_require__("EirK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fbb0b0fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbb0b0fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rZAK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrototypeManager_v_0_3_vue__ = __webpack_require__("LBmn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5faa446d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrototypeManager_v_0_3_vue__ = __webpack_require__("AFMB");
function injectStyle (ssrContext) {
  __webpack_require__("v8PV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5faa446d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrototypeManager_v_0_3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5faa446d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrototypeManager_v_0_3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ri21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  props: ['cart'],
  data: function data() {
    return {};
  },

  methods: {
    editPressed: function editPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('edit');
    }
  }
});

/***/ }),

/***/ "rxJ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100vh","overflow":"auto"}},[_c('div',{staticClass:"padding-hor-l padding-vert-m black flexy",staticStyle:{"height":"80px","background-color":"#232f3e"}},[_c('div',[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'Start'}}},[_vm._v("Amazon")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px"}},[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_vm._v("Cart")])])]),_vm._v(" "),(_vm.currentView === 'Start')?_c('Start'):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShoppingCart')?_c('ShoppingCart',{attrs:{"cart":_vm.cart,"alsoItems":_vm.alsoItems,"recentItems":_vm.recentItems,"extraItems":_vm.extraItems,"laterItems":_vm.laterItems},on:{"confirmed":function($event){_vm.shoppingCartConfirmed($event)}}}):_vm._e(),_vm._v(" "),(_vm.doShowAddressManager)?_c('ShippingAddress',{attrs:{"mode":_vm.addressMode,"addresses":_vm.addresses,"selectedAddress":_vm.selectedAddressForEditing},on:{"add":function($event){_vm.addAddressPressed()},"edit":function($event){_vm.editAddressPressed($event)},"delete":function($event){_vm.deleteAddressPressed($event)},"saveNew":function($event){_vm.shippingAddressSaveNew($event)},"saveExisting":function($event){_vm.shippingAddressSaveExisting($event)},"backToManager":function($event){_vm.shippingAddressCancelledBackToManager()},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.doShowPaymentManager)?_c('PaymentMethod',{attrs:{"mode":_vm.paymentMode,"payments":_vm.payments,"selectedPayment":_vm.selectedPaymentForEditing},on:{"add":function($event){_vm.addPaymentPressed()},"edit":function($event){_vm.editPaymentPressed($event)},"delete":function($event){_vm.deletePaymentPressed($event)},"saveNew":function($event){_vm.paymentMethodSaveNew($event)},"saveExisting":function($event){_vm.paymentMethodSaveExisting($event)},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ExtraSignup')?_c('ExtraSignup'):_vm._e(),_vm._v(" "),(_vm.currentView === 'Checkout')?_c('div',{attrs:{"id":"checkout"}},[_c('div',{staticClass:"padding-hor-l",staticStyle:{"background-color":"#f1f3f7","min-height":"100vh"}},[_c('div',{staticClass:"padding-vert-m flexy"}),_vm._v(" "),_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"padding-vert-s"},[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{attrs:{"selectedAddress":_vm.selectedAddress,"addresses":_vm.addresses,"reactivator":_vm.reactivator},on:{"add":function($event){_vm.addAddressPressed()},"signin":function($event){_vm.signInPressed()},"change":function($event){_vm.changeAddressSelected($event)},"manage":function($event){_vm.manageAddressPressed()}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('PaymentMethodMin',{attrs:{"selectedPayment":_vm.selectedPayment,"payments":_vm.payments,"reactivator":_vm.reactivator},on:{"add":function($event){_vm.addPaymentPressed()},"signin":function($event){_vm.signInPressed()},"change":function($event){_vm.changePaymentSelected($event)},"manage":function($event){_vm.managePaymentPressed()}}})],1),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch"},[_c('ShoppingCartMin',{attrs:{"cart":_vm.cart},on:{"edit":function($event){_vm.currentView = 'ShoppingCart'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('Delivery',{attrs:{"chosenDelivery":_vm.chosenDelivery}})],1)]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('OrderSummary',{attrs:{"selectedAddress":_vm.selectedAddress,"selectedPayment":_vm.selectedPayment},on:{"placed":function($event){_vm.currentView = 'ExtraSignup'}}}),_vm._v(" "),(_vm.doShowSignIn)?_c('SignIn',{on:{"close":function($event){_vm.signInClosed()},"login":_vm.loginPressed}}):_vm._e()],1)])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ry8j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A2_vue__ = __webpack_require__("GMrb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d07bfde8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A2_vue__ = __webpack_require__("J2LK");
function injectStyle (ssrContext) {
  __webpack_require__("Tvuf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d07bfde8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d07bfde8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ryDJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-s padding-hor-xl"},[_vm._m(0),_vm._v(" "),(_vm.isPaymentFilled)?_c('div',{staticClass:"text-grey"},[_c('div',[_vm._v("Sam Bell")]),_vm._v(" "),_c('div',[_vm._v("**** **** **** 5457")]),_vm._v(" "),_c('div',[_vm._v("07 / 20")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs"},[_c('h3',[_vm._v("Payment Method")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sBnd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-s padding-hor-xl"},[_vm._m(0),_vm._v(" "),(_vm.isShippingFilled)?_c('div',{staticClass:"text-grey"},[_c('div',[_vm._v("Sam Bell")]),_vm._v(" "),_c('div',[_vm._v("821 Washington St")]),_vm._v(" "),_c('div',[_vm._v("Ashland, Illinois, United States")]),_vm._v(" "),_c('div',[_vm._v("1 555 374 82 96")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs"},[_c('h3',[_vm._v("Shipping Address")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sFdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedPayment'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      number: { value: '', isValid: true, wasFocused: false },
      month: { value: '', isValid: true, wasFocused: false },
      year: { value: '', isValid: true, wasFocused: false }
    };
  },

  methods: {
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      this.$emit('confirmed', {
        name: this.name.value,
        number: this.number.value,
        month: this.month.value,
        year: this.year.value
      });
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.number.isValid = true;
      this.month.isValid = true;
      this.year.isValid = true;
      //
      this.name.wasFocused = false;
      this.number.wasFocused = false;
      this.month.wasFocused = false;
      this.year.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.number.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.number.isValid = false;
      }
      if (this.month.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.month.isValid = false;
      }
      if (this.year.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.year.isValid = false;
      }
      return hasErrors;
    }
  },
  created: function created() {
    if (this.selectedPayment !== null) {
      this.name = { value: this.selectedPayment.name, isValid: true, wasFocused: false };
      this.number = { value: this.selectedPayment.number, isValid: true, wasFocused: false };
      this.month = { value: this.selectedPayment.month, isValid: true, wasFocused: false };
      this.year = { value: this.selectedPayment.year, isValid: true, wasFocused: false };
    }
  }
});

/***/ }),

/***/ "sHcn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sHl0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__ = __webpack_require__("Kez7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  components: {
    QuickPreview: __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__["a" /* default */]
  },
  props: ['cart', 'alsoItems', 'recentItems', 'extraItems', 'laterItems'],
  data: function data() {
    return {
      items: [],
      also: [],
      recent: [],
      extra: [],
      later: [],
      doShowPreview: false,
      selectedForPreview: null,
      youRecentlyViewed: 'You recently viewed'
    };
  },

  computed: {
    subtotal: function subtotal() {
      var result = 0;
      for (var i in this.items) {
        result += this.items[i].price * this.items[i].quantity;
      }
      return result.toFixed(2);
    }
  },
  methods: {
    checkoutPressed: function checkoutPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('confirmed', this.items);
    },
    removeItemPressed: function removeItemPressed(index) {
      this.items.splice(index, 1);
      this.$emit('updated', this.items);
    },
    xPressed: function xPressed(index) {
      this.items[index].isXPressed = !this.items[index].isXPressed;
      this.youRecentlyViewed = this.youRecentlyViewed + ' ';
      // this.also.splice(index, 1)
      // for (let i in this.items) {
      //   let currentItem = this.items[i]
      //   currentItem['updated'] = Math.random() * (100 - 5) + 5
      //   console.log(currentItem['updated'])
      // }
    },
    saveForLaterPressed: function saveForLaterPressed(index) {
      var tempItem = this.items[index];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.later.push(this.items[index]);
      this.items.splice(index, 1);
      this.$emit('updated', this.items);
    },
    addFromLaterPressed: function addFromLaterPressed(index) {
      var _this = this;

      this.later[index].isBeingAddedToCart = true;
      this.items.push(this.later[index]);
      setTimeout(function () {
        _this.later.splice(index, 1);
      }, 500);
      this.$emit('updated', this.items);
    },
    addFromAlsoPressed: function addFromAlsoPressed(index) {
      var _this2 = this;

      this.also[index].isBeingAddedToCart = true;
      this.items.push(this.also[index]);
      setTimeout(function () {
        _this2.also.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this2.extra.length > 0) {
          _this2.also.push(_this2.extra[0]);
          _this2.extra.splice(0, 1);
        }
      }, 1000);
      this.$emit('updated', this.items);
    },
    addFromRecentPressed: function addFromRecentPressed(index) {
      var _this3 = this;

      this.recent[index].isBeingAddedToCart = true;
      this.items.push(this.recent[index]);
      setTimeout(function () {
        _this3.recent.splice(index, 1);
      }, 500);
      setTimeout(function () {
        if (_this3.extra.length > 0) {
          _this3.recent.push(_this3.extra[0]);
          _this3.extra.splice(0, 1);
        }
      }, 1000);
      this.$emit('updated', this.items);
      // var rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.right, rect.bottom, rect.left);
      // let lastIndex = this.items.length - 1
      // let lastItem = document.getElementById('cart-item-' + lastIndex)
      // console.log(lastItem)
      // console.log('cart-item-' + lastIndex)
      // let rect = lastItem.getBoundingClientRect()
      // console.log(rect)
      // let position = 0 + (this.items.length * 136)
      // window.scroll({
      //   top: position,
      //   left: 0,
      //   behavior: 'smooth'
      // })
    },
    addedToCartFromPreview: function addedToCartFromPreview(item) {
      if (item.section === 'items') {
        this.items[item.index].quantity = this.items[item.index].quantity + 1;
      } else if (item.section === 'recent') {
        this.addFromRecentPressed(item.index);
      } else if (item.section === 'also') {
        this.addFromAlsoPressed(item.index);
      } else if (item.section === 'later') {
        this.addFromLaterPressed(item.index);
      }
      this.doShowPreview = false;
      this.$emit('updated', this.items);
    },
    openPreview: function openPreview(section, index) {
      if (section === 'items') {
        this.doShowPreview = true;
        this.selectedForPreview = this.items[index];
      } else if (section === 'recent') {
        this.doShowPreview = true;
        this.selectedForPreview = this.recent[index];
      } else if (section === 'also') {
        this.doShowPreview = true;
        this.selectedForPreview = this.also[index];
      } else if (section === 'later') {
        this.doShowPreview = true;
        this.selectedForPreview = this.later[index];
      }
      this.selectedForPreview['section'] = section;
      this.selectedForPreview['index'] = index;
    }
  },
  created: function created() {
    for (var i in this.cart) {
      var tempItem = this.cart[i];
      tempItem['isXPressed'] = false;
      tempItem['isBeingAddedToCart'] = false;
      this.items.push(tempItem);
    }
    for (var _i in this.alsoItems) {
      var _tempItem = this.alsoItems[_i];
      _tempItem['isBeingAddedToCart'] = false;
      this.also.push(_tempItem);
    }
    for (var _i2 in this.recentItems) {
      var _tempItem2 = this.recentItems[_i2];
      _tempItem2['isBeingAddedToCart'] = false;
      this.recent.push(_tempItem2);
    }
    for (var _i3 in this.extraItems) {
      var _tempItem3 = this.extraItems[_i3];
      _tempItem3['isBeingAddedToCart'] = false;
      this.extra.push(_tempItem3);
    }
    for (var _i4 in this.laterItems) {
      var _tempItem4 = this.laterItems[_i4];
      _tempItem4['isBeingAddedToCart'] = false;
      this.later.push(_tempItem4);
    }
  }
});

/***/ }),

/***/ "sLjn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      isValid: true,
      wasFocused: false,
      isProcessing: false,
      hasRegistered: false
    };
  },

  computed: {
    isSignedIn: function isSignedIn() {
      return this.$store.getters.getIsSignedIn;
    }
  },
  methods: {
    createPressed: function createPressed() {
      var _this = this;

      if (!this.isProcessing) {
        this.isValid = true;
        this.wasFocused = false;
        if (this.email.replace(/\s/g, '').length === 0) {
          this.isValid = false;
        } else {
          this.isProcessing = true;
          setTimeout(function () {
            _this.hasRegistered = true;
          }, 1000);
        }
      }
    }
  }
});

/***/ }),

/***/ "sa46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l fixed flexy align-top",staticStyle:{"width":"50%"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("+TgY"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900","padding-bottom":"8px"}},[_vm._v("Shopping cart")]),_vm._v(" "),_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"flexy align-top",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"64px","margin-right":"16px"}},[_c('img',{attrs:{"src":item.img,"width":"64px"}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"font-size":"14px","padding-top":"6px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"font-size":"14px","padding-top":"2px"}},[_vm._v("x"+_vm._s(item.quantity))])])])}),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.editPressed()}}},[_vm._v("Edit")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sbM0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"flexy align-top"},[_c('div',[_c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-vert-l padding-hor-xl"},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Shopping Cart")])]),_vm._v(" "),_c('transition-group',{attrs:{"name":"cart-list-ani","tag":"div"}},_vm._l((_vm.items),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item large",staticStyle:{"padding-top":"16px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('items', i)}}},[_c('img',{staticStyle:{"width":"40px","padding":"28px 0 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 24px 0 12px"}},[_c('div',{staticStyle:{"padding-top":"6px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"2px","font-size":"14px"}},[_vm._v(_vm._s(item.availability)+", "+_vm._s(item.seller))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"91px","padding-top":"6px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"72px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticStyle:{"min-width":"auto","width":"56px","background-color":"rgba(255,255,255,0.6)","padding":"4px 8px"},attrs:{"name":"quantity","id":"item-quantity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px","padding-top":"2px"}},[(!item.isXPressed)?_c('button',{on:{"click":function($event){_vm.xPressed(i)}}},[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1"},attrs:{"src":__webpack_require__("xLw2")}})]):_vm._e(),_vm._v(" "),(item.isXPressed)?_c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"90","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.xPressed(i)}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-xs rounded",staticStyle:{"position":"relative","width":"160px","transform":"translate(-136px, -16px)","z-index":"120","background-color":"white","box-shadow":"0px 4px 12px rgba(0,0,0,0.0.5)"}},[_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"7px 12px","color":"#409EFF","margin":"0"},on:{"click":function($event){_vm.saveForLaterPressed(i)}}},[_vm._v("Save for later")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"7px 12px","color":"#fd3737","margin":"0"},on:{"click":function($event){_vm.removeItemPressed(i)}}},[_vm._v("Remove from cart")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"7px 12px","color":"silver","margin":"0"},on:{"click":function($event){_vm.xPressed(i)}}},[_vm._v("Cancel")])])]):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"padding-vert-m",staticStyle:{"font-size":"12px","color":"#878D98"}},[_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("The price and availability of items at Amazon.com are subject to change. The Cart is a temporary place to store a list of your items and reflects each item's most recent price. Shopping Cart "),_c('span',{staticStyle:{"color":"#878D98","border-bottom":"1px dashed","cursor":"pointer"}},[_vm._v("Learn more")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_vm._v("Do you have a gift card or promotional code? We'll ask you to enter your claim code when it's time to pay.")])])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[(_vm.later.length > 0)?_c('div',[_c('div',{staticClass:"padding-hor-xl",staticStyle:{"padding-top":"12px"}},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("You saved for later")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('transition-group',{staticClass:"flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.later),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item higher fixed",staticStyle:{"width":"50%","padding-right":"32px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('later', i)}}},[_c('img',{staticStyle:{"width":"40px","padding":"28px 0 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 0 0 12px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"6px"}},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.addFromLaterPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","font-size":"13px","min-width":"88px","padding":"3px 0","border":"1px solid","border-radius":"4px","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',{staticClass:"padding-hor-xl",staticStyle:{"padding-top":"12px"}},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v(_vm._s(_vm.youRecentlyViewed))])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('transition-group',{staticClass:"flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.recent),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item higher fixed",staticStyle:{"width":"50%","padding-right":"32px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('recent', i)}}},[_c('img',{staticStyle:{"width":"40px","padding":"28px 0 0","border-radius":"6px"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 0 0 12px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"6px"}},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.addFromRecentPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","font-size":"13px","min-width":"88px","padding":"3px 0","border":"1px solid","border-radius":"4px","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',{staticClass:"padding-hor-xl",staticStyle:{"padding-top":"12px"}},[_c('div',{},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Customers also bought")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('transition-group',{staticClass:"flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.also),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item higher fixed",staticStyle:{"width":"50%","padding-right":"32px"}},[_c('div',{staticClass:"flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":item.img,"width":"64"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('also', i)}}})]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 0 0 12px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey",staticStyle:{"padding-top":"4px","font-size":"14px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"6px"}},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.addFromAlsoPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","font-size":"13px","min-width":"88px","padding":"3px 0","border":"1px solid","border-radius":"4px","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])])],1),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-xl padding-vert-m",staticStyle:{"width":"32%","background-color":"#F5F5F5","min-height":"100vh","position":"sticky","top":"0"}},[_c('div',{staticClass:"padding-hor-m"},[_c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900","padding-top":"8px"}},[_vm._v("Subtotal")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"16px","font-weight":"900"}},[_vm._v(_vm._s(_vm.cart.length)+" item"),(_vm.cart.length > 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(", "+_vm._s(_vm.subtotal)+" ")]),_vm._v(" "),_c('div',{staticClass:"flexy align-top",staticStyle:{"padding-top":"8px"}},[_c('input',{staticClass:"fixed",staticStyle:{"width":"16px","text-align":"left"},attrs:{"type":"checkbox","id":"gift"}}),_vm._v(" "),_c('label',{attrs:{"for":"gift"}},[_c('div',[_vm._v("This order contains a gift")])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"24px"}},[_c('button',{staticClass:"boxed primary wide properBlue",staticStyle:{"background-color":"#3a84e8"},on:{"click":function($event){_vm.checkoutPressed()}}},[_vm._v("Proceed to Checkout")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"right-column-appear","appear":""}},[_c('div',{staticStyle:{"padding-top":"40px"}},[_c('div',{staticClass:"padding-vert-m padding-hor-xl bordered rounded silver",staticStyle:{"height":"400px","text-align":"center"}},[_c('img',{staticStyle:{"padding-top":"146px"},attrs:{"src":__webpack_require__("Kufr"),"width":"125px"}})])])])],1)])]),_vm._v(" "),(_vm.doShowPreview)?_c('QuickPreview',{attrs:{"selectedForPreview":_vm.selectedForPreview},on:{"close":function($event){_vm.doShowPreview = false},"addToCart":function($event){_vm.addedToCartFromPreview($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sg//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['selectedPayment', 'payments', 'reactivator'],
  data: function data() {
    return {
      doShowMethodsList: false
    };
  },

  computed: {
    isSignedIn: function isSignedIn() {
      return this.$store.getters.getIsSignedIn;
    }
  },
  methods: {
    addPressed: function addPressed() {
      this.$emit('add');
    },
    changePressed: function changePressed() {
      this.doShowMethodsList = true;
    },
    choosePressed: function choosePressed(index) {
      this.$store.dispatch('setSelectedPayment', index);
      this.doShowMethodsList = false;
      //
    },
    addNewPaymentPressed: function addNewPaymentPressed() {
      this.doShowMethodsList = false;
      this.$emit('add');
    },
    managePaymentPressed: function managePaymentPressed() {
      this.doShowMethodsList = false;
      this.$emit('manage');
    },

    //
    doNothing: function doNothing() {
      //
    },
    mutateCardNumber: function mutateCardNumber(number) {
      var safeString = '**** **** **** ';
      var lastChars = number.slice(number.length - 4, number.length);
      safeString = safeString + lastChars;
      return safeString;
    },

    //
    openSignIn: function openSignIn() {
      this.$emit('signin');
    }
  }
});

/***/ }),

/***/ "sq3h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-l bordered rounded"},_vm._l((_vm.cart),function(item,i){return _c('div',{key:i,staticClass:"padding-vert-m flexy"},[_vm._m(1,true),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v("$ "+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"20px"}},[_vm._v("x")])])})),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Checkout")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l flexy"},[_c('h1',[_vm._v("Shopping Cart")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('img',{attrs:{"src":__webpack_require__("R4sD"),"width":"75px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "svPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "swTv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t613":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__ = __webpack_require__("GhId");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCart',
  components: {
    QuickPreview: __WEBPACK_IMPORTED_MODULE_0__QuickPreview_vue__["a" /* default */]
  },
  props: ['cart', 'alsoItems', 'recentItems', 'extraItems'],
  data: function data() {
    return {
      items: [],
      also: [],
      recent: [],
      extra: [],
      doShowPreview: false,
      selectedForPreview: null
    };
  },

  computed: {
    subtotal: function subtotal() {
      var result = 0;
      for (var i in this.items) {
        result += this.items[i].price * this.items[i].quantity;
      }
      return result.toFixed(2);
    }
  },
  methods: {
    checkoutPressed: function checkoutPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('confirmed', this.items);
    },
    removeItemPressed: function removeItemPressed(index) {
      this.items.splice(index, 1);
    },
    addFromAlsoPressed: function addFromAlsoPressed(index) {
      this.items.push(this.also[index]);
      this.also.splice(index, 1);
      if (this.extra.length > 0) {
        this.also.push(this.extra[0]);
        this.extra.splice(0, 1);
      }
    },
    addFromRecentPressed: function addFromRecentPressed(index) {
      this.items.push(this.recent[index]);
      this.recent.splice(index, 1);
      if (this.extra.length > 0) {
        this.recent.push(this.extra[0]);
        this.extra.splice(0, 1);
      }
      // var rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.right, rect.bottom, rect.left);
      // let lastIndex = this.items.length - 1
      // let lastItem = document.getElementById('cart-item-' + lastIndex)
      // console.log(lastItem)
      // console.log('cart-item-' + lastIndex)
      // let rect = lastItem.getBoundingClientRect()
      // console.log(rect)
      // let position = 0 + (this.items.length * 136)
      // window.scroll({
      //   top: position,
      //   left: 0,
      //   behavior: 'smooth'
      // })
    },
    addedToCartFromPreview: function addedToCartFromPreview(item) {
      if (item.section === 'items') {
        this.items[item.index].quantity = this.items[item.index].quantity + 1;
      } else if (item.section === 'recent') {
        this.addFromRecentPressed(item.index);
      } else if (item.section === 'also') {
        this.addFromAlsoPressed(item.index);
      }
      this.doShowPreview = false;
    },
    openPreview: function openPreview(section, index) {
      if (section === 'items') {
        this.doShowPreview = true;
        this.selectedForPreview = this.items[index];
      } else if (section === 'recent') {
        this.doShowPreview = true;
        this.selectedForPreview = this.recent[index];
      } else if (section === 'also') {
        this.doShowPreview = true;
        this.selectedForPreview = this.also[index];
      }
      this.selectedForPreview['section'] = section;
      this.selectedForPreview['index'] = index;
    }
  },
  created: function created() {
    for (var i in this.cart) {
      this.items.push(this.cart[i]);
    }
    for (var _i in this.alsoItems) {
      this.also.push(this.alsoItems[_i]);
    }
    for (var _i2 in this.recentItems) {
      this.recent.push(this.recentItems[_i2]);
    }
    for (var _i3 in this.extraItems) {
      this.extra.push(this.extraItems[_i3]);
    }
  }
});

/***/ }),

/***/ "t70U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"border-bottom":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","border-radius":"10px 10px 0 0"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[(_vm.mode === 'add')?_c('span',[_vm._v("New shipping address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('span',[_vm._v("Edit address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'manage')?_c('span',[_vm._v("Manage shipping addresses")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.$emit('cancelled')}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",class:{roundBottom: _vm.mode === 'manage'},staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"16px","padding-bottom":"40px"}},[(this.mode === 'manage')?_c('div',[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"flexy",staticStyle:{"padding":"12px 0","border-bottom":"1px solid #DDE1EB"}},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"#409EFF"},on:{"click":function($event){_vm.editSelectedPressed(i)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"silver"},on:{"click":function($event){_vm.deleteSelectedPressed(i)}}},[_vm._v("Delete")])])])}),_vm._v(" "),_c('div',{staticClass:"clickable flexy",staticStyle:{"padding":"12px 0","color":"#409EFF","font-weight":"500","font-size":"14px"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("\n            Add new address\n          ")])],2):_vm._e(),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1.value),expression:"address1.value"}],class:{errorInputHighlight: !_vm.address1.isValid && !_vm.address1.wasFocused},attrs:{"type":"text","name":"","id":"addressLine1"},domProps:{"value":(_vm.address1.value)},on:{"focus":function($event){_vm.address1.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address1, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.address1.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.address1.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city.value),expression:"city.value"}],class:{errorInputHighlight: !_vm.city.isValid && !_vm.city.wasFocused},attrs:{"type":"text","name":"","id":"city"},domProps:{"value":(_vm.city.value)},on:{"focus":function($event){_vm.city.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.city, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.city.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.city.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],class:{errorInputHighlight: !_vm.state.isValid && !_vm.state.wasFocused},attrs:{"type":"text","name":"","id":"state"},domProps:{"value":(_vm.state.value)},on:{"focus":function($event){_vm.state.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.state.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.state.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country.value),expression:"country.value"}],class:{errorInputHighlight: !_vm.country.isValid && !_vm.country.wasFocused},on:{"focus":function($event){_vm.country.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.country, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose country...")]),_vm._v(" "),_c('option',{attrs:{"value":"United States"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"Mexico"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"Canada"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"Brazil"}},[_vm._v("Brazil")])]),_vm._v(" "),(!_vm.country.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.country.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zip.value),expression:"zip.value"}],class:{errorInputHighlight: !_vm.zip.isValid && !_vm.zip.wasFocused},attrs:{"type":"text","name":"","id":"zip"},domProps:{"value":(_vm.zip.value)},on:{"focus":function($event){_vm.zip.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zip, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.zip.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.zip.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone.value),expression:"phone.value"}],class:{errorInputHighlight: !_vm.phone.isValid && !_vm.phone.wasFocused},attrs:{"type":"text","name":"","id":"phone"},domProps:{"value":(_vm.phone.value)},on:{"focus":function($event){_vm.phone.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.phone, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.phone.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.phone.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',{staticClass:"padding-hor-l",staticStyle:{"border-top":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","padding-top":"10px","text-align":"right","border-radius":"0 0 10px 10px"}},[_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary",staticStyle:{"min-width":"120px"},on:{"click":_vm.savePressed}},[_vm._v("Save")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tQ0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100vh","overflow":"auto"}},[_c('div',{staticClass:"padding-hor-l padding-vert-m black flexy",staticStyle:{"height":"80px"}},[_c('div',[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'Start'}}},[_vm._v("Amazon ")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"40px"}},[_c('button',{staticStyle:{"color":"white"},on:{"click":function($event){_vm.currentView = 'ShoppingCart'}}},[_vm._v("Cart")])])]),_vm._v(" "),(_vm.currentView === 'Start')?_c('Start'):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShoppingCart')?_c('ShoppingCart',{attrs:{"cart":_vm.cart,"alsoItems":_vm.alsoItems,"recentItems":_vm.recentItems,"extraItems":_vm.extraItems},on:{"confirmed":function($event){_vm.shoppingCartConfirmed($event)}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ShippingAddress')?_c('ShippingAddress',{on:{"confirmed":function($event){_vm.shippingAddressConfirmed()},"cancelled":function($event){_vm.shippingAddressCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'PaymentMethod')?_c('PaymentMethod',{on:{"confirmed":function($event){_vm.paymentMethodConfirmed()},"cancelled":function($event){_vm.paymentMethodCancelled()}}}):_vm._e(),_vm._v(" "),(_vm.currentView === 'ExtraSignup')?_c('ExtraSignup'):_vm._e(),_vm._v(" "),(_vm.currentView === 'Checkout')?_c('div',{attrs:{"id":"checkout"}},[_c('div',{staticClass:"padding-hor-l"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flexy align-top"},[_c('div',[_c('div',{staticClass:"flexy align-stretch"},[_c('ShippingAddressMin',{attrs:{"isShippingFilled":_vm.isShippingFilled},on:{"edit":function($event){_vm.currentView = 'ShippingAddress'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('PaymentMethodMin',{attrs:{"isPaymentFilled":_vm.isPaymentFilled},on:{"edit":function($event){_vm.currentView = 'PaymentMethod'}}})],1),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"flexy align-stretch"},[_c('ShoppingCartMin',{attrs:{"cart":_vm.cart},on:{"edit":function($event){_vm.currentView = 'ShoppingCart'}}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"2%"}}),_vm._v(" "),_c('Delivery',{attrs:{"chosenDelivery":_vm.chosenDelivery}})],1)]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('OrderSummary',{attrs:{"isShippingFilled":_vm.isShippingFilled,"isPaymentFilled":_vm.isPaymentFilled},on:{"placed":function($event){_vm.currentView = 'ExtraSignup'}}})],1)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-l flexy"},[_c('h1',[_vm._v("Checkout")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tSVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedPayment', 'mode', 'payments'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      number: { value: '', isValid: true, wasFocused: false },
      month: { value: '', isValid: true, wasFocused: false },
      year: { value: '', isValid: true, wasFocused: false },
      //
      shouldComeBackToManager: false,
      //
      scrollable: null,
      didScroll: false,
      doesHaveScrollDown: false
    };
  },

  methods: {
    checkScrollPosition: function checkScrollPosition() {
      this.checkIfCanScroll();
      if (this.scrollable.scrollTop > 10) {
        this.didScroll = true;
      } else {
        this.didScroll = false;
      }
    },
    checkIfCanScroll: function checkIfCanScroll() {
      if (this.scrollable.scrollHeight > this.scrollable.clientHeight && this.scrollable.scrollTop + 10 < this.scrollable.scrollHeight - this.scrollable.clientHeight) {
        this.doesHaveScrollDown = true;
      } else {
        this.doesHaveScrollDown = false;
      }
    },
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      var data = {
        name: this.name.value,
        number: this.number.value,
        month: this.month.value,
        year: this.year.value
      };
      if (this.mode === 'add') {
        this.$emit('saveNew', data);
      } else {
        this.$emit('saveExisting', data);
      }
    },
    cancelPressed: function cancelPressed() {
      if (this.shouldComeBackToManager) {
        this.$emit('backToManager');
      } else {
        this.$emit('cancelled');
      }
    },
    addPressed: function addPressed() {
      var _this = this;

      setTimeout(function () {
        _this.checkIfCanScroll();
      }, 100);
      this.shouldComeBackToManager = false;
      this.$emit('add');
      this.clearForm();
    },
    editSelectedPressed: function editSelectedPressed(index) {
      var _this2 = this;

      setTimeout(function () {
        _this2.checkIfCanScroll();
      }, 100);
      this.shouldComeBackToManager = true;
      this.$emit('edit', index);
      this.fillForm();
    },
    deleteSelectedPressed: function deleteSelectedPressed(index) {
      this.$emit('delete', index);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.number.isValid = true;
      this.month.isValid = true;
      this.year.isValid = true;
      //
      this.name.wasFocused = false;
      this.number.wasFocused = false;
      this.month.wasFocused = false;
      this.year.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.number.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.number.isValid = false;
      }
      if (this.month.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.month.isValid = false;
      }
      if (this.year.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.year.isValid = false;
      }
      return hasErrors;
    },
    fillForm: function fillForm() {
      this.name = { value: this.payments[this.selectedPayment].name, isValid: true, wasFocused: false };
      this.number = { value: this.payments[this.selectedPayment].number, isValid: true, wasFocused: false };
      this.month = { value: this.payments[this.selectedPayment].month, isValid: true, wasFocused: false };
      this.year = { value: this.payments[this.selectedPayment].year, isValid: true, wasFocused: false };
    },
    clearForm: function clearForm() {
      this.name = { value: '', isValid: true, wasFocused: false };
      this.number = { value: '', isValid: true, wasFocused: false };
      this.month = { value: '', isValid: true, wasFocused: false };
      this.year = { value: '', isValid: true, wasFocused: false };
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.mode === 'edit') {
      this.fillForm();
    }
    setTimeout(function () {
      _this3.scrollable = document.getElementById('watchMeScroll');
      _this3.checkIfCanScroll();
    }, 100);
  },

  watch: {
    selectedPayment: function selectedPayment() {
      this.fillForm();
    }
  }
});

/***/ }),

/***/ "tdBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shipping address")]),_vm._v(" "),(!_vm.isShippingFilled)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add shipping address")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Sam Bell")]),_vm._v(" "),_c('div',[_vm._v("821 Washington St")]),_vm._v(" "),_c('div',[_vm._v("Ashland, Illinois, United States")]),_vm._v(" "),_c('div',[_vm._v("1 555 374 82 96")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tocp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tqbw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedAddress', 'mode', 'addresses'],
  data: function data() {
    return {
      name: { value: '', isValid: true, wasFocused: false },
      address1: { value: '', isValid: true, wasFocused: false },
      city: { value: '', isValid: true, wasFocused: false },
      state: { value: '', isValid: true, wasFocused: false },
      zip: { value: '', isValid: true, wasFocused: false },
      country: { value: '', isValid: true, wasFocused: false },
      phone: { value: '', isValid: true, wasFocused: false },
      //
      shouldComeBackToManager: false
    };
  },

  methods: {
    savePressed: function savePressed() {
      var errors = this.checkForErrors();
      if (errors) {
        return;
      }
      var data = {
        name: this.name.value,
        address1: this.address1.value,
        city: this.city.value,
        state: this.state.value,
        zip: this.zip.value,
        country: this.country.value,
        phone: this.phone.value
      };
      if (this.mode === 'add') {
        this.$emit('saveNew', data);
      } else {
        this.$emit('saveExisting', data);
      }
    },
    addPressed: function addPressed() {
      this.shouldComeBackToManager = false;
      this.$emit('add');
    },
    editSelectedPressed: function editSelectedPressed(index) {
      this.shouldComeBackToManager = true;
      this.$emit('edit', index);
      this.fillForm();
    },
    deleteSelectedPressed: function deleteSelectedPressed(index) {
      this.$emit('delete', index);
    },
    checkForErrors: function checkForErrors(data) {
      var hasErrors = false;
      //
      this.name.isValid = true;
      this.address1.isValid = true;
      this.city.isValid = true;
      this.state.isValid = true;
      this.zip.isValid = true;
      this.country.isValid = true;
      this.phone.isValid = true;
      //
      this.name.wasFocused = false;
      this.address1.wasFocused = false;
      this.city.wasFocused = false;
      this.state.wasFocused = false;
      this.zip.wasFocused = false;
      this.country.wasFocused = false;
      this.phone.wasFocused = false;
      //
      if (this.name.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.name.isValid = false;
      }
      if (this.address1.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.address1.isValid = false;
      }
      if (this.city.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.city.isValid = false;
      }
      if (this.state.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.state.isValid = false;
      }
      if (this.zip.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.zip.isValid = false;
      }
      if (this.country.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.country.isValid = false;
      }
      if (this.phone.value.replace(/\s/g, '').length === 0) {
        hasErrors = true;
        this.phone.isValid = false;
      }
      return hasErrors;
    },
    fillForm: function fillForm() {
      this.name = { value: this.addresses[this.selectedAddress].name, isValid: true, wasFocused: false };
      this.address1 = { value: this.addresses[this.selectedAddress].address1, isValid: true, wasFocused: false };
      this.city = { value: this.addresses[this.selectedAddress].city, isValid: true, wasFocused: false };
      this.state = { value: this.addresses[this.selectedAddress].state, isValid: true, wasFocused: false };
      this.zip = { value: this.addresses[this.selectedAddress].zip, isValid: true, wasFocused: false };
      this.country = { value: this.addresses[this.selectedAddress].country, isValid: true, wasFocused: false };
      this.phone = { value: this.addresses[this.selectedAddress].phone, isValid: true, wasFocused: false };
    }
  },
  watch: {
    selectedAddress: function selectedAddress() {
      this.fillForm();
    }
  },
  created: function created() {
    if (this.mode === 'edit') {
      this.fillForm();
    }
  }
});

/***/ }),

/***/ "ttiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkout_vue__ = __webpack_require__("oVmj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2efb3646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkout_vue__ = __webpack_require__("HxM7");
function injectStyle (ssrContext) {
  __webpack_require__("iF1G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2efb3646"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2efb3646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u4Iz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shipping address")]),_vm._v(" "),(_vm.selectedAddress === null)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":_vm.addPressed}},[_vm._v("+ Add shipping address")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].name))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].address1)+" ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].city)+", "+_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].state)+", "+_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.reactiveAddresses[_vm.selectedAddress].phone))]),_vm._v(" "),_c('div',{staticStyle:{"color":"transparent","width":"0","height":"0","overflow":"hidden"}},[_vm._v(_vm._s(_vm.reactivator))]),_vm._v(" "),(_vm.doShowAddressesList)?_c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"100","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.doShowAddressesList=false}}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","z-index":"101","display":"inline-block","background-color":"white","box-shadow":"0 8px 18px rgba(0,0,0,0.2)","border-radius":"6px","padding":"8px 0","transform":"translate(0,-100px)"},on:{"click":function($event){$event.stopPropagation();_vm.doNothing($event)}}},[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"hoverableItem clickable flexy",on:{"click":function($event){_vm.choosePressed(i)}}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"32px","text-align":"center","color":"#409EFF"}}),_vm._v(" "),_c('div',{staticStyle:{"padding":"12px 24px 12px 0","border-bottom":"1px solid #DDE1EB"}},[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])])])}),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",on:{"click":_vm.addNewAddressPressed}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"32px","text-align":"center","color":"#409EFF"}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",on:{"click":_vm.manageAddressesPressed}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"32px","text-align":"center","color":"#409EFF"}}),_vm._v(" "),_vm._m(1)])],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":_vm.changePressed}},[_vm._v("Change")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"12px 24px 12px 0","border-bottom":"1px solid #DDE1EB"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Add new address")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"12px 24px 12px 0","border-bottom":"1px solid #DDE1EB"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Manage addresses")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u4yN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l",staticStyle:{"background-color":"#f1f3f7"}},[_c('div',{staticClass:"padding-vert-l flexy align-top"},[_c('div',[_c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l rounded silver",staticStyle:{"padding":"12px 40px","background-color":"white","box-shadow":"0px 7px 24px rgba(0,0,0,0.1)"}},[_c('div',{},[_c('h1',{staticStyle:{"padding":"24px 0","font-size":"24px","font-weight":"600","border-bottom":"1px solid #EBEEF5"}},[_vm._v("Shopping Cart")])]),_vm._v(" "),_c('transition-group',{staticStyle:{"padding":"12px 0"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.items),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item large"},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('items', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-right":"24px","padding-top":"4px"}},[_c('div',{staticStyle:{"font-size":"16px","font-weight":"500"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey padding-vert-xs"},[_vm._v(_vm._s(item.availability)+", "+_vm._s(item.seller))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px","padding-top":"8px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticStyle:{"min-width":"auto","width":"60px","background-color":"rgba(255,255,255,0.6)"},attrs:{"name":"quantity","id":"item-quantity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"20px","margin-right":"12px","padding-top":"6px"}},[(!item.isXPressed)?_c('button',{on:{"click":function($event){_vm.xPressed(i)}}},[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1"},attrs:{"src":__webpack_require__("5F5F")}})]):_vm._e(),_vm._v(" "),(item.isXPressed)?_c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"90","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.xPressed(i)}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-xs rounded",staticStyle:{"position":"relative","width":"160px","transform":"translate(-130px, -12px)","z-index":"120","background-color":"white","box-shadow":"0px 4px 12px rgba(0,0,0,0.0.5)"}},[_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"#409EFF","margin":"0"},on:{"click":function($event){_vm.saveForLaterPressed(i)}}},[_vm._v("Save for later")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"#fd3737","margin":"0"},on:{"click":function($event){_vm.removeItemPressed(i)}}},[_vm._v("Remove from cart")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"silver","margin":"0"},on:{"click":function($event){_vm.xPressed(i)}}},[_vm._v("Cancel")])])]):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"padding-vert-m flexy",staticStyle:{"padding-top":"24px","padding-bottom":"32px","border-top":"1px solid #EBEEF5"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"102px"}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"16px","font-weight":"500"}},[_vm._v("Subtotal")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v("$"+_vm._s(_vm.subtotal))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"132px"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"padding":"12px 29px"},on:{"click":function($event){_vm.checkoutPressed()}}},[_vm._v("Checkout")])])])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',[_c('transition',{attrs:{"name":"later-fade"}},[(_vm.later.length > 0)?_c('div',{staticStyle:{"padding":"12px 32px"}},[_c('div',[_c('h2',{staticStyle:{"padding":"32px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v("You saved for later")])]),_vm._v(" "),_c('transition-group',{staticClass:"padding-vert-m flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.later),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('later', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromLaterPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"12px 32px"}},[_c('div',[_c('h2',{staticStyle:{"padding":"32px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v(_vm._s(_vm.youRecentlyViewed))])]),_vm._v(" "),_c('transition-group',{staticClass:"padding-vert-m flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.recent),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('recent', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromRecentPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)],1)])],1),_vm._v(" "),_c('transition',{attrs:{"name":"right-column-appear","appear":""}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"320px","margin-left":"48px"}},[_c('div',{staticClass:"padding-vert-m padding-hor-xl bordered rounded silver",staticStyle:{"height":"224px","text-align":"center"}},[_c('img',{staticStyle:{"padding-top":"56px"},attrs:{"src":__webpack_require__("Kufr"),"width":"125px"}})]),_vm._v(" "),_c('div',[_c('h2',{staticStyle:{"padding":"42px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v("Customers also bought")])]),_vm._v(" "),_c('div',{},[_c('transition-group',{attrs:{"name":"list-ani"}},_vm._l((_vm.also),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item"},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('also', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromAlsoPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])])],1),_vm._v(" "),(_vm.doShowPreview)?_c('QuickPreview',{attrs:{"selectedForPreview":_vm.selectedForPreview},on:{"close":function($event){_vm.doShowPreview = false},"addToCart":function($event){_vm.addedToCartFromPreview($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u8JT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Shipping Address")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"fullName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"addressLine1"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine2"}},[_vm._v("Address Line 2")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"addressLine2"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"city"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"state"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"zip"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',[_c('option',{attrs:{"value":"volvo"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"saab"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"mercedes"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"audi"}},[_vm._v("Brazil")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"phone"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uLoE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_B1_vue__ = __webpack_require__("ysXc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d1066a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_B1_vue__ = __webpack_require__("DmS9");
function injectStyle (ssrContext) {
  __webpack_require__("TiC/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25d1066a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_B1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d1066a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_B1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ubYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__ = __webpack_require__("YGZQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e75ea7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__ = __webpack_require__("3LxM");
function injectStyle (ssrContext) {
  __webpack_require__("l8fn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e75ea7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e75ea7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ue8e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uesK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d8b5fd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("v8Tr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d8b5fd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "unr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShoppingCartMin',
  props: ['cart'],
  data: function data() {
    return {};
  },

  methods: {
    editPressed: function editPressed() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$emit('edit');
    }
  }
});

/***/ }),

/***/ "ux34":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Shipping address")]),_vm._v(" "),(!_vm.isShippingFilled)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add shipping address")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Sam Bell")]),_vm._v(" "),_c('div',[_vm._v("821 Washington St")]),_vm._v(" "),_c('div',[_vm._v("Ashland, Illinois, United States")]),_vm._v(" "),_c('div',[_vm._v("1 555 374 82 96")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v5qv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('PrototypeManager',{attrs:{"managerProps":_vm.managerProps}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v7Jy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__ = __webpack_require__("HG1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e4c36cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__ = __webpack_require__("xJOe");
function injectStyle (ssrContext) {
  __webpack_require__("jpC7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e4c36cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e4c36cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v8PV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v8Tr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m flexy"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l fixed",staticStyle:{"width":"20px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('div',{staticClass:"padding-vert-l rounded silver",staticStyle:{"height":"200px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vHvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"border-bottom":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","border-radius":"10px 10px 0 0"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[(_vm.mode === 'add')?_c('span',[_vm._v("New shipping address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('span',[_vm._v("Edit address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'manage')?_c('span',[_vm._v("Manage shipping addresses")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.$emit('cancelled')}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",class:{roundBottom: _vm.mode === 'manage'},staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"16px","padding-bottom":"40px"}},[(this.mode === 'manage')?_c('div',_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"flexy",staticStyle:{"padding":"12px 0","border-bottom":"1px solid #DDE1EB"}},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{on:{"click":function($event){_vm.editSelectedPressed(i)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{on:{"click":function($event){_vm.deleteSelectedPressed(i)}}},[_vm._v("Delete")])])])})):_vm._e(),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1.value),expression:"address1.value"}],class:{errorInputHighlight: !_vm.address1.isValid && !_vm.address1.wasFocused},attrs:{"type":"text","name":"","id":"addressLine1"},domProps:{"value":(_vm.address1.value)},on:{"focus":function($event){_vm.address1.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address1, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.address1.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.address1.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city.value),expression:"city.value"}],class:{errorInputHighlight: !_vm.city.isValid && !_vm.city.wasFocused},attrs:{"type":"text","name":"","id":"city"},domProps:{"value":(_vm.city.value)},on:{"focus":function($event){_vm.city.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.city, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.city.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.city.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],class:{errorInputHighlight: !_vm.state.isValid && !_vm.state.wasFocused},attrs:{"type":"text","name":"","id":"state"},domProps:{"value":(_vm.state.value)},on:{"focus":function($event){_vm.state.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.state.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.state.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country.value),expression:"country.value"}],class:{errorInputHighlight: !_vm.country.isValid && !_vm.country.wasFocused},on:{"focus":function($event){_vm.country.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.country, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose country...")]),_vm._v(" "),_c('option',{attrs:{"value":"United States"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"Mexico"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"Canada"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"Brazil"}},[_vm._v("Brazil")])]),_vm._v(" "),(!_vm.country.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.country.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zip.value),expression:"zip.value"}],class:{errorInputHighlight: !_vm.zip.isValid && !_vm.zip.wasFocused},attrs:{"type":"text","name":"","id":"zip"},domProps:{"value":(_vm.zip.value)},on:{"focus":function($event){_vm.zip.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zip, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.zip.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.zip.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone.value),expression:"phone.value"}],class:{errorInputHighlight: !_vm.phone.isValid && !_vm.phone.wasFocused},attrs:{"type":"text","name":"","id":"phone"},domProps:{"value":(_vm.phone.value)},on:{"focus":function($event){_vm.phone.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.phone, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.phone.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.phone.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',{staticClass:"padding-hor-l",staticStyle:{"border-top":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","padding-top":"10px","text-align":"right","border-radius":"0 0 10px 10px"}},[_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary",staticStyle:{"min-width":"120px"},on:{"click":_vm.savePressed}},[_vm._v("Save")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vOl4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_C3_vue__ = __webpack_require__("2+Fc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a44e30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_C3_vue__ = __webpack_require__("rxJ7");
function injectStyle (ssrContext) {
  __webpack_require__("DfNI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28a44e30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_C3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a44e30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_C3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vPAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"400px","margin":"5vh auto","border-radius":"2px","box-shadow":"0px 12px 36px rgba(0,0,0,0.1)"}},[_c('div',{staticClass:"flexy padding-hor-xl",staticStyle:{"background-color":"white","border-radius":"10px 10px 0 0","padding-top":"24px","padding-bottom":"16px"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"900"}},[_vm._v("Sign in")])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl",staticStyle:{"max-height":"80vh","overflow":"auto","background-color":"white"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","name":"","id":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-xl padding-vert-l",staticStyle:{"background-color":"white","flex":"0 0 auto","text-align":"right","border-radius":"0 0 10px 10px","padding-top":"24px"}},[_c('button',{staticClass:"boxed primary properGrey",staticStyle:{"margin-right":"4px"},on:{"click":function($event){_vm.closePressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary properBlue",staticStyle:{"min-width":"120px"},on:{"click":function($event){_vm.loginPressed()}}},[_vm._v("Login")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vc5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //
    };
  }
});

/***/ }),

/***/ "vnW9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"border-bottom":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","border-radius":"10px 10px 0 0"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[_vm._v("Payment information")])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"16px","padding-bottom":"40px"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"cardName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n            Shouldn't be empty\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number.value),expression:"number.value"}],class:{errorInputHighlight: !_vm.number.isValid && !_vm.number.wasFocused},attrs:{"type":"text","name":"","id":"cardNumber"},domProps:{"value":(_vm.number.value)},on:{"focus":function($event){_vm.number.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.number, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.number.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.number.wasFocused}},[_vm._v("\n            Shouldn't be empty\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month.value),expression:"month.value"}],class:{errorInputHighlight: !_vm.month.isValid && !_vm.month.wasFocused},on:{"focus":function($event){_vm.month.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.month, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose month...")]),_vm._v(" "),_c('option',[_vm._v("01")]),_vm._v(" "),_c('option',[_vm._v("02")]),_vm._v(" "),_c('option',[_vm._v("03")]),_vm._v(" "),_c('option',[_vm._v("04")]),_vm._v(" "),_c('option',[_vm._v("05")]),_vm._v(" "),_c('option',[_vm._v("06")]),_vm._v(" "),_c('option',[_vm._v("07")]),_vm._v(" "),_c('option',[_vm._v("08")]),_vm._v(" "),_c('option',[_vm._v("09")]),_vm._v(" "),_c('option',[_vm._v("10")]),_vm._v(" "),_c('option',[_vm._v("11")]),_vm._v(" "),_c('option',[_vm._v("12")])]),_vm._v(" "),(!_vm.month.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.month.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year.value),expression:"year.value"}],class:{errorInputHighlight: !_vm.year.isValid && !_vm.year.wasFocused},on:{"focus":function($event){_vm.year.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.year, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose year...")]),_vm._v(" "),_c('option',[_vm._v("17")]),_vm._v(" "),_c('option',[_vm._v("18")]),_vm._v(" "),_c('option',[_vm._v("19")]),_vm._v(" "),_c('option',[_vm._v("20")]),_vm._v(" "),_c('option',[_vm._v("21")]),_vm._v(" "),_c('option',[_vm._v("22")]),_vm._v(" "),_c('option',[_vm._v("23")]),_vm._v(" "),_c('option',[_vm._v("24")]),_vm._v(" "),_c('option',[_vm._v("25")]),_vm._v(" "),_c('option',[_vm._v("26")]),_vm._v(" "),_c('option',[_vm._v("27")])]),_vm._v(" "),(!_vm.year.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.year.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",staticStyle:{"border-top":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","padding-top":"10px","text-align":"right","border-radius":"0 0 10px 10px"}},[_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary",staticStyle:{"min-width":"120px"},on:{"click":_vm.savePressed}},[_vm._v("Save")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vpkY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Delivery")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l"},[_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice1","value":"1"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"1")},on:{"change":function($event){_vm.chosenDelivery="1"}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice2","value":"2"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"2")},on:{"change":function($event){_vm.chosenDelivery="2"}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice3","value":"3"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"3")},on:{"change":function($event){_vm.chosenDelivery="3"}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice4","value":"4"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"4")},on:{"change":function($event){_vm.chosenDelivery="4"}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"flexy align-top padding-vert-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chosenDelivery),expression:"chosenDelivery"}],staticClass:"fixed",staticStyle:{"width":"24px"},attrs:{"type":"radio","id":"deliveryChoice5","value":"5"},domProps:{"checked":_vm._q(_vm.chosenDelivery,"5")},on:{"change":function($event){_vm.chosenDelivery="5"}}}),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice1"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("Free Two-Day shipping with a free trial of Amazon Prime")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice2"}},[_c('div',[_vm._v("Nov 6—10")]),_c('div',[_vm._v("FREE shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice3"}},[_c('div',[_vm._v("Monday, Nov 6")]),_c('div',[_vm._v("$6.98 - Standart shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice4"}},[_c('div',[_vm._v("Thursday, Nov 2")]),_c('div',[_vm._v("$13.98 - Two-Day Shipping")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryChoice5"}},[_c('div',[_vm._v("Wednesday, Nov 1")]),_c('div',[_vm._v("$20.98 - One-Day Shipping")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w9Vr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info-appear","appear":""}},[_c('div',{staticClass:"fixed flexy align-top",staticStyle:{"width":"50%","padding-right":"40px"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","margin-right":"12px"}},[_c('img',{staticStyle:{"width":"48px"},attrs:{"src":__webpack_require__("CUcu"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"12px"}},[_c('div',{staticStyle:{"font-size":"19px","font-weight":"900"}},[_vm._v("Payment information")]),_vm._v(" "),(_vm.selectedPayment === null)?_c('div',{staticStyle:{"padding-top":"12px"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"background-color":"#3a84e8"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add payment method")]),_vm._v(" "),(!_vm.isSignedIn)?_c('div',{staticStyle:{"font-size":"14px","padding-top":"12px"}},[_c('button',{staticStyle:{"font-size":"13px","padding":"3px 8px","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.openSignIn()}}},[_vm._v("Sign in")]),_vm._v(" for 1-click checkout")]):_vm._e()]):_c('div',{staticStyle:{"padding-top":"8px"}},[_c('div',[_vm._v(_vm._s(_vm.payments[_vm.selectedPayment].name))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.mutateCardNumber(_vm.payments[_vm.selectedPayment].number)))]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.payments[_vm.selectedPayment].month)+" / "+_vm._s(_vm.payments[_vm.selectedPayment].year))]),_vm._v(" "),_c('div',{staticStyle:{"color":"transparent","width":"0","height":"0","overflow":"hidden"}},[_vm._v(_vm._s(_vm.reactivator))]),_vm._v(" "),_c('transition',{attrs:{"name":"popover"}},[(_vm.doShowMethodsList)?_c('div',[_c('div',{staticClass:"popover-curtain",on:{"click":function($event){_vm.doShowMethodsList=false}}}),_vm._v(" "),_c('div',{staticClass:"popover-content",on:{"click":function($event){$event.stopPropagation();_vm.doNothing($event)}}},[_vm._l((_vm.payments),function(payment,i){return _c('div',{key:i,staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":function($event){_vm.choosePressed(i)}}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('div',[_c('strong',[_vm._v(_vm._s(payment.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(payment.month)+" / "+_vm._s(payment.year))])])])}),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px","margin-top":"4px"},on:{"click":_vm.addNewPaymentPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Add new payment")])])]),_vm._v(" "),_c('div',{staticClass:"hoverableItem clickable flexy",staticStyle:{"border-radius":"6px"},on:{"click":_vm.managePaymentPressed}},[_c('div',{staticStyle:{"padding":"12px 24px"}},[_c('button',{staticStyle:{"font-weight":"400","color":"#409EFF"}},[_vm._v("Manage payment methods")])])])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticStyle:{"font-size":"13px","min-width":"88px","padding":"3px 0","color":"#3a84e8","border":"1px solid","border-radius":"4px"},on:{"click":function($event){_vm.changePressed()}}},[_vm._v("\n            Change\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wE/f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wm72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("XOT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458af534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("xn+D");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458af534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wmCO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wnP2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodMin',
  props: ['selectedPayment'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "wqnM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("ViXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86b91672_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("mwoX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86b91672_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xGe7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"400px","margin":"5vh auto","background-color":"white","border-radius":"2px","box-shadow":"0px 12px 36px rgba(0,0,0,0.1)"}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"height":"7vh","border-bottom":"1px solid #DDE1EB"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[_vm._v("Sign in")])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l padding-vert-m",staticStyle:{"max-height":"80vh","overflow":"auto"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","name":"","id":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",staticStyle:{"border-top":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","padding-top":"10px","text-align":"right","border-radius":"0 0 10px 10px"}},[_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.closePressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary",staticStyle:{"min-width":"120px"},on:{"click":function($event){_vm.loginPressed()}}},[_vm._v("Login")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PrototypeManager_v_0_3__ = __webpack_require__("rZAK");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      toggleManager: false,
      managerProps: {
        name: 'Amazon Checkout Redesign',
        description: 'An attempt to improve the perfect',
        author: 'And Gordy',
        website: 'http://twitter.com/andgordy',
        date: 'Jan 3 2017',
        iterations: [{
          name: 'D',
          description: 'Final preparations',
          versions: [{
            name: '3',
            description: 'Extra screen, cherries on top'
          },
          // {
          //   name: '2b',
          //   description: 'Instance manager: quick menu only'
          // },
          {
            name: '2',
            description: 'Order summary logic, back navigation'
          }, {
            name: '1',
            description: 'Layout and style'
          }]
        }, {
          name: 'C',
          description: 'Shipping and payment design',
          versions: [{
            name: '3',
            description: 'Login, animation, layout'
          }, {
            name: '2b',
            description: 'Instance manager: quick menu only'
          }, {
            name: '2a',
            description: 'Instance manager: quick selection + manager'
          }, {
            name: '1',
            description: 'Basic layout, functionality and validation'
          }]
        }, {
          name: 'B',
          description: 'Cart design',
          versions: [{
            name: '3',
            description: 'Animation, composition, details'
          }, {
            name: '2',
            description: 'Feature: quick preview'
          }, {
            name: '1',
            description: 'Basic layout and items management'
          }]
        }, {
          name: 'A',
          description: 'Navigation design',
          versions: [{
            name: '2',
            description: 'Steps-based design'
          }, {
            name: '1',
            description: 'Checkout-centric approach'
          }]
          // {
          //   name: 'B',
          //   description: 'Steps-based design',
          //   versions: [
          //     {
          //       name: '1',
          //       description: 'Navigation design'
          //     }
          //   ]
          // }
        }]
      }
    };
  },

  components: {
    PrototypeManager: __WEBPACK_IMPORTED_MODULE_0__components_PrototypeManager_v_0_3__["a" /* default */]
  }
});

/***/ }),

/***/ "xJOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"},on:{"click":function($event){_vm.closePressed()}}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"800px","margin":"5vh auto","background-color":"white","border-radius":"2px","box-shadow":"0px 12px 36px rgba(0,0,0,0.1)"},on:{"click":function($event){$event.stopPropagation();_vm.doThis()}}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"height":"7vh","border-bottom":"1px solid #DDE1EB"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[_vm._v("You recently viewed")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.closePressed()}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticStyle:{"max-height":"80vh","overflow":"auto"}},[_c('div',{staticClass:"flexy align-top padding-hor-l padding-vert-l"},[_c('div',{staticClass:"fixed",staticStyle:{"width":"220px"}},[_c('img',{attrs:{"src":_vm.item.img,"width":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.item.name))])]),_vm._v(" "),_c('div',[_vm._v("by "+_vm._s(_vm.item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-m",staticStyle:{"background-color":"pink","display":"inline-block"}},[_vm._v("#1 Bestseller in Industrial Product Design")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s flexy"},[_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'kindle'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'kindle'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Kindle book")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$17.63")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'hardcover'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'hardcover'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Hardcover")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$18.89")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-s padding-vert-s bordered rounded",class:{selected: _vm.selectedFormat === 'paperback'},staticStyle:{"width":"120px","cursor":"pointer"},on:{"click":function($event){_vm.selectedFormat = 'paperback'}}},[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Paperback")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","padding-top":"4px"}},[_vm._v("$55.77")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[(!_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.addPressed()}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(_vm.isBeingAddedToCart)?_c('button',{staticClass:"boxed subtle-primary",staticStyle:{"background-color":"#b3ffb3","color":"green","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-l padding-hor-l"},[_c('div',{staticClass:"flexy rounded"},[_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'description'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none","border-top-left-radius":"6px","border-bottom-left-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'description'}}},[_vm._v("\n              Description\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'editors'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-right":"none"},on:{"click":function($event){_vm.selectedTab = 'editors'}}},[_vm._v("\n              Editorial reviews\n            ")]),_vm._v(" "),_c('div',{staticClass:"fixed padding-vert-s",class:{selectedTab: _vm.selectedTab === 'user'},staticStyle:{"width":"140px","text-align":"center","font-size":"14px","cursor":"pointer","border":"1px solid #E6EBF5","border-top-right-radius":"6px","border-bottom-right-radius":"6px"},on:{"click":function($event){_vm.selectedTab = 'user'}}},[_vm._v("\n              User reviews\n            ")])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-m padding-hor-xs"},[(_vm.selectedTab === 'description')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Why do some products capture widespread attention while others flop? What makes us engage with certain products out of sheer habit? Is there a pattern underlying how technologies hook us?")]),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Nir Eyal answers these questions (and many more) by explaining the Hook Model—a four-step process embedded into the products of many successful companies to subtly encourage customer behavior. Through consecutive “hook cycles,” these products reach their ultimate goal of bringing users back again and again without depending on costly advertising or aggressive messaging.")]):_vm._e(),_vm._v(" "),(!_vm.showFullDescription)?_c('p',{staticStyle:{"padding":"12px 0"}},[_vm._v("Hooked is based on Eyal’s years of research, consulting, and practical experience. He wrote the book he wished had been available to him as a start-up founder—not abstract theory, but a how-to guide for building better products. Hooked is written for product managers, designers, marketers, start-up founders, and anyone who seeks to understand how products influence our behavior.")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'editors')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Publisher's Weekly")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Eric Ries, author of The Lean Startup")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('i',[_vm._v("—Boris Veldhuijzen van Zanten, founder of The Next Web ")])])])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'user')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('div',[_c('strong',[_vm._v("This is the absolute best book on product development I've ever read")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gold"}},[_vm._v("★★★★☆")]),_vm._v(" "),_c('div',[_vm._v("\"With concrete advice and tales from the product-development trenches, this is a thoughtful discussion of how to create something that users never knew they couldn’t live without.\"")]),_vm._v(" "),_c('div',{},[_c('i',[_vm._v("Paul W")])])])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xL07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__ = __webpack_require__("Po17");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47f2bc18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__ = __webpack_require__("nw8d");
function injectStyle (ssrContext) {
  __webpack_require__("PZli")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47f2bc18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47f2bc18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xLw2":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFkSURBVHgB7djBUcJAFMbxtxkasAkz3lSc2IZWIFagHYCdYAd2oUQy8YZgE1aQNR9eAgNM9u23XHi/C2GGgfcHkmwiYowxxhhjTsdn/TOezZd3QlTWq6eyWoxEwYW8uCxXlzLwNbYzJ6Obq/xVIuEL8b6ZYLu4zoPmWc8R8uKiOP9qP+wF242X6bxePkiE7vDim0dRCC6GWbWYOJeNsa39JbaHL4YXU1FQBUBMBGt4UAeAJoI5PEQFQEgEe3iIDoA+ESmGB0oAHIpINTzQAmBXRMrhgRoA3Qjv5c05+T9rJxge6AHQjVhLNDwEnYl7v2k28JvPMy+J0AO6/3n8hfDIWHbsQw3Y3mFvh/k9c+20C20fOHS0Yayd9qEE9DlUpoqIDgg5zqeIiArQnKTYEeqAmDMsM0IVwFgesCKCA5hrG0aE+qKetTzoRPy2F/Vnkho+kH1b5b29pfJRfT+LMcYYY8xx/QHmOUozJWAz4gAAAABJRU5ErkJggg=="

/***/ }),

/***/ "xcPX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lean.90e3d7a.jpg";

/***/ }),

/***/ "xhMT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef1179f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("/gak");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef1179f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xn+D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Payment information")]),_vm._v(" "),(!_vm.isPaymentFilled)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add payment method")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Sam Bell")]),_vm._v(" "),_c('div',[_vm._v("**** **** **** 5457")]),_vm._v(" "),_c('div',[_vm._v("07 / 20")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y+PD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/face.3cf2f88.jpg";

/***/ }),

/***/ "y6fU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y93l":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "yF01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "yIPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Delivery',
  props: ['chosenDelivery'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "yPM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Shipping Address")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardName"}},[_vm._v("Name on card")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"cardName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"cardNumber"}},[_vm._v("Card number")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"cardNumber"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"month"}},[_vm._v("Expiration Month")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"fullName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"year"}},[_vm._v("Expiration Year")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"year"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yR8Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Done!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yRkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['isShippingFilled', 'isPaymentFilled'],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.isShippingFilled && this.isPaymentFilled;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "ypnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",staticStyle:{"position":"absolute","top":"0","left":"0","z-index":"120","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.4)"}},[_c('div',{staticClass:"modal-container",staticStyle:{"max-width":"540px","max-height":"100vh","display":"flex","flex-direction":"column","margin":"0 auto","padding":"24px 0"}},[_c('div',{staticClass:"flexy padding-vert-m padding-hor-l",staticStyle:{"border-bottom":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","border-radius":"10px 10px 0 0"}},[_c('h2',{staticStyle:{"font-size":"20px"}},[(_vm.mode === 'add')?_c('span',[_vm._v("New shipping address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('span',[_vm._v("Edit address")]):_vm._e(),_vm._v(" "),(_vm.mode === 'manage')?_c('span',[_vm._v("Manage shipping addresses")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"},on:{"click":function($event){_vm.$emit('cancelled')}}},[_c('button',[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1","padding-top":"4px"},attrs:{"src":__webpack_require__("5F5F")}})])])]),_vm._v(" "),_c('div',{staticClass:"padding-hor-l",class:{roundBottom: _vm.mode === 'manage'},staticStyle:{"overflow":"scroll","background-color":"white","padding-top":"16px","padding-bottom":"24px"}},[(this.mode === 'manage')?_c('div',[_vm._l((_vm.addresses),function(address,i){return _c('div',{key:i,staticClass:"flexy",staticStyle:{"padding":"12px 0"}},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(address.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.address1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.city)+", "+_vm._s(address.state)+", "+_vm._s(address.country))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(address.phone))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"#409EFF"},on:{"click":function($event){_vm.editSelectedPressed(i)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"80px","text-align":"right"}},[_c('button',{staticStyle:{"color":"silver"},on:{"click":function($event){_vm.deleteSelectedPressed(i)}}},[_vm._v("Delete")])])])}),_vm._v(" "),_c('div',{staticClass:"clickable flexy",staticStyle:{"padding":"24px 0 12px","color":"#409EFF","font-weight":"500","font-size":"14px"},on:{"click":function($event){_vm.addPressed()}}},[_vm._v("\n            Add new address\n          ")])],2):_vm._e(),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name.value),expression:"name.value"}],class:{errorInputHighlight: !_vm.name.isValid && !_vm.name.wasFocused},attrs:{"type":"text","name":"","id":"fullName"},domProps:{"value":(_vm.name.value)},on:{"focus":function($event){_vm.name.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.name, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.name.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.name.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1.value),expression:"address1.value"}],class:{errorInputHighlight: !_vm.address1.isValid && !_vm.address1.wasFocused},attrs:{"type":"text","name":"","id":"addressLine1"},domProps:{"value":(_vm.address1.value)},on:{"focus":function($event){_vm.address1.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address1, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.address1.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.address1.wasFocused}},[_vm._v("\n              Shouldn't be empty\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city.value),expression:"city.value"}],class:{errorInputHighlight: !_vm.city.isValid && !_vm.city.wasFocused},attrs:{"type":"text","name":"","id":"city"},domProps:{"value":(_vm.city.value)},on:{"focus":function($event){_vm.city.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.city, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.city.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.city.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],class:{errorInputHighlight: !_vm.state.isValid && !_vm.state.wasFocused},attrs:{"type":"text","name":"","id":"state"},domProps:{"value":(_vm.state.value)},on:{"focus":function($event){_vm.state.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.state.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.state.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flexy",staticStyle:{"align-items":"flex-start"}},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.country.value),expression:"country.value"}],class:{errorInputHighlight: !_vm.country.isValid && !_vm.country.wasFocused},on:{"focus":function($event){_vm.country.wasFocused = true},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.country, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose country...")]),_vm._v(" "),_c('option',{attrs:{"value":"United States"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"Mexico"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"Canada"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"Brazil"}},[_vm._v("Brazil")])]),_vm._v(" "),(!_vm.country.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.country.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zip.value),expression:"zip.value"}],class:{errorInputHighlight: !_vm.zip.isValid && !_vm.zip.wasFocused},attrs:{"type":"text","name":"","id":"zip"},domProps:{"value":(_vm.zip.value)},on:{"focus":function($event){_vm.zip.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zip, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.zip.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.zip.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone.value),expression:"phone.value"}],class:{errorInputHighlight: !_vm.phone.isValid && !_vm.phone.wasFocused},attrs:{"type":"text","name":"","id":"phone"},domProps:{"value":(_vm.phone.value)},on:{"focus":function($event){_vm.phone.wasFocused = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.phone, "value", $event.target.value)}}}),_vm._v(" "),(!_vm.phone.isValid)?_c('div',{staticClass:"errorMessage",class:{errorMessageHighlight: !_vm.phone.wasFocused}},[_vm._v("\n                Shouldn't be empty\n              ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),(this.mode === 'add' || this.mode === 'edit')?_c('div',{staticClass:"padding-hor-l",staticStyle:{"border-top":"1px solid #DDE1EB","background-color":"white","flex":"0 0 auto","height":"64px","padding-top":"10px","text-align":"right","border-radius":"0 0 10px 10px"}},[_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.cancelPressed()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"boxed primary",staticStyle:{"min-width":"120px"},on:{"click":function($event){_vm.savePressed()}}},[_vm._v("Save")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ysXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("PaQA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__ = __webpack_require__("A8d0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__ = __webpack_require__("bvAK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Delivery__ = __webpack_require__("9Aai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__ = __webpack_require__("9gs6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__ = __webpack_require__("fGQj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__ = __webpack_require__("ubYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__ = __webpack_require__("wm72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderSummary__ = __webpack_require__("UwYX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__ = __webpack_require__("3fPZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Start: __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
    ShoppingCart: __WEBPACK_IMPORTED_MODULE_1__ShoppingCart__["a" /* default */],
    ShoppingCartMin: __WEBPACK_IMPORTED_MODULE_2__ShoppingCartMin__["a" /* default */],
    ShippingAddress: __WEBPACK_IMPORTED_MODULE_4__ShippingAddress__["a" /* default */],
    ShippingAddressMin: __WEBPACK_IMPORTED_MODULE_5__ShippingAddressMin__["a" /* default */],
    PaymentMethod: __WEBPACK_IMPORTED_MODULE_6__PaymentMethod__["a" /* default */],
    PaymentMethodMin: __WEBPACK_IMPORTED_MODULE_7__PaymentMethodMin__["a" /* default */],
    Delivery: __WEBPACK_IMPORTED_MODULE_3__Delivery__["a" /* default */],
    OrderSummary: __WEBPACK_IMPORTED_MODULE_8__OrderSummary__["a" /* default */],
    ExtraSignup: __WEBPACK_IMPORTED_MODULE_9__ExtraSignup__["a" /* default */]
  },
  data: function data() {
    return {
      currentView: 'Start',
      chosenDelivery: '1',
      isShippingFilled: false,
      isPaymentFilled: false,
      cart: [{
        name: 'Beautiful Evidence',
        by: 'Edward R. Tufte',
        img: __webpack_require__("OEdX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 28.87,
        quantity: 1
      }, {
        name: 'Hooked: How to Build Habit-Forming Products',
        by: 'Nir Eyal',
        img: __webpack_require__("IBtq"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 18.56,
        quantity: 1
      }],
      alsoItems: [{
        name: 'Sprint: How to Solve Big Problems and Test New Ideas in Just Five Days',
        by: 'Jake Knapp',
        img: __webpack_require__("RVgH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.53,
        quantity: 1
      }, {
        name: 'The Lean Startup: How Today\'s Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses',
        by: 'Eric Ries',
        img: __webpack_require__("xcPX"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.29,
        quantity: 1
      }, {
        name: 'The Hard Thing About Hard Things: Building a Business When There Are No Easy Answers',
        by: 'Ben Horowitz',
        img: __webpack_require__("fiE3"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 19.66,
        quantity: 1
      }, {
        name: 'Rework',
        by: 'Jason Fried',
        img: __webpack_require__("7fXA"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 17.68,
        quantity: 1
      }, {
        name: 'Remote: Office Not Required',
        by: 'Jason Fried',
        img: __webpack_require__("LhVL"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 15.59,
        quantity: 1
      }],
      recentItems: [{
        name: 'Envisioning Information',
        by: 'Edward R. Tufte',
        img: __webpack_require__("CySp"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 34.96,
        quantity: 1
      }, {
        name: 'About Face: The Essentials of Interaction Design',
        by: 'Alan Cooper',
        img: __webpack_require__("y+PD"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 36.47,
        quantity: 1
      }, {
        name: '100 Things Every Designer Needs to Know About People',
        by: 'Susan Weinschenk',
        img: __webpack_require__("P+u0"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 22.95,
        quantity: 1
      }, {
        name: 'HTML and CSS: Design and Build Websites',
        by: 'Jon Duckett',
        img: __webpack_require__("AqZH"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 20.53,
        quantity: 1
      }],
      extraItems: [{
        name: 'CSS: The Missing Manual',
        by: 'David Sawyer McFarland',
        img: __webpack_require__("PF3y"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 24.61,
        quantity: 1
      }, {
        name: 'The Principles of Beautiful Web Design: Designing Great Web Sites is Not Rocket Science!',
        by: 'Jason Beaird',
        img: __webpack_require__("jAj8"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.23,
        quantity: 1
      }, {
        name: 'Logo Design Love: A Guide to Creating Iconic Brand Identities, 2nd Edition',
        by: 'David Airey',
        img: __webpack_require__("WOmI"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 31.05,
        quantity: 1
      }, {
        name: 'Layout Essentials: 100 Design Principles for Using Grids (Design Essentials)',
        by: 'Beth Tondreau',
        img: __webpack_require__("Mvmb"),
        seller: 'Amazon',
        availability: 'In Stock',
        price: 14.76,
        quantity: 1
      }]
    };
  },

  methods: {
    shoppingCartConfirmed: function shoppingCartConfirmed(items) {
      this.currentView = 'Checkout';
      this.cart = items;
    },
    shippingAddressConfirmed: function shippingAddressConfirmed(items) {
      this.isShippingFilled = true;
      this.currentView = 'Checkout';
    },
    shippingAddressCancelled: function shippingAddressCancelled() {
      this.currentView = 'Checkout';
    },
    paymentMethodConfirmed: function paymentMethodConfirmed() {
      this.isPaymentFilled = true;
      this.currentView = 'Checkout';
    },
    paymentMethodCancelled: function paymentMethodCancelled() {
      this.currentView = 'Checkout';
    }
  },
  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "ywve":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l",staticStyle:{"background-color":"#f1f3f7"}},[_c('div',{staticClass:"padding-vert-l flexy align-top"},[_c('div',[_c('transition',{attrs:{"name":"cart-appear","appear":""}},[_c('div',{staticClass:"padding-vert-m padding-hor-l rounded silver",staticStyle:{"padding":"12px 40px","background-color":"white","box-shadow":"0px 7px 24px rgba(0,0,0,0.1)"}},[_c('div',{},[_c('h1',{staticStyle:{"padding":"24px 0","font-size":"24px","font-weight":"600","border-bottom":"1px solid #EBEEF5"}},[_vm._v("Shopping Cart")])]),_vm._v(" "),_c('transition-group',{staticStyle:{"padding":"12px 0"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.items),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item large"},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('items', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"24px"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-right":"24px","padding-top":"4px"}},[_c('div',{staticStyle:{"font-size":"16px","font-weight":"500"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"text-grey padding-vert-xs"},[_vm._v(_vm._s(item.availability)+", "+_vm._s(item.seller))])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px","padding-top":"8px"}},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticStyle:{"min-width":"auto","width":"60px","background-color":"rgba(255,255,255,0.6)"},attrs:{"name":"quantity","id":"item-quantity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"20px","margin-right":"12px","padding-top":"6px"}},[(!item.isXPressed)?_c('button',{on:{"click":function($event){_vm.xPressed(i)}}},[_c('img',{staticClass:"button-icon",staticStyle:{"opacity":"1"},attrs:{"src":__webpack_require__("5F5F")}})]):_vm._e(),_vm._v(" "),(item.isXPressed)?_c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"90","top":"0","left":"0","width":"100vw","height":"100vh","background-color":"rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.xPressed(i)}}}),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs padding-hor-xs rounded",staticStyle:{"position":"relative","width":"160px","transform":"translate(-130px, -12px)","z-index":"120","background-color":"white","box-shadow":"0px 4px 12px rgba(0,0,0,0.0.5)"}},[_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"#409EFF","margin":"0"},on:{"click":function($event){_vm.saveForLaterPressed(i)}}},[_vm._v("Save for later")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"#fd3737","margin":"0"},on:{"click":function($event){_vm.removeItemPressed(i)}}},[_vm._v("Remove from cart")]),_vm._v(" "),_c('button',{staticClass:"overlay-button",staticStyle:{"display":"block","width":"100%","text-align":"left","padding":"8px 12px","color":"silver","margin":"0"},on:{"click":function($event){_vm.xPressed(i)}}},[_vm._v("Cancel")])])]):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"padding-vert-m flexy",staticStyle:{"padding-top":"24px","padding-bottom":"32px","border-top":"1px solid #EBEEF5"}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"102px"}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"16px","font-weight":"500"}},[_vm._v("Subtotal")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"100px"}},[_vm._v("$"+_vm._s(_vm.subtotal))]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"132px"}},[_c('button',{staticClass:"boxed primary",staticStyle:{"padding":"12px 29px"},on:{"click":function($event){_vm.checkoutPressed()}}},[_vm._v("Checkout")])])])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"left-column-appear","appear":""}},[_c('div',[_c('transition',{attrs:{"name":"later-fade"}},[(_vm.later.length > 0)?_c('div',{staticStyle:{"padding":"12px 32px"}},[_c('div',[_c('h2',{staticStyle:{"padding":"32px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v("You saved for later")])]),_vm._v(" "),_c('transition-group',{staticClass:"padding-vert-m flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.later),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('later', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromLaterPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"12px 32px"}},[_c('div',[_c('h2',{staticStyle:{"padding":"32px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v(_vm._s(_vm.youRecentlyViewed))])]),_vm._v(" "),_c('transition-group',{staticClass:"padding-vert-m flexy",staticStyle:{"flex-wrap":"wrap"},attrs:{"name":"list-ani","tag":"div"}},_vm._l((_vm.recent),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item",staticStyle:{"width":"40%","padding-right":"24px"}},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('recent', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromRecentPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)],1)])],1),_vm._v(" "),_c('transition',{attrs:{"name":"right-column-appear","appear":""}},[_c('div',{staticClass:"fixed",staticStyle:{"width":"320px","margin-left":"48px"}},[_c('div',{staticClass:"padding-vert-m padding-hor-xl bordered rounded silver",staticStyle:{"height":"224px","text-align":"center"}},[_c('img',{staticStyle:{"padding-top":"56px"},attrs:{"src":__webpack_require__("Kufr"),"width":"125px"}})]),_vm._v(" "),_c('div',[_c('h2',{staticStyle:{"padding":"42px 0px 24px","font-size":"20px","border-bottom":"1px solid #DDE1EB"}},[_vm._v("Customers also bought")])]),_vm._v(" "),_c('div',{},[_c('transition-group',{attrs:{"name":"list-ani"}},_vm._l((_vm.also),function(item,i){return _c('div',{key:item.name,staticClass:"list-ani-item"},[_c('div',{staticClass:"padding-vert-m flexy align-top"},[_c('div',{staticClass:"fixed overlay-wrapper"},[_c('div',{staticClass:"overlay-image"},[_c('img',{staticStyle:{"border-radius":"2px"},attrs:{"src":item.img,"width":"75px"}})]),_vm._v(" "),_c('div',{staticClass:"overlay-content",staticStyle:{"cursor":"pointer","text-align":"center"},on:{"click":function($event){_vm.openPreview('also', i)}}},[_c('img',{staticStyle:{"width":"48px","padding":"24px 0"},attrs:{"src":__webpack_require__("95Jx")}})])]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"16px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"110px"}},[_c('div',{staticStyle:{"max-height":"34px","overflow":"hidden"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"text-grey"},[_vm._v("by "+_vm._s(item.by))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs text-grey"},[_vm._v("$"+_vm._s(item.price))]),_vm._v(" "),_c('div',{},[(!item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#409EFF","padding":"4px 0"},on:{"click":function($event){_vm.addFromAlsoPressed(i)}}},[_vm._v("Add to cart")]):_vm._e(),_vm._v(" "),(item.isBeingAddedToCart)?_c('button',{staticStyle:{"color":"#28B87B","padding":"4px 0","cursor":"auto"}},[_vm._v("Added!")]):_vm._e()])])])])}))],1)])])],1),_vm._v(" "),(_vm.doShowPreview)?_c('QuickPreview',{attrs:{"selectedForPreview":_vm.selectedForPreview},on:{"close":function($event){_vm.doShowPreview = false},"addToCart":function($event){_vm.addedToCartFromPreview($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yxel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  data: function data() {
    return {
      showInstructions: false
    };
  },

  props: ['isShippingFilled', 'isPaymentFilled'],
  computed: {
    canPlaceOrder: function canPlaceOrder() {
      return this.isShippingFilled && this.isPaymentFilled;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      if (this.canPlaceOrder) {
        this.$emit('placed');
      } else {
        this.showInstructions = true;
      }
    }
  }
});

/***/ }),

/***/ "z+yW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-m fixed silver rounded",staticStyle:{"width":"300px"}},[_c('h3',[_vm._v("Order summary")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"}),_vm._v(" "),_c('button',{staticClass:"boxed primary wide",class:{grey: !_vm.canPlaceOrder},on:{"click":function($event){_vm.placeOrder()}}},[_vm._v("Place order")]),_vm._v(" "),(_vm.showInstructions)?_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v("Before you can place your order, please, do the following:")]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('ul',[(!_vm.isShippingFilled)?_c('li',[_vm._v("Add shipping address")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentFilled)?_c('li',[_vm._v("Add payment method")]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Shipping & handling")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Free shipping")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("-$6.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Total before tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$89.98")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Estimated tax")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$6.87")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-xs flexy"},[_c('div',[_vm._v("Order total")]),_vm._v(" "),_c('div',{staticClass:"fixed text-right",staticStyle:{"width":"56px"}},[_vm._v("$96.85")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z4bv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zPMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-hor-l padding-vert-l"},[_c('h1',[_vm._v("Shipping Address")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('confirmed')}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"boxed silver",on:{"click":function($event){_vm.$emit('cancelled')}}},[_vm._v("Cancel")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-vert-m"},[_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"fullName"}},[_vm._v("Full name")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"fullName"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine1"}},[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"addressLine1"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"addressLine2"}},[_vm._v("Address Line 2")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"addressLine2"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"city"}},[_vm._v("City")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"city"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"state"}},[_vm._v("State/Region/Province")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"state"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"zip"}})]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('label',{staticClass:"text",attrs:{"for":"zip"}},[_vm._v("Country")]),_vm._v(" "),_c('select',[_c('option',{attrs:{"value":"volvo"}},[_vm._v("United States")]),_vm._v(" "),_c('option',{attrs:{"value":"saab"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"mercedes"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"audi"}},[_vm._v("Brazil")])])]),_vm._v(" "),_c('div',{staticClass:"padding-vert-xs"},[_c('label',{staticClass:"text",attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":"","id":"phone"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zQPw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100vh","overflow":"auto"}},[_c('div',{staticStyle:{"background-color":"#24303D","color":"white"}},[_c('div',{staticClass:"flexy",staticStyle:{"height":"60px","position":"relative","align-items":"flex-start"},attrs:{"id":"first"}},[_c('div',{staticClass:"fixed padding-hor-l",staticStyle:{"width":"140px","cursor":"pointer","padding-top":"12px"},on:{"click":function($event){_vm.$router.push({name: 'Start'})}}},[_c('img',{staticStyle:{"width":"84px"},attrs:{"src":__webpack_require__("23Cc"),"alt":""}})]),_vm._v(" "),_c('transition',{attrs:{"name":"lineonecheckout"}},[(_vm.$route.name !== 'Start' && _vm.$route.name !== 'ShoppingCart' && _vm.$route.name !== 'Complete')?_c('div',{staticStyle:{"position":"absolute","margin-top":"12px","padding-top":"4px","padding-bottom":"4px","margin-left":"132px","padding-left":"21px","color":"#FF9900","font-size":"19px","font-weight":"500","border-left":"1px solid rgba(255,255,255,0.2)"}},[_vm._v("Checkout")]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"lineoneinit"}},[(_vm.$route.name === 'Start' || _vm.$route.name === 'ShoppingCart' || _vm.$route.name === 'Complete')?_c('div',{staticClass:"flexy padding-hor-m lineoneinit"},[_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"width":"48px","height":"35px","background-color":"#f3f3f3","border-right":"1px solid d1d1d1","color":"#666","border-radius":"5px 0 0 5px","text-align":"center","cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n            All\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("/kAr"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"white","height":"35px","cursor":"text"}}),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"width":"48px","background-color":"#FFB647","height":"35px","line-height":"35px","border-radius":"0 5px 5px 0","text-align":"center","padding-top":"4px","cursor":"pointer"}},[_c('img',{staticStyle:{"width":"21px"},attrs:{"src":__webpack_require__("+h5J"),"alt":""}})])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"lineoneinit"}},[(_vm.$route.name === 'Start' || _vm.$route.name === 'ShoppingCart' || _vm.$route.name === 'Complete')?_c('div',{staticClass:"fixed padding-hor-l flexy align-center lineoneinit",staticStyle:{"width":"140px","cursor":"pointer"},on:{"click":function($event){_vm.$router.push({name:'ShoppingCart'})}}},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',[_c('img',{staticStyle:{"width":"38px","padding-top":"6px"},attrs:{"src":__webpack_require__("c6bX"),"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","top":"-1px","left":"11px","width":"24px","text-align":"center","color":"#FF9900","font-weight":"900","font-size":"16px"}},[_vm._v(_vm._s(_vm.cart.length))])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"18px","font-weight":"900"}},[_vm._v("\n          cart\n        ")])]):_vm._e()])],1),_vm._v(" "),_c('transition',{attrs:{"name":"linetwo"}},[(_vm.$route.name === 'Start' || _vm.$route.name === 'ShoppingCart' || _vm.$route.name === 'Complete')?_c('div',{staticClass:"flexy align-center linetwo-container",attrs:{"id":"second"}},[_c('div',{staticClass:"fixed padding-hor-l flexy align-center",staticStyle:{"width":"140px","cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n          Departments\n        ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"flexy padding-hor-m align-center",staticStyle:{"opacity":"0.6","font-size":"13px"}},[_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right"}},[_vm._v("\n            Browsing History\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("My Amazon.com")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Today's Deals")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Gift Cards")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Registry")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Sell")]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-left":"12px"}},[_vm._v("Help")])]),_vm._v(" "),_c('div',{staticClass:"fixed padding-hor-l flexy align-center",staticStyle:{"cursor":"pointer","font-size":"13px","font-weight":"900"},on:{"click":function($event){_vm.$route.name = 'ShoppingCart'}}},[_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"cursor":"pointer","padding-right":"24px"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n            Account & Lists\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px","margin-right":"8px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"fixed",staticStyle:{"padding-right":"24px"}},[_vm._v("Orders")]),_vm._v(" "),_c('div',{staticClass:"fixed flexy align-center",staticStyle:{"cursor":"pointer"}},[_c('div',{staticStyle:{"text-align":"right","font-size":"13px","font-weight":"900"}},[_vm._v("\n            Try Prime\n          ")]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block","width":"8px","flex":"0 0 auto","margin-left":"6px"},attrs:{"src":__webpack_require__("I5m+"),"alt":""}})])])]):_vm._e()])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ziAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered rounded padding-vert-m padding-hor-l fixed",staticStyle:{"width":"49%"}},[_c('h3',[_vm._v("Payment information")]),_vm._v(" "),(_vm.selectedPayment === null)?_c('div',{staticClass:"padding-vert-m"},[_c('button',{staticClass:"boxed primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("+ Add payment method")])]):_c('div',{staticClass:"padding-vert-m"},[_c('div',[_vm._v(_vm._s(_vm.selectedPayment.name))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selectedPayment.number))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selectedPayment.month)+" / "+_vm._s(_vm.selectedPayment.year))]),_vm._v(" "),_c('div',{staticClass:"padding-vert-s"},[_c('button',{staticClass:"boxed subtle-primary",on:{"click":function($event){_vm.$emit('edit')}}},[_vm._v("Change")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zmbX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__ = __webpack_require__("ZDDx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdefebb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__ = __webpack_require__("U4YK");
function injectStyle (ssrContext) {
  __webpack_require__("h8Hu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cdefebb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingAddressMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdefebb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingAddressMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zxRT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__ = __webpack_require__("2JC2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67beb126_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__ = __webpack_require__("ryDJ");
function injectStyle (ssrContext) {
  __webpack_require__("gB41")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67beb126"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMethodMin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67beb126_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethodMin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ee2d122c2d0e5ae18d0e.js